// This file is auto-generated by @hey-api/openapi-ts

export const ADSBComplianceInfoSchema = {
    description: 'Use if task_type is airworthiness_directive or service_bulletin',
    properties: {
        method_of_compliance: {
            $ref: '#/components/schemas/MethodOfCompliance'
        },
        tsi: {
            $ref: '#/components/schemas/TimeGrouping'
        }
    },
    required: [
        'method_of_compliance',
        'tsi'
    ],
    title: 'ADSBComplianceInfo',
    type: 'object'
} as const;

export const AcceptOutsideServiceSchema = {
    properties: {
        action: {
            const: 'accept',
            title: 'Action',
            type: 'string'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/OutsideServiceCheck'
            },
            title: 'Checks',
            type: 'array'
        },
        note: {
            anyOf: [
                {
                    maxLength: 4000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        }
    },
    required: [
        'checks',
        'action'
    ],
    title: 'AcceptOutsideService',
    type: 'object'
} as const;

export const AcceptedAdAssessmentCreateSchema = {
    description: 'Schema for creating a new accepted AD assessment.',
    properties: {
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        trace_ad_eval_report_id: {
            format: 'uuid',
            title: 'Trace Ad Eval Report Id',
            type: 'string'
        }
    },
    required: [
        'trace_ad_eval_report_id'
    ],
    title: 'AcceptedAdAssessmentCreate',
    type: 'object'
} as const;

export const AcceptedAdAssessmentPublicSchema = {
    description: 'Schema for public accepted AD assessment response.',
    properties: {
        accepted_at: {
            format: 'date-time',
            title: 'Accepted At',
            type: 'string'
        },
        accepted_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserPublicMinimal'
                },
                {
                    type: 'null'
                }
            ]
        },
        accepted_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accepted By Id'
        },
        ad_record: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AdRecordPublicMinimal'
                },
                {
                    type: 'null'
                }
            ]
        },
        ad_record_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Record Id'
        },
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        status: {
            title: 'Status',
            type: 'string'
        },
        supersedes_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Supersedes Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        trace_ad_eval_report: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TraceAdEvalReportPublicMinimal'
                },
                {
                    type: 'null'
                }
            ]
        },
        trace_ad_eval_report_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Trace Ad Eval Report Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        version: {
            title: 'Version',
            type: 'integer'
        }
    },
    required: [
        'id',
        'tenant_id',
        'aircraft_id',
        'ad_record_id',
        'document_id',
        'trace_ad_eval_report_id',
        'accepted_by_id',
        'accepted_at',
        'supersedes_id',
        'version',
        'status',
        'created_at',
        'updated_at'
    ],
    title: 'AcceptedAdAssessmentPublic',
    type: 'object'
} as const;

export const AcceptedSbAssessmentCreateSchema = {
    description: 'Schema for creating a new accepted SB assessment.',
    properties: {
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        trace_sb_eval_report_id: {
            format: 'uuid',
            title: 'Trace Sb Eval Report Id',
            type: 'string'
        }
    },
    required: [
        'trace_sb_eval_report_id'
    ],
    title: 'AcceptedSbAssessmentCreate',
    type: 'object'
} as const;

export const AcceptedSbAssessmentPublicSchema = {
    description: 'Schema for public accepted SB assessment response.',
    properties: {
        accepted_at: {
            format: 'date-time',
            title: 'Accepted At',
            type: 'string'
        },
        accepted_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserPublicMinimal'
                },
                {
                    type: 'null'
                }
            ]
        },
        accepted_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accepted By Id'
        },
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        service_bulletin: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ServiceBulletinPublicMinimal'
                },
                {
                    type: 'null'
                }
            ]
        },
        service_bulletin_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Service Bulletin Id'
        },
        status: {
            title: 'Status',
            type: 'string'
        },
        supersedes_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Supersedes Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        trace_sb_eval_report: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TraceSbEvalReportPublicMinimal'
                },
                {
                    type: 'null'
                }
            ]
        },
        trace_sb_eval_report_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Trace Sb Eval Report Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        version: {
            title: 'Version',
            type: 'integer'
        }
    },
    required: [
        'id',
        'tenant_id',
        'aircraft_id',
        'service_bulletin_id',
        'document_id',
        'trace_sb_eval_report_id',
        'accepted_by_id',
        'accepted_at',
        'supersedes_id',
        'version',
        'status',
        'created_at',
        'updated_at'
    ],
    title: 'AcceptedSbAssessmentPublic',
    type: 'object'
} as const;

export const AccomplishedCheckSchema = {
    properties: {
        check_id: {
            format: 'uuid',
            title: 'Check Id',
            type: 'string'
        },
        kind: {
            const: 'check',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind',
        'check_id'
    ],
    title: 'AccomplishedCheck',
    type: 'object'
} as const;

export const AccomplishedItemSchema = {
    discriminator: {
        mapping: {
            check: '#/components/schemas/AccomplishedCheck',
            task: '#/components/schemas/AccomplishedTask'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/AccomplishedTask'
        },
        {
            $ref: '#/components/schemas/AccomplishedCheck'
        }
    ]
} as const;

export const AccomplishedTaskSchema = {
    properties: {
        kind: {
            const: 'task',
            title: 'Kind',
            type: 'string'
        },
        task_id: {
            format: 'uuid',
            title: 'Task Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'task_id'
    ],
    title: 'AccomplishedTask',
    type: 'object'
} as const;

export const ActorTeamMembersAudienceSchema = {
    additionalProperties: false,
    properties: {
        kind: {
            const: 'actor_team_members',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind'
    ],
    title: 'ActorTeamMembersAudience',
    type: 'object'
} as const;

export const AdComplianceHistoriesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/AdComplianceHistoryPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'AdComplianceHistoriesPublic',
    type: 'object'
} as const;

export const AdComplianceHistoryApplicabilityStatusSchema = {
    enum: [
        'APPLICABLE',
        'NOT_APPLICABLE',
        'SUPERSEDED',
        'CANCELLED',
        'UNKNOWN'
    ],
    title: 'AdComplianceHistoryApplicabilityStatus',
    type: 'string'
} as const;

export const AdComplianceHistoryCreateSchema = {
    properties: {
        ad_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Summary of AD purpose & requirements',
            title: 'Ad Description'
        },
        ad_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date the AD became effective / mandatory',
            title: 'Ad Effective Date'
        },
        ad_issue_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date the AD was originally issued',
            title: 'Ad Issue Date'
        },
        ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Official AD reference code issued by the authority',
            title: 'Ad Number'
        },
        ad_revision_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of latest AD revision',
            title: 'Ad Revision Date'
        },
        ad_revision_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Latest AD revision level',
            title: 'Ad Revision Number'
        },
        ad_title: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Official AD title or short description',
            title: 'Ad Title'
        },
        aircraft_association: {
            anyOf: [
                {
                    $ref: '#/components/schemas/app__aircraft__ad_compliance_history__schemas__AircraftAssociation'
                },
                {
                    type: 'null'
                }
            ],
            description: 'What part of the aircraft the AD relates to'
        },
        aircraft_id: {
            description: 'Internal unique ID of the aircraft',
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AdComplianceHistoryApplicabilityStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Applicability decision for this aircraft/assembly'
        },
        applicability_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Reason why AD applies or does not apply',
            title: 'Applicability Reason'
        },
        associated_equipment_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Identifier of affected engine/equipment/APU if applicable',
            title: 'Associated Equipment Id'
        },
        ata_chapter: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ATA chapter / sub-chapter reference',
            title: 'Ata Chapter'
        },
        casa_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'CASA equivalent AD number',
            title: 'Casa Equivalent Ad Number'
        },
        compliance_category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceCategory'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Whether compliance is one-time or recurring'
        },
        compliance_interval_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Human-readable compliance interval / threshold',
            title: 'Compliance Interval Description'
        },
        compliance_interval_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceIntervalType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Type of recurring interval'
        },
        compliance_interval_value: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Interval value (numeric for primary unit)',
            title: 'Compliance Interval Value'
        },
        compliance_method: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Primary method of compliance',
            title: 'Compliance Method'
        },
        compliance_record_reference: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Internal record(s) of compliance',
            title: 'Compliance Record Reference'
        },
        easa_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'EASA equivalent AD number',
            title: 'Easa Equivalent Ad Number'
        },
        faa_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'FAA equivalent AD number',
            title: 'Faa Equivalent Ad Number'
        },
        last_compliance_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of last compliance action',
            title: 'Last Compliance Date'
        },
        last_compliance_flight_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Aircraft/assembly flight cycles at last compliance',
            title: 'Last Compliance Flight Cycles'
        },
        last_compliance_flight_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Aircraft/assembly flight hours at last compliance',
            title: 'Last Compliance Flight Hours'
        },
        last_done: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Last maintenance or action completed to maintain compliance',
            title: 'Last Done'
        },
        next_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Calculated next due date where applicable',
            title: 'Next Due Date'
        },
        next_due_flight_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Calculated next due flight cycles',
            title: 'Next Due Flight Cycles'
        },
        next_due_flight_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Calculated next due flight hours',
            title: 'Next Due Flight Hours'
        },
        notes_remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Additional compliance notes',
            title: 'Notes Remarks'
        },
        other_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Any other authority equivalent AD',
            title: 'Other Equivalent Ad Number'
        },
        reference_documentation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Key compliance references (AD, SB, AMP task, ICA, EO)',
            title: 'Reference Documentation'
        },
        regulatory_authority: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RegulatoryAuthority'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Authority issuing the AD'
        },
        state_of_design: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'State of Design of the product',
            title: 'State Of Design'
        },
        state_of_registry: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'State of Registry of the aircraft',
            title: 'State Of Registry'
        },
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Current compliance status'
        },
        status_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date from which the current status is valid',
            title: 'Status Effective Date'
        }
    },
    required: [
        'aircraft_id'
    ],
    title: 'AdComplianceHistoryCreate',
    type: 'object'
} as const;

export const AdComplianceHistoryPublicSchema = {
    properties: {
        ad_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Summary of AD purpose & requirements',
            title: 'Ad Description'
        },
        ad_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date the AD became effective / mandatory',
            title: 'Ad Effective Date'
        },
        ad_issue_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date the AD was originally issued',
            title: 'Ad Issue Date'
        },
        ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Official AD reference code issued by the authority',
            title: 'Ad Number'
        },
        ad_revision_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of latest AD revision',
            title: 'Ad Revision Date'
        },
        ad_revision_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Latest AD revision level',
            title: 'Ad Revision Number'
        },
        ad_title: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Official AD title or short description',
            title: 'Ad Title'
        },
        aircraft_association: {
            anyOf: [
                {
                    $ref: '#/components/schemas/app__aircraft__ad_compliance_history__schemas__AircraftAssociation'
                },
                {
                    type: 'null'
                }
            ],
            description: 'What part of the aircraft the AD relates to'
        },
        aircraft_id: {
            description: 'Internal unique ID of the aircraft',
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AdComplianceHistoryApplicabilityStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Applicability decision for this aircraft/assembly'
        },
        applicability_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Reason why AD applies or does not apply',
            title: 'Applicability Reason'
        },
        associated_equipment_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Identifier of affected engine/equipment/APU if applicable',
            title: 'Associated Equipment Id'
        },
        ata_chapter: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ATA chapter / sub-chapter reference',
            title: 'Ata Chapter'
        },
        casa_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'CASA equivalent AD number',
            title: 'Casa Equivalent Ad Number'
        },
        compliance_category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceCategory'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Whether compliance is one-time or recurring'
        },
        compliance_interval_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Human-readable compliance interval / threshold',
            title: 'Compliance Interval Description'
        },
        compliance_interval_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceIntervalType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Type of recurring interval'
        },
        compliance_interval_value: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Interval value (numeric for primary unit)',
            title: 'Compliance Interval Value'
        },
        compliance_method: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Primary method of compliance',
            title: 'Compliance Method'
        },
        compliance_record_reference: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Internal record(s) of compliance',
            title: 'Compliance Record Reference'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        easa_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'EASA equivalent AD number',
            title: 'Easa Equivalent Ad Number'
        },
        faa_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'FAA equivalent AD number',
            title: 'Faa Equivalent Ad Number'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_compliance_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of last compliance action',
            title: 'Last Compliance Date'
        },
        last_compliance_flight_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Aircraft/assembly flight cycles at last compliance',
            title: 'Last Compliance Flight Cycles'
        },
        last_compliance_flight_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Aircraft/assembly flight hours at last compliance',
            title: 'Last Compliance Flight Hours'
        },
        last_done: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Last maintenance or action completed to maintain compliance',
            title: 'Last Done'
        },
        next_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Calculated next due date where applicable',
            title: 'Next Due Date'
        },
        next_due_flight_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Calculated next due flight cycles',
            title: 'Next Due Flight Cycles'
        },
        next_due_flight_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Calculated next due flight hours',
            title: 'Next Due Flight Hours'
        },
        notes_remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Additional compliance notes',
            title: 'Notes Remarks'
        },
        other_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Any other authority equivalent AD',
            title: 'Other Equivalent Ad Number'
        },
        reference_documentation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Key compliance references (AD, SB, AMP task, ICA, EO)',
            title: 'Reference Documentation'
        },
        regulatory_authority: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RegulatoryAuthority'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Authority issuing the AD'
        },
        state_of_design: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'State of Design of the product',
            title: 'State Of Design'
        },
        state_of_registry: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'State of Registry of the aircraft',
            title: 'State Of Registry'
        },
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Current compliance status'
        },
        status_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date from which the current status is valid',
            title: 'Status Effective Date'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'aircraft_id',
        'id',
        'tenant_id',
        'created_at',
        'updated_at'
    ],
    title: 'AdComplianceHistoryPublic',
    type: 'object'
} as const;

export const AdComplianceHistoryUpdateSchema = {
    description: 'Update schema - all fields optional.',
    properties: {
        ad_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Description'
        },
        ad_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Effective Date'
        },
        ad_issue_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Issue Date'
        },
        ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Number'
        },
        ad_revision_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Revision Date'
        },
        ad_revision_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Revision Number'
        },
        ad_title: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Title'
        },
        aircraft_association: {
            anyOf: [
                {
                    $ref: '#/components/schemas/app__aircraft__ad_compliance_history__schemas__AircraftAssociation'
                },
                {
                    type: 'null'
                }
            ]
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AdComplianceHistoryApplicabilityStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        applicability_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicability Reason'
        },
        associated_equipment_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Associated Equipment Id'
        },
        ata_chapter: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        casa_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Casa Equivalent Ad Number'
        },
        compliance_category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceCategory'
                },
                {
                    type: 'null'
                }
            ]
        },
        compliance_interval_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Interval Description'
        },
        compliance_interval_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceIntervalType'
                },
                {
                    type: 'null'
                }
            ]
        },
        compliance_interval_value: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Interval Value'
        },
        compliance_method: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Method'
        },
        compliance_record_reference: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Record Reference'
        },
        easa_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Easa Equivalent Ad Number'
        },
        faa_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Faa Equivalent Ad Number'
        },
        last_compliance_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Compliance Date'
        },
        last_compliance_flight_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Compliance Flight Cycles'
        },
        last_compliance_flight_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Compliance Flight Hours'
        },
        last_done: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Done'
        },
        next_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next Due Date'
        },
        next_due_flight_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next Due Flight Cycles'
        },
        next_due_flight_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next Due Flight Hours'
        },
        notes_remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes Remarks'
        },
        other_equivalent_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Other Equivalent Ad Number'
        },
        reference_documentation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reference Documentation'
        },
        regulatory_authority: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RegulatoryAuthority'
                },
                {
                    type: 'null'
                }
            ]
        },
        state_of_design: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'State Of Design'
        },
        state_of_registry: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'State Of Registry'
        },
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        status_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Effective Date'
        }
    },
    title: 'AdComplianceHistoryUpdate',
    type: 'object'
} as const;

export const AdComplianceListPublicSchema = {
    description: 'List response for AD Compliance table.',
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/AdComplianceRow'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'AdComplianceListPublic',
    type: 'object'
} as const;

export const AdComplianceRowSchema = {
    description: 'A single row in the AD Compliance table (similar to SummaryReportRow).',
    properties: {
        accepted_at: {
            format: 'date-time',
            title: 'Accepted At',
            type: 'string'
        },
        accepted_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        accepted_by_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accepted By Name'
        },
        ad_number: {
            title: 'Ad Number',
            type: 'string'
        },
        aircraft_registration: {
            title: 'Aircraft Registration',
            type: 'string'
        },
        aircraft_serial_no: {
            title: 'Aircraft Serial No',
            type: 'string'
        },
        applicability: {
            enum: [
                'Y',
                'N'
            ],
            title: 'Applicability',
            type: 'string'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        due_date: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        recurrent: {
            enum: [
                'Y',
                'N'
            ],
            title: 'Recurrent',
            type: 'string'
        },
        regulatory_authority: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Regulatory Authority'
        },
        requirements: {
            title: 'Requirements',
            type: 'string'
        },
        trace_ad_eval_report_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Trace Ad Eval Report Id'
        },
        version: {
            title: 'Version',
            type: 'integer'
        }
    },
    required: [
        'id',
        'ad_number',
        'aircraft_serial_no',
        'aircraft_registration',
        'applicability',
        'description',
        'due_date',
        'requirements',
        'recurrent',
        'regulatory_authority',
        'accepted_at',
        'accepted_by_name',
        'accepted_by',
        'version',
        'trace_ad_eval_report_id'
    ],
    title: 'AdComplianceRow',
    type: 'object'
} as const;

export const AdRecordPublicMinimalSchema = {
    description: 'Minimal AD record information for display.',
    properties: {
        ad_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Number'
        },
        effective_date: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Effective Date'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        regulatory_authority: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Regulatory Authority'
        },
        subject: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subject'
        }
    },
    required: [
        'id'
    ],
    title: 'AdRecordPublicMinimal',
    type: 'object'
} as const;

export const AdditionalInfoSchema = {
    properties: {},
    title: 'AdditionalInfo',
    type: 'object'
} as const;

export const AdminPasswordResetSchema = {
    description: 'Schema for admin-initiated password reset',
    properties: {
        new_password: {
            maxLength: 128,
            minLength: 12,
            title: 'New Password',
            type: 'string'
        },
        notify_user: {
            default: true,
            description: 'Send notification if user has email',
            title: 'Notify User',
            type: 'boolean'
        },
        user_id: {
            format: 'uuid',
            title: 'User Id',
            type: 'string'
        }
    },
    required: [
        'user_id',
        'new_password'
    ],
    title: 'AdminPasswordReset',
    type: 'object'
} as const;

export const AircraftSchema = {
    properties: {
        manufacturer: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            maxLength: 255,
            title: 'Model',
            type: 'string'
        },
        registration_no: {
            maxLength: 255,
            title: 'Registration No',
            type: 'string'
        },
        serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial No'
        }
    },
    required: [
        'registration_no',
        'model'
    ],
    title: 'Aircraft',
    type: 'object'
} as const;

export const AircraftAgentCreateSchema = {
    properties: {
        manufacturer: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            examples: [
                'A320',
                'B737'
            ],
            maxLength: 255,
            title: 'Model',
            type: 'string'
        },
        registration_no: {
            maxLength: 255,
            title: 'Registration No',
            type: 'string'
        },
        serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial No'
        },
        submodel_variant: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            examples: [
                'A320-214',
                'B737-800'
            ],
            title: 'Submodel Variant'
        }
    },
    required: [
        'registration_no',
        'model'
    ],
    title: 'AircraftAgentCreate',
    type: 'object'
} as const;

export const AircraftApplicabilityCreateSchema = {
    properties: {
        subject: {
            const: 'aircraft',
            title: 'Subject',
            type: 'string'
        },
        type_certificate_model_variant_id: {
            format: 'uuid',
            title: 'Type Certificate Model Variant Id',
            type: 'string'
        }
    },
    required: [
        'subject',
        'type_certificate_model_variant_id'
    ],
    title: 'AircraftApplicabilityCreate',
    type: 'object'
} as const;

export const AircraftCreateSchema = {
    properties: {
        certification_date: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of initial certification of the aircraft',
            title: 'Certification Date'
        },
        data_source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftDataSource'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Origin of identification data'
        },
        data_source_reference: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'File/document reference of source (File ID / URL / archive ref)',
            title: 'Data Source Reference'
        },
        entry_into_service_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'First entry into operational service (YYYY-MM-DD)',
            title: 'Entry Into Service Date'
        },
        manufacturer: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            examples: [
                'A320',
                'B737'
            ],
            maxLength: 255,
            title: 'Model',
            type: 'string'
        },
        notes_remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Any additional configuration or registry notes',
            title: 'Notes Remarks'
        },
        operator: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Operator'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Operator of the aircraft'
        },
        planned_daily_cycles: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Cycles per day the operator plans to fly, for forecasts',
            title: 'Planned Daily Cycles'
        },
        planned_daily_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Flight hours per day the operator plans to fly, for forecasts',
            title: 'Planned Daily Hours'
        },
        registration_no: {
            maxLength: 255,
            title: 'Registration No',
            type: 'string'
        },
        serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial No'
        },
        state_of_design: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ICAO State of Design (e.g. USA for Boeing, EU for Airbus)',
            title: 'State Of Design'
        },
        state_of_registry: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ICAO State of Registry (e.g. UK, USA, EU)',
            title: 'State Of Registry'
        },
        submodel_variant: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            examples: [
                'A320-214',
                'B737-800'
            ],
            title: 'Submodel Variant'
        },
        vector_store_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Vector store id for the aircraft',
            title: 'Vector Store Id'
        }
    },
    required: [
        'registration_no',
        'model'
    ],
    title: 'AircraftCreate',
    type: 'object'
} as const;

export const AircraftDataSourceSchema = {
    description: 'Enum for aircraft data source origin.',
    enum: [
        'OEM_DATA',
        'REGISTRY_EXPORT',
        'AIRLINE_RECORDS',
        'CAMO_EXPORT',
        'LESSOR_RECORDS',
        'OTHER'
    ],
    title: 'AircraftDataSource',
    type: 'string'
} as const;

export const AircraftEnrolmentPublicSchema = {
    properties: {
        effective_from: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Effective From'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        programme: {
            $ref: '#/components/schemas/ProgrammePublic'
        }
    },
    required: [
        'id',
        'effective_from',
        'programme'
    ],
    title: 'AircraftEnrolmentPublic',
    type: 'object'
} as const;

export const AircraftEnrolmentsPublicSchema = {
    properties: {
        data: {
            items: {
                $ref: '#/components/schemas/AircraftEnrolmentPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data'
    ],
    title: 'AircraftEnrolmentsPublic',
    type: 'object'
} as const;

export const AircraftImportSchema = {
    additionalProperties: false,
    properties: {
        certification_date: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of initial certification of the aircraft',
            title: 'Certification Date'
        },
        data_source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftDataSource'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Origin of identification data'
        },
        data_source_reference: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'File/document reference of source (File ID / URL / archive ref)',
            title: 'Data Source Reference'
        },
        entry_into_service_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'First entry into operational service (YYYY-MM-DD)',
            title: 'Entry Into Service Date'
        },
        manufacturer: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            examples: [
                'A320',
                'B737'
            ],
            maxLength: 255,
            title: 'Model',
            type: 'string'
        },
        notes_remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Any additional configuration or registry notes',
            title: 'Notes Remarks'
        },
        operator: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Operator'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Operator of the aircraft'
        },
        planned_daily_cycles: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Cycles per day the operator plans to fly, for forecasts',
            title: 'Planned Daily Cycles'
        },
        planned_daily_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Flight hours per day the operator plans to fly, for forecasts',
            title: 'Planned Daily Hours'
        },
        registration_no: {
            maxLength: 255,
            title: 'Registration No',
            type: 'string'
        },
        serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial No'
        },
        state_of_design: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ICAO State of Design (e.g. USA for Boeing, EU for Airbus)',
            title: 'State Of Design'
        },
        state_of_registry: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ICAO State of Registry (e.g. UK, USA, EU)',
            title: 'State Of Registry'
        },
        submodel_variant: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            examples: [
                'A320-214',
                'B737-800'
            ],
            title: 'Submodel Variant'
        },
        total_flight_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Total Flight Hours'
        },
        total_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Total Landings'
        },
        utilisation_as_of: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Utilisation As Of'
        },
        vector_store_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Vector store id for the aircraft',
            title: 'Vector Store Id'
        }
    },
    required: [
        'registration_no',
        'model'
    ],
    title: 'AircraftImport',
    type: 'object'
} as const;

export const AircraftImportPayloadSchema = {
    additionalProperties: false,
    properties: {
        aircraft: {
            $ref: '#/components/schemas/AircraftImport'
        },
        fitted_components: {
            default: [],
            items: {
                $ref: '#/components/schemas/ImportedInstallation'
            },
            title: 'Fitted Components',
            type: 'array'
        },
        mod_status: {
            default: [],
            items: {
                $ref: '#/components/schemas/ModStatusCreate'
            },
            title: 'Mod Status',
            type: 'array'
        },
        tenant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Id'
        }
    },
    required: [
        'aircraft'
    ],
    title: 'AircraftImportPayload',
    type: 'object'
} as const;

export const AircraftImportResultSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        fitted_components_count: {
            title: 'Fitted Components Count',
            type: 'integer'
        },
        mod_status_count: {
            title: 'Mod Status Count',
            type: 'integer'
        }
    },
    required: [
        'aircraft_id',
        'fitted_components_count',
        'mod_status_count'
    ],
    title: 'AircraftImportResult',
    type: 'object'
} as const;

export const AircraftPublicSchema = {
    properties: {
        certification_date: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of initial certification of the aircraft',
            title: 'Certification Date'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        data_source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftDataSource'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Origin of identification data'
        },
        data_source_reference: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'File/document reference of source (File ID / URL / archive ref)',
            title: 'Data Source Reference'
        },
        entry_into_service_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'First entry into operational service (YYYY-MM-DD)',
            title: 'Entry Into Service Date'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        manufacturer: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            examples: [
                'A320',
                'B737'
            ],
            maxLength: 255,
            title: 'Model',
            type: 'string'
        },
        notes_remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Any additional configuration or registry notes',
            title: 'Notes Remarks'
        },
        operator: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Operator'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Operator of the aircraft'
        },
        pinned_forecast_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pinned Forecast Id'
        },
        planned_daily_cycles: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Cycles per day the operator plans to fly, for forecasts',
            title: 'Planned Daily Cycles'
        },
        planned_daily_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Flight hours per day the operator plans to fly, for forecasts',
            title: 'Planned Daily Hours'
        },
        registration_no: {
            maxLength: 255,
            title: 'Registration No',
            type: 'string'
        },
        serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial No'
        },
        state_of_design: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ICAO State of Design (e.g. USA for Boeing, EU for Airbus)',
            title: 'State Of Design'
        },
        state_of_registry: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ICAO State of Registry (e.g. UK, USA, EU)',
            title: 'State Of Registry'
        },
        submodel_variant: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            examples: [
                'A320-214',
                'B737-800'
            ],
            title: 'Submodel Variant'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        total_flight_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Latest airframe hours since new, from the utilization readings',
            title: 'Total Flight Hours'
        },
        total_flight_hours_as_of: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of the latest airframe hours reading',
            title: 'Total Flight Hours As Of'
        },
        total_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Latest airframe landings since new, from the utilization readings',
            title: 'Total Landings'
        },
        total_landings_as_of: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of the latest airframe landings reading',
            title: 'Total Landings As Of'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        vector_store_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Vector store id for the aircraft',
            title: 'Vector Store Id'
        }
    },
    required: [
        'registration_no',
        'model',
        'id',
        'tenant_id',
        'pinned_forecast_id',
        'created_at',
        'updated_at'
    ],
    title: 'AircraftPublic',
    type: 'object'
} as const;

export const AircraftRowPublicSchema = {
    properties: {
        certification_date: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of initial certification of the aircraft',
            title: 'Certification Date'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        data_source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftDataSource'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Origin of identification data'
        },
        data_source_reference: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'File/document reference of source (File ID / URL / archive ref)',
            title: 'Data Source Reference'
        },
        entry_into_service_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'First entry into operational service (YYYY-MM-DD)',
            title: 'Entry Into Service Date'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_changed_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ChangedBy'
                },
                {
                    type: 'null'
                }
            ]
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        manufacturer: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            examples: [
                'A320',
                'B737'
            ],
            maxLength: 255,
            title: 'Model',
            type: 'string'
        },
        notes_remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Any additional configuration or registry notes',
            title: 'Notes Remarks'
        },
        operator: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Operator'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Operator of the aircraft'
        },
        pinned_forecast_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pinned Forecast Id'
        },
        planned_daily_cycles: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Cycles per day the operator plans to fly, for forecasts',
            title: 'Planned Daily Cycles'
        },
        planned_daily_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Flight hours per day the operator plans to fly, for forecasts',
            title: 'Planned Daily Hours'
        },
        registration_no: {
            maxLength: 255,
            title: 'Registration No',
            type: 'string'
        },
        serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial No'
        },
        state_of_design: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ICAO State of Design (e.g. USA for Boeing, EU for Airbus)',
            title: 'State Of Design'
        },
        state_of_registry: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ICAO State of Registry (e.g. UK, USA, EU)',
            title: 'State Of Registry'
        },
        submodel_variant: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            examples: [
                'A320-214',
                'B737-800'
            ],
            title: 'Submodel Variant'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        total_flight_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Latest airframe hours since new, from the utilization readings',
            title: 'Total Flight Hours'
        },
        total_flight_hours_as_of: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of the latest airframe hours reading',
            title: 'Total Flight Hours As Of'
        },
        total_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Latest airframe landings since new, from the utilization readings',
            title: 'Total Landings'
        },
        total_landings_as_of: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date of the latest airframe landings reading',
            title: 'Total Landings As Of'
        },
        type_certificate_model_variant: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TypeCertificateModelVariantWithParentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        vector_store_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Vector store id for the aircraft',
            title: 'Vector Store Id'
        }
    },
    required: [
        'registration_no',
        'model',
        'id',
        'tenant_id',
        'pinned_forecast_id',
        'created_at',
        'updated_at',
        'last_modified_by',
        'type_certificate_model_variant'
    ],
    title: 'AircraftRowPublic',
    type: 'object'
} as const;

export const AircraftScopeSchema = {
    properties: {
        aircraft_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 200,
            minItems: 1,
            title: 'Aircraft Ids',
            type: 'array'
        },
        kind: {
            const: 'aircraft',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind',
        'aircraft_ids'
    ],
    title: 'AircraftScope',
    type: 'object'
} as const;

export const AircraftSubjectSchema = {
    properties: {
        kind: {
            const: 'aircraft',
            title: 'Kind',
            type: 'string'
        },
        type_certificate_model_variant_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Type Certificate Model Variant Ids',
            type: 'array'
        }
    },
    required: [
        'kind',
        'type_certificate_model_variant_ids'
    ],
    title: 'AircraftSubject',
    type: 'object'
} as const;

export const AircraftUpdateSchema = {
    description: 'Update schema - all fields optional.',
    properties: {
        certification_date: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certification Date'
        },
        data_source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftDataSource'
                },
                {
                    type: 'null'
                }
            ]
        },
        data_source_reference: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Data Source Reference'
        },
        entry_into_service_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Entry Into Service Date'
        },
        manufacturer: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            examples: [
                'A320',
                'B737'
            ],
            title: 'Model'
        },
        notes_remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes Remarks'
        },
        operator: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Operator'
                },
                {
                    type: 'null'
                }
            ]
        },
        planned_daily_cycles: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Daily Cycles'
        },
        planned_daily_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Daily Hours'
        },
        registration_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Registration No'
        },
        serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial No'
        },
        state_of_design: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'State Of Design'
        },
        state_of_registry: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'State Of Registry'
        },
        submodel_variant: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            examples: [
                'A320-214',
                'B737-800'
            ],
            title: 'Submodel Variant'
        },
        vector_store_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vector Store Id'
        }
    },
    title: 'AircraftUpdate',
    type: 'object'
} as const;

export const AircraftUsagePublicSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        cycles: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cycles'
        },
        daily_cycles: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Daily Cycles'
        },
        daily_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Daily Hours'
        },
        daily_landings: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Daily Landings'
        },
        hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours'
        },
        landings: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landings'
        },
        model: {
            title: 'Model',
            type: 'string'
        },
        rate_source: {
            $ref: '#/components/schemas/RateSource'
        },
        registration: {
            title: 'Registration',
            type: 'string'
        }
    },
    required: [
        'aircraft_id',
        'registration',
        'model',
        'hours',
        'cycles',
        'landings',
        'daily_hours',
        'daily_cycles',
        'daily_landings',
        'rate_source'
    ],
    title: 'AircraftUsagePublic',
    type: 'object'
} as const;

export const AircraftsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/AircraftRowPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'AircraftsPublic',
    type: 'object'
} as const;

export const AirworthinessDirectiveFiltersSchema = {
    properties: {
        effective_date: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DateRange'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Bounds the date the directive came into effect.'
        },
        emergency: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            description: 'True for emergency directives only, false to leave them out.',
            title: 'Emergency'
        },
        issued_by: {
            default: [],
            description: 'Abbreviations of the authority that issued the directive.',
            items: {
                enum: [
                    'AAC CD',
                    'AAC PA',
                    'AAC RM',
                    'AAC SV',
                    'AACM',
                    'AACR',
                    'AAN',
                    'ACAA',
                    'AESA',
                    'ANAC AR',
                    'ANAC BR',
                    'ANAC CI',
                    'ANAC DJ',
                    'ANAC GA',
                    'ANAC GN',
                    'ANAC ML',
                    'ANAC MR',
                    'ANAC Niger',
                    'ANAC PT',
                    'ANAC Senegal',
                    'ANAC Togo',
                    'ASECNA',
                    'BHDCA',
                    'CAA AL',
                    'CAA BG',
                    'CAA BH',
                    'CAA CR',
                    'CAA LT',
                    'CAA LV',
                    'CAA LY',
                    'CAA MK',
                    'CAA MNE',
                    'CAA MV',
                    'CAA NO',
                    'CAA NZ',
                    'CAA Pakistan',
                    'CAA QA',
                    'CAA RT',
                    'CAA SI',
                    'CAA SL',
                    'CAA SR',
                    'CAA TW',
                    'CAA UK',
                    'CAA Uganda',
                    'CAAB BD',
                    'CAAB BW',
                    'CAAC',
                    'CAAE',
                    'CAAF',
                    'CAAH',
                    'CAAI',
                    'CAAM MN',
                    'CAAM MW',
                    'CAAM MY',
                    'CAAN',
                    'CAAP',
                    'CAAS',
                    'CAASI',
                    'CAAT',
                    'CAAV VN',
                    'CAAV VU',
                    'CAAZ ZM',
                    'CAAZ ZW',
                    'CAD HK',
                    'CAD MT',
                    'CAD RS',
                    'CAMA',
                    'CAO.IRI',
                    'CARC',
                    'CASA',
                    'CASA PNG',
                    'CASAS',
                    'CCAA',
                    'DAC',
                    'DCA BN',
                    'DCA CY',
                    'DCA LA',
                    'DCA MM',
                    'DGAC BO',
                    'DGAC CL',
                    'DGAC CR',
                    'DGAC DZ',
                    'DGAC EC',
                    'DGAC FR',
                    'DGAC GT',
                    'DGAC HN',
                    'DGAC MX',
                    'DGAC PE',
                    'DGAC TN',
                    'DGCA ID',
                    'DGCA IN',
                    'DGCA KW',
                    'DGCA LB',
                    'DGCA TR',
                    'DGTA/DGLV',
                    'DINAC',
                    'DINACIA',
                    'EASA',
                    'ECAA EE',
                    'ECAA EG',
                    'ECAA ET',
                    'ENAC',
                    'FAA',
                    'FOCA',
                    'GACA',
                    'GCAA AE',
                    'GCAA GE',
                    'GCAA GH',
                    'GCAA GM',
                    'GDCA',
                    'HCAA',
                    'IAA',
                    'IACC',
                    'ICAA',
                    'ICETRA',
                    'IDAC',
                    'ILT',
                    'INAC NI',
                    'INAC VE',
                    'INAVIC',
                    'JCAA',
                    'JCAB',
                    'KCAA KE',
                    'KCAA KR',
                    'LBA',
                    'LCAA LR',
                    'LCAA LS',
                    'MAA',
                    'MCA',
                    'Ministry of Transport and Communications',
                    'MoIC',
                    'NCAA NA',
                    'NCAA NG',
                    'OACM',
                    'OCA',
                    'ONDA',
                    'PACA',
                    'RCAA',
                    'Rosaviation',
                    'SAA',
                    'SAAU',
                    'SACA',
                    'SACAA',
                    'SCAA AZ',
                    'SCAA SC',
                    'SCAA SD',
                    'SCAA SY',
                    'SCAST',
                    'SLCAA LC',
                    'SLCAA SL',
                    'SMCAA',
                    'SSCA',
                    'SSCAA',
                    'TCAA',
                    'TCCA',
                    'TTCAA',
                    'Traficom',
                    'Transportstyrelsen',
                    'UAEAC',
                    'ULC',
                    'UzCAA'
                ],
                type: 'string'
            },
            title: 'Issued By',
            type: 'array'
        }
    },
    title: 'AirworthinessDirectiveFilters',
    type: 'object'
} as const;

export const AnchorKindSchema = {
    enum: [
        'new',
        'last_done'
    ],
    title: 'AnchorKind',
    type: 'string'
} as const;

export const ApplicabilityStatusSchema = {
    description: 'AD applicability status for aircraft.',
    enum: [
        'APPLICABLE',
        'NOT_APPLICABLE',
        'UNKNOWN'
    ],
    title: 'ApplicabilityStatus',
    type: 'string'
} as const;

export const ApplySquawkSuggestionSchema = {
    properties: {
        option: {
            minLength: 1,
            title: 'Option',
            type: 'string'
        },
        question: {
            minLength: 1,
            title: 'Question',
            type: 'string'
        }
    },
    required: [
        'question',
        'option'
    ],
    title: 'ApplySquawkSuggestion',
    type: 'object'
} as const;

export const ApplyTemplateSchema = {
    properties: {
        canned_work_task_id: {
            format: 'uuid',
            title: 'Canned Work Task Id',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'apply_template',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id',
        'canned_work_task_id'
    ],
    title: 'ApplyTemplate',
    type: 'object'
} as const;

export const ApprovalAnyOfConditionSchema = {
    additionalProperties: false,
    properties: {
        field: {
            $ref: '#/components/schemas/ApprovalConditionField'
        },
        op: {
            const: 'is_any_of',
            title: 'Op',
            type: 'string'
        },
        value: {
            items: {
                type: 'string'
            },
            title: 'Value',
            type: 'array'
        }
    },
    required: [
        'field',
        'op',
        'value'
    ],
    title: 'ApprovalAnyOfCondition',
    type: 'object'
} as const;

export const ApprovalAudienceDocumentSchema = {
    discriminator: {
        mapping: {
            customer_contact: '#/components/schemas/CustomerContactAudience',
            department: '#/components/schemas/DepartmentAudience',
            facility: '#/components/schemas/FacilityAudience',
            permission: '#/components/schemas/PermissionAudience',
            person: '#/components/schemas/PersonAudience',
            position: '#/components/schemas/PositionAudience',
            record_role: '#/components/schemas/ApprovalRecordRoleAudience',
            relative_position: '#/components/schemas/RelativePositionAudience',
            role: '#/components/schemas/RoleAudience',
            team: '#/components/schemas/TeamAudience'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/PersonAudience'
        },
        {
            $ref: '#/components/schemas/PositionAudience'
        },
        {
            $ref: '#/components/schemas/TeamAudience'
        },
        {
            $ref: '#/components/schemas/DepartmentAudience'
        },
        {
            $ref: '#/components/schemas/FacilityAudience'
        },
        {
            $ref: '#/components/schemas/RoleAudience'
        },
        {
            $ref: '#/components/schemas/PermissionAudience'
        },
        {
            $ref: '#/components/schemas/ApprovalRecordRoleAudience'
        },
        {
            $ref: '#/components/schemas/RelativePositionAudience'
        },
        {
            $ref: '#/components/schemas/CustomerContactAudience'
        }
    ]
} as const;

export const ApprovalChoiceValueSchema = {
    properties: {
        choices: {
            items: {
                type: 'string'
            },
            title: 'Choices',
            type: 'array'
        },
        kind: {
            const: 'choice',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind',
        'choices'
    ],
    title: 'ApprovalChoiceValue',
    type: 'object'
} as const;

export const ApprovalConditionFieldSchema = {
    enum: [
        'work_package',
        'customer',
        'aircraft',
        'department',
        'facility',
        'severity',
        'requester_team'
    ],
    title: 'ApprovalConditionField',
    type: 'string'
} as const;

export const ApprovalConditionReferenceSchema = {
    properties: {
        field: {
            $ref: '#/components/schemas/ApprovalConditionField'
        },
        value: {
            $ref: '#/components/schemas/ApprovalConditionValue'
        }
    },
    required: [
        'field',
        'value'
    ],
    title: 'ApprovalConditionReference',
    type: 'object'
} as const;

export const ApprovalConditionValueSchema = {
    discriminator: {
        mapping: {
            choice: '#/components/schemas/ApprovalChoiceValue',
            id: '#/components/schemas/ApprovalIdValue'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/ApprovalChoiceValue'
        },
        {
            $ref: '#/components/schemas/ApprovalIdValue'
        }
    ]
} as const;

export const ApprovalDecisionPublicSchema = {
    properties: {
        comment: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Comment'
        },
        customer_contact: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerContactPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        decided_at: {
            format: 'date-time',
            title: 'Decided At',
            type: 'string'
        },
        decided_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        revokes_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revokes Id'
        },
        step_id: {
            format: 'uuid',
            title: 'Step Id',
            type: 'string'
        },
        verdict: {
            $ref: '#/components/schemas/ApprovalVerdict'
        }
    },
    required: [
        'id',
        'step_id',
        'verdict',
        'comment',
        'decided_at',
        'decided_by',
        'customer_contact',
        'revokes_id'
    ],
    title: 'ApprovalDecisionPublic',
    type: 'object'
} as const;

export const ApprovalEqualsConditionSchema = {
    additionalProperties: false,
    properties: {
        field: {
            $ref: '#/components/schemas/ApprovalConditionField'
        },
        op: {
            enum: [
                'is',
                'is_not'
            ],
            title: 'Op',
            type: 'string'
        },
        value: {
            title: 'Value',
            type: 'string'
        }
    },
    required: [
        'field',
        'op',
        'value'
    ],
    title: 'ApprovalEqualsCondition',
    type: 'object'
} as const;

export const ApprovalIdValueSchema = {
    properties: {
        found_in: {
            title: 'Found In',
            type: 'string'
        },
        kind: {
            const: 'id',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind',
        'found_in'
    ],
    title: 'ApprovalIdValue',
    type: 'object'
} as const;

export const ApprovalIsSetConditionSchema = {
    additionalProperties: false,
    properties: {
        field: {
            $ref: '#/components/schemas/ApprovalConditionField'
        },
        op: {
            const: 'is_set',
            title: 'Op',
            type: 'string'
        },
        value: {
            title: 'Value',
            type: 'boolean'
        }
    },
    required: [
        'field',
        'op',
        'value'
    ],
    title: 'ApprovalIsSetCondition',
    type: 'object'
} as const;

export const ApprovalMinimumReferenceSchema = {
    properties: {
        excludes_earlier_approvers: {
            title: 'Excludes Earlier Approvers',
            type: 'boolean'
        },
        excludes_requester: {
            title: 'Excludes Requester',
            type: 'boolean'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        only_when_required: {
            title: 'Only When Required',
            type: 'boolean'
        },
        party: {
            $ref: '#/components/schemas/ApprovalParty'
        },
        permission: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Permission'
        },
        required_approvals: {
            title: 'Required Approvals',
            type: 'integer'
        },
        required_contact_role: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApprovalRecordRole'
                },
                {
                    type: 'null'
                }
            ]
        },
        requirement: {
            $ref: '#/components/schemas/ApprovalRequirement'
        }
    },
    required: [
        'requirement',
        'name',
        'party',
        'permission',
        'required_approvals',
        'excludes_requester',
        'excludes_earlier_approvers',
        'required_contact_role',
        'only_when_required'
    ],
    title: 'ApprovalMinimumReference',
    type: 'object'
} as const;

export const ApprovalPartySchema = {
    enum: [
        'staff',
        'customer'
    ],
    title: 'ApprovalParty',
    type: 'string'
} as const;

export const ApprovalPolicyConditionSchema = {
    discriminator: {
        mapping: {
            is: '#/components/schemas/ApprovalEqualsCondition',
            is_any_of: '#/components/schemas/ApprovalAnyOfCondition',
            is_not: '#/components/schemas/ApprovalEqualsCondition',
            is_set: '#/components/schemas/ApprovalIsSetCondition'
        },
        propertyName: 'op'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/ApprovalEqualsCondition'
        },
        {
            $ref: '#/components/schemas/ApprovalAnyOfCondition'
        },
        {
            $ref: '#/components/schemas/ApprovalIsSetCondition'
        }
    ]
} as const;

export const ApprovalPolicyCreateSchema = {
    additionalProperties: false,
    properties: {
        conditions: {
            default: [],
            items: {
                $ref: '#/components/schemas/ApprovalPolicyCondition'
            },
            maxItems: 20,
            title: 'Conditions',
            type: 'array'
        },
        is_enabled: {
            default: true,
            title: 'Is Enabled',
            type: 'boolean'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        steps: {
            items: {
                $ref: '#/components/schemas/ApprovalStepDocument'
            },
            maxItems: 20,
            minItems: 1,
            title: 'Steps',
            type: 'array'
        },
        subject: {
            $ref: '#/components/schemas/ApprovalSubject'
        }
    },
    required: [
        'name',
        'subject',
        'steps'
    ],
    title: 'ApprovalPolicyCreate',
    type: 'object'
} as const;

export const ApprovalPolicyDocumentSchema = {
    additionalProperties: false,
    properties: {
        conditions: {
            default: [],
            description: 'Every condition must hold. The reference lists each record type\'s conditions and the exact values to write.',
            items: {
                $ref: '#/components/schemas/ApprovalPolicyCondition'
            },
            title: 'Conditions',
            type: 'array'
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Leave out for a new policy. Keep it on an existing policy; a policy missing from the set is removed.',
            title: 'Id'
        },
        is_default: {
            default: false,
            description: 'Set on each record type\'s built-in policy only. Leave it as it is.',
            title: 'Is Default',
            type: 'boolean'
        },
        is_enabled: {
            default: true,
            title: 'Is Enabled',
            type: 'boolean'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        priority: {
            default: 0,
            description: 'The lowest priority whose conditions all hold is used. The default policy is used when none do.',
            maximum: 32767,
            minimum: 0,
            title: 'Priority',
            type: 'integer'
        },
        steps: {
            description: 'Approved in this order.',
            items: {
                $ref: '#/components/schemas/ApprovalStepDocument'
            },
            minItems: 1,
            title: 'Steps',
            type: 'array'
        },
        subject: {
            $ref: '#/components/schemas/ApprovalSubject'
        }
    },
    required: [
        'name',
        'subject',
        'steps'
    ],
    title: 'ApprovalPolicyDocument',
    type: 'object'
} as const;

export const ApprovalPolicyOptionsSchema = {
    properties: {
        departments: {
            items: {
                $ref: '#/components/schemas/DepartmentReference'
            },
            title: 'Departments',
            type: 'array'
        },
        facilities: {
            items: {
                $ref: '#/components/schemas/FacilityReference'
            },
            title: 'Facilities',
            type: 'array'
        },
        permissions: {
            items: {
                type: 'string'
            },
            title: 'Permissions',
            type: 'array'
        },
        positions: {
            items: {
                $ref: '#/components/schemas/PositionReference'
            },
            title: 'Positions',
            type: 'array'
        },
        roles: {
            items: {
                $ref: '#/components/schemas/RoleReference'
            },
            title: 'Roles',
            type: 'array'
        },
        subjects: {
            items: {
                $ref: '#/components/schemas/ApprovalSubjectReference'
            },
            title: 'Subjects',
            type: 'array'
        },
        teams: {
            items: {
                $ref: '#/components/schemas/TeamReference'
            },
            title: 'Teams',
            type: 'array'
        },
        users: {
            items: {
                $ref: '#/components/schemas/UserReference'
            },
            title: 'Users',
            type: 'array'
        }
    },
    required: [
        'subjects',
        'teams',
        'departments',
        'facilities',
        'roles',
        'positions',
        'users',
        'permissions'
    ],
    title: 'ApprovalPolicyOptions',
    type: 'object'
} as const;

export const ApprovalPolicyOrderSchema = {
    additionalProperties: false,
    properties: {
        policy_ids: {
            description: 'Every custom policy of the subject, in the order they are checked.',
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 100,
            title: 'Policy Ids',
            type: 'array'
        },
        subject: {
            $ref: '#/components/schemas/ApprovalSubject'
        }
    },
    required: [
        'subject',
        'policy_ids'
    ],
    title: 'ApprovalPolicyOrder',
    type: 'object'
} as const;

export const ApprovalPolicyPublicSchema = {
    properties: {
        policy: {
            $ref: '#/components/schemas/ApprovalPolicyDocument'
        },
        step_rules: {
            description: 'What the engine applies to each step, in step order: the step\'s own settings joined with the record type\'s minimum.',
            items: {
                $ref: '#/components/schemas/ApprovalStepRulesPublic'
            },
            title: 'Step Rules',
            type: 'array'
        }
    },
    required: [
        'policy',
        'step_rules'
    ],
    title: 'ApprovalPolicyPublic',
    type: 'object'
} as const;

export const ApprovalPolicyReferenceSchema = {
    properties: {
        departments: {
            items: {
                $ref: '#/components/schemas/DepartmentReference'
            },
            title: 'Departments',
            type: 'array'
        },
        facilities: {
            items: {
                $ref: '#/components/schemas/FacilityReference'
            },
            title: 'Facilities',
            type: 'array'
        },
        json_schema: {
            $ref: '#/components/schemas/JsonValue'
        },
        permissions: {
            items: {
                type: 'string'
            },
            title: 'Permissions',
            type: 'array'
        },
        positions: {
            items: {
                $ref: '#/components/schemas/PositionReference'
            },
            title: 'Positions',
            type: 'array'
        },
        roles: {
            items: {
                $ref: '#/components/schemas/RoleReference'
            },
            title: 'Roles',
            type: 'array'
        },
        subjects: {
            items: {
                $ref: '#/components/schemas/ApprovalSubjectReference'
            },
            title: 'Subjects',
            type: 'array'
        },
        teams: {
            items: {
                $ref: '#/components/schemas/TeamReference'
            },
            title: 'Teams',
            type: 'array'
        },
        users: {
            items: {
                $ref: '#/components/schemas/UserReference'
            },
            title: 'Users',
            type: 'array'
        }
    },
    required: [
        'subjects',
        'teams',
        'departments',
        'facilities',
        'roles',
        'positions',
        'users',
        'permissions',
        'json_schema'
    ],
    title: 'ApprovalPolicyReference',
    type: 'object'
} as const;

export const ApprovalPolicySetSchema = {
    additionalProperties: false,
    properties: {
        policies: {
            items: {
                $ref: '#/components/schemas/ApprovalPolicyDocument'
            },
            title: 'Policies',
            type: 'array'
        }
    },
    required: [
        'policies'
    ],
    title: 'ApprovalPolicySet',
    type: 'object'
} as const;

export const ApprovalPolicySetPublicSchema = {
    properties: {
        names: {
            additionalProperties: {
                type: 'string'
            },
            propertyNames: {
                format: 'uuid'
            },
            title: 'Names',
            type: 'object'
        },
        policies: {
            items: {
                $ref: '#/components/schemas/ApprovalPolicyPublic'
            },
            title: 'Policies',
            type: 'array'
        }
    },
    required: [
        'policies',
        'names'
    ],
    title: 'ApprovalPolicySetPublic',
    type: 'object'
} as const;

export const ApprovalPolicySetUpdateSchema = {
    properties: {
        document: {
            title: 'Document',
            type: 'string'
        }
    },
    required: [
        'document'
    ],
    title: 'ApprovalPolicySetUpdate',
    type: 'object'
} as const;

export const ApprovalPolicyUpdateSchema = {
    additionalProperties: false,
    properties: {
        conditions: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/ApprovalPolicyCondition'
                    },
                    maxItems: 20,
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Conditions'
        },
        is_enabled: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Enabled'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        steps: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/ApprovalStepDocument'
                    },
                    maxItems: 20,
                    minItems: 1,
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Steps'
        }
    },
    title: 'ApprovalPolicyUpdate',
    type: 'object'
} as const;

export const ApprovalProgressPublicSchema = {
    properties: {
        can_sign: {
            title: 'Can Sign',
            type: 'boolean'
        },
        done: {
            title: 'Done',
            type: 'integer'
        },
        required: {
            title: 'Required',
            type: 'integer'
        }
    },
    required: [
        'done',
        'required',
        'can_sign'
    ],
    title: 'ApprovalProgressPublic',
    type: 'object'
} as const;

export const ApprovalRecordRoleSchema = {
    enum: [
        'assigned_reviewers',
        'lead_technician',
        'inspector',
        'customer_contacts',
        'approval_contact'
    ],
    title: 'ApprovalRecordRole',
    type: 'string'
} as const;

export const ApprovalRecordRoleAudienceSchema = {
    additionalProperties: false,
    properties: {
        kind: {
            const: 'record_role',
            title: 'Kind',
            type: 'string'
        },
        record_role: {
            $ref: '#/components/schemas/ApprovalRecordRole'
        }
    },
    required: [
        'kind',
        'record_role'
    ],
    title: 'ApprovalRecordRoleAudience',
    type: 'object'
} as const;

export const ApprovalRequestPublicSchema = {
    properties: {
        completed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Completed At'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        decisions: {
            items: {
                $ref: '#/components/schemas/ApprovalDecisionPublic'
            },
            title: 'Decisions',
            type: 'array'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        requested_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        squawk_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Squawk Id'
        },
        status: {
            $ref: '#/components/schemas/ApprovalRequestStatus'
        },
        steps: {
            items: {
                $ref: '#/components/schemas/ApprovalStepPublic'
            },
            title: 'Steps',
            type: 'array'
        },
        subject: {
            $ref: '#/components/schemas/ApprovalSubject'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    required: [
        'id',
        'subject',
        'status',
        'work_task_id',
        'work_task_step_id',
        'quote_task_id',
        'squawk_id',
        'requested_by',
        'created_at',
        'completed_at',
        'steps',
        'decisions'
    ],
    title: 'ApprovalRequestPublic',
    type: 'object'
} as const;

export const ApprovalRequestStatusSchema = {
    enum: [
        'pending',
        'approved',
        'rejected',
        'withdrawn',
        'superseded'
    ],
    title: 'ApprovalRequestStatus',
    type: 'string'
} as const;

export const ApprovalRequestsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ApprovalRequestPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ApprovalRequestsPublic',
    type: 'object'
} as const;

export const ApprovalRequirementSchema = {
    enum: [
        'technician',
        'inspector',
        'reviewer',
        'verifier',
        'customer'
    ],
    title: 'ApprovalRequirement',
    type: 'string'
} as const;

export const ApprovalStepDocumentSchema = {
    additionalProperties: false,
    properties: {
        audiences: {
            default: [],
            description: 'Who may approve this step. Empty means anyone of the step\'s party. A step from the minimum still needs the minimum\'s permission.',
            items: {
                $ref: '#/components/schemas/ApprovalAudienceDocument'
            },
            title: 'Audiences',
            type: 'array'
        },
        excludes_earlier_approvers: {
            default: false,
            title: 'Excludes Earlier Approvers',
            type: 'boolean'
        },
        excludes_requester: {
            default: false,
            title: 'Excludes Requester',
            type: 'boolean'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        party: {
            $ref: '#/components/schemas/ApprovalParty'
        },
        required_approvals: {
            default: 1,
            maximum: 32767,
            minimum: 1,
            title: 'Required Approvals',
            type: 'integer'
        },
        requirement: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApprovalRequirement'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Set it on the steps that meet the record type\'s minimum from the reference. Leave it out on extra steps.'
        }
    },
    required: [
        'name',
        'party'
    ],
    title: 'ApprovalStepDocument',
    type: 'object'
} as const;

export const ApprovalStepPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        },
        required_approvals: {
            title: 'Required Approvals',
            type: 'integer'
        },
        requirement: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApprovalRequirement'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'id',
        'name',
        'position',
        'requirement',
        'required_approvals'
    ],
    title: 'ApprovalStepPublic',
    type: 'object'
} as const;

export const ApprovalStepRulesPublicSchema = {
    properties: {
        excludes_earlier_approvers: {
            title: 'Excludes Earlier Approvers',
            type: 'boolean'
        },
        excludes_requester: {
            title: 'Excludes Requester',
            type: 'boolean'
        },
        only_when_required: {
            title: 'Only When Required',
            type: 'boolean'
        },
        permission: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Permission'
        },
        required_approvals: {
            title: 'Required Approvals',
            type: 'integer'
        },
        required_contact_role: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApprovalRecordRole'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'required_approvals',
        'permission',
        'excludes_requester',
        'excludes_earlier_approvers',
        'required_contact_role',
        'only_when_required'
    ],
    title: 'ApprovalStepRulesPublic',
    type: 'object'
} as const;

export const ApprovalSubjectSchema = {
    enum: [
        'work_task',
        'work_task_step',
        'quote_task_review',
        'quote_task_customer',
        'squawk_review',
        'squawk_verify',
        'canned_work_task_version'
    ],
    title: 'ApprovalSubject',
    type: 'string'
} as const;

export const ApprovalSubjectReferenceSchema = {
    properties: {
        conditions: {
            items: {
                $ref: '#/components/schemas/ApprovalConditionReference'
            },
            title: 'Conditions',
            type: 'array'
        },
        contact_roles: {
            items: {
                $ref: '#/components/schemas/ApprovalRecordRole'
            },
            title: 'Contact Roles',
            type: 'array'
        },
        minimum: {
            items: {
                $ref: '#/components/schemas/ApprovalMinimumReference'
            },
            title: 'Minimum',
            type: 'array'
        },
        subject: {
            $ref: '#/components/schemas/ApprovalSubject'
        },
        user_roles: {
            items: {
                $ref: '#/components/schemas/ApprovalRecordRole'
            },
            title: 'User Roles',
            type: 'array'
        }
    },
    required: [
        'subject',
        'minimum',
        'user_roles',
        'contact_roles',
        'conditions'
    ],
    title: 'ApprovalSubjectReference',
    type: 'object'
} as const;

export const ApprovalVerdictSchema = {
    enum: [
        'approved',
        'rejected',
        'changes_requested',
        'revoked'
    ],
    title: 'ApprovalVerdict',
    type: 'string'
} as const;

export const ApprovedVendorBulkDeletePublicSchema = {
    properties: {
        deleted: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Deleted',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'deleted',
        'skipped'
    ],
    title: 'ApprovedVendorBulkDeletePublic',
    type: 'object'
} as const;

export const ApprovedVendorBulkIdsSchema = {
    properties: {
        vendor_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 500,
            minItems: 1,
            title: 'Vendor Ids',
            type: 'array'
        }
    },
    required: [
        'vendor_ids'
    ],
    title: 'ApprovedVendorBulkIds',
    type: 'object'
} as const;

export const ApprovedVendorCreateSchema = {
    properties: {
        address: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address'
        },
        approvals: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/VendorApproval'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approvals'
        },
        approved_locations: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approved Locations'
        },
        country: {
            anyOf: [
                {
                    maxLength: 2,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        external_ref: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ref'
        },
        name: {
            maxLength: 255,
            title: 'Name',
            type: 'string'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        status: {
            $ref: '#/components/schemas/VendorStatus',
            default: 'active'
        }
    },
    required: [
        'name'
    ],
    title: 'ApprovedVendorCreate',
    type: 'object'
} as const;

export const ApprovedVendorPublicSchema = {
    properties: {
        address: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address'
        },
        approvals: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/VendorApproval'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approvals'
        },
        approved_locations: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approved Locations'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        country: {
            anyOf: [
                {
                    maxLength: 2,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        external_ref: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ref'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_expired: {
            default: false,
            title: 'Is Expired',
            type: 'boolean'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            maxLength: 255,
            title: 'Name',
            type: 'string'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        status: {
            $ref: '#/components/schemas/VendorStatus'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'name',
        'status',
        'id',
        'tenant_id',
        'created_at',
        'updated_at'
    ],
    title: 'ApprovedVendorPublic',
    type: 'object'
} as const;

export const ApprovedVendorUpdateSchema = {
    properties: {
        address: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address'
        },
        approvals: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/VendorApproval'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approvals'
        },
        approved_locations: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approved Locations'
        },
        country: {
            anyOf: [
                {
                    maxLength: 2,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        external_ref: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ref'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/VendorStatus'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    title: 'ApprovedVendorUpdate',
    type: 'object'
} as const;

export const ApprovedVendorsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ApprovedVendorPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ApprovedVendorsPublic',
    type: 'object'
} as const;

export const ArchetypeNameSchema = {
    enum: [
        'airworthiness_directive',
        'technical_publication',
        'service_bulletin',
        'ica',
        'due_list',
        'other'
    ],
    title: 'ArchetypeName',
    type: 'string'
} as const;

export const AssignWorkTasksSchema = {
    properties: {
        assignee_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Assignee Id'
        },
        ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Ids',
            type: 'array'
        }
    },
    required: [
        'ids',
        'assignee_id'
    ],
    title: 'AssignWorkTasks',
    type: 'object'
} as const;

export const AtaChapterPublicSchema = {
    properties: {
        chapter: {
            title: 'Chapter',
            type: 'integer'
        },
        section: {
            title: 'Section',
            type: 'string'
        },
        title: {
            title: 'Title',
            type: 'string'
        }
    },
    required: [
        'chapter',
        'title',
        'section'
    ],
    title: 'AtaChapterPublic',
    type: 'object'
} as const;

export const AtlCertificationPublicSchema = {
    properties: {
        approval_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certified_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified On'
        },
        certifier: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        limitations: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Limitations'
        }
    },
    required: [
        'id',
        'certified_on',
        'certified_at',
        'certifier',
        'approval_reference',
        'limitations'
    ],
    title: 'AtlCertificationPublic',
    type: 'object'
} as const;

export const AtlCheckDetailPublicSchema = {
    properties: {
        certification: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlCertificationPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        check_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Check Name'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        ordinal: {
            title: 'Ordinal',
            type: 'integer'
        },
        programme_check_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Programme Check Id'
        },
        station_code: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Station Code'
        }
    },
    required: [
        'id',
        'ordinal',
        'check_name',
        'station_code',
        'programme_check_id',
        'certification'
    ],
    title: 'AtlCheckDetailPublic',
    type: 'object'
} as const;

export const AtlCheckEntrySchema = {
    properties: {
        approval_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certified_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified On'
        },
        certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        check_name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Check Name'
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        station_code: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Station Code'
        }
    },
    required: [
        'check_name',
        'station_code',
        'certifier',
        'certified_on',
        'certified_at',
        'approval_reference'
    ],
    title: 'AtlCheckEntry',
    type: 'object'
} as const;

export const AtlComponentChangeEntrySchema = {
    properties: {
        component_name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Component Name'
        },
        defect_index: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Defect Index'
        },
        form1_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Form1 Reference'
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        part_number_off: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number Off'
        },
        part_number_on: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number On'
        },
        removal_note: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Removal Note'
        },
        serial_number_off: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number Off'
        },
        serial_number_on: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number On'
        },
        tag_number_off: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tag Number Off'
        },
        tag_number_on: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tag Number On'
        }
    },
    required: [
        'defect_index',
        'component_name',
        'part_number_off',
        'serial_number_off',
        'tag_number_off',
        'part_number_on',
        'serial_number_on',
        'tag_number_on',
        'form1_reference',
        'removal_note'
    ],
    title: 'AtlComponentChangeEntry',
    type: 'object'
} as const;

export const AtlComponentChangePublicSchema = {
    properties: {
        component_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Component Name'
        },
        defect_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Defect Id'
        },
        form1_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Form1 Reference'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        installed_part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Part Instance Id'
        },
        ordinal: {
            title: 'Ordinal',
            type: 'integer'
        },
        part_number_off: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number Off'
        },
        part_number_on: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number On'
        },
        removal_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Removal Note'
        },
        removed_part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Removed Part Instance Id'
        },
        serial_number_off: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number Off'
        },
        serial_number_on: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number On'
        },
        tag_number_off: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tag Number Off'
        },
        tag_number_on: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tag Number On'
        }
    },
    required: [
        'id',
        'ordinal',
        'defect_id',
        'component_name',
        'part_number_off',
        'serial_number_off',
        'tag_number_off',
        'part_number_on',
        'serial_number_on',
        'tag_number_on',
        'form1_reference',
        'removal_note',
        'removed_part_instance_id',
        'installed_part_instance_id'
    ],
    title: 'AtlComponentChangePublic',
    type: 'object'
} as const;

export const AtlDefectDetailPublicSchema = {
    properties: {
        accomplished_iaw: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accomplished Iaw'
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        certification: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlCertificationPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        complaint_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Complaint Number'
        },
        corrective_action: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corrective Action'
        },
        deferred_defect: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDeferredDefectDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        disposition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDefectDisposition'
                },
                {
                    type: 'null'
                }
            ]
        },
        draft_deferral: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDraftDeferral'
                },
                {
                    type: 'null'
                }
            ]
        },
        fault_code: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fault Code'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        item_number: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Item Number'
        },
        maintenance_completed: {
            title: 'Maintenance Completed',
            type: 'boolean'
        },
        ordinal: {
            title: 'Ordinal',
            type: 'integer'
        },
        reported_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDefectSource'
                },
                {
                    type: 'null'
                }
            ]
        },
        reported_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported Date'
        },
        reported_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported Time'
        },
        sector_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sector Id'
        },
        work_order_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Order Number'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'id',
        'ordinal',
        'sector_id',
        'item_number',
        'complaint_number',
        'reported_by',
        'reported_date',
        'reported_time',
        'ata_chapter',
        'fault_code',
        'description',
        'disposition',
        'corrective_action',
        'accomplished_iaw',
        'maintenance_completed',
        'draft_deferral',
        'work_order_number',
        'work_package_id',
        'certification',
        'deferred_defect'
    ],
    title: 'AtlDefectDetailPublic',
    type: 'object'
} as const;

export const AtlDefectDispositionSchema = {
    enum: [
        'rectified',
        'deferred',
        'deferral_cleared',
        'inspected',
        'no_defect',
        'other'
    ],
    title: 'AtlDefectDisposition',
    type: 'string'
} as const;

export const AtlDefectEntrySchema = {
    properties: {
        accomplished_iaw: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accomplished Iaw'
        },
        approval_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        ata_chapter: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certified_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified On'
        },
        certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        complaint_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Complaint Number'
        },
        corrective_action: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corrective Action'
        },
        deferral: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDeferralEntry-Input'
                },
                {
                    type: 'null'
                }
            ]
        },
        deferral_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferral Number'
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        disposition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDefectDisposition'
                },
                {
                    type: 'null'
                }
            ]
        },
        fault_code: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fault Code'
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        item_number: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Item Number'
        },
        limitations: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Limitations'
        },
        maintenance_completed: {
            title: 'Maintenance Completed',
            type: 'boolean'
        },
        mel_category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationCategory'
                },
                {
                    type: 'null'
                }
            ]
        },
        mel_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mel Reference'
        },
        reported_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDefectSource'
                },
                {
                    type: 'null'
                }
            ]
        },
        reported_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported Date'
        },
        reported_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported Time'
        },
        sector_index: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sector Index'
        },
        work_order_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Order Number'
        }
    },
    required: [
        'sector_index',
        'description',
        'reported_by',
        'reported_date',
        'ata_chapter',
        'disposition',
        'corrective_action',
        'deferral_number',
        'mel_reference',
        'mel_category',
        'certifier',
        'certified_on',
        'certified_at',
        'approval_reference',
        'limitations',
        'item_number',
        'complaint_number',
        'reported_time',
        'fault_code',
        'accomplished_iaw',
        'work_order_number',
        'maintenance_completed',
        'deferral'
    ],
    title: 'AtlDefectEntry',
    type: 'object'
} as const;

export const AtlDefectSourceSchema = {
    enum: [
        'flight_crew',
        'maintenance',
        'camo',
        'other'
    ],
    title: 'AtlDefectSource',
    type: 'string'
} as const;

export const AtlDeferralEntry_InputSchema = {
    properties: {
        deferral_kind: {
            $ref: '#/components/schemas/DeferralKind'
        },
        deferred_at_cycles: {
            anyOf: [
                {
                    maximum: 2147483647,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Cycles'
        },
        deferred_at_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Hours'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        procedure_tasks: {
            items: {
                $ref: '#/components/schemas/AtlProcedureTaskEntry-Input'
            },
            title: 'Procedure Tasks',
            type: 'array'
        },
        rectification_unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationUnit'
                },
                {
                    type: 'null'
                }
            ]
        },
        rectification_value: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rectification Value'
        },
        rie_applied: {
            title: 'Rie Applied',
            type: 'boolean'
        },
        rie_approval_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Approval Date'
        },
        rie_original_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Original Due Date'
        },
        rie_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Reference'
        }
    },
    required: [
        'deferral_kind',
        'deferred_at_hours',
        'deferred_at_cycles',
        'due_date',
        'rectification_value',
        'rectification_unit',
        'rie_applied',
        'rie_original_due_date',
        'rie_approval_date',
        'rie_reference',
        'procedure_tasks'
    ],
    title: 'AtlDeferralEntry',
    type: 'object'
} as const;

export const AtlDeferralEntry_OutputSchema = {
    properties: {
        deferral_kind: {
            $ref: '#/components/schemas/DeferralKind'
        },
        deferred_at_cycles: {
            anyOf: [
                {
                    maximum: 2147483647,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Cycles'
        },
        deferred_at_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Hours'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        procedure_tasks: {
            items: {
                $ref: '#/components/schemas/AtlProcedureTaskEntry-Output'
            },
            title: 'Procedure Tasks',
            type: 'array'
        },
        rectification_unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationUnit'
                },
                {
                    type: 'null'
                }
            ]
        },
        rectification_value: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rectification Value'
        },
        rie_applied: {
            title: 'Rie Applied',
            type: 'boolean'
        },
        rie_approval_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Approval Date'
        },
        rie_original_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Original Due Date'
        },
        rie_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Reference'
        }
    },
    required: [
        'deferral_kind',
        'deferred_at_hours',
        'deferred_at_cycles',
        'due_date',
        'rectification_value',
        'rectification_unit',
        'rie_applied',
        'rie_original_due_date',
        'rie_approval_date',
        'rie_reference',
        'procedure_tasks'
    ],
    title: 'AtlDeferralEntry',
    type: 'object'
} as const;

export const AtlDeferredDefectDetailPublicSchema = {
    properties: {
        add_number: {
            title: 'Add Number',
            type: 'string'
        },
        defect_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Defect Description'
        },
        deferral_kind: {
            $ref: '#/components/schemas/DeferralKind'
        },
        deferred_at_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Cycles'
        },
        deferred_at_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Hours'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        mel_category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationCategory'
                },
                {
                    type: 'null'
                }
            ]
        },
        mel_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mel Reference'
        },
        open_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Open Date'
        },
        procedure_tasks: {
            items: {
                $ref: '#/components/schemas/DeferralProcedureTaskPublic'
            },
            title: 'Procedure Tasks',
            type: 'array'
        },
        rectification_unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationUnit'
                },
                {
                    type: 'null'
                }
            ]
        },
        rectification_value: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rectification Value'
        },
        rie_applied: {
            title: 'Rie Applied',
            type: 'boolean'
        },
        rie_approval_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Approval Date'
        },
        rie_original_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Original Due Date'
        },
        rie_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Reference'
        },
        status: {
            $ref: '#/components/schemas/DeferredDefectStatus'
        }
    },
    required: [
        'id',
        'add_number',
        'deferral_kind',
        'mel_reference',
        'mel_category',
        'defect_description',
        'open_date',
        'due_date',
        'deferred_at_hours',
        'deferred_at_cycles',
        'rectification_value',
        'rectification_unit',
        'rie_applied',
        'rie_original_due_date',
        'rie_approval_date',
        'rie_reference',
        'status',
        'procedure_tasks'
    ],
    title: 'AtlDeferredDefectDetailPublic',
    type: 'object'
} as const;

export const AtlDraftDeferralSchema = {
    properties: {
        details: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDeferralEntry-Output'
                },
                {
                    type: 'null'
                }
            ]
        },
        mel_category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationCategory'
                },
                {
                    type: 'null'
                }
            ]
        },
        mel_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mel Reference'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        }
    },
    required: [
        'number',
        'mel_reference',
        'mel_category',
        'details'
    ],
    title: 'AtlDraftDeferral',
    type: 'object'
} as const;

export const AtlExtractionAcceptedSchema = {
    properties: {
        status: {
            const: 'scheduled',
            default: 'scheduled',
            title: 'Status',
            type: 'string'
        }
    },
    title: 'AtlExtractionAccepted',
    type: 'object'
} as const;

export const AtlFieldReferencePublicSchema = {
    properties: {
        field: {
            title: 'Field',
            type: 'string'
        },
        reference: {
            $ref: '#/components/schemas/DocumentReferencePublic'
        }
    },
    required: [
        'field',
        'reference'
    ],
    title: 'AtlFieldReferencePublic',
    type: 'object'
} as const;

export const AtlFluidUpliftDetailPublicSchema = {
    properties: {
        certification: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlCertificationPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        fluid_type: {
            $ref: '#/components/schemas/FluidType'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        ordinal: {
            title: 'Ordinal',
            type: 'integer'
        },
        position: {
            $ref: '#/components/schemas/FluidPosition'
        },
        quantity: {
            title: 'Quantity',
            type: 'string'
        },
        unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FluidUnit'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'id',
        'ordinal',
        'fluid_type',
        'position',
        'quantity',
        'unit',
        'certification'
    ],
    title: 'AtlFluidUpliftDetailPublic',
    type: 'object'
} as const;

export const AtlFluidUpliftEntrySchema = {
    properties: {
        approval_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        fluid_type: {
            $ref: '#/components/schemas/FluidType'
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        position: {
            $ref: '#/components/schemas/FluidPosition'
        },
        quantity: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Quantity'
        },
        sector_index: {
            minimum: 0,
            title: 'Sector Index',
            type: 'integer'
        },
        unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FluidUnit'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'sector_index',
        'fluid_type',
        'position',
        'quantity',
        'unit',
        'certifier',
        'certified_at',
        'approval_reference'
    ],
    title: 'AtlFluidUpliftEntry',
    type: 'object'
} as const;

export const AtlPageDetailPublicSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        aircraft_registration: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Registration'
        },
        aircraft_type: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Type'
        },
        cabin_crew: {
            items: {
                type: 'string'
            },
            title: 'Cabin Crew',
            type: 'array'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/AtlCheckDetailPublic'
            },
            title: 'Checks',
            type: 'array'
        },
        commander: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Commander'
        },
        component_changes: {
            items: {
                $ref: '#/components/schemas/AtlComponentChangePublic'
            },
            title: 'Component Changes',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        current_crs_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Current Crs Reference'
        },
        defects: {
            items: {
                $ref: '#/components/schemas/AtlDefectDetailPublic'
            },
            title: 'Defects',
            type: 'array'
        },
        document: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        field_references: {
            items: {
                $ref: '#/components/schemas/AtlFieldReferencePublic'
            },
            title: 'Field References',
            type: 'array'
        },
        first_officer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'First Officer'
        },
        flagged_fields: {
            items: {
                type: 'string'
            },
            title: 'Flagged Fields',
            type: 'array'
        },
        flight_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Date'
        },
        form_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Form Reference'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        log_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Log Number'
        },
        maintenance_status_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Maintenance Status Reference'
        },
        operator: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Operator'
        },
        purser: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purser'
        },
        scan_angle: {
            title: 'Scan Angle',
            type: 'number'
        },
        sectors: {
            items: {
                $ref: '#/components/schemas/AtlSectorDetailPublic'
            },
            title: 'Sectors',
            type: 'array'
        },
        status: {
            $ref: '#/components/schemas/AtlPageStatus'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        verifying: {
            title: 'Verifying',
            type: 'boolean'
        }
    },
    required: [
        'id',
        'status',
        'aircraft_id',
        'aircraft_registration',
        'aircraft_type',
        'document_id',
        'operator',
        'log_number',
        'commander',
        'first_officer',
        'purser',
        'cabin_crew',
        'form_reference',
        'maintenance_status_reference',
        'current_crs_reference',
        'flagged_fields',
        'verifying',
        'scan_angle',
        'created_at',
        'updated_at',
        'flight_date',
        'created_by',
        'last_modified_by',
        'document',
        'sectors',
        'defects',
        'component_changes',
        'checks',
        'field_references'
    ],
    title: 'AtlPageDetailPublic',
    type: 'object'
} as const;

export const AtlPageEntrySchema = {
    properties: {
        aircraft_registration: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Registration'
        },
        aircraft_type: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Type'
        },
        cabin_crew: {
            items: {
                minLength: 1,
                type: 'string'
            },
            title: 'Cabin Crew',
            type: 'array'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/AtlCheckEntry'
            },
            title: 'Checks',
            type: 'array'
        },
        commander: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Commander'
        },
        component_changes: {
            items: {
                $ref: '#/components/schemas/AtlComponentChangeEntry'
            },
            title: 'Component Changes',
            type: 'array'
        },
        current_crs_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Current Crs Reference'
        },
        defects: {
            items: {
                $ref: '#/components/schemas/AtlDefectEntry'
            },
            title: 'Defects',
            type: 'array'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        first_officer: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'First Officer'
        },
        flagged_fields: {
            items: {
                type: 'string'
            },
            title: 'Flagged Fields',
            type: 'array'
        },
        fluid_uplifts: {
            items: {
                $ref: '#/components/schemas/AtlFluidUpliftEntry'
            },
            title: 'Fluid Uplifts',
            type: 'array'
        },
        form_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Form Reference'
        },
        log_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Log Number'
        },
        maintenance_status_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Maintenance Status Reference'
        },
        operator: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Operator'
        },
        purser: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purser'
        },
        sectors: {
            items: {
                $ref: '#/components/schemas/AtlSectorEntry'
            },
            title: 'Sectors',
            type: 'array'
        }
    },
    required: [
        'log_number',
        'operator',
        'aircraft_registration',
        'aircraft_type',
        'commander',
        'first_officer',
        'purser',
        'cabin_crew',
        'form_reference',
        'maintenance_status_reference',
        'current_crs_reference',
        'document_id',
        'flagged_fields',
        'sectors',
        'defects',
        'component_changes',
        'checks',
        'fluid_uplifts'
    ],
    title: 'AtlPageEntry',
    type: 'object'
} as const;

export const AtlPageEntryCreateSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        aircraft_registration: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Registration'
        },
        aircraft_type: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Type'
        },
        cabin_crew: {
            items: {
                minLength: 1,
                type: 'string'
            },
            title: 'Cabin Crew',
            type: 'array'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/AtlCheckEntry'
            },
            title: 'Checks',
            type: 'array'
        },
        commander: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Commander'
        },
        component_changes: {
            items: {
                $ref: '#/components/schemas/AtlComponentChangeEntry'
            },
            title: 'Component Changes',
            type: 'array'
        },
        current_crs_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Current Crs Reference'
        },
        defects: {
            items: {
                $ref: '#/components/schemas/AtlDefectEntry'
            },
            title: 'Defects',
            type: 'array'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        first_officer: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'First Officer'
        },
        flagged_fields: {
            items: {
                type: 'string'
            },
            title: 'Flagged Fields',
            type: 'array'
        },
        fluid_uplifts: {
            items: {
                $ref: '#/components/schemas/AtlFluidUpliftEntry'
            },
            title: 'Fluid Uplifts',
            type: 'array'
        },
        form_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Form Reference'
        },
        log_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Log Number'
        },
        maintenance_status_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Maintenance Status Reference'
        },
        operator: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Operator'
        },
        purser: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purser'
        },
        sectors: {
            items: {
                $ref: '#/components/schemas/AtlSectorEntry'
            },
            title: 'Sectors',
            type: 'array'
        }
    },
    required: [
        'log_number',
        'operator',
        'aircraft_registration',
        'aircraft_type',
        'commander',
        'first_officer',
        'purser',
        'cabin_crew',
        'form_reference',
        'maintenance_status_reference',
        'current_crs_reference',
        'document_id',
        'flagged_fields',
        'sectors',
        'defects',
        'component_changes',
        'checks',
        'fluid_uplifts',
        'aircraft_id'
    ],
    title: 'AtlPageEntryCreate',
    type: 'object'
} as const;

export const AtlPageGroupingSchema = {
    enum: [
        'status',
        'aircraft',
        'entered_by'
    ],
    title: 'AtlPageGrouping',
    type: 'string'
} as const;

export const AtlPagePatchResultSchema = {
    properties: {
        created_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Created Ids',
            type: 'array'
        }
    },
    required: [
        'created_ids'
    ],
    title: 'AtlPagePatchResult',
    type: 'object'
} as const;

export const AtlPageSortSchema = {
    enum: [
        'flight_date',
        'log_number'
    ],
    title: 'AtlPageSort',
    type: 'string'
} as const;

export const AtlPageStatusSchema = {
    enum: [
        'draft',
        'recorded'
    ],
    title: 'AtlPageStatus',
    type: 'string'
} as const;

export const AtlPagesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/AtlPageDetailPublic'
            },
            title: 'Data',
            type: 'array'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/GroupCountPublic'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'data',
        'count',
        'groups'
    ],
    title: 'AtlPagesPublic',
    type: 'object'
} as const;

export const AtlProcedureTaskEntry_InputSchema = {
    properties: {
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        last_done_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Done Date'
        },
        last_done_value: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Done Value'
        },
        next_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next Due Date'
        },
        next_due_value: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next Due Value'
        },
        parameter: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Unit'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        }
    },
    required: [
        'parameter',
        'last_done_value',
        'next_due_value',
        'last_done_date',
        'next_due_date',
        'status'
    ],
    title: 'AtlProcedureTaskEntry',
    type: 'object'
} as const;

export const AtlProcedureTaskEntry_OutputSchema = {
    properties: {
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        last_done_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Done Date'
        },
        last_done_value: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Done Value'
        },
        next_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next Due Date'
        },
        next_due_value: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next Due Value'
        },
        parameter: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Unit'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        }
    },
    required: [
        'parameter',
        'last_done_value',
        'next_due_value',
        'last_done_date',
        'next_due_date',
        'status'
    ],
    title: 'AtlProcedureTaskEntry',
    type: 'object'
} as const;

export const AtlSectorDetailPublicSchema = {
    properties: {
        block_minutes: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block Minutes'
        },
        block_off: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block Off'
        },
        block_on: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block On'
        },
        cycles_since_new: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cycles Since New'
        },
        flight_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Cycles'
        },
        flight_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Date'
        },
        flight_minutes: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Minutes'
        },
        flight_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Number'
        },
        flight_off: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Off'
        },
        flight_on: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight On'
        },
        fluid_uplifts: {
            items: {
                $ref: '#/components/schemas/AtlFluidUpliftDetailPublic'
            },
            title: 'Fluid Uplifts',
            type: 'array'
        },
        from_station: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'From Station'
        },
        hours_since_new: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours Since New'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landings'
        },
        ops: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlSectorOpsDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        sector_number: {
            title: 'Sector Number',
            type: 'integer'
        },
        time_correction_minutes: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Time Correction Minutes'
        },
        to_station: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'To Station'
        }
    },
    required: [
        'id',
        'sector_number',
        'flight_date',
        'flight_number',
        'from_station',
        'to_station',
        'block_off',
        'block_on',
        'block_minutes',
        'flight_off',
        'flight_on',
        'flight_minutes',
        'time_correction_minutes',
        'landings',
        'flight_cycles',
        'hours_since_new',
        'cycles_since_new',
        'ops',
        'fluid_uplifts'
    ],
    title: 'AtlSectorDetailPublic',
    type: 'object'
} as const;

export const AtlSectorEntrySchema = {
    properties: {
        autoland: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Autoland'
        },
        block_minutes: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block Minutes'
        },
        block_off: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block Off'
        },
        block_on: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block On'
        },
        commander_acceptance: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Commander Acceptance'
        },
        cycles_since_new: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cycles Since New'
        },
        deicing_mix_ratio: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Mix Ratio'
        },
        deicing_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Time'
        },
        deicing_type: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Type'
        },
        flight_cycles: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Cycles'
        },
        flight_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Date'
        },
        flight_minutes: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Minutes'
        },
        flight_nature: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Nature'
        },
        flight_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Number'
        },
        flight_off: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Off'
        },
        flight_on: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight On'
        },
        from_station: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'From Station'
        },
        fuel_arrival_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Arrival Kg'
        },
        fuel_density: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Density'
        },
        fuel_departure_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Departure Kg'
        },
        fuel_extra_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Extra Kg'
        },
        fuel_extra_reason: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Extra Reason'
        },
        fuel_min_required_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Min Required Kg'
        },
        fuel_uplift_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Uplift Kg'
        },
        fuel_uplift_litres: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Uplift Litres'
        },
        go_arounds: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Go Arounds'
        },
        hours_since_new: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours Since New'
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        landing_pilot: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landing Pilot'
        },
        landings: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landings'
        },
        pre_flight_certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pre Flight Certifier'
        },
        security_check_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Security Check Time'
        },
        takeoff_pilot: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Takeoff Pilot'
        },
        thrust_setting: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thrust Setting'
        },
        time_correction_minutes: {
            anyOf: [
                {
                    maximum: 1440,
                    minimum: -1440,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Time Correction Minutes'
        },
        to_station: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'To Station'
        },
        touch_and_go: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Touch And Go'
        }
    },
    required: [
        'flight_date',
        'flight_number',
        'from_station',
        'to_station',
        'block_off',
        'block_on',
        'block_minutes',
        'flight_off',
        'flight_on',
        'flight_minutes',
        'landings',
        'flight_cycles',
        'takeoff_pilot',
        'landing_pilot',
        'fuel_departure_kg',
        'fuel_arrival_kg',
        'fuel_min_required_kg',
        'fuel_uplift_kg',
        'fuel_uplift_litres',
        'fuel_density',
        'fuel_extra_kg',
        'deicing_time',
        'security_check_time',
        'time_correction_minutes',
        'flight_nature',
        'autoland',
        'thrust_setting',
        'go_arounds',
        'touch_and_go',
        'fuel_extra_reason',
        'deicing_type',
        'deicing_mix_ratio',
        'commander_acceptance',
        'pre_flight_certifier',
        'hours_since_new',
        'cycles_since_new'
    ],
    title: 'AtlSectorEntry',
    type: 'object'
} as const;

export const AtlSectorOpsDetailPublicSchema = {
    properties: {
        autoland: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Autoland'
        },
        commander_acceptance: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Commander Acceptance'
        },
        deicing_mix_ratio: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Mix Ratio'
        },
        deicing_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Time'
        },
        deicing_type: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Type'
        },
        flight_nature: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Nature'
        },
        fuel_arrival_kg: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Arrival Kg'
        },
        fuel_density: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Density'
        },
        fuel_departure_kg: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Departure Kg'
        },
        fuel_extra_kg: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Extra Kg'
        },
        fuel_extra_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Extra Reason'
        },
        fuel_min_required_kg: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Min Required Kg'
        },
        fuel_uplift_kg: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Uplift Kg'
        },
        fuel_uplift_litres: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Uplift Litres'
        },
        go_arounds: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Go Arounds'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        landing_pilot: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landing Pilot'
        },
        pre_flight_certification: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlCertificationPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        security_check_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Security Check Time'
        },
        takeoff_pilot: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Takeoff Pilot'
        },
        thrust_setting: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thrust Setting'
        },
        touch_and_go: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Touch And Go'
        }
    },
    required: [
        'id',
        'fuel_uplift_kg',
        'fuel_min_required_kg',
        'fuel_departure_kg',
        'fuel_arrival_kg',
        'fuel_uplift_litres',
        'fuel_density',
        'fuel_extra_kg',
        'takeoff_pilot',
        'landing_pilot',
        'deicing_time',
        'security_check_time',
        'flight_nature',
        'autoland',
        'thrust_setting',
        'go_arounds',
        'touch_and_go',
        'fuel_extra_reason',
        'deicing_type',
        'deicing_mix_ratio',
        'commander_acceptance',
        'pre_flight_certification'
    ],
    title: 'AtlSectorOpsDetailPublic',
    type: 'object'
} as const;

export const AtlTotalsPublicSchema = {
    properties: {
        cycles: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cycles'
        },
        hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours'
        }
    },
    required: [
        'hours',
        'cycles'
    ],
    title: 'AtlTotalsPublic',
    type: 'object'
} as const;

export const AttachExistingDocumentsSchema = {
    properties: {
        document_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 100,
            minItems: 1,
            title: 'Document Ids',
            type: 'array'
        }
    },
    required: [
        'document_ids'
    ],
    title: 'AttachExistingDocuments',
    type: 'object'
} as const;

export const AttachmentPublicSchema = {
    properties: {
        content_type: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content Type'
        },
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        },
        file_name: {
            title: 'File Name',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        trace_id: {
            format: 'uuid',
            title: 'Trace Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'trace_id',
        'document_id',
        'file_name',
        'content_type'
    ],
    title: 'AttachmentPublic',
    type: 'object'
} as const;

export const AudienceScopeSchema = {
    enum: [
        'actor_team',
        'actor_department',
        'actor_facility',
        'subject_department',
        'subject_facility'
    ],
    title: 'AudienceScope',
    type: 'string'
} as const;

export const AudioIntentSchema = {
    enum: [
        'add_tie_in',
        'add_work_task'
    ],
    title: 'AudioIntent',
    type: 'string'
} as const;

export const AuditActionSchema = {
    enum: [
        'create',
        'update',
        'delete',
        'archive',
        'restore'
    ],
    title: 'AuditAction',
    type: 'string'
} as const;

export const AuditFieldChangeSchema = {
    properties: {
        field: {
            title: 'Field',
            type: 'string'
        },
        value: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Value'
        }
    },
    required: [
        'field',
        'value'
    ],
    title: 'AuditFieldChange',
    type: 'object'
} as const;

export const AuditLogPublicSchema = {
    properties: {
        action: {
            $ref: '#/components/schemas/AuditAction'
        },
        changed_at: {
            format: 'date-time',
            title: 'Changed At',
            type: 'string'
        },
        changed_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ChangedBy'
                },
                {
                    type: 'null'
                }
            ]
        },
        changed_by_user: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        changes: {
            items: {
                $ref: '#/components/schemas/AuditFieldChange'
            },
            title: 'Changes',
            type: 'array'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        record_id: {
            format: 'uuid',
            title: 'Record Id',
            type: 'string'
        },
        table_name: {
            title: 'Table Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'record_id',
        'table_name',
        'changed_at',
        'action',
        'changed_by',
        'changed_by_user',
        'changes'
    ],
    title: 'AuditLogPublic',
    type: 'object'
} as const;

export const AuditLogsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/AuditLogPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'AuditLogsPublic',
    type: 'object'
} as const;

export const AvailableIntentSchema = {
    properties: {
        id: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AudioIntent'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'name'
    ],
    title: 'AvailableIntent',
    type: 'object'
} as const;

export const AvailableModeSchema = {
    properties: {
        id: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Mode'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'name'
    ],
    title: 'AvailableMode',
    type: 'object'
} as const;

export const AvrefCandidatePriceSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        condition: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Condition'
        },
        date: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Date'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        manufacturer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        minimum_quantity: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Minimum Quantity'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'part_number',
        'description',
        'amount',
        'condition',
        'unit_of_measure',
        'minimum_quantity',
        'manufacturer',
        'date'
    ],
    title: 'AvrefCandidatePrice',
    type: 'object'
} as const;

export const AvrefPriceSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        date: {
            format: 'date-time',
            title: 'Date',
            type: 'string'
        },
        source: {
            const: 'avref',
            default: 'avref',
            title: 'Source',
            type: 'string'
        }
    },
    required: [
        'amount',
        'date'
    ],
    title: 'AvrefPrice',
    type: 'object'
} as const;

export const AvrefPricesPublicSchema = {
    properties: {
        prices: {
            items: {
                $ref: '#/components/schemas/AvrefCandidatePrice'
            },
            title: 'Prices',
            type: 'array'
        },
        total: {
            title: 'Total',
            type: 'integer'
        }
    },
    required: [
        'prices',
        'total'
    ],
    title: 'AvrefPricesPublic',
    type: 'object'
} as const;

export const BandPublicSchema = {
    properties: {
        maximum: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Maximum'
        },
        median: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Median'
        },
        minimum: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Minimum'
        }
    },
    required: [
        'minimum',
        'median',
        'maximum'
    ],
    title: 'BandPublic',
    type: 'object'
} as const;

export const Body_documents_uploadSchema = {
    properties: {
        file: {
            contentMediaType: 'application/octet-stream',
            title: 'File',
            type: 'string'
        },
        visibility: {
            $ref: '#/components/schemas/SettableVisibility',
            default: 'user'
        }
    },
    required: [
        'file'
    ],
    title: 'Body_documents-upload',
    type: 'object'
} as const;

export const Body_documents_upload_globalSchema = {
    properties: {
        file: {
            contentMediaType: 'application/octet-stream',
            title: 'File',
            type: 'string'
        }
    },
    required: [
        'file'
    ],
    title: 'Body_documents-upload_global',
    type: 'object'
} as const;

export const Body_login_login_access_tokenSchema = {
    properties: {
        client_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Id'
        },
        client_secret: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            format: 'password',
            title: 'Client Secret'
        },
        grant_type: {
            anyOf: [
                {
                    pattern: '^password$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Grant Type'
        },
        password: {
            format: 'password',
            title: 'Password',
            type: 'string'
        },
        scope: {
            default: '',
            title: 'Scope',
            type: 'string'
        },
        username: {
            title: 'Username',
            type: 'string'
        }
    },
    required: [
        'username',
        'password'
    ],
    title: 'Body_login-login_access_token',
    type: 'object'
} as const;

export const Body_quote_task_attachment_upload_for_quote_taskSchema = {
    properties: {
        files: {
            items: {
                contentMediaType: 'application/octet-stream',
                type: 'string'
            },
            title: 'Files',
            type: 'array'
        }
    },
    required: [
        'files'
    ],
    title: 'Body_quote-task-attachment-upload_for_quote_task',
    type: 'object'
} as const;

export const Body_tenant_upload_company_logoSchema = {
    properties: {
        file: {
            contentMediaType: 'application/octet-stream',
            title: 'File',
            type: 'string'
        }
    },
    required: [
        'file'
    ],
    title: 'Body_tenant-upload_company_logo',
    type: 'object'
} as const;

export const Body_tenant_upload_current_company_logoSchema = {
    properties: {
        file: {
            contentMediaType: 'application/octet-stream',
            title: 'File',
            type: 'string'
        }
    },
    required: [
        'file'
    ],
    title: 'Body_tenant-upload_current_company_logo',
    type: 'object'
} as const;

export const Body_trace_attachment_upload_attachmentSchema = {
    properties: {
        file: {
            contentMediaType: 'application/octet-stream',
            title: 'File',
            type: 'string'
        }
    },
    required: [
        'file'
    ],
    title: 'Body_trace-attachment-upload_attachment',
    type: 'object'
} as const;

export const Body_trace_attachment_upload_sandbox_attachmentSchema = {
    properties: {
        file: {
            contentMediaType: 'application/octet-stream',
            title: 'File',
            type: 'string'
        }
    },
    required: [
        'file'
    ],
    title: 'Body_trace-attachment-upload_sandbox_attachment',
    type: 'object'
} as const;

export const Body_trace_audioSchema = {
    properties: {
        file: {
            contentMediaType: 'application/octet-stream',
            title: 'File',
            type: 'string'
        }
    },
    required: [
        'file'
    ],
    title: 'Body_trace-audio',
    type: 'object'
} as const;

export const Body_trace_transcribeSchema = {
    properties: {
        file: {
            contentMediaType: 'application/octet-stream',
            title: 'File',
            type: 'string'
        }
    },
    required: [
        'file'
    ],
    title: 'Body_trace-transcribe',
    type: 'object'
} as const;

export const BoundingBoxSchema = {
    description: 'Bounding box coordinates for document region (0-1 percentages).',
    properties: {
        height: {
            title: 'Height',
            type: 'number'
        },
        left: {
            title: 'Left',
            type: 'number'
        },
        page: {
            title: 'Page',
            type: 'integer'
        },
        top: {
            title: 'Top',
            type: 'number'
        },
        width: {
            title: 'Width',
            type: 'number'
        }
    },
    required: [
        'left',
        'top',
        'width',
        'height',
        'page'
    ],
    title: 'BoundingBox',
    type: 'object'
} as const;

export const BoundingBoxReferenceSchema = {
    properties: {
        height: {
            maximum: 1,
            minimum: 0,
            title: 'Height',
            type: 'number'
        },
        left: {
            maximum: 1,
            minimum: 0,
            title: 'Left',
            type: 'number'
        },
        page: {
            minimum: 1,
            title: 'Page',
            type: 'integer'
        },
        top: {
            maximum: 1,
            minimum: 0,
            title: 'Top',
            type: 'number'
        },
        type: {
            const: 'bounding_box',
            title: 'Type',
            type: 'string'
        },
        width: {
            maximum: 1,
            minimum: 0,
            title: 'Width',
            type: 'number'
        }
    },
    required: [
        'type',
        'page',
        'left',
        'top',
        'width',
        'height'
    ],
    title: 'BoundingBoxReference',
    type: 'object'
} as const;

export const CancelWorkPackageSchema = {
    properties: {
        action: {
            const: 'cancel',
            title: 'Action',
            type: 'string'
        },
        reason: {
            minLength: 1,
            title: 'Reason',
            type: 'string'
        }
    },
    required: [
        'action',
        'reason'
    ],
    title: 'CancelWorkPackage',
    type: 'object'
} as const;

export const CannedChargeTypeSchema = {
    enum: [
        'part',
        'misc',
        'labour_flat_rate',
        'labour',
        'outside_service'
    ],
    type: 'string'
} as const;

export const CannedWorkPackageBulkArchivePublicSchema = {
    properties: {
        archived: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Archived',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'archived',
        'skipped'
    ],
    title: 'CannedWorkPackageBulkArchivePublic',
    type: 'object'
} as const;

export const CannedWorkPackageBulkDeletePublicSchema = {
    properties: {
        deleted: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Deleted',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'deleted',
        'skipped'
    ],
    title: 'CannedWorkPackageBulkDeletePublic',
    type: 'object'
} as const;

export const CannedWorkPackageBulkIdsSchema = {
    properties: {
        canned_work_package_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Canned Work Package Ids',
            type: 'array'
        }
    },
    required: [
        'canned_work_package_ids'
    ],
    title: 'CannedWorkPackageBulkIds',
    type: 'object'
} as const;

export const CannedWorkPackageBulkRestorePublicSchema = {
    properties: {
        restored: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Restored',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'restored',
        'skipped'
    ],
    title: 'CannedWorkPackageBulkRestorePublic',
    type: 'object'
} as const;

export const CannedWorkPackageCreateSchema = {
    properties: {
        canned_work_task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Canned Work Task Ids',
            type: 'array'
        },
        name: {
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        type_certificate_model_variant_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Type Certificate Model Variant Ids',
            type: 'array'
        }
    },
    required: [
        'name',
        'canned_work_task_ids'
    ],
    title: 'CannedWorkPackageCreate',
    type: 'object'
} as const;

export const CannedWorkPackageDetailPublicSchema = {
    properties: {
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskDetailPublic'
            },
            title: 'Tasks',
            type: 'array'
        },
        type_certificate_model_variants: {
            items: {
                $ref: '#/components/schemas/TypeCertificateModelVariantWithParentPublic'
            },
            title: 'Type Certificate Model Variants',
            type: 'array'
        }
    },
    required: [
        'id',
        'name',
        'number',
        'created_by_id',
        'created_at',
        'archived_at',
        'deleted_at',
        'created_by',
        'type_certificate_model_variants',
        'tasks'
    ],
    title: 'CannedWorkPackageDetailPublic',
    type: 'object'
} as const;

export const CannedWorkPackageGroupingSchema = {
    enum: [
        'status'
    ],
    title: 'CannedWorkPackageGrouping',
    type: 'string'
} as const;

export const CannedWorkPackageImportSchema = {
    properties: {
        canned_work_task_numbers: {
            items: {
                type: 'string'
            },
            title: 'Canned Work Task Numbers',
            type: 'array'
        },
        name: {
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        type_certificate_model_variant_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Type Certificate Model Variant Ids',
            type: 'array'
        }
    },
    required: [
        'name',
        'number',
        'canned_work_task_numbers'
    ],
    title: 'CannedWorkPackageImport',
    type: 'object'
} as const;

export const CannedWorkPackageImportOutcomeSchema = {
    enum: [
        'created',
        'existing',
        'unknown_variant',
        'unknown_task',
        'task_in_other_package'
    ],
    title: 'CannedWorkPackageImportOutcome',
    type: 'string'
} as const;

export const CannedWorkPackageImportResultPublicSchema = {
    properties: {
        canned_work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Package Id'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        outcome: {
            $ref: '#/components/schemas/CannedWorkPackageImportOutcome'
        }
    },
    required: [
        'number',
        'outcome',
        'canned_work_package_id'
    ],
    title: 'CannedWorkPackageImportResultPublic',
    type: 'object'
} as const;

export const CannedWorkPackageSortFieldSchema = {
    enum: [
        'created_at',
        'number',
        'name'
    ],
    title: 'CannedWorkPackageSortField',
    type: 'string'
} as const;

export const CannedWorkPackageStatusSchema = {
    enum: [
        'approved',
        'in_progress',
        'draft'
    ],
    title: 'CannedWorkPackageStatus',
    type: 'string'
} as const;

export const CannedWorkPackageUpdateSchema = {
    properties: {
        canned_work_task_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Task Ids'
        },
        name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        type_certificate_model_variant_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Type Certificate Model Variant Ids'
        }
    },
    title: 'CannedWorkPackageUpdate',
    type: 'object'
} as const;

export const CannedWorkPackagesImportSchema = {
    properties: {
        packages: {
            items: {
                $ref: '#/components/schemas/CannedWorkPackageImport'
            },
            minItems: 1,
            title: 'Packages',
            type: 'array'
        }
    },
    required: [
        'packages'
    ],
    title: 'CannedWorkPackagesImport',
    type: 'object'
} as const;

export const CannedWorkPackagesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/CannedWorkPackageDetailPublic'
            },
            title: 'Data',
            type: 'array'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/GroupCountPublic'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'data',
        'count',
        'groups'
    ],
    title: 'CannedWorkPackagesPublic',
    type: 'object'
} as const;

export const CannedWorkTaskBulkArchivePublicSchema = {
    properties: {
        archived: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Archived',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'archived',
        'skipped'
    ],
    title: 'CannedWorkTaskBulkArchivePublic',
    type: 'object'
} as const;

export const CannedWorkTaskBulkDepartmentSchema = {
    properties: {
        canned_work_task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Canned Work Task Ids',
            type: 'array'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        }
    },
    required: [
        'canned_work_task_ids',
        'department_id'
    ],
    title: 'CannedWorkTaskBulkDepartment',
    type: 'object'
} as const;

export const CannedWorkTaskBulkIdsSchema = {
    properties: {
        canned_work_task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Canned Work Task Ids',
            type: 'array'
        }
    },
    required: [
        'canned_work_task_ids'
    ],
    title: 'CannedWorkTaskBulkIds',
    type: 'object'
} as const;

export const CannedWorkTaskBulkRestorePublicSchema = {
    properties: {
        restored: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Restored',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'restored',
        'skipped'
    ],
    title: 'CannedWorkTaskBulkRestorePublic',
    type: 'object'
} as const;

export const CannedWorkTaskBulkTaskGroupSchema = {
    properties: {
        canned_work_task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Canned Work Task Ids',
            type: 'array'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        }
    },
    required: [
        'canned_work_task_ids',
        'task_group_id'
    ],
    title: 'CannedWorkTaskBulkTaskGroup',
    type: 'object'
} as const;

export const CannedWorkTaskChargeCreateSchema = {
    properties: {
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        lead_time: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        part_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        type: {
            $ref: '#/components/schemas/CannedChargeType'
        },
        unit_of_measure: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'description',
        'type'
    ],
    title: 'CannedWorkTaskChargeCreate',
    type: 'object'
} as const;

export const CannedWorkTaskChargePublicSchema = {
    properties: {
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        lead_time: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        part_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        type: {
            $ref: '#/components/schemas/CannedChargeType'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'id',
        'description',
        'type',
        'part_number',
        'purchase_unit_price',
        'sale_unit_price',
        'currency',
        'quantity',
        'unit_of_measure',
        'tax_amount',
        'lead_time'
    ],
    title: 'CannedWorkTaskChargePublic',
    type: 'object'
} as const;

export const CannedWorkTaskCreateSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        canned_work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Package Id'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskChargeCreate'
            },
            title: 'Charges',
            type: 'array'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        name: {
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        steps: {
            items: {
                $ref: '#/components/schemas/StepDefinition'
            },
            title: 'Steps',
            type: 'array'
        },
        subject: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Subject'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'description',
        'name'
    ],
    title: 'CannedWorkTaskCreate',
    type: 'object'
} as const;

export const CannedWorkTaskDetailPublicSchema = {
    properties: {
        approved_version: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CannedWorkTaskVersionDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        canned_work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Package Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        latest_version: {
            $ref: '#/components/schemas/CannedWorkTaskVersionDetailPublic'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        previous_versions: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskVersionDetailPublic'
            },
            title: 'Previous Versions',
            type: 'array'
        },
        source: {
            $ref: '#/components/schemas/ChangedBy'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        },
        template_quote_variants: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/TypeCertificateModelVariantWithParentPublic'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Template Quote Variants'
        }
    },
    required: [
        'id',
        'name',
        'number',
        'source',
        'task_group_id',
        'department_id',
        'created_by_id',
        'created_at',
        'deleted_at',
        'created_by',
        'latest_version',
        'approved_version',
        'previous_versions',
        'canned_work_package_id',
        'template_quote_variants'
    ],
    title: 'CannedWorkTaskDetailPublic',
    type: 'object'
} as const;

export const CannedWorkTaskGroupingSchema = {
    enum: [
        'status',
        'task_group'
    ],
    title: 'CannedWorkTaskGrouping',
    type: 'string'
} as const;

export const CannedWorkTaskImportSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskChargeCreate'
            },
            title: 'Charges',
            type: 'array'
        },
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        name: {
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        review_status: {
            enum: [
                'approved',
                'pending'
            ],
            title: 'Review Status',
            type: 'string'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        steps: {
            items: {
                $ref: '#/components/schemas/StepDefinition'
            },
            title: 'Steps',
            type: 'array'
        },
        subject: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftSubject'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'description',
        'name',
        'number',
        'review_status'
    ],
    title: 'CannedWorkTaskImport',
    type: 'object'
} as const;

export const CannedWorkTaskImportOutcomeSchema = {
    enum: [
        'created',
        'existing',
        'unknown_variant'
    ],
    title: 'CannedWorkTaskImportOutcome',
    type: 'string'
} as const;

export const CannedWorkTaskImportResultPublicSchema = {
    properties: {
        canned_work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Task Id'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        outcome: {
            $ref: '#/components/schemas/CannedWorkTaskImportOutcome'
        }
    },
    required: [
        'number',
        'outcome',
        'canned_work_task_id'
    ],
    title: 'CannedWorkTaskImportResultPublic',
    type: 'object'
} as const;

export const CannedWorkTaskMatchPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        source: {
            $ref: '#/components/schemas/ChangedBy'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        },
        template_quote_variants: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/TypeCertificateModelVariantWithParentPublic'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Template Quote Variants'
        },
        tier: {
            $ref: '#/components/schemas/MatchTier'
        },
        version: {
            $ref: '#/components/schemas/CannedWorkTaskVersionDetailPublic'
        }
    },
    required: [
        'id',
        'name',
        'number',
        'source',
        'task_group_id',
        'department_id',
        'created_by_id',
        'created_at',
        'deleted_at',
        'version',
        'template_quote_variants',
        'tier'
    ],
    title: 'CannedWorkTaskMatchPublic',
    type: 'object'
} as const;

export const CannedWorkTaskPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        source: {
            $ref: '#/components/schemas/ChangedBy'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        }
    },
    required: [
        'id',
        'name',
        'number',
        'source',
        'task_group_id',
        'department_id',
        'created_by_id',
        'created_at',
        'deleted_at'
    ],
    title: 'CannedWorkTaskPublic',
    type: 'object'
} as const;

export const CannedWorkTaskReviewFailureSchema = {
    enum: [
        'not_found',
        'already_reviewed',
        'outdated',
        'not_allowed',
        'needs_more_approvals'
    ],
    title: 'CannedWorkTaskReviewFailure',
    type: 'string'
} as const;

export const CannedWorkTaskReviewFailurePublicSchema = {
    properties: {
        canned_work_task_id: {
            format: 'uuid',
            title: 'Canned Work Task Id',
            type: 'string'
        },
        canned_work_task_version_id: {
            format: 'uuid',
            title: 'Canned Work Task Version Id',
            type: 'string'
        },
        reason: {
            $ref: '#/components/schemas/CannedWorkTaskReviewFailure'
        }
    },
    required: [
        'canned_work_task_id',
        'canned_work_task_version_id',
        'reason'
    ],
    title: 'CannedWorkTaskReviewFailurePublic',
    type: 'object'
} as const;

export const CannedWorkTaskReviewsSchema = {
    properties: {
        status: {
            $ref: '#/components/schemas/ReviewDecision-Input'
        },
        versions: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskVersionRef'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Versions',
            type: 'array'
        }
    },
    required: [
        'versions',
        'status'
    ],
    title: 'CannedWorkTaskReviews',
    type: 'object'
} as const;

export const CannedWorkTaskReviewsPublicSchema = {
    properties: {
        failed: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskReviewFailurePublic'
            },
            title: 'Failed',
            type: 'array'
        },
        reviewed: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Reviewed',
            type: 'array'
        }
    },
    required: [
        'reviewed',
        'failed'
    ],
    title: 'CannedWorkTaskReviewsPublic',
    type: 'object'
} as const;

export const CannedWorkTaskSortFieldSchema = {
    enum: [
        'created_at',
        'number',
        'name',
        'review_status'
    ],
    title: 'CannedWorkTaskSortField',
    type: 'string'
} as const;

export const CannedWorkTaskStatusCountPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        review_status: {
            $ref: '#/components/schemas/ReviewStatus'
        }
    },
    required: [
        'review_status',
        'count'
    ],
    title: 'CannedWorkTaskStatusCountPublic',
    type: 'object'
} as const;

export const CannedWorkTaskStepPublicSchema = {
    properties: {
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        inspection_required: {
            title: 'Inspection Required',
            type: 'boolean'
        },
        parent_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Step Id'
        },
        position: {
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'id',
        'parent_step_id',
        'position',
        'description',
        'inspection_required'
    ],
    title: 'CannedWorkTaskStepPublic',
    type: 'object'
} as const;

export const CannedWorkTaskVersionCreateSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskChargeCreate'
            },
            title: 'Charges',
            type: 'array'
        },
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        steps: {
            items: {
                $ref: '#/components/schemas/StepDefinition'
            },
            title: 'Steps',
            type: 'array'
        },
        subject: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Subject'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'description'
    ],
    title: 'CannedWorkTaskVersionCreate',
    type: 'object'
} as const;

export const CannedWorkTaskVersionDetailPublicSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        canned_work_task_id: {
            format: 'uuid',
            title: 'Canned Work Task Id',
            type: 'string'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskChargePublic'
            },
            title: 'Charges',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        manual_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        part: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        resolution: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        review_status: {
            $ref: '#/components/schemas/ReviewStatus'
        },
        reviewed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reviewed At'
        },
        reviewed_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reviewed By Id'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        steps: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskStepPublic'
            },
            title: 'Steps',
            type: 'array'
        },
        type_certificate_model_variants: {
            items: {
                $ref: '#/components/schemas/TypeCertificateModelVariantWithParentPublic'
            },
            title: 'Type Certificate Model Variants',
            type: 'array'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'canned_work_task_id',
        'review_status',
        'reviewed_at',
        'reviewed_by_id',
        'last_modified_by_id',
        'description',
        'severity',
        'manual_reference',
        'ata_chapter',
        'ata_subchapter',
        'ata_zone',
        'resolution',
        'part_id',
        'created_at',
        'updated_at',
        'deleted_at',
        'part',
        'type_certificate_model_variants',
        'last_modified_by',
        'charges',
        'steps'
    ],
    title: 'CannedWorkTaskVersionDetailPublic',
    type: 'object'
} as const;

export const CannedWorkTaskVersionRefSchema = {
    properties: {
        canned_work_task_id: {
            format: 'uuid',
            title: 'Canned Work Task Id',
            type: 'string'
        },
        canned_work_task_version_id: {
            format: 'uuid',
            title: 'Canned Work Task Version Id',
            type: 'string'
        }
    },
    required: [
        'canned_work_task_id',
        'canned_work_task_version_id'
    ],
    title: 'CannedWorkTaskVersionRef',
    type: 'object'
} as const;

export const CannedWorkTaskVersionReviewSchema = {
    properties: {
        status: {
            $ref: '#/components/schemas/ReviewDecision-Input'
        }
    },
    required: [
        'status'
    ],
    title: 'CannedWorkTaskVersionReview',
    type: 'object'
} as const;

export const CannedWorkTaskWithApprovalPublicSchema = {
    properties: {
        approval: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApprovalProgressPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        approved_version: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CannedWorkTaskVersionDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        approvers: {
            items: {
                $ref: '#/components/schemas/UserBasicInfo'
            },
            title: 'Approvers',
            type: 'array'
        },
        canned_work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Package Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        latest_version: {
            $ref: '#/components/schemas/CannedWorkTaskVersionDetailPublic'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        previous_versions: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskVersionDetailPublic'
            },
            title: 'Previous Versions',
            type: 'array'
        },
        source: {
            $ref: '#/components/schemas/ChangedBy'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        },
        template_quote_variants: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/TypeCertificateModelVariantWithParentPublic'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Template Quote Variants'
        }
    },
    required: [
        'id',
        'name',
        'number',
        'source',
        'task_group_id',
        'department_id',
        'created_by_id',
        'created_at',
        'deleted_at',
        'created_by',
        'latest_version',
        'approved_version',
        'previous_versions',
        'canned_work_package_id',
        'template_quote_variants',
        'approval',
        'approvers'
    ],
    title: 'CannedWorkTaskWithApprovalPublic',
    type: 'object'
} as const;

export const CannedWorkTasksImportSchema = {
    properties: {
        tasks: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskImport'
            },
            minItems: 1,
            title: 'Tasks',
            type: 'array'
        }
    },
    required: [
        'tasks'
    ],
    title: 'CannedWorkTasksImport',
    type: 'object'
} as const;

export const CannedWorkTasksPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskDetailPublic'
            },
            title: 'Data',
            type: 'array'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/GroupCountPublic'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'data',
        'count',
        'groups'
    ],
    title: 'CannedWorkTasksPublic',
    type: 'object'
} as const;

export const Case_InputSchema = {
    additionalProperties: false,
    properties: {
        then: {
            $ref: '#/components/schemas/Expr-Input'
        },
        when: {
            $ref: '#/components/schemas/Condition-Input'
        }
    },
    required: [
        'when',
        'then'
    ],
    title: 'Case',
    type: 'object'
} as const;

export const Case_OutputSchema = {
    additionalProperties: false,
    properties: {
        then: {
            $ref: '#/components/schemas/Expr-Output'
        },
        when: {
            $ref: '#/components/schemas/Condition-Output'
        }
    },
    required: [
        'when',
        'then'
    ],
    title: 'Case',
    type: 'object'
} as const;

export const CaseExpr_InputSchema = {
    additionalProperties: false,
    properties: {
        cases: {
            items: {
                $ref: '#/components/schemas/Case-Input'
            },
            minItems: 1,
            title: 'Cases',
            type: 'array'
        },
        else: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Expr-Input'
                },
                {
                    type: 'null'
                }
            ]
        },
        op: {
            const: 'case',
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'cases'
    ],
    title: 'CaseExpr',
    type: 'object'
} as const;

export const CaseExpr_OutputSchema = {
    additionalProperties: false,
    properties: {
        cases: {
            items: {
                $ref: '#/components/schemas/Case-Output'
            },
            minItems: 1,
            title: 'Cases',
            type: 'array'
        },
        else: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Expr-Output'
                },
                {
                    type: 'null'
                }
            ]
        },
        op: {
            const: 'case',
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'cases'
    ],
    title: 'CaseExpr',
    type: 'object'
} as const;

export const CategoryDiscountSchema = {
    properties: {
        category: {
            $ref: '#/components/schemas/ChargeCategory'
        },
        kind: {
            const: 'category',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind',
        'category'
    ],
    title: 'CategoryDiscount',
    type: 'object'
} as const;

export const ChangedBySchema = {
    enum: [
        'ad_scraper',
        'agent',
        'aircraft_backfill',
        'alert_scanner',
        'assigner',
        'atl_extraction',
        'avref',
        'camo_import',
        'customer',
        'erp_sync',
        'extractor',
        'inventory',
        'llm',
        'mailgun',
        'programme_extraction',
        'quote_email',
        'quote_expiry',
        'quote_extraction',
        'role_sync',
        'squawk_upload',
        'tenant_setup',
        'trace_cleanup',
        'migration',
        'user'
    ],
    title: 'ChangedBy',
    type: 'string'
} as const;

export const ChargeCategorySchema = {
    enum: [
        'labour',
        'parts',
        'services',
        'misc'
    ],
    title: 'ChargeCategory',
    type: 'string'
} as const;

export const ChargeDiscountSchema = {
    properties: {
        kind: {
            const: 'charge',
            title: 'Kind',
            type: 'string'
        },
        quote_task_charge_id: {
            format: 'uuid',
            title: 'Quote Task Charge Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'quote_task_charge_id'
    ],
    title: 'ChargeDiscount',
    type: 'object'
} as const;

export const ChargeOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateCharge',
            remove: '#/components/schemas/RemoveCharge',
            set: '#/components/schemas/SetCharge',
            update: '#/components/schemas/UpdateCharge'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateCharge'
        },
        {
            $ref: '#/components/schemas/UpdateCharge'
        },
        {
            $ref: '#/components/schemas/SetCharge'
        },
        {
            $ref: '#/components/schemas/RemoveCharge'
        }
    ]
} as const;

export const ChargePriceSchema = {
    discriminator: {
        mapping: {
            avref: '#/components/schemas/AvrefPrice',
            inventory: '#/components/schemas/InventoryPrice',
            user: '#/components/schemas/UserPrice'
        },
        propertyName: 'source'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/AvrefPrice'
        },
        {
            $ref: '#/components/schemas/InventoryPrice'
        },
        {
            $ref: '#/components/schemas/UserPrice'
        }
    ]
} as const;

export const ChargePriceHistoryPublicSchema = {
    properties: {
        charge_id: {
            format: 'uuid',
            title: 'Charge Id',
            type: 'string'
        },
        prices: {
            items: {
                $ref: '#/components/schemas/ChargePrice'
            },
            title: 'Prices',
            type: 'array'
        }
    },
    required: [
        'charge_id',
        'prices'
    ],
    title: 'ChargePriceHistoryPublic',
    type: 'object'
} as const;

export const ChargeTypeSchema = {
    enum: [
        'part',
        'misc',
        'part_flat_rate',
        'labour_flat_rate',
        'labour',
        'outside_service',
        'estimate',
        'freight',
        'insurance'
    ],
    title: 'ChargeType',
    type: 'string'
} as const;

export const CheckOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateCheck',
            remove: '#/components/schemas/RemoveCheck',
            update: '#/components/schemas/UpdateCheck'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateCheck'
        },
        {
            $ref: '#/components/schemas/UpdateCheck'
        },
        {
            $ref: '#/components/schemas/RemoveCheck'
        }
    ]
} as const;

export const ChoiceConditionValueSchema = {
    properties: {
        choices: {
            items: {
                type: 'string'
            },
            title: 'Choices',
            type: 'array'
        },
        kind: {
            const: 'choice',
            title: 'Kind',
            type: 'string'
        },
        records_change: {
            title: 'Records Change',
            type: 'boolean'
        }
    },
    required: [
        'kind',
        'choices',
        'records_change'
    ],
    title: 'ChoiceConditionValue',
    type: 'object'
} as const;

export const ClassifyResponseSchema = {
    properties: {
        chapters: {
            items: {
                type: 'integer'
            },
            title: 'Chapters',
            type: 'array',
            uniqueItems: true
        }
    },
    required: [
        'chapters'
    ],
    title: 'ClassifyResponse',
    type: 'object'
} as const;

export const ClassifyTasksSchema = {
    properties: {
        task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 500,
            title: 'Task Ids',
            type: 'array'
        }
    },
    required: [
        'task_ids'
    ],
    title: 'ClassifyTasks',
    type: 'object'
} as const;

export const ClearLimitsSchema = {
    properties: {
        operation: {
            const: 'clear',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation'
    ],
    title: 'ClearLimits',
    type: 'object'
} as const;

export const CloseWorkPackagesSchema = {
    properties: {
        ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Ids',
            type: 'array'
        }
    },
    required: [
        'ids'
    ],
    title: 'CloseWorkPackages',
    type: 'object'
} as const;

export const CloseWorkTasksSchema = {
    properties: {
        ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Ids',
            type: 'array'
        }
    },
    required: [
        'ids'
    ],
    title: 'CloseWorkTasks',
    type: 'object'
} as const;

export const ClosedWorkPackagesSchema = {
    properties: {
        closed: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Closed',
            type: 'array'
        },
        refused: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Refused',
            type: 'array'
        }
    },
    required: [
        'closed',
        'refused'
    ],
    title: 'ClosedWorkPackages',
    type: 'object'
} as const;

export const CombinedCondition_InputSchema = {
    additionalProperties: false,
    properties: {
        of: {
            items: {
                $ref: '#/components/schemas/Condition-Input'
            },
            minItems: 1,
            title: 'Of',
            type: 'array'
        },
        op: {
            enum: [
                'all',
                'any'
            ],
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'of'
    ],
    title: 'CombinedCondition',
    type: 'object'
} as const;

export const CombinedCondition_OutputSchema = {
    additionalProperties: false,
    properties: {
        of: {
            items: {
                $ref: '#/components/schemas/Condition-Output'
            },
            minItems: 1,
            title: 'Of',
            type: 'array'
        },
        op: {
            enum: [
                'all',
                'any'
            ],
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'of'
    ],
    title: 'CombinedCondition',
    type: 'object'
} as const;

export const CommentSideSchema = {
    enum: [
        'shop',
        'customer'
    ],
    title: 'CommentSide',
    type: 'string'
} as const;

export const CommentVisibilitySchema = {
    enum: [
        'internal',
        'customer'
    ],
    title: 'CommentVisibility',
    type: 'string'
} as const;

export const ComplianceCategorySchema = {
    enum: [
        'ONE_TIME',
        'RECURRING'
    ],
    title: 'ComplianceCategory',
    type: 'string'
} as const;

export const ComplianceIntervalTypeSchema = {
    enum: [
        'CALENDAR',
        'FLIGHT_HOURS',
        'FLIGHT_CYCLES',
        'LANDINGS',
        'APPLICABLE_EVENT',
        'MIXED',
        'N/A'
    ],
    title: 'ComplianceIntervalType',
    type: 'string'
} as const;

export const ComplianceNoteCreateSchema = {
    properties: {
        category: {
            $ref: '#/components/schemas/NoteCategory'
        },
        task_card_entry: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Card Entry'
        },
        task_card_entry_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Card Entry Created At'
        },
        task_card_entry_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Card Entry Edited'
        },
        task_card_entry_generation_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/NoteGenerationStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_task_id: {
            format: 'uuid',
            title: 'Work Task Id',
            type: 'string'
        }
    },
    required: [
        'work_task_id',
        'category'
    ],
    title: 'ComplianceNoteCreate',
    type: 'object'
} as const;

export const ComplianceNoteEntryPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        task_card_entry: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Card Entry'
        }
    },
    required: [
        'id',
        'task_card_entry'
    ],
    title: 'ComplianceNoteEntryPublic',
    type: 'object'
} as const;

export const ComplianceNotePublicSchema = {
    properties: {
        additional_info: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AdditionalInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        category: {
            $ref: '#/components/schemas/NoteCategory'
        },
        compliance_info: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SnagComplianceInfo'
                },
                {
                    $ref: '#/components/schemas/PartComplianceInfo'
                },
                {
                    $ref: '#/components/schemas/InspectionComplianceInfo'
                },
                {
                    $ref: '#/components/schemas/ADSBComplianceInfo'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Info'
        },
        compliance_info_edited: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SnagComplianceInfo'
                },
                {
                    $ref: '#/components/schemas/PartComplianceInfo'
                },
                {
                    $ref: '#/components/schemas/InspectionComplianceInfo'
                },
                {
                    $ref: '#/components/schemas/ADSBComplianceInfo'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Info Edited'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        log_entry: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Log Entry'
        },
        log_entry_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Log Entry Created At'
        },
        log_entry_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Log Entry Edited'
        },
        log_entry_generation_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/NoteGenerationStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        log_entry_updated_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Log Entry Updated At'
        },
        sent_to_erp: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent To Erp'
        },
        sent_to_erp_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent To Erp At'
        },
        sent_to_erp_vendor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ERPVendor'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_card_entry: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Card Entry'
        },
        task_card_entry_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Card Entry Created At'
        },
        task_card_entry_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Card Entry Edited'
        },
        task_card_entry_generation_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/NoteGenerationStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_card_entry_updated_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Card Entry Updated At'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'category',
        'created_at',
        'updated_at'
    ],
    title: 'ComplianceNotePublic',
    type: 'object'
} as const;

export const ComplianceNoteUpdateSchema = {
    properties: {
        sent_to_erp: {
            title: 'Sent To Erp',
            type: 'boolean'
        },
        sent_to_erp_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent To Erp At'
        },
        sent_to_erp_vendor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ERPVendor'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent To Erp Vendor'
        },
        task_card_entry_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Card Entry Edited'
        }
    },
    title: 'ComplianceNoteUpdate',
    type: 'object'
} as const;

export const ComplianceStatusSchema = {
    enum: [
        'COMPLIED',
        'NOT_COMPLIED',
        'DUE',
        'OVERDUE',
        'IN_PROGRESS',
        'RECURRING_COMPLIED',
        'RECURRING_OVERDUE'
    ],
    title: 'ComplianceStatus',
    type: 'string'
} as const;

export const ComponentChangeOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateComponentChange',
            remove: '#/components/schemas/RemoveComponentChange',
            update: '#/components/schemas/UpdateComponentChange'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateComponentChange'
        },
        {
            $ref: '#/components/schemas/UpdateComponentChange'
        },
        {
            $ref: '#/components/schemas/RemoveComponentChange'
        }
    ]
} as const;

export const ComponentConditionSchema = {
    additionalProperties: false,
    properties: {
        major_assembly: {
            anyOf: [
                {
                    $ref: '#/components/schemas/MajorAssemblyKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        manufacturer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Match'
                },
                {
                    type: 'null'
                }
            ]
        },
        model: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Match'
                },
                {
                    type: 'null'
                }
            ]
        },
        op: {
            const: 'component',
            title: 'Op',
            type: 'string'
        },
        part_name: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Match'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_number: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Match'
                },
                {
                    type: 'null'
                }
            ]
        },
        position: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        },
        serial: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Range'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'op'
    ],
    title: 'ComponentCondition',
    type: 'object'
} as const;

export const ComponentMatchSchema = {
    additionalProperties: false,
    properties: {
        major_assembly: {
            anyOf: [
                {
                    $ref: '#/components/schemas/MajorAssemblyKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        manufacturer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Match'
                },
                {
                    type: 'null'
                }
            ]
        },
        model: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Match'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_name: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Match'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_number: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Match'
                },
                {
                    type: 'null'
                }
            ]
        },
        position: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        },
        serial: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Range'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    title: 'ComponentMatch',
    type: 'object'
} as const;

export const Condition_InputSchema = {
    discriminator: {
        mapping: {
            all: '#/components/schemas/CombinedCondition-Input',
            any: '#/components/schemas/CombinedCondition-Input',
            component: '#/components/schemas/ComponentCondition',
            configuration: '#/components/schemas/ConfigurationCondition',
            mod: '#/components/schemas/ModificationCondition',
            model: '#/components/schemas/MatchCondition',
            not: '#/components/schemas/NotCondition-Input',
            registry: '#/components/schemas/RegistryCondition',
            sb: '#/components/schemas/ModificationCondition',
            serial: '#/components/schemas/RangeCondition',
            text: '#/components/schemas/TextCondition',
            usage: '#/components/schemas/UsageCondition',
            variant: '#/components/schemas/MatchCondition'
        },
        propertyName: 'op'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CombinedCondition-Input'
        },
        {
            $ref: '#/components/schemas/NotCondition-Input'
        },
        {
            $ref: '#/components/schemas/MatchCondition'
        },
        {
            $ref: '#/components/schemas/RangeCondition'
        },
        {
            $ref: '#/components/schemas/ModificationCondition'
        },
        {
            $ref: '#/components/schemas/ComponentCondition'
        },
        {
            $ref: '#/components/schemas/RegistryCondition'
        },
        {
            $ref: '#/components/schemas/ConfigurationCondition'
        },
        {
            $ref: '#/components/schemas/UsageCondition'
        },
        {
            $ref: '#/components/schemas/TextCondition'
        }
    ]
} as const;

export const Condition_OutputSchema = {
    discriminator: {
        mapping: {
            all: '#/components/schemas/CombinedCondition-Output',
            any: '#/components/schemas/CombinedCondition-Output',
            component: '#/components/schemas/ComponentCondition',
            configuration: '#/components/schemas/ConfigurationCondition',
            mod: '#/components/schemas/ModificationCondition',
            model: '#/components/schemas/MatchCondition',
            not: '#/components/schemas/NotCondition-Output',
            registry: '#/components/schemas/RegistryCondition',
            sb: '#/components/schemas/ModificationCondition',
            serial: '#/components/schemas/RangeCondition',
            text: '#/components/schemas/TextCondition',
            usage: '#/components/schemas/UsageCondition',
            variant: '#/components/schemas/MatchCondition'
        },
        propertyName: 'op'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CombinedCondition-Output'
        },
        {
            $ref: '#/components/schemas/NotCondition-Output'
        },
        {
            $ref: '#/components/schemas/MatchCondition'
        },
        {
            $ref: '#/components/schemas/RangeCondition'
        },
        {
            $ref: '#/components/schemas/ModificationCondition'
        },
        {
            $ref: '#/components/schemas/ComponentCondition'
        },
        {
            $ref: '#/components/schemas/RegistryCondition'
        },
        {
            $ref: '#/components/schemas/ConfigurationCondition'
        },
        {
            $ref: '#/components/schemas/UsageCondition'
        },
        {
            $ref: '#/components/schemas/TextCondition'
        }
    ]
} as const;

export const ConfigurationConditionSchema = {
    additionalProperties: false,
    properties: {
        op: {
            const: 'configuration',
            title: 'Op',
            type: 'string'
        },
        ref: {
            title: 'Ref',
            type: 'string'
        }
    },
    required: [
        'op',
        'ref'
    ],
    title: 'ConfigurationCondition',
    type: 'object'
} as const;

export const CorridorQuotePushCreateSchema = {
    properties: {
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        }
    },
    required: [
        'quote_id'
    ],
    title: 'CorridorQuotePushCreate',
    type: 'object'
} as const;

export const CorridorQuotePushPublicSchema = {
    properties: {
        corridor_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corridor Number'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        department: {
            title: 'Department',
            type: 'string'
        },
        error: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Error'
        },
        finished_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Finished At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        item_type: {
            title: 'Item Type',
            type: 'string'
        },
        progress: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Progress'
        },
        queue_position: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Queue Position'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        requested_by_id: {
            format: 'uuid',
            title: 'Requested By Id',
            type: 'string'
        },
        resume_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resume Number'
        },
        started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Started At'
        },
        status: {
            $ref: '#/components/schemas/CorridorQuotePushStatus'
        }
    },
    required: [
        'id',
        'quote_id',
        'requested_by_id',
        'department',
        'item_type',
        'status',
        'resume_number',
        'corridor_number',
        'progress',
        'error',
        'queue_position',
        'created_at',
        'started_at',
        'finished_at'
    ],
    title: 'CorridorQuotePushPublic',
    type: 'object'
} as const;

export const CorridorQuotePushStatusSchema = {
    enum: [
        'queued',
        'running',
        'succeeded',
        'failed'
    ],
    title: 'CorridorQuotePushStatus',
    type: 'string'
} as const;

export const CorridorQuotePushesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/CorridorQuotePushPublic'
            },
            title: 'Data',
            type: 'array'
        },
        relay_configured: {
            title: 'Relay Configured',
            type: 'boolean'
        }
    },
    required: [
        'relay_configured',
        'data',
        'count'
    ],
    title: 'CorridorQuotePushesPublic',
    type: 'object'
} as const;

export const CorridorRelayPublicSchema = {
    properties: {
        key_prefix: {
            title: 'Key Prefix',
            type: 'string'
        },
        set_at: {
            format: 'date-time',
            title: 'Set At',
            type: 'string'
        },
        set_by_id: {
            format: 'uuid',
            title: 'Set By Id',
            type: 'string'
        },
        url: {
            title: 'Url',
            type: 'string'
        }
    },
    required: [
        'url',
        'key_prefix',
        'set_by_id',
        'set_at'
    ],
    title: 'CorridorRelayPublic',
    type: 'object'
} as const;

export const CorridorRelayStatePublicSchema = {
    properties: {
        relay: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CorridorRelayPublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'relay'
    ],
    title: 'CorridorRelayStatePublic',
    type: 'object'
} as const;

export const CorridorRelayUpdateSchema = {
    properties: {
        key: {
            format: 'password',
            maxLength: 512,
            minLength: 8,
            title: 'Key',
            type: 'string',
            writeOnly: true
        },
        url: {
            format: 'uri',
            minLength: 1,
            title: 'Url',
            type: 'string'
        }
    },
    required: [
        'url',
        'key'
    ],
    title: 'CorridorRelayUpdate',
    type: 'object'
} as const;

export const CreatableStatusSchema = {
    enum: [
        'draft',
        'pending_review'
    ],
    type: 'string'
} as const;

export const CreateChargeSchema = {
    properties: {
        cost_quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost Quantity'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        document_references: {
            items: {
                $ref: '#/components/schemas/CreateDocumentReference'
            },
            title: 'Document References',
            type: 'array'
        },
        estimate_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        lead_time: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        part_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        turnaround_time: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Turnaround Time'
        },
        type: {
            $ref: '#/components/schemas/ChargeType'
        },
        unit_of_measure: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        },
        vendor_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Id'
        }
    },
    required: [
        'operation',
        'type'
    ],
    title: 'CreateCharge',
    type: 'object'
} as const;

export const CreateCheckSchema = {
    properties: {
        approval_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certified_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified On'
        },
        certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        check_name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Check Name'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        station_code: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Station Code'
        }
    },
    required: [
        'operation'
    ],
    title: 'CreateCheck',
    type: 'object'
} as const;

export const CreateComponentChangeSchema = {
    properties: {
        component_name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Component Name'
        },
        defect_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Defect Id'
        },
        form1_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Form1 Reference'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        part_number_off: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number Off'
        },
        part_number_on: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number On'
        },
        removal_note: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Removal Note'
        },
        serial_number_off: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number Off'
        },
        serial_number_on: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number On'
        },
        tag_number_off: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tag Number Off'
        },
        tag_number_on: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tag Number On'
        }
    },
    required: [
        'operation'
    ],
    title: 'CreateComponentChange',
    type: 'object'
} as const;

export const CreateDefectSchema = {
    properties: {
        accomplished_iaw: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accomplished Iaw'
        },
        approval_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        ata_chapter: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certified_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified On'
        },
        certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        complaint_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Complaint Number'
        },
        corrective_action: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corrective Action'
        },
        deferral_kind: {
            $ref: '#/components/schemas/DeferralKind',
            default: 'add'
        },
        deferral_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferral Number'
        },
        deferred_at_cycles: {
            anyOf: [
                {
                    maximum: 2147483647,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Cycles'
        },
        deferred_at_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Hours'
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        disposition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDefectDisposition'
                },
                {
                    type: 'null'
                }
            ]
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        fault_code: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fault Code'
        },
        item_number: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Item Number'
        },
        limitations: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Limitations'
        },
        maintenance_completed: {
            default: false,
            title: 'Maintenance Completed',
            type: 'boolean'
        },
        mel_category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationCategory'
                },
                {
                    type: 'null'
                }
            ]
        },
        mel_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mel Reference'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        procedure_tasks: {
            items: {
                $ref: '#/components/schemas/AtlProcedureTaskEntry-Input'
            },
            title: 'Procedure Tasks',
            type: 'array'
        },
        rectification_unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationUnit'
                },
                {
                    type: 'null'
                }
            ]
        },
        rectification_value: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rectification Value'
        },
        reported_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDefectSource'
                },
                {
                    type: 'null'
                }
            ]
        },
        reported_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported Date'
        },
        reported_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported Time'
        },
        rie_applied: {
            default: false,
            title: 'Rie Applied',
            type: 'boolean'
        },
        rie_approval_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Approval Date'
        },
        rie_original_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Original Due Date'
        },
        rie_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Reference'
        },
        sector_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sector Id'
        },
        work_order_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Order Number'
        }
    },
    required: [
        'operation'
    ],
    title: 'CreateDefect',
    type: 'object'
} as const;

export const CreateDiscountSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amount'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        percentage: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    maximum: 100,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Percentage'
        },
        target: {
            $ref: '#/components/schemas/DiscountTargetChoice'
        }
    },
    required: [
        'operation',
        'target'
    ],
    title: 'CreateDiscount',
    type: 'object'
} as const;

export const CreateDocumentReferenceSchema = {
    properties: {
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        value: {
            $ref: '#/components/schemas/DocumentReferenceValue'
        }
    },
    required: [
        'operation',
        'document_id',
        'value'
    ],
    title: 'CreateDocumentReference',
    type: 'object'
} as const;

export const CreateDueStatusSchema = {
    properties: {
        is_overdue: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Overdue'
        },
        limits: {
            items: {
                $ref: '#/components/schemas/CreateLimit'
            },
            title: 'Limits',
            type: 'array'
        },
        raw: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Raw'
        }
    },
    title: 'CreateDueStatus',
    type: 'object'
} as const;

export const CreateFeeSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Amount'
        },
        cap_amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cap Amount'
        },
        is_taxable: {
            default: true,
            title: 'Is Taxable',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/FeeKind'
        },
        name: {
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        quote_fee_template_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Fee Template Id'
        }
    },
    required: [
        'operation',
        'name',
        'kind',
        'amount'
    ],
    title: 'CreateFee',
    type: 'object'
} as const;

export const CreateFluidUpliftSchema = {
    properties: {
        approval_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        fluid_type: {
            $ref: '#/components/schemas/FluidType'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        position: {
            $ref: '#/components/schemas/FluidPosition'
        },
        quantity: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Quantity'
        },
        sector_id: {
            format: 'uuid',
            title: 'Sector Id',
            type: 'string'
        },
        unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FluidUnit'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'operation',
        'sector_id',
        'fluid_type',
        'position',
        'quantity'
    ],
    title: 'CreateFluidUplift',
    type: 'object'
} as const;

export const CreateLimitSchema = {
    properties: {
        due_at: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due At'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        remaining: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Remaining'
        },
        unit: {
            $ref: '#/components/schemas/DueUnit'
        }
    },
    required: [
        'operation',
        'unit'
    ],
    title: 'CreateLimit',
    type: 'object'
} as const;

export const CreateProgrammeCheckSchema = {
    properties: {
        code: {
            minLength: 1,
            title: 'Code',
            type: 'string'
        },
        included_check_ids: {
            default: [],
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            title: 'Included Check Ids',
            type: 'array'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        schedule: {
            $ref: '#/components/schemas/Schedule-Input'
        },
        title: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        }
    },
    required: [
        'code',
        'schedule',
        'operation'
    ],
    title: 'CreateProgrammeCheck',
    type: 'object'
} as const;

export const CreateProgrammeTaskSchema = {
    properties: {
        access: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Access'
        },
        access_man_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Access Man Hours'
        },
        applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Condition-Input'
                },
                {
                    type: 'null'
                }
            ]
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        check_ids: {
            default: [],
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            title: 'Check Ids',
            type: 'array'
        },
        cmr_escalation_allowed: {
            default: false,
            title: 'Cmr Escalation Allowed',
            type: 'boolean'
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        man_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Man Hours'
        },
        men: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Men'
        },
        on_condition: {
            default: false,
            title: 'On Condition',
            type: 'boolean'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        preparation: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Preparation'
        },
        preparation_man_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Preparation Man Hours'
        },
        references: {
            default: [],
            items: {
                $ref: '#/components/schemas/ProgrammeTaskReferenceBase'
            },
            maxItems: 50,
            title: 'References',
            type: 'array'
        },
        schedule: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Schedule-Input'
                },
                {
                    type: 'null'
                }
            ]
        },
        section: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Section'
        },
        skill_codes: {
            default: [],
            items: {
                $ref: '#/components/schemas/SkillCode'
            },
            title: 'Skill Codes',
            type: 'array'
        },
        sources: {
            default: [],
            items: {
                $ref: '#/components/schemas/ProgrammeTaskSource'
            },
            title: 'Sources',
            type: 'array'
        },
        task_code: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskCode'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_number: {
            minLength: 1,
            title: 'Task Number',
            type: 'string'
        },
        time_controlled_item: {
            default: false,
            title: 'Time Controlled Item',
            type: 'boolean'
        },
        title: {
            minLength: 1,
            title: 'Title',
            type: 'string'
        },
        zones: {
            default: [],
            items: {
                minLength: 1,
                type: 'string'
            },
            title: 'Zones',
            type: 'array'
        }
    },
    required: [
        'task_number',
        'title',
        'operation'
    ],
    title: 'CreateProgrammeTask',
    type: 'object'
} as const;

export const CreateSectorSchema = {
    properties: {
        autoland: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Autoland'
        },
        block_minutes: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block Minutes'
        },
        block_off: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block Off'
        },
        block_on: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block On'
        },
        commander_acceptance: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Commander Acceptance'
        },
        cycles_since_new: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cycles Since New'
        },
        deicing_mix_ratio: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Mix Ratio'
        },
        deicing_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Time'
        },
        deicing_type: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Type'
        },
        flight_cycles: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Cycles'
        },
        flight_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Date'
        },
        flight_minutes: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Minutes'
        },
        flight_nature: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Nature'
        },
        flight_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Number'
        },
        flight_off: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Off'
        },
        flight_on: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight On'
        },
        from_station: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'From Station'
        },
        fuel_arrival_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Arrival Kg'
        },
        fuel_density: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Density'
        },
        fuel_departure_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Departure Kg'
        },
        fuel_extra_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Extra Kg'
        },
        fuel_extra_reason: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Extra Reason'
        },
        fuel_min_required_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Min Required Kg'
        },
        fuel_uplift_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Uplift Kg'
        },
        fuel_uplift_litres: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Uplift Litres'
        },
        go_arounds: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Go Arounds'
        },
        hours_since_new: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours Since New'
        },
        landing_pilot: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landing Pilot'
        },
        landings: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landings'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        pre_flight_certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pre Flight Certifier'
        },
        security_check_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Security Check Time'
        },
        takeoff_pilot: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Takeoff Pilot'
        },
        thrust_setting: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thrust Setting'
        },
        time_correction_minutes: {
            anyOf: [
                {
                    maximum: 1440,
                    minimum: -1440,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Time Correction Minutes'
        },
        to_station: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'To Station'
        },
        touch_and_go: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Touch And Go'
        }
    },
    required: [
        'operation'
    ],
    title: 'CreateSector',
    type: 'object'
} as const;

export const CreateTaskSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/CreateCharge'
            },
            title: 'Charges',
            type: 'array'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            default: '',
            title: 'Description',
            type: 'string'
        },
        document_references: {
            items: {
                $ref: '#/components/schemas/CreateDocumentReference'
            },
            title: 'Document References',
            type: 'array'
        },
        due_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CreateDueStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        operation: {
            const: 'create',
            title: 'Operation',
            type: 'string'
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        phase_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Phase Ids',
            type: 'array'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteTaskStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        }
    },
    required: [
        'operation'
    ],
    title: 'CreateTask',
    type: 'object'
} as const;

export const CreateTaskFromTemplateSchema = {
    properties: {
        canned_work_task_id: {
            format: 'uuid',
            title: 'Canned Work Task Id',
            type: 'string'
        },
        operation: {
            const: 'create_from_template',
            title: 'Operation',
            type: 'string'
        },
        phase_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Phase Ids',
            type: 'array'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        }
    },
    required: [
        'operation',
        'canned_work_task_id'
    ],
    title: 'CreateTaskFromTemplate',
    type: 'object'
} as const;

export const CredentialTypeSchema = {
    enum: [
        'public_api'
    ],
    title: 'CredentialType',
    type: 'string'
} as const;

export const CurrencySchema = {
    enum: [
        'usd',
        'cad',
        'eur',
        'gbp',
        'aud'
    ],
    title: 'Currency',
    type: 'string'
} as const;

export const CurrencyAmountSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        }
    },
    required: [
        'currency',
        'amount'
    ],
    title: 'CurrencyAmount',
    type: 'object'
} as const;

export const CurrentTimerPublicSchema = {
    properties: {
        timer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TimerDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'timer'
    ],
    title: 'CurrentTimerPublic',
    type: 'object'
} as const;

export const CustomRoleCreateSchema = {
    properties: {
        capabilities: {
            items: {
                $ref: '#/components/schemas/RoleCapability'
            },
            title: 'Capabilities',
            type: 'array'
        },
        description: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'name',
        'capabilities'
    ],
    title: 'CustomRoleCreate',
    type: 'object'
} as const;

export const CustomRoleUpdateSchema = {
    properties: {
        capabilities: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/RoleCapability'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Capabilities'
        },
        description: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    title: 'CustomRoleUpdate',
    type: 'object'
} as const;

export const CustomerAddressCreateSchema = {
    properties: {
        address_city: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address City'
        },
        address_country: {
            anyOf: [
                {
                    pattern: '^[A-Z]{2}$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Country'
        },
        address_line1: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line1'
        },
        address_line2: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line2'
        },
        address_postal_code: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Postal Code'
        },
        address_region: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Region'
        },
        customer_id: {
            format: 'uuid',
            title: 'Customer Id',
            type: 'string'
        },
        is_primary: {
            default: false,
            title: 'Is Primary',
            type: 'boolean'
        },
        label: {
            maxLength: 255,
            minLength: 1,
            title: 'Label',
            type: 'string'
        }
    },
    required: [
        'customer_id',
        'label'
    ],
    title: 'CustomerAddressCreate',
    type: 'object'
} as const;

export const CustomerAddressPublicSchema = {
    properties: {
        address_city: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address City'
        },
        address_country: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Country'
        },
        address_line1: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line1'
        },
        address_line2: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line2'
        },
        address_postal_code: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Postal Code'
        },
        address_region: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Region'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        customer_id: {
            format: 'uuid',
            title: 'Customer Id',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        external_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_primary: {
            title: 'Is Primary',
            type: 'boolean'
        },
        label: {
            title: 'Label',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'customer_id',
        'label',
        'is_primary',
        'created_at',
        'updated_at'
    ],
    title: 'CustomerAddressPublic',
    type: 'object'
} as const;

export const CustomerAddressUpdateSchema = {
    properties: {
        address_city: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address City'
        },
        address_country: {
            anyOf: [
                {
                    pattern: '^[A-Z]{2}$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Country'
        },
        address_line1: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line1'
        },
        address_line2: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line2'
        },
        address_postal_code: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Postal Code'
        },
        address_region: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Region'
        },
        is_primary: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Primary'
        },
        label: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Label'
        }
    },
    title: 'CustomerAddressUpdate',
    type: 'object'
} as const;

export const CustomerAddressesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/CustomerAddressPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'CustomerAddressesPublic',
    type: 'object'
} as const;

export const CustomerApplicabilityCreateSchema = {
    properties: {
        customer_id: {
            format: 'uuid',
            title: 'Customer Id',
            type: 'string'
        },
        subject: {
            const: 'customer',
            title: 'Subject',
            type: 'string'
        }
    },
    required: [
        'subject',
        'customer_id'
    ],
    title: 'CustomerApplicabilityCreate',
    type: 'object'
} as const;

export const CustomerContactAudienceSchema = {
    additionalProperties: false,
    properties: {
        customer_contact_id: {
            format: 'uuid',
            title: 'Customer Contact Id',
            type: 'string'
        },
        kind: {
            const: 'customer_contact',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind',
        'customer_contact_id'
    ],
    title: 'CustomerContactAudience',
    type: 'object'
} as const;

export const CustomerContactCreateSchema = {
    properties: {
        customer_id: {
            format: 'uuid',
            title: 'Customer Id',
            type: 'string'
        },
        email: {
            anyOf: [
                {
                    format: 'email',
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        first_name: {
            maxLength: 255,
            minLength: 1,
            title: 'First Name',
            type: 'string'
        },
        is_primary: {
            default: false,
            title: 'Is Primary',
            type: 'boolean'
        },
        job_title: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_name: {
            maxLength: 255,
            minLength: 1,
            title: 'Last Name',
            type: 'string'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        }
    },
    required: [
        'customer_id',
        'first_name',
        'last_name'
    ],
    title: 'CustomerContactCreate',
    type: 'object'
} as const;

export const CustomerContactPublicSchema = {
    properties: {
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        customer_id: {
            format: 'uuid',
            title: 'Customer Id',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        external_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        first_name: {
            title: 'First Name',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_primary: {
            title: 'Is Primary',
            type: 'boolean'
        },
        job_title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        last_name: {
            title: 'Last Name',
            type: 'string'
        },
        phone: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'customer_id',
        'first_name',
        'last_name',
        'is_primary',
        'created_at',
        'updated_at'
    ],
    title: 'CustomerContactPublic',
    type: 'object'
} as const;

export const CustomerContactUpdateSchema = {
    properties: {
        email: {
            anyOf: [
                {
                    format: 'email',
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        first_name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'First Name'
        },
        is_primary: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Primary'
        },
        job_title: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Name'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        }
    },
    title: 'CustomerContactUpdate',
    type: 'object'
} as const;

export const CustomerContactsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/CustomerContactPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'CustomerContactsPublic',
    type: 'object'
} as const;

export const CustomerCreateSchema = {
    properties: {
        address: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address'
        },
        city: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'City'
        },
        country: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        email: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        external_id: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        is_deleted: {
            default: false,
            title: 'Is Deleted',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/CustomerKind',
            default: 'customer'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        source_info: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SourceInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_synced_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Source Synced At'
        },
        state: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'State'
        },
        status: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        },
        tax_exemption_reference: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Exemption Reference'
        },
        tax_registration_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Registration Number'
        },
        website: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Website'
        },
        zip_code: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Zip Code'
        }
    },
    title: 'CustomerCreate',
    type: 'object'
} as const;

export const CustomerKindSchema = {
    enum: [
        'customer',
        'warranty_provider'
    ],
    title: 'CustomerKind',
    type: 'string'
} as const;

export const CustomerPublicSchema = {
    properties: {
        address: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        city: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'City'
        },
        country: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        email: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        external_id: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_deleted: {
            default: false,
            title: 'Is Deleted',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/CustomerKind',
            default: 'customer'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        source_info: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SourceInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_synced_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Source Synced At'
        },
        state: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'State'
        },
        status: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        },
        tax_exemption_reference: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Exemption Reference'
        },
        tax_registration_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Registration Number'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        website: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Website'
        },
        zip_code: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Zip Code'
        }
    },
    required: [
        'id',
        'created_at',
        'updated_at'
    ],
    title: 'CustomerPublic',
    type: 'object'
} as const;

export const CustomerReviewStatusSchema = {
    enum: [
        'unread',
        'opened',
        'reviewing'
    ],
    title: 'CustomerReviewStatus',
    type: 'string'
} as const;

export const CustomerUpdateSchema = {
    properties: {
        address: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address'
        },
        city: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'City'
        },
        country: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        email: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        external_id: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        is_deleted: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Deleted'
        },
        kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        source_info: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SourceInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_synced_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Source Synced At'
        },
        state: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'State'
        },
        status: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        },
        tax_exemption_reference: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Exemption Reference'
        },
        tax_registration_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Registration Number'
        },
        website: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Website'
        },
        zip_code: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Zip Code'
        }
    },
    title: 'CustomerUpdate',
    type: 'object'
} as const;

export const CustomersPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/CustomerPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'CustomersPublic',
    type: 'object'
} as const;

export const DatabaseReference_InputSchema = {
    description: 'Reference to a database resource (mod_status, fitted_component, etc.).',
    properties: {
        metadata: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Metadata'
        },
        resource_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'integer'
                }
            ],
            title: 'Resource Id'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        type: {
            enum: [
                'mod_status',
                'fitted_component',
                'ad_compliance_history',
                'aircraft'
            ],
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'resource_id'
    ],
    title: 'DatabaseReference',
    type: 'object'
} as const;

export const DatabaseReference_OutputSchema = {
    description: 'Reference to a database resource (mod_status, fitted_component, etc.).',
    properties: {
        metadata: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Metadata'
        },
        resource_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                }
            ],
            title: 'Resource Id'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        type: {
            enum: [
                'mod_status',
                'fitted_component',
                'ad_compliance_history',
                'aircraft'
            ],
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'resource_id'
    ],
    title: 'DatabaseReference',
    type: 'object'
} as const;

export const DateRangeSchema = {
    properties: {
        from: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Inclusive lower bound.',
            title: 'From'
        },
        to: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Inclusive upper bound.',
            title: 'To'
        }
    },
    title: 'DateRange',
    type: 'object'
} as const;

export const DealFilterSchema = {
    properties: {
        property_name: {
            maxLength: 255,
            pattern: '^[a-z0-9_]+$',
            title: 'Property Name',
            type: 'string'
        },
        value: {
            maxLength: 255,
            minLength: 1,
            title: 'Value',
            type: 'string'
        }
    },
    required: [
        'property_name',
        'value'
    ],
    title: 'DealFilter',
    type: 'object'
} as const;

export const DefectOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateDefect',
            remove: '#/components/schemas/RemoveDefect',
            update: '#/components/schemas/UpdateDefect'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateDefect'
        },
        {
            $ref: '#/components/schemas/UpdateDefect'
        },
        {
            $ref: '#/components/schemas/RemoveDefect'
        }
    ]
} as const;

export const DeferralKindSchema = {
    enum: [
        'add',
        'cfd',
        'hil'
    ],
    title: 'DeferralKind',
    type: 'string'
} as const;

export const DeferralProcedureTaskPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_done_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Done Date'
        },
        last_done_value: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Done Value'
        },
        next_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next Due Date'
        },
        next_due_value: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next Due Value'
        },
        parameter: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Unit'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        }
    },
    required: [
        'id',
        'parameter',
        'last_done_value',
        'next_due_value',
        'last_done_date',
        'next_due_date',
        'status'
    ],
    title: 'DeferralProcedureTaskPublic',
    type: 'object'
} as const;

export const DeferredDefectStatusSchema = {
    enum: [
        'open',
        'cleared'
    ],
    title: 'DeferredDefectStatus',
    type: 'string'
} as const;

export const DeleteWorkTasksSchema = {
    properties: {
        ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Ids',
            type: 'array'
        }
    },
    required: [
        'ids'
    ],
    title: 'DeleteWorkTasks',
    type: 'object'
} as const;

export const DepartmentAudienceSchema = {
    additionalProperties: false,
    properties: {
        department_id: {
            format: 'uuid',
            title: 'Department Id',
            type: 'string'
        },
        kind: {
            const: 'department',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind',
        'department_id'
    ],
    title: 'DepartmentAudience',
    type: 'object'
} as const;

export const DepartmentCreateSchema = {
    properties: {
        email: {
            anyOf: [
                {
                    format: 'email',
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        position: {
            default: 0,
            maximum: 32767,
            minimum: 0,
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'name'
    ],
    title: 'DepartmentCreate',
    type: 'object'
} as const;

export const DepartmentPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        external_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_active: {
            title: 'Is Active',
            type: 'boolean'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        phone: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        position: {
            title: 'Position',
            type: 'integer'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'name',
        'position',
        'is_active',
        'phone',
        'email',
        'external_id',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at'
    ],
    title: 'DepartmentPublic',
    type: 'object'
} as const;

export const DepartmentReferenceSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'name'
    ],
    title: 'DepartmentReference',
    type: 'object'
} as const;

export const DepartmentUpdateSchema = {
    properties: {
        email: {
            anyOf: [
                {
                    format: 'email',
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        is_active: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Active'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        position: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        }
    },
    title: 'DepartmentUpdate',
    type: 'object'
} as const;

export const DepartmentsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/DepartmentPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'DepartmentsPublic',
    type: 'object'
} as const;

export const DiscountOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateDiscount',
            remove: '#/components/schemas/RemoveDiscount',
            update: '#/components/schemas/UpdateDiscount'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateDiscount'
        },
        {
            $ref: '#/components/schemas/UpdateDiscount'
        },
        {
            $ref: '#/components/schemas/RemoveDiscount'
        }
    ]
} as const;

export const DiscountTargetSchema = {
    enum: [
        'charge',
        'task',
        'task_group',
        'category',
        'subtotal',
        'fee'
    ],
    title: 'DiscountTarget',
    type: 'string'
} as const;

export const DiscountTargetChoiceSchema = {
    discriminator: {
        mapping: {
            category: '#/components/schemas/CategoryDiscount',
            charge: '#/components/schemas/ChargeDiscount',
            fee: '#/components/schemas/FeeDiscount',
            subtotal: '#/components/schemas/SubtotalDiscount',
            task: '#/components/schemas/TaskDiscount',
            task_group: '#/components/schemas/TaskGroupDiscount'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/SubtotalDiscount'
        },
        {
            $ref: '#/components/schemas/CategoryDiscount'
        },
        {
            $ref: '#/components/schemas/TaskGroupDiscount'
        },
        {
            $ref: '#/components/schemas/TaskDiscount'
        },
        {
            $ref: '#/components/schemas/ChargeDiscount'
        },
        {
            $ref: '#/components/schemas/FeeDiscount'
        }
    ]
} as const;

export const DocumentAirworthinessDirectivePublicSchema = {
    properties: {
        effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Effective Date'
        },
        emergency: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emergency'
        },
        issued_by: {
            anyOf: [
                {
                    enum: [
                        'AAC CD',
                        'AAC PA',
                        'AAC RM',
                        'AAC SV',
                        'AACM',
                        'AACR',
                        'AAN',
                        'ACAA',
                        'AESA',
                        'ANAC AR',
                        'ANAC BR',
                        'ANAC CI',
                        'ANAC DJ',
                        'ANAC GA',
                        'ANAC GN',
                        'ANAC ML',
                        'ANAC MR',
                        'ANAC Niger',
                        'ANAC PT',
                        'ANAC Senegal',
                        'ANAC Togo',
                        'ASECNA',
                        'BHDCA',
                        'CAA AL',
                        'CAA BG',
                        'CAA BH',
                        'CAA CR',
                        'CAA LT',
                        'CAA LV',
                        'CAA LY',
                        'CAA MK',
                        'CAA MNE',
                        'CAA MV',
                        'CAA NO',
                        'CAA NZ',
                        'CAA Pakistan',
                        'CAA QA',
                        'CAA RT',
                        'CAA SI',
                        'CAA SL',
                        'CAA SR',
                        'CAA TW',
                        'CAA UK',
                        'CAA Uganda',
                        'CAAB BD',
                        'CAAB BW',
                        'CAAC',
                        'CAAE',
                        'CAAF',
                        'CAAH',
                        'CAAI',
                        'CAAM MN',
                        'CAAM MW',
                        'CAAM MY',
                        'CAAN',
                        'CAAP',
                        'CAAS',
                        'CAASI',
                        'CAAT',
                        'CAAV VN',
                        'CAAV VU',
                        'CAAZ ZM',
                        'CAAZ ZW',
                        'CAD HK',
                        'CAD MT',
                        'CAD RS',
                        'CAMA',
                        'CAO.IRI',
                        'CARC',
                        'CASA',
                        'CASA PNG',
                        'CASAS',
                        'CCAA',
                        'DAC',
                        'DCA BN',
                        'DCA CY',
                        'DCA LA',
                        'DCA MM',
                        'DGAC BO',
                        'DGAC CL',
                        'DGAC CR',
                        'DGAC DZ',
                        'DGAC EC',
                        'DGAC FR',
                        'DGAC GT',
                        'DGAC HN',
                        'DGAC MX',
                        'DGAC PE',
                        'DGAC TN',
                        'DGCA ID',
                        'DGCA IN',
                        'DGCA KW',
                        'DGCA LB',
                        'DGCA TR',
                        'DGTA/DGLV',
                        'DINAC',
                        'DINACIA',
                        'EASA',
                        'ECAA EE',
                        'ECAA EG',
                        'ECAA ET',
                        'ENAC',
                        'FAA',
                        'FOCA',
                        'GACA',
                        'GCAA AE',
                        'GCAA GE',
                        'GCAA GH',
                        'GCAA GM',
                        'GDCA',
                        'HCAA',
                        'IAA',
                        'IACC',
                        'ICAA',
                        'ICETRA',
                        'IDAC',
                        'ILT',
                        'INAC NI',
                        'INAC VE',
                        'INAVIC',
                        'JCAA',
                        'JCAB',
                        'KCAA KE',
                        'KCAA KR',
                        'LBA',
                        'LCAA LR',
                        'LCAA LS',
                        'MAA',
                        'MCA',
                        'Ministry of Transport and Communications',
                        'MoIC',
                        'NCAA NA',
                        'NCAA NG',
                        'OACM',
                        'OCA',
                        'ONDA',
                        'PACA',
                        'RCAA',
                        'Rosaviation',
                        'SAA',
                        'SAAU',
                        'SACA',
                        'SACAA',
                        'SCAA AZ',
                        'SCAA SC',
                        'SCAA SD',
                        'SCAA SY',
                        'SCAST',
                        'SLCAA LC',
                        'SLCAA SL',
                        'SMCAA',
                        'SSCA',
                        'SSCAA',
                        'TCAA',
                        'TCCA',
                        'TTCAA',
                        'Traficom',
                        'Transportstyrelsen',
                        'UAEAC',
                        'ULC',
                        'UzCAA'
                    ],
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issued By'
        }
    },
    required: [
        'effective_date',
        'issued_by',
        'emergency'
    ],
    title: 'DocumentAirworthinessDirectivePublic',
    type: 'object'
} as const;

export const DocumentAttributeFiltersSchema = {
    properties: {
        archetype: {
            default: [],
            description: 'Kinds of document, as classified on upload.',
            items: {
                $ref: '#/components/schemas/ArchetypeName'
            },
            title: 'Archetype',
            type: 'array'
        },
        ata_chapter: {
            default: [],
            description: 'ATA chapter numbers.',
            items: {
                type: 'integer'
            },
            title: 'Ata Chapter',
            type: 'array'
        },
        document_number: {
            default: [],
            description: 'Whole document numbers, matched exactly: no partial numbers and no issuer prefix.',
            items: {
                type: 'string'
            },
            title: 'Document Number',
            type: 'array'
        },
        manufacturer: {
            default: [],
            description: 'Matches any part of the manufacturer\'s name, ignoring case.',
            items: {
                type: 'string'
            },
            title: 'Manufacturer',
            type: 'array'
        },
        model: {
            default: [],
            description: 'Matches any part of the model name, ignoring case.',
            items: {
                type: 'string'
            },
            title: 'Model',
            type: 'array'
        },
        references: {
            default: [],
            description: 'Whole numbers of the documents this one cites, matched exactly.',
            items: {
                type: 'string'
            },
            title: 'References',
            type: 'array'
        },
        regulator: {
            default: [],
            description: 'Abbreviations of the authority whose feed the document was scraped from, which for an AD can differ from the authority that issued it.',
            items: {
                enum: [
                    'AAC CD',
                    'AAC PA',
                    'AAC RM',
                    'AAC SV',
                    'AACM',
                    'AACR',
                    'AAN',
                    'ACAA',
                    'AESA',
                    'ANAC AR',
                    'ANAC BR',
                    'ANAC CI',
                    'ANAC DJ',
                    'ANAC GA',
                    'ANAC GN',
                    'ANAC ML',
                    'ANAC MR',
                    'ANAC Niger',
                    'ANAC PT',
                    'ANAC Senegal',
                    'ANAC Togo',
                    'ASECNA',
                    'BHDCA',
                    'CAA AL',
                    'CAA BG',
                    'CAA BH',
                    'CAA CR',
                    'CAA LT',
                    'CAA LV',
                    'CAA LY',
                    'CAA MK',
                    'CAA MNE',
                    'CAA MV',
                    'CAA NO',
                    'CAA NZ',
                    'CAA Pakistan',
                    'CAA QA',
                    'CAA RT',
                    'CAA SI',
                    'CAA SL',
                    'CAA SR',
                    'CAA TW',
                    'CAA UK',
                    'CAA Uganda',
                    'CAAB BD',
                    'CAAB BW',
                    'CAAC',
                    'CAAE',
                    'CAAF',
                    'CAAH',
                    'CAAI',
                    'CAAM MN',
                    'CAAM MW',
                    'CAAM MY',
                    'CAAN',
                    'CAAP',
                    'CAAS',
                    'CAASI',
                    'CAAT',
                    'CAAV VN',
                    'CAAV VU',
                    'CAAZ ZM',
                    'CAAZ ZW',
                    'CAD HK',
                    'CAD MT',
                    'CAD RS',
                    'CAMA',
                    'CAO.IRI',
                    'CARC',
                    'CASA',
                    'CASA PNG',
                    'CASAS',
                    'CCAA',
                    'DAC',
                    'DCA BN',
                    'DCA CY',
                    'DCA LA',
                    'DCA MM',
                    'DGAC BO',
                    'DGAC CL',
                    'DGAC CR',
                    'DGAC DZ',
                    'DGAC EC',
                    'DGAC FR',
                    'DGAC GT',
                    'DGAC HN',
                    'DGAC MX',
                    'DGAC PE',
                    'DGAC TN',
                    'DGCA ID',
                    'DGCA IN',
                    'DGCA KW',
                    'DGCA LB',
                    'DGCA TR',
                    'DGTA/DGLV',
                    'DINAC',
                    'DINACIA',
                    'EASA',
                    'ECAA EE',
                    'ECAA EG',
                    'ECAA ET',
                    'ENAC',
                    'FAA',
                    'FOCA',
                    'GACA',
                    'GCAA AE',
                    'GCAA GE',
                    'GCAA GH',
                    'GCAA GM',
                    'GDCA',
                    'HCAA',
                    'IAA',
                    'IACC',
                    'ICAA',
                    'ICETRA',
                    'IDAC',
                    'ILT',
                    'INAC NI',
                    'INAC VE',
                    'INAVIC',
                    'JCAA',
                    'JCAB',
                    'KCAA KE',
                    'KCAA KR',
                    'LBA',
                    'LCAA LR',
                    'LCAA LS',
                    'MAA',
                    'MCA',
                    'Ministry of Transport and Communications',
                    'MoIC',
                    'NCAA NA',
                    'NCAA NG',
                    'OACM',
                    'OCA',
                    'ONDA',
                    'PACA',
                    'RCAA',
                    'Rosaviation',
                    'SAA',
                    'SAAU',
                    'SACA',
                    'SACAA',
                    'SCAA AZ',
                    'SCAA SC',
                    'SCAA SD',
                    'SCAA SY',
                    'SCAST',
                    'SLCAA LC',
                    'SLCAA SL',
                    'SMCAA',
                    'SSCA',
                    'SSCAA',
                    'TCAA',
                    'TCCA',
                    'TTCAA',
                    'Traficom',
                    'Transportstyrelsen',
                    'UAEAC',
                    'ULC',
                    'UzCAA'
                ],
                type: 'string'
            },
            title: 'Regulator',
            type: 'array'
        }
    },
    title: 'DocumentAttributeFilters',
    type: 'object'
} as const;

export const DocumentAttributesPublicSchema = {
    properties: {
        archetype: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ArchetypeName'
                },
                {
                    type: 'null'
                }
            ]
        },
        ata_chapter: {
            items: {
                type: 'integer'
            },
            title: 'Ata Chapter',
            type: 'array'
        },
        document_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Number'
        },
        issue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue'
        },
        issuer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issuer'
        },
        manufacturer: {
            items: {
                type: 'string'
            },
            title: 'Manufacturer',
            type: 'array'
        },
        model: {
            items: {
                type: 'string'
            },
            title: 'Model',
            type: 'array'
        },
        references: {
            items: {
                type: 'string'
            },
            title: 'References',
            type: 'array'
        },
        regulator: {
            anyOf: [
                {
                    enum: [
                        'AAC CD',
                        'AAC PA',
                        'AAC RM',
                        'AAC SV',
                        'AACM',
                        'AACR',
                        'AAN',
                        'ACAA',
                        'AESA',
                        'ANAC AR',
                        'ANAC BR',
                        'ANAC CI',
                        'ANAC DJ',
                        'ANAC GA',
                        'ANAC GN',
                        'ANAC ML',
                        'ANAC MR',
                        'ANAC Niger',
                        'ANAC PT',
                        'ANAC Senegal',
                        'ANAC Togo',
                        'ASECNA',
                        'BHDCA',
                        'CAA AL',
                        'CAA BG',
                        'CAA BH',
                        'CAA CR',
                        'CAA LT',
                        'CAA LV',
                        'CAA LY',
                        'CAA MK',
                        'CAA MNE',
                        'CAA MV',
                        'CAA NO',
                        'CAA NZ',
                        'CAA Pakistan',
                        'CAA QA',
                        'CAA RT',
                        'CAA SI',
                        'CAA SL',
                        'CAA SR',
                        'CAA TW',
                        'CAA UK',
                        'CAA Uganda',
                        'CAAB BD',
                        'CAAB BW',
                        'CAAC',
                        'CAAE',
                        'CAAF',
                        'CAAH',
                        'CAAI',
                        'CAAM MN',
                        'CAAM MW',
                        'CAAM MY',
                        'CAAN',
                        'CAAP',
                        'CAAS',
                        'CAASI',
                        'CAAT',
                        'CAAV VN',
                        'CAAV VU',
                        'CAAZ ZM',
                        'CAAZ ZW',
                        'CAD HK',
                        'CAD MT',
                        'CAD RS',
                        'CAMA',
                        'CAO.IRI',
                        'CARC',
                        'CASA',
                        'CASA PNG',
                        'CASAS',
                        'CCAA',
                        'DAC',
                        'DCA BN',
                        'DCA CY',
                        'DCA LA',
                        'DCA MM',
                        'DGAC BO',
                        'DGAC CL',
                        'DGAC CR',
                        'DGAC DZ',
                        'DGAC EC',
                        'DGAC FR',
                        'DGAC GT',
                        'DGAC HN',
                        'DGAC MX',
                        'DGAC PE',
                        'DGAC TN',
                        'DGCA ID',
                        'DGCA IN',
                        'DGCA KW',
                        'DGCA LB',
                        'DGCA TR',
                        'DGTA/DGLV',
                        'DINAC',
                        'DINACIA',
                        'EASA',
                        'ECAA EE',
                        'ECAA EG',
                        'ECAA ET',
                        'ENAC',
                        'FAA',
                        'FOCA',
                        'GACA',
                        'GCAA AE',
                        'GCAA GE',
                        'GCAA GH',
                        'GCAA GM',
                        'GDCA',
                        'HCAA',
                        'IAA',
                        'IACC',
                        'ICAA',
                        'ICETRA',
                        'IDAC',
                        'ILT',
                        'INAC NI',
                        'INAC VE',
                        'INAVIC',
                        'JCAA',
                        'JCAB',
                        'KCAA KE',
                        'KCAA KR',
                        'LBA',
                        'LCAA LR',
                        'LCAA LS',
                        'MAA',
                        'MCA',
                        'Ministry of Transport and Communications',
                        'MoIC',
                        'NCAA NA',
                        'NCAA NG',
                        'OACM',
                        'OCA',
                        'ONDA',
                        'PACA',
                        'RCAA',
                        'Rosaviation',
                        'SAA',
                        'SAAU',
                        'SACA',
                        'SACAA',
                        'SCAA AZ',
                        'SCAA SC',
                        'SCAA SD',
                        'SCAA SY',
                        'SCAST',
                        'SLCAA LC',
                        'SLCAA SL',
                        'SMCAA',
                        'SSCA',
                        'SSCAA',
                        'TCAA',
                        'TCCA',
                        'TTCAA',
                        'Traficom',
                        'Transportstyrelsen',
                        'UAEAC',
                        'ULC',
                        'UzCAA'
                    ],
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Regulator'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        revision_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision Date'
        },
        supersedes: {
            items: {
                type: 'string'
            },
            title: 'Supersedes',
            type: 'array'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        }
    },
    required: [
        'archetype',
        'regulator',
        'title',
        'document_number',
        'issuer',
        'revision',
        'issue',
        'revision_date',
        'manufacturer',
        'model',
        'ata_chapter',
        'supersedes',
        'references'
    ],
    title: 'DocumentAttributesPublic',
    type: 'object'
} as const;

export const DocumentBatchDownloadSchema = {
    properties: {
        document_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            title: 'Document Ids',
            type: 'array'
        },
        formats: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Formats'
        },
        trace_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Trace Id'
        }
    },
    required: [
        'document_ids'
    ],
    title: 'DocumentBatchDownload',
    type: 'object'
} as const;

export const DocumentBulkArchivePublicSchema = {
    properties: {
        archived: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Archived',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'archived',
        'skipped'
    ],
    title: 'DocumentBulkArchivePublic',
    type: 'object'
} as const;

export const DocumentBulkDeleteSchema = {
    properties: {
        document_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            minItems: 1,
            title: 'Document Ids',
            type: 'array'
        }
    },
    required: [
        'document_ids'
    ],
    title: 'DocumentBulkDelete',
    type: 'object'
} as const;

export const DocumentBulkDeletePublicSchema = {
    properties: {
        deleted: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Deleted',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'deleted',
        'skipped'
    ],
    title: 'DocumentBulkDeletePublic',
    type: 'object'
} as const;

export const DocumentBulkRestorePublicSchema = {
    properties: {
        restored: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Restored',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'restored',
        'skipped'
    ],
    title: 'DocumentBulkRestorePublic',
    type: 'object'
} as const;

export const DocumentBulkUpdateSchema = {
    properties: {
        document_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            minItems: 1,
            title: 'Document Ids',
            type: 'array'
        },
        visibility: {
            $ref: '#/components/schemas/SettableVisibility'
        }
    },
    required: [
        'document_ids',
        'visibility'
    ],
    title: 'DocumentBulkUpdate',
    type: 'object'
} as const;

export const DocumentDetailPublicSchema = {
    properties: {
        active_airworthiness_directive: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentAirworthinessDirectivePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        active_attributes: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentAttributesPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        active_emails: {
            items: {
                $ref: '#/components/schemas/EmailPublic'
            },
            title: 'Active Emails',
            type: 'array'
        },
        active_formats: {
            items: {
                $ref: '#/components/schemas/DocumentFormatPublic'
            },
            title: 'Active Formats',
            type: 'array'
        },
        active_quote_tasks: {
            items: {
                $ref: '#/components/schemas/QuoteTaskPublic'
            },
            title: 'Active Quote Tasks',
            type: 'array'
        },
        active_traces: {
            items: {
                $ref: '#/components/schemas/TracePublic'
            },
            title: 'Active Traces',
            type: 'array'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        canonical_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canonical Document Id'
        },
        content_type: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content Type'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        file_name: {
            title: 'File Name',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        links: {
            default: [],
            items: {
                $ref: '#/components/schemas/DocumentLinkPublic'
            },
            title: 'Links',
            type: 'array'
        },
        owner_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Id'
        },
        search: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentSearchInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        thumbnail_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thumbnail Url'
        },
        upload_result: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentUploadResult'
                },
                {
                    type: 'null'
                }
            ]
        },
        used_by: {
            default: [],
            items: {
                $ref: '#/components/schemas/UserBasicInfo'
            },
            title: 'Used By',
            type: 'array'
        },
        visibility: {
            $ref: '#/components/schemas/Visibility'
        }
    },
    required: [
        'id',
        'file_name',
        'content_type',
        'visibility',
        'owner_id',
        'created_at',
        'deleted_at',
        'archived_at',
        'active_formats',
        'active_quote_tasks',
        'active_emails',
        'active_traces'
    ],
    title: 'DocumentDetailPublic',
    type: 'object'
} as const;

export const DocumentFilterOptionsPublicSchema = {
    properties: {
        ata_chapter: {
            items: {
                type: 'integer'
            },
            title: 'Ata Chapter',
            type: 'array'
        },
        issued_by: {
            items: {
                enum: [
                    'AAC CD',
                    'AAC PA',
                    'AAC RM',
                    'AAC SV',
                    'AACM',
                    'AACR',
                    'AAN',
                    'ACAA',
                    'AESA',
                    'ANAC AR',
                    'ANAC BR',
                    'ANAC CI',
                    'ANAC DJ',
                    'ANAC GA',
                    'ANAC GN',
                    'ANAC ML',
                    'ANAC MR',
                    'ANAC Niger',
                    'ANAC PT',
                    'ANAC Senegal',
                    'ANAC Togo',
                    'ASECNA',
                    'BHDCA',
                    'CAA AL',
                    'CAA BG',
                    'CAA BH',
                    'CAA CR',
                    'CAA LT',
                    'CAA LV',
                    'CAA LY',
                    'CAA MK',
                    'CAA MNE',
                    'CAA MV',
                    'CAA NO',
                    'CAA NZ',
                    'CAA Pakistan',
                    'CAA QA',
                    'CAA RT',
                    'CAA SI',
                    'CAA SL',
                    'CAA SR',
                    'CAA TW',
                    'CAA UK',
                    'CAA Uganda',
                    'CAAB BD',
                    'CAAB BW',
                    'CAAC',
                    'CAAE',
                    'CAAF',
                    'CAAH',
                    'CAAI',
                    'CAAM MN',
                    'CAAM MW',
                    'CAAM MY',
                    'CAAN',
                    'CAAP',
                    'CAAS',
                    'CAASI',
                    'CAAT',
                    'CAAV VN',
                    'CAAV VU',
                    'CAAZ ZM',
                    'CAAZ ZW',
                    'CAD HK',
                    'CAD MT',
                    'CAD RS',
                    'CAMA',
                    'CAO.IRI',
                    'CARC',
                    'CASA',
                    'CASA PNG',
                    'CASAS',
                    'CCAA',
                    'DAC',
                    'DCA BN',
                    'DCA CY',
                    'DCA LA',
                    'DCA MM',
                    'DGAC BO',
                    'DGAC CL',
                    'DGAC CR',
                    'DGAC DZ',
                    'DGAC EC',
                    'DGAC FR',
                    'DGAC GT',
                    'DGAC HN',
                    'DGAC MX',
                    'DGAC PE',
                    'DGAC TN',
                    'DGCA ID',
                    'DGCA IN',
                    'DGCA KW',
                    'DGCA LB',
                    'DGCA TR',
                    'DGTA/DGLV',
                    'DINAC',
                    'DINACIA',
                    'EASA',
                    'ECAA EE',
                    'ECAA EG',
                    'ECAA ET',
                    'ENAC',
                    'FAA',
                    'FOCA',
                    'GACA',
                    'GCAA AE',
                    'GCAA GE',
                    'GCAA GH',
                    'GCAA GM',
                    'GDCA',
                    'HCAA',
                    'IAA',
                    'IACC',
                    'ICAA',
                    'ICETRA',
                    'IDAC',
                    'ILT',
                    'INAC NI',
                    'INAC VE',
                    'INAVIC',
                    'JCAA',
                    'JCAB',
                    'KCAA KE',
                    'KCAA KR',
                    'LBA',
                    'LCAA LR',
                    'LCAA LS',
                    'MAA',
                    'MCA',
                    'Ministry of Transport and Communications',
                    'MoIC',
                    'NCAA NA',
                    'NCAA NG',
                    'OACM',
                    'OCA',
                    'ONDA',
                    'PACA',
                    'RCAA',
                    'Rosaviation',
                    'SAA',
                    'SAAU',
                    'SACA',
                    'SACAA',
                    'SCAA AZ',
                    'SCAA SC',
                    'SCAA SD',
                    'SCAA SY',
                    'SCAST',
                    'SLCAA LC',
                    'SLCAA SL',
                    'SMCAA',
                    'SSCA',
                    'SSCAA',
                    'TCAA',
                    'TCCA',
                    'TTCAA',
                    'Traficom',
                    'Transportstyrelsen',
                    'UAEAC',
                    'ULC',
                    'UzCAA'
                ],
                type: 'string'
            },
            title: 'Issued By',
            type: 'array'
        },
        manufacturer: {
            items: {
                type: 'string'
            },
            title: 'Manufacturer',
            type: 'array'
        },
        manufacturer_count: {
            title: 'Manufacturer Count',
            type: 'integer'
        },
        regulator: {
            items: {
                enum: [
                    'AAC CD',
                    'AAC PA',
                    'AAC RM',
                    'AAC SV',
                    'AACM',
                    'AACR',
                    'AAN',
                    'ACAA',
                    'AESA',
                    'ANAC AR',
                    'ANAC BR',
                    'ANAC CI',
                    'ANAC DJ',
                    'ANAC GA',
                    'ANAC GN',
                    'ANAC ML',
                    'ANAC MR',
                    'ANAC Niger',
                    'ANAC PT',
                    'ANAC Senegal',
                    'ANAC Togo',
                    'ASECNA',
                    'BHDCA',
                    'CAA AL',
                    'CAA BG',
                    'CAA BH',
                    'CAA CR',
                    'CAA LT',
                    'CAA LV',
                    'CAA LY',
                    'CAA MK',
                    'CAA MNE',
                    'CAA MV',
                    'CAA NO',
                    'CAA NZ',
                    'CAA Pakistan',
                    'CAA QA',
                    'CAA RT',
                    'CAA SI',
                    'CAA SL',
                    'CAA SR',
                    'CAA TW',
                    'CAA UK',
                    'CAA Uganda',
                    'CAAB BD',
                    'CAAB BW',
                    'CAAC',
                    'CAAE',
                    'CAAF',
                    'CAAH',
                    'CAAI',
                    'CAAM MN',
                    'CAAM MW',
                    'CAAM MY',
                    'CAAN',
                    'CAAP',
                    'CAAS',
                    'CAASI',
                    'CAAT',
                    'CAAV VN',
                    'CAAV VU',
                    'CAAZ ZM',
                    'CAAZ ZW',
                    'CAD HK',
                    'CAD MT',
                    'CAD RS',
                    'CAMA',
                    'CAO.IRI',
                    'CARC',
                    'CASA',
                    'CASA PNG',
                    'CASAS',
                    'CCAA',
                    'DAC',
                    'DCA BN',
                    'DCA CY',
                    'DCA LA',
                    'DCA MM',
                    'DGAC BO',
                    'DGAC CL',
                    'DGAC CR',
                    'DGAC DZ',
                    'DGAC EC',
                    'DGAC FR',
                    'DGAC GT',
                    'DGAC HN',
                    'DGAC MX',
                    'DGAC PE',
                    'DGAC TN',
                    'DGCA ID',
                    'DGCA IN',
                    'DGCA KW',
                    'DGCA LB',
                    'DGCA TR',
                    'DGTA/DGLV',
                    'DINAC',
                    'DINACIA',
                    'EASA',
                    'ECAA EE',
                    'ECAA EG',
                    'ECAA ET',
                    'ENAC',
                    'FAA',
                    'FOCA',
                    'GACA',
                    'GCAA AE',
                    'GCAA GE',
                    'GCAA GH',
                    'GCAA GM',
                    'GDCA',
                    'HCAA',
                    'IAA',
                    'IACC',
                    'ICAA',
                    'ICETRA',
                    'IDAC',
                    'ILT',
                    'INAC NI',
                    'INAC VE',
                    'INAVIC',
                    'JCAA',
                    'JCAB',
                    'KCAA KE',
                    'KCAA KR',
                    'LBA',
                    'LCAA LR',
                    'LCAA LS',
                    'MAA',
                    'MCA',
                    'Ministry of Transport and Communications',
                    'MoIC',
                    'NCAA NA',
                    'NCAA NG',
                    'OACM',
                    'OCA',
                    'ONDA',
                    'PACA',
                    'RCAA',
                    'Rosaviation',
                    'SAA',
                    'SAAU',
                    'SACA',
                    'SACAA',
                    'SCAA AZ',
                    'SCAA SC',
                    'SCAA SD',
                    'SCAA SY',
                    'SCAST',
                    'SLCAA LC',
                    'SLCAA SL',
                    'SMCAA',
                    'SSCA',
                    'SSCAA',
                    'TCAA',
                    'TCCA',
                    'TTCAA',
                    'Traficom',
                    'Transportstyrelsen',
                    'UAEAC',
                    'ULC',
                    'UzCAA'
                ],
                type: 'string'
            },
            title: 'Regulator',
            type: 'array'
        }
    },
    required: [
        'issued_by',
        'regulator',
        'manufacturer',
        'manufacturer_count',
        'ata_chapter'
    ],
    title: 'DocumentFilterOptionsPublic',
    type: 'object'
} as const;

export const DocumentFiltersSchema = {
    properties: {
        airworthiness_directive: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AirworthinessDirectiveFilters'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Restricts results to airworthiness directives. Send it empty to mean only ADs, or with filters to narrow them further.'
        },
        archived: {
            default: false,
            description: 'Returns archived documents instead of live ones.',
            title: 'Archived',
            type: 'boolean'
        },
        attributes: {
            $ref: '#/components/schemas/DocumentAttributeFilters',
            default: {
                archetype: [],
                ata_chapter: [],
                document_number: [],
                manufacturer: [],
                model: [],
                references: [],
                regulator: []
            },
            description: 'Filters over what was extracted from each document. A document matches a field if it matches any one of that field\'s entries.'
        },
        exclude_archetypes: {
            default: [],
            description: 'Leaves documents of these kinds out of the results.',
            items: {
                $ref: '#/components/schemas/ArchetypeName'
            },
            title: 'Exclude Archetypes',
            type: 'array'
        },
        ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Restricts results to these documents, for fetching a known set in one call. An empty list matches nothing.',
            title: 'Ids'
        },
        superseded: {
            default: false,
            description: 'Includes superseded revisions alongside the current ones.',
            title: 'Superseded',
            type: 'boolean'
        },
        visibility: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Visibility'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Restricts results to documents of one visibility.'
        }
    },
    title: 'DocumentFilters',
    type: 'object'
} as const;

export const DocumentFormatPublicSchema = {
    properties: {
        blob_url: {
            title: 'Blob Url',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        mime_type: {
            title: 'Mime Type',
            type: 'string'
        }
    },
    required: [
        'id',
        'mime_type',
        'blob_url'
    ],
    title: 'DocumentFormatPublic',
    type: 'object'
} as const;

export const DocumentGroupingSchema = {
    enum: [
        'issued_by',
        'regulator',
        'manufacturer',
        'ata_chapter'
    ],
    title: 'DocumentGrouping',
    type: 'string'
} as const;

export const DocumentKindSchema = {
    enum: [
        'quote',
        'work_order',
        'task_card',
        'due_list',
        'squawk_card',
        'squawk_list'
    ],
    title: 'DocumentKind',
    type: 'string'
} as const;

export const DocumentLinkPublicSchema = {
    properties: {
        archetype: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ArchetypeName'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        direction: {
            $ref: '#/components/schemas/LinkDirection'
        },
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        },
        document_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Number'
        },
        file_name: {
            title: 'File Name',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        link_type: {
            $ref: '#/components/schemas/DocumentLinkType'
        }
    },
    required: [
        'id',
        'link_type',
        'direction',
        'document_id',
        'file_name',
        'created_at'
    ],
    title: 'DocumentLinkPublic',
    type: 'object'
} as const;

export const DocumentLinkTypeSchema = {
    enum: [
        'references',
        'supersedes',
        'alternate'
    ],
    title: 'DocumentLinkType',
    type: 'string'
} as const;

export const DocumentOrderBySchema = {
    enum: [
        'created_at',
        'usage',
        'document_number',
        'title',
        'issued_by',
        'regulator',
        'manufacturer',
        'ata_chapter',
        'effective_date'
    ],
    title: 'DocumentOrderBy',
    type: 'string'
} as const;

export const DocumentPublicSchema = {
    properties: {
        active_airworthiness_directive: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentAirworthinessDirectivePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        active_attributes: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentAttributesPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        canonical_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canonical Document Id'
        },
        content_type: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content Type'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        file_name: {
            title: 'File Name',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        links: {
            default: [],
            items: {
                $ref: '#/components/schemas/DocumentLinkPublic'
            },
            title: 'Links',
            type: 'array'
        },
        owner_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Id'
        },
        search: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentSearchInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        thumbnail_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thumbnail Url'
        },
        upload_result: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentUploadResult'
                },
                {
                    type: 'null'
                }
            ]
        },
        used_by: {
            default: [],
            items: {
                $ref: '#/components/schemas/UserBasicInfo'
            },
            title: 'Used By',
            type: 'array'
        },
        visibility: {
            $ref: '#/components/schemas/Visibility'
        }
    },
    required: [
        'id',
        'file_name',
        'content_type',
        'visibility',
        'owner_id',
        'created_at',
        'deleted_at',
        'archived_at'
    ],
    title: 'DocumentPublic',
    type: 'object'
} as const;

export const DocumentReferenceOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateDocumentReference',
            remove: '#/components/schemas/RemoveDocumentReference'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateDocumentReference'
        },
        {
            $ref: '#/components/schemas/RemoveDocumentReference'
        }
    ]
} as const;

export const DocumentReferencePublicSchema = {
    properties: {
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        value: {
            $ref: '#/components/schemas/DocumentReferenceValue'
        }
    },
    required: [
        'id',
        'document_id',
        'value'
    ],
    title: 'DocumentReferencePublic',
    type: 'object'
} as const;

export const DocumentReferenceValueSchema = {
    discriminator: {
        mapping: {
            bounding_box: '#/components/schemas/BoundingBoxReference',
            text: '#/components/schemas/TextReference'
        },
        propertyName: 'type'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/BoundingBoxReference'
        },
        {
            $ref: '#/components/schemas/TextReference'
        }
    ]
} as const;

export const DocumentRegionReference_InputSchema = {
    description: 'Reference to specific region(s) in a PDF document.',
    properties: {
        bboxes: {
            items: {
                $ref: '#/components/schemas/BoundingBox'
            },
            title: 'Bboxes',
            type: 'array'
        },
        blob_url: {
            title: 'Blob Url',
            type: 'string'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'integer'
                }
            ],
            title: 'Document Id'
        },
        excerpt: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Excerpt'
        },
        resource: {
            enum: [
                'airworthiness_directive',
                'service_bulletin'
            ],
            title: 'Resource',
            type: 'string'
        },
        type: {
            const: 'document_region',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'resource',
        'document_id',
        'blob_url',
        'bboxes'
    ],
    title: 'DocumentRegionReference',
    type: 'object'
} as const;

export const DocumentRegionReference_OutputSchema = {
    description: 'Reference to specific region(s) in a PDF document.',
    properties: {
        bboxes: {
            items: {
                $ref: '#/components/schemas/BoundingBox'
            },
            title: 'Bboxes',
            type: 'array'
        },
        blob_url: {
            title: 'Blob Url',
            type: 'string'
        },
        document_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                }
            ],
            title: 'Document Id'
        },
        excerpt: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Excerpt'
        },
        resource: {
            enum: [
                'airworthiness_directive',
                'service_bulletin'
            ],
            title: 'Resource',
            type: 'string'
        },
        type: {
            const: 'document_region',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'resource',
        'document_id',
        'blob_url',
        'bboxes'
    ],
    title: 'DocumentRegionReference',
    type: 'object'
} as const;

export const DocumentRegionReferenceV2_InputSchema = {
    properties: {
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        },
        page: {
            title: 'Page',
            type: 'integer'
        },
        text: {
            title: 'Text',
            type: 'string'
        },
        type: {
            const: 'document_region_v2',
            default: 'document_region_v2',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'document_id',
        'page',
        'text'
    ],
    title: 'DocumentRegionReferenceV2',
    type: 'object'
} as const;

export const DocumentRegionReferenceV2_OutputSchema = {
    properties: {
        document_id: {
            title: 'Document Id',
            type: 'string'
        },
        page: {
            title: 'Page',
            type: 'integer'
        },
        text: {
            title: 'Text',
            type: 'string'
        },
        type: {
            const: 'document_region_v2',
            default: 'document_region_v2',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'document_id',
        'page',
        'text'
    ],
    title: 'DocumentRegionReferenceV2',
    type: 'object'
} as const;

export const DocumentSearchSchema = {
    properties: {
        airworthiness_directive: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AirworthinessDirectiveFilters'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Restricts results to airworthiness directives. Send it empty to mean only ADs, or with filters to narrow them further.'
        },
        archived: {
            default: false,
            description: 'Returns archived documents instead of live ones.',
            title: 'Archived',
            type: 'boolean'
        },
        attributes: {
            $ref: '#/components/schemas/DocumentAttributeFilters',
            default: {
                archetype: [],
                ata_chapter: [],
                document_number: [],
                manufacturer: [],
                model: [],
                references: [],
                regulator: []
            },
            description: 'Filters over what was extracted from each document. A document matches a field if it matches any one of that field\'s entries.'
        },
        direction: {
            $ref: '#/components/schemas/SortDirection',
            default: 'desc',
            description: 'Direction of `order_by`. Documents without a value for it come last either way.'
        },
        exclude_archetypes: {
            default: [],
            description: 'Leaves documents of these kinds out of the results.',
            items: {
                $ref: '#/components/schemas/ArchetypeName'
            },
            title: 'Exclude Archetypes',
            type: 'array'
        },
        group: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentGrouping'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Orders results by this key first, and counts each group on the first page. Ignored while `search` is set.'
        },
        group_key: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Only documents in this group of `group`, as keyed in `groups`. Groups are not counted then.',
            title: 'Group Key'
        },
        group_limit: {
            anyOf: [
                {
                    maximum: 100,
                    minimum: 1,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            description: 'On the first page of a grouped list, returns the first this many documents of every group instead of `skip` and `limit`.',
            title: 'Group Limit'
        },
        ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Restricts results to these documents, for fetching a known set in one call. An empty list matches nothing.',
            title: 'Ids'
        },
        limit: {
            default: 100,
            description: 'Documents per page, within the ranked best while `search` is set.',
            maximum: 500,
            minimum: 0,
            title: 'Limit',
            type: 'integer'
        },
        order_by: {
            $ref: '#/components/schemas/DocumentOrderBy',
            default: 'created_at',
            description: 'Ignored while `search` is set, which orders by relevance.'
        },
        search: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'On /documents/search, documents whose file name, title or document number contain every word come first, then BM25 over the documents\' own text; /documents/airworthiness-directives/search ranks number and title by BM25 too. BM25 is stemmed and stopword-stripped, so search the distinctive words. The best matches come back ranked, 50 on /documents/search and 200 on /documents/airworthiness-directives/search; filters pick what is ranked, so a narrow filter with a broad query is fine.',
            title: 'Search'
        },
        skip: {
            default: 0,
            description: 'Documents to skip.',
            minimum: 0,
            title: 'Skip',
            type: 'integer'
        },
        subgroup: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentGrouping'
                },
                {
                    type: 'null'
                }
            ],
            description: 'A second key within each group, counted under its group.'
        },
        superseded: {
            default: false,
            description: 'Includes superseded revisions alongside the current ones.',
            title: 'Superseded',
            type: 'boolean'
        },
        visibility: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Visibility'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Restricts results to documents of one visibility.'
        }
    },
    title: 'DocumentSearch',
    type: 'object'
} as const;

export const DocumentSearchInfoSchema = {
    properties: {
        matched: {
            anyOf: [
                {
                    $ref: '#/components/schemas/MatchedTextPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        page: {
            title: 'Page',
            type: 'integer'
        }
    },
    required: [
        'matched',
        'page'
    ],
    title: 'DocumentSearchInfo',
    type: 'object'
} as const;

export const DocumentTemplatePreviewSchema = {
    properties: {
        record: {
            $ref: '#/components/schemas/PreviewRecord'
        },
        template: {
            $ref: '#/components/schemas/DocumentTemplateUpsert'
        }
    },
    required: [
        'template',
        'record'
    ],
    title: 'DocumentTemplatePreview',
    type: 'object'
} as const;

export const DocumentTemplatePublicSchema = {
    properties: {
        body: {
            title: 'Body',
            type: 'string'
        },
        footer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Footer'
        },
        header: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Header'
        },
        is_default: {
            title: 'Is Default',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/DocumentKind'
        },
        updated_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At'
        }
    },
    required: [
        'kind',
        'body',
        'header',
        'footer',
        'is_default',
        'updated_at'
    ],
    title: 'DocumentTemplatePublic',
    type: 'object'
} as const;

export const DocumentTemplateUpsertSchema = {
    properties: {
        body: {
            minLength: 1,
            title: 'Body',
            type: 'string'
        },
        footer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Footer'
        },
        header: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Header'
        }
    },
    required: [
        'body'
    ],
    title: 'DocumentTemplateUpsert',
    type: 'object'
} as const;

export const DocumentUpdateSchema = {
    properties: {
        visibility: {
            $ref: '#/components/schemas/SettableVisibility'
        }
    },
    required: [
        'visibility'
    ],
    title: 'DocumentUpdate',
    type: 'object'
} as const;

export const DocumentUploadResultSchema = {
    enum: [
        'uploaded',
        'exact_duplicate'
    ],
    title: 'DocumentUploadResult',
    type: 'string'
} as const;

export const DocumentsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/DocumentPublic'
            },
            title: 'Data',
            type: 'array'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/GroupCountPublic'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'data',
        'count',
        'groups'
    ],
    title: 'DocumentsPublic',
    type: 'object'
} as const;

export const DraftTraceCreateSchema = {
    properties: {
        aircraft_registration: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Registration'
        },
        work_task_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Number'
        }
    },
    required: [
        'aircraft_registration',
        'work_task_number'
    ],
    title: 'DraftTraceCreate',
    type: 'object'
} as const;

export const DueHorizonFromSchema = {
    enum: [
        'arrival',
        'departure'
    ],
    title: 'DueHorizonFrom',
    type: 'string'
} as const;

export const DueListItemSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        check_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Check Id'
        },
        task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Id'
        }
    },
    required: [
        'aircraft_id',
        'task_id',
        'check_id'
    ],
    title: 'DueListItem',
    type: 'object'
} as const;

export const DueListPreviewRecordSchema = {
    properties: {
        forecast_id: {
            format: 'uuid',
            title: 'Forecast Id',
            type: 'string'
        },
        source: {
            const: 'due_list',
            title: 'Source',
            type: 'string'
        }
    },
    required: [
        'source',
        'forecast_id'
    ],
    title: 'DueListPreviewRecord',
    type: 'object'
} as const;

export const DueOutlookSchema = {
    enum: [
        'within_horizon',
        'beyond_horizon'
    ],
    title: 'DueOutlook',
    type: 'string'
} as const;

export const DueRowPublicSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        anchor: {
            $ref: '#/components/schemas/AnchorKind'
        },
        check_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Check Id'
        },
        check_ids: {
            description: 'For a task, the checks that cover it, with the checks that include them',
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Check Ids',
            type: 'array'
        },
        days: {
            title: 'Days',
            type: 'integer'
        },
        due_at: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The counter reading at which a usage limit falls due',
            title: 'Due At'
        },
        due_on: {
            format: 'date',
            title: 'Due On',
            type: 'string'
        },
        earliest_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Earliest On'
        },
        findings: {
            items: {
                $ref: '#/components/schemas/FindingPublic'
            },
            title: 'Findings',
            type: 'array'
        },
        fitted_component_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The fitted component the limit is measured on; empty for the airframe',
            title: 'Fitted Component Id'
        },
        interval: {
            title: 'Interval',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/ForecastItemKind'
        },
        last_done: {
            anyOf: [
                {
                    $ref: '#/components/schemas/LastDonePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        latest_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Latest On'
        },
        man_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Man Hours'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        programme_id: {
            format: 'uuid',
            title: 'Programme Id',
            type: 'string'
        },
        programme_number: {
            title: 'Programme Number',
            type: 'string'
        },
        programme_title: {
            title: 'Programme Title',
            type: 'string'
        },
        projected: {
            description: 'Whether due_on is projected from daily utilization',
            title: 'Projected',
            type: 'boolean'
        },
        registration: {
            title: 'Registration',
            type: 'string'
        },
        remaining: {
            description: 'Usage left in the limit\'s unit, or days left for calendar limits',
            title: 'Remaining',
            type: 'string'
        },
        requires_approval: {
            title: 'Requires Approval',
            type: 'boolean'
        },
        revision_id: {
            format: 'uuid',
            title: 'Revision Id',
            type: 'string'
        },
        schedule: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Schedule-Output'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The interval the item follows; empty when inherited from several checks'
        },
        status: {
            $ref: '#/components/schemas/DueStatus'
        },
        subject: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The component the limit is measured on; empty for the airframe',
            title: 'Subject'
        },
        task_code: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskCode'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Id'
        },
        title: {
            title: 'Title',
            type: 'string'
        },
        unit: {
            $ref: '#/components/schemas/Unit'
        },
        window: {
            $ref: '#/components/schemas/DueWindow'
        }
    },
    required: [
        'aircraft_id',
        'registration',
        'programme_id',
        'programme_number',
        'programme_title',
        'revision_id',
        'kind',
        'task_id',
        'check_id',
        'number',
        'title',
        'task_code',
        'schedule',
        'man_hours',
        'last_done',
        'findings',
        'check_ids',
        'unit',
        'interval',
        'anchor',
        'subject',
        'fitted_component_id',
        'due_at',
        'due_on',
        'projected',
        'remaining',
        'days',
        'earliest_on',
        'latest_on',
        'requires_approval',
        'status',
        'window'
    ],
    title: 'DueRowPublic',
    type: 'object'
} as const;

export const DueStatusSchema = {
    enum: [
        'overdue',
        'in_tolerance',
        'due_soon',
        'scheduled'
    ],
    title: 'DueStatus',
    type: 'string'
} as const;

export const DueUnitSchema = {
    enum: [
        'date',
        'hours',
        'landings',
        'months',
        'cycles'
    ],
    title: 'DueUnit',
    type: 'string'
} as const;

export const DueWindowSchema = {
    enum: [
        'overdue',
        'next_7_days',
        'days_8_to_30',
        'days_31_to_90',
        'days_91_to_180',
        'days_181_to_365',
        'later'
    ],
    title: 'DueWindow',
    type: 'string'
} as const;

export const ERPApiKeyPublicSchema = {
    properties: {
        key_prefix: {
            title: 'Key Prefix',
            type: 'string'
        },
        set_at: {
            format: 'date-time',
            title: 'Set At',
            type: 'string'
        },
        set_by_id: {
            format: 'uuid',
            title: 'Set By Id',
            type: 'string'
        }
    },
    required: [
        'key_prefix',
        'set_by_id',
        'set_at'
    ],
    title: 'ERPApiKeyPublic',
    type: 'object'
} as const;

export const ERPApiKeyScopePublicSchema = {
    properties: {
        tenant_erp_config_id: {
            format: 'uuid',
            title: 'Tenant Erp Config Id',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        }
    },
    required: [
        'tenant_id',
        'tenant_erp_config_id'
    ],
    title: 'ERPApiKeyScopePublic',
    type: 'object'
} as const;

export const ERPApiKeySecretPublicSchema = {
    properties: {
        key: {
            title: 'Key',
            type: 'string'
        },
        key_prefix: {
            title: 'Key Prefix',
            type: 'string'
        },
        set_at: {
            format: 'date-time',
            title: 'Set At',
            type: 'string'
        },
        set_by_id: {
            format: 'uuid',
            title: 'Set By Id',
            type: 'string'
        }
    },
    required: [
        'key_prefix',
        'set_by_id',
        'set_at',
        'key'
    ],
    title: 'ERPApiKeySecretPublic',
    type: 'object'
} as const;

export const ERPApiKeyStatePublicSchema = {
    properties: {
        api_key: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ERPApiKeyPublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'api_key'
    ],
    title: 'ERPApiKeyStatePublic',
    type: 'object'
} as const;

export const ERPConfigResponseSchema = {
    properties: {
        configured: {
            title: 'Configured',
            type: 'boolean'
        },
        display_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Display Name'
        },
        domain: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        },
        vendor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ERPVendor'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'configured'
    ],
    title: 'ERPConfigResponse',
    type: 'object'
} as const;

export const ERPCredentialVendorSchema = {
    enum: [
        'ebis5_internal',
        'ebis5',
        'partsbase'
    ],
    title: 'ERPCredentialVendor',
    type: 'string'
} as const;

export const ERPSyncResponseSchema = {
    properties: {
        duration_seconds: {
            default: 0,
            title: 'Duration Seconds',
            type: 'number'
        },
        errors: {
            default: 0,
            title: 'Errors',
            type: 'integer'
        },
        message: {
            title: 'Message',
            type: 'string'
        },
        work_packages: {
            default: 0,
            title: 'Work Packages',
            type: 'integer'
        },
        work_tasks: {
            default: 0,
            title: 'Work Tasks',
            type: 'integer'
        }
    },
    required: [
        'message'
    ],
    title: 'ERPSyncResponse',
    type: 'object'
} as const;

export const ERPVendorSchema = {
    enum: [
        'corridor',
        'ebis5',
        'quantum'
    ],
    title: 'ERPVendor',
    type: 'string'
} as const;

export const EmailBulkArchivePublicSchema = {
    properties: {
        archived: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Archived',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'archived',
        'skipped'
    ],
    title: 'EmailBulkArchivePublic',
    type: 'object'
} as const;

export const EmailBulkDeletePublicSchema = {
    properties: {
        deleted: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Deleted',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'deleted',
        'skipped'
    ],
    title: 'EmailBulkDeletePublic',
    type: 'object'
} as const;

export const EmailBulkIdsSchema = {
    properties: {
        email_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            minItems: 1,
            title: 'Email Ids',
            type: 'array'
        }
    },
    required: [
        'email_ids'
    ],
    title: 'EmailBulkIds',
    type: 'object'
} as const;

export const EmailBulkRestorePublicSchema = {
    properties: {
        restored: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Restored',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'restored',
        'skipped'
    ],
    title: 'EmailBulkRestorePublic',
    type: 'object'
} as const;

export const EmailBulkSharePublicSchema = {
    properties: {
        shared: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Shared',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'shared',
        'skipped'
    ],
    title: 'EmailBulkSharePublic',
    type: 'object'
} as const;

export const EmailDetailPublicSchema = {
    properties: {
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        body_plain: {
            title: 'Body Plain',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        from_address: {
            title: 'From Address',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        owner_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Id'
        },
        stripped_signature: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Stripped Signature'
        },
        stripped_text: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Stripped Text'
        },
        subject: {
            title: 'Subject',
            type: 'string'
        },
        visibility: {
            $ref: '#/components/schemas/EmailVisibility'
        },
        visible_documents: {
            items: {
                $ref: '#/components/schemas/DocumentPublic'
            },
            title: 'Visible Documents',
            type: 'array'
        }
    },
    required: [
        'id',
        'subject',
        'from_address',
        'body_plain',
        'stripped_text',
        'stripped_signature',
        'visibility',
        'owner_id',
        'created_at',
        'deleted_at',
        'archived_at'
    ],
    title: 'EmailDetailPublic',
    type: 'object'
} as const;

export const EmailFilterOptionsPublicSchema = {
    properties: {
        senders: {
            items: {
                type: 'string'
            },
            title: 'Senders',
            type: 'array'
        }
    },
    required: [
        'senders'
    ],
    title: 'EmailFilterOptionsPublic',
    type: 'object'
} as const;

export const EmailPublicSchema = {
    properties: {
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        body_plain: {
            title: 'Body Plain',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        from_address: {
            title: 'From Address',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        owner_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Id'
        },
        stripped_signature: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Stripped Signature'
        },
        stripped_text: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Stripped Text'
        },
        subject: {
            title: 'Subject',
            type: 'string'
        },
        visibility: {
            $ref: '#/components/schemas/EmailVisibility'
        }
    },
    required: [
        'id',
        'subject',
        'from_address',
        'body_plain',
        'stripped_text',
        'stripped_signature',
        'visibility',
        'owner_id',
        'created_at',
        'deleted_at',
        'archived_at'
    ],
    title: 'EmailPublic',
    type: 'object'
} as const;

export const EmailUpdateSchema = {
    properties: {
        visibility: {
            $ref: '#/components/schemas/EmailVisibility'
        }
    },
    required: [
        'visibility'
    ],
    title: 'EmailUpdate',
    type: 'object'
} as const;

export const EmailVisibilitySchema = {
    enum: [
        'user',
        'tenant'
    ],
    title: 'EmailVisibility',
    type: 'string'
} as const;

export const EmailsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/EmailDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'EmailsPublic',
    type: 'object'
} as const;

export const ErrorCodeSchema = {
    description: 'Error codes with user-friendly messages.\n\nThe value is the sanitized message shown to users.',
    enum: [
        'The requested resource was not found.',
        'A resource with this identifier already exists.',
        'A conflict occurred with the requested resource.',
        'Invalid input provided. Please check your data and try again.',
        'Invalid URL format provided.',
        'Invalid file format. Please check the file and try again.',
        'Failed to generate PDF. Please try again or contact support.',
        'Failed to process document. Please check the file format and try again.',
        'The document template could not be rendered.',
        'Failed to send email. Please try again later.',
        'Failed to sync with external system. Please try again later.',
        'An error occurred with an external service. Please try again later.',
        'File is too large. The maximum file size is 100 MB.',
        'Failed to upload file. Please try again.',
        'Failed to delete file. Please try again.',
        'The requested file was not found.',
        'Your session has expired. Please log in again.',
        'You don\'t have permission to perform this action.',
        'Invalid username or password. Please try again.',
        'Your session needs to be refreshed. Please re-authenticate.',
        'Too many requests. Please try again later.',
        'Failed to transcribe audio. Please try again.',
        'Failed to process audio file.',
        'An unexpected error occurred. Please try again or contact support.',
        'An internal error occurred. Please try again or contact support.',
        'A database error occurred. Please try again or contact support.',
        'Service temporarily unavailable. Please try again later.',
        'A configuration issue was detected. Please contact support.',
        'The requested notification was not found.',
        'Signed-off steps can\'t be changed. Undo the sign-off first.',
        'Only steps without sub-steps can be signed off or marked for inspection.',
        'Steps marked for inspection can\'t have sub-steps.',
        'Steps with sub-steps can\'t be marked for inspection.',
        'Steps can be nested at most five levels deep.',
        'This step isn\'t marked for inspection.',
        'This task is signed off. Undo the sign-off first.',
        'This task is closed.',
        'This task has logged time or parts. Remove them before deleting the task.',
        'This task is inspected. Undo the inspection first.',
        'This step is inspected. Undo the inspection first.',
        'This task can\'t move to that status from its current one.',
        'Sign off every step before signing off the task.',
        'Add a resolution before signing off the task.',
        'The technician must sign off the task before the inspector.',
        'The technician must sign off before the inspector.',
        'A task can\'t be inspected by the technician who signed it off.',
        'A step can\'t be inspected by the technician who signed it off.',
        'Your workspace\'s review rules don\'t let you review this task.',
        'You sent this quote for review, so someone else needs to review it.',
        'You\'ve already approved this task. Another reviewer needs to approve it.',
        'Your workspace\'s review rules don\'t let you decide this squawk.',
        'You\'ve already approved this squawk. Someone else needs to approve it.',
        'Choose who is signing.',
        'That person hasn\'t set a signing PIN.',
        'That person\'s signing PIN is locked after too many wrong tries. They need to set a new one.',
        'That person can\'t sign from this account.',
        'That person isn\'t allowed to sign this.',
        'Set a signing PIN in Settings > Account > Signing PIN before you sign.',
        'That signing PIN is incorrect.',
        'Your signing PIN is locked after too many wrong tries. Set a new one in Settings > Account > Signing PIN.',
        'Your workspace\'s sign-off rules don\'t let you sign this.',
        'You\'ve already inspected this. Another inspector needs to sign.',
        'You\'ve already signed this. Another technician needs to sign.',
        'The planned departure can\'t be before the arrival.',
        'This action isn\'t available for the work order\'s current status.',
        'Set the arrival and planned departure before releasing the work order.',
        'Sign off or defer every task before completing the work order.',
        'Close every task before closing the work order.',
        'This work order is cancelled.',
        'This work order is closed.',
        'This work order is complete. Reopen it first.',
        'Another work order already has this number.',
        'Another task on this work order already has this number.',
        'This part is already on the task. Change its quantity instead.',
        'Parts have been issued against this request, so it can\'t be changed.',
        'That\'s more than the request still needs.',
        'Reserve no more than the request still needs.',
        'Set the part\'s condition before reserving it.',
        'That stock line holds a different part.',
        'That stock line isn\'t serviceable.',
        'That stock line doesn\'t have that many on hand.',
        'Not enough of this part is free. Other work holds the rest.',
        'Someone else locked this reservation, so only they can change or release it.',
        'This reservation belongs to a work order task. Change it from the task.',
        'This service is already on a purchase order, so it can\'t be withdrawn.',
        'This service isn\'t at a stage where that can happen.',
        'Time can only be booked to open tasks on scheduled or in-progress work orders.',
        'Time can\'t be logged for a time that hasn\'t happened yet.',
        'Set up the Corridor relay in Settings > ERP first.',
        'Only a failed send to Corridor can be retried.',
        'Set the quote\'s department before sending it to Corridor.',
        'RFP quotes can\'t be sent to Corridor.'
    ],
    title: 'ErrorCode',
    type: 'string'
} as const;

export const EventExprSchema = {
    additionalProperties: false,
    properties: {
        event: {
            $ref: '#/components/schemas/EventKind'
        },
        label: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Label'
        },
        op: {
            const: 'event',
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'event'
    ],
    title: 'EventExpr',
    type: 'object'
} as const;

export const EventKindSchema = {
    enum: [
        'engine_change',
        'apu_change',
        'other'
    ],
    title: 'EventKind',
    type: 'string'
} as const;

export const ExcludedItemPublicSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        check_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Check Id'
        },
        check_ids: {
            description: 'For a task, the checks that cover it, with the checks that include them',
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Check Ids',
            type: 'array'
        },
        exclusion: {
            $ref: '#/components/schemas/ForecastExclusionPublic'
        },
        findings: {
            items: {
                $ref: '#/components/schemas/FindingPublic'
            },
            title: 'Findings',
            type: 'array'
        },
        kind: {
            $ref: '#/components/schemas/ForecastItemKind'
        },
        last_done: {
            anyOf: [
                {
                    $ref: '#/components/schemas/LastDonePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        man_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Man Hours'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        programme_id: {
            format: 'uuid',
            title: 'Programme Id',
            type: 'string'
        },
        programme_number: {
            title: 'Programme Number',
            type: 'string'
        },
        programme_title: {
            title: 'Programme Title',
            type: 'string'
        },
        registration: {
            title: 'Registration',
            type: 'string'
        },
        revision_id: {
            format: 'uuid',
            title: 'Revision Id',
            type: 'string'
        },
        schedule: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Schedule-Output'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The interval the item follows; empty when inherited from several checks'
        },
        task_code: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskCode'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Id'
        },
        title: {
            title: 'Title',
            type: 'string'
        }
    },
    required: [
        'aircraft_id',
        'registration',
        'programme_id',
        'programme_number',
        'programme_title',
        'revision_id',
        'kind',
        'task_id',
        'check_id',
        'number',
        'title',
        'task_code',
        'schedule',
        'man_hours',
        'last_done',
        'findings',
        'check_ids',
        'exclusion'
    ],
    title: 'ExcludedItemPublic',
    type: 'object'
} as const;

export const ExistingPartSchema = {
    properties: {
        kind: {
            const: 'existing_part',
            title: 'Kind',
            type: 'string'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'part_id'
    ],
    title: 'ExistingPart',
    type: 'object'
} as const;

export const Expr_InputSchema = {
    discriminator: {
        mapping: {
            case: '#/components/schemas/CaseExpr-Input',
            event: '#/components/schemas/EventExpr',
            external: '#/components/schemas/ExternalExpr',
            first: '#/components/schemas/WhicheverExpr-Input',
            later: '#/components/schemas/WhicheverExpr-Input',
            limit: '#/components/schemas/LimitExpr',
            option: '#/components/schemas/OptionExpr-Input'
        },
        propertyName: 'op'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/LimitExpr'
        },
        {
            $ref: '#/components/schemas/EventExpr'
        },
        {
            $ref: '#/components/schemas/WhicheverExpr-Input'
        },
        {
            $ref: '#/components/schemas/CaseExpr-Input'
        },
        {
            $ref: '#/components/schemas/OptionExpr-Input'
        },
        {
            $ref: '#/components/schemas/ExternalExpr'
        }
    ]
} as const;

export const Expr_OutputSchema = {
    discriminator: {
        mapping: {
            case: '#/components/schemas/CaseExpr-Output',
            event: '#/components/schemas/EventExpr',
            external: '#/components/schemas/ExternalExpr',
            first: '#/components/schemas/WhicheverExpr-Output',
            later: '#/components/schemas/WhicheverExpr-Output',
            limit: '#/components/schemas/LimitExpr',
            option: '#/components/schemas/OptionExpr-Output'
        },
        propertyName: 'op'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/LimitExpr'
        },
        {
            $ref: '#/components/schemas/EventExpr'
        },
        {
            $ref: '#/components/schemas/WhicheverExpr-Output'
        },
        {
            $ref: '#/components/schemas/CaseExpr-Output'
        },
        {
            $ref: '#/components/schemas/OptionExpr-Output'
        },
        {
            $ref: '#/components/schemas/ExternalExpr'
        }
    ]
} as const;

export const ExtensionFeedbackCreateSchema = {
    properties: {
        message: {
            maxLength: 5000,
            minLength: 1,
            title: 'Message',
            type: 'string'
        }
    },
    required: [
        'message'
    ],
    title: 'ExtensionFeedbackCreate',
    type: 'object'
} as const;

export const ExternalExprSchema = {
    additionalProperties: false,
    properties: {
        op: {
            const: 'external',
            title: 'Op',
            type: 'string'
        },
        reference: {
            title: 'Reference',
            type: 'string'
        }
    },
    required: [
        'op',
        'reference'
    ],
    title: 'ExternalExpr',
    type: 'object'
} as const;

export const ExternalQuoteTaskUpsertSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/QuoteTaskChargeUpsert'
            },
            title: 'Charges',
            type: 'array'
        },
        description: {
            default: '',
            title: 'Description',
            type: 'string'
        },
        due_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteTaskDueStatusUpsert'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'charges'
    ],
    title: 'ExternalQuoteTaskUpsert',
    type: 'object'
} as const;

export const ExtractAtlSchema = {
    properties: {
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        }
    },
    required: [
        'document_id'
    ],
    title: 'ExtractAtl',
    type: 'object'
} as const;

export const ExtractProgrammeSchema = {
    properties: {
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        }
    },
    required: [
        'document_id'
    ],
    title: 'ExtractProgramme',
    type: 'object'
} as const;

export const ExtractionOutputSchema = {
    enum: [
        'tasks',
        'list'
    ],
    title: 'ExtractionOutput',
    type: 'string'
} as const;

export const ExtractionRequestSchema = {
    properties: {
        document_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Document Ids',
            type: 'array'
        }
    },
    required: [
        'document_ids'
    ],
    title: 'ExtractionRequest',
    type: 'object'
} as const;

export const FacilitiesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/FacilityPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'FacilitiesPublic',
    type: 'object'
} as const;

export const FacilityAudienceSchema = {
    additionalProperties: false,
    properties: {
        facility_id: {
            format: 'uuid',
            title: 'Facility Id',
            type: 'string'
        },
        kind: {
            const: 'facility',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind',
        'facility_id'
    ],
    title: 'FacilityAudience',
    type: 'object'
} as const;

export const FacilityCreateSchema = {
    properties: {
        address_city: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address City'
        },
        address_country: {
            anyOf: [
                {
                    maxLength: 2,
                    minLength: 2,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Country'
        },
        address_line1: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line1'
        },
        address_line2: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line2'
        },
        address_postal_code: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Postal Code'
        },
        address_region: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Region'
        },
        email: {
            anyOf: [
                {
                    format: 'email',
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        is_default: {
            default: false,
            title: 'Is Default',
            type: 'boolean'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        position: {
            default: 0,
            maximum: 32767,
            minimum: 0,
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'name'
    ],
    title: 'FacilityCreate',
    type: 'object'
} as const;

export const FacilityPublicSchema = {
    properties: {
        address_city: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address City'
        },
        address_country: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Country'
        },
        address_line1: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line1'
        },
        address_line2: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line2'
        },
        address_postal_code: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Postal Code'
        },
        address_region: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Region'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_default: {
            title: 'Is Default',
            type: 'boolean'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        phone: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        position: {
            title: 'Position',
            type: 'integer'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'name',
        'position',
        'is_default',
        'created_at',
        'updated_at'
    ],
    title: 'FacilityPublic',
    type: 'object'
} as const;

export const FacilityReferenceSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'name'
    ],
    title: 'FacilityReference',
    type: 'object'
} as const;

export const FacilityUpdateSchema = {
    properties: {
        address_city: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address City'
        },
        address_country: {
            anyOf: [
                {
                    maxLength: 2,
                    minLength: 2,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Country'
        },
        address_line1: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line1'
        },
        address_line2: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Line2'
        },
        address_postal_code: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Postal Code'
        },
        address_region: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address Region'
        },
        email: {
            anyOf: [
                {
                    format: 'email',
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        is_default: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Default'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        position: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        }
    },
    title: 'FacilityUpdate',
    type: 'object'
} as const;

export const FailedQuoteImportPublicSchema = {
    properties: {
        external_id: {
            title: 'External Id',
            type: 'string'
        },
        outcome: {
            const: 'failed',
            title: 'Outcome',
            type: 'string'
        },
        reason: {
            $ref: '#/components/schemas/QuoteImportFailure'
        }
    },
    required: [
        'outcome',
        'external_id',
        'reason'
    ],
    title: 'FailedQuoteImportPublic',
    type: 'object'
} as const;

export const FeeDiscountSchema = {
    properties: {
        kind: {
            const: 'fee',
            title: 'Kind',
            type: 'string'
        },
        quote_fee_id: {
            format: 'uuid',
            title: 'Quote Fee Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'quote_fee_id'
    ],
    title: 'FeeDiscount',
    type: 'object'
} as const;

export const FeeKindSchema = {
    enum: [
        'amount',
        'percentage_of_labour',
        'percentage_of_parts',
        'percentage_of_services',
        'percentage_of_subtotal'
    ],
    title: 'FeeKind',
    type: 'string'
} as const;

export const FeeOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateFee',
            remove: '#/components/schemas/RemoveFee',
            update: '#/components/schemas/UpdateFee'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateFee'
        },
        {
            $ref: '#/components/schemas/UpdateFee'
        },
        {
            $ref: '#/components/schemas/RemoveFee'
        }
    ]
} as const;

export const FieldUpdateRequestSchema = {
    description: 'Unified schema for updating any evaluation field\'s edited value.',
    properties: {
        edited_value: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'boolean'
                }
            ],
            title: 'Edited Value'
        }
    },
    required: [
        'edited_value'
    ],
    title: 'FieldUpdateRequest',
    type: 'object'
} as const;

export const FilterableSquawkStatusSchema = {
    enum: [
        'pending_review',
        'approved',
        'rejected',
        'verified'
    ],
    type: 'string'
} as const;

export const FindingKindSchema = {
    enum: [
        'applicability_unknown',
        'condition_unknown',
        'option_not_chosen',
        'event',
        'external',
        'no_subject',
        'subject_unknown',
        'no_counter',
        'no_rate',
        'too_far_to_project',
        'no_start_date',
        'no_record',
        'no_case'
    ],
    title: 'FindingKind',
    type: 'string'
} as const;

export const FindingPublicSchema = {
    properties: {
        detail: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Detail'
        },
        kind: {
            $ref: '#/components/schemas/FindingKind'
        }
    },
    required: [
        'kind',
        'detail'
    ],
    title: 'FindingPublic',
    type: 'object'
} as const;

export const FittedComponentCreateSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        data_source: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Data Source'
        },
        installed_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Date'
        },
        location_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location Number'
        },
        major_assembly: {
            anyOf: [
                {
                    $ref: '#/components/schemas/MajorAssemblyKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        parent_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Id'
        },
        part_balance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Balance Id'
        },
        part_description: {
            anyOf: [
                {
                    maxLength: 1024,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Description'
        },
        part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Instance Id'
        },
        part_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        position: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        },
        serial_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    required: [
        'aircraft_id'
    ],
    title: 'FittedComponentCreate',
    type: 'object'
} as const;

export const FittedComponentDetailPublicSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        data_source: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Data Source'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        installed_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Airframe cycles on the installation date',
            title: 'Installed Cycles'
        },
        installed_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Date'
        },
        installed_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Airframe hours on the installation date, from the aircraft readings',
            title: 'Installed Hours'
        },
        installed_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Airframe landings on the installation date',
            title: 'Installed Landings'
        },
        location_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location Number'
        },
        major_assembly: {
            anyOf: [
                {
                    $ref: '#/components/schemas/MajorAssemblyKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        parent_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Id'
        },
        part_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Description'
        },
        part_instance: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartInstancePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_instance_id: {
            format: 'uuid',
            title: 'Part Instance Id',
            type: 'string'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        },
        position: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'aircraft_id',
        'major_assembly',
        'position',
        'location_number',
        'ata_chapter',
        'installed_date',
        'data_source',
        'id',
        'tenant_id',
        'part_instance_id',
        'parent_id',
        'part_number',
        'serial_number',
        'part_description',
        'created_at',
        'updated_at',
        'part_instance'
    ],
    title: 'FittedComponentDetailPublic',
    type: 'object'
} as const;

export const FittedComponentUpdateSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        data_source: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Data Source'
        },
        installed_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Date'
        },
        location_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location Number'
        },
        major_assembly: {
            anyOf: [
                {
                    $ref: '#/components/schemas/MajorAssemblyKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        parent_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Id'
        },
        part_description: {
            anyOf: [
                {
                    maxLength: 1024,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Description'
        },
        part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Instance Id'
        },
        part_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        position: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        },
        serial_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    title: 'FittedComponentUpdate',
    type: 'object'
} as const;

export const FittedComponentsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/FittedComponentDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'FittedComponentsPublic',
    type: 'object'
} as const;

export const FlagConditionValueSchema = {
    properties: {
        kind: {
            const: 'flag',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind'
    ],
    title: 'FlagConditionValue',
    type: 'object'
} as const;

export const FleetScopeSchema = {
    properties: {
        kind: {
            const: 'fleet',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind'
    ],
    title: 'FleetScope',
    type: 'object'
} as const;

export const FluidPositionSchema = {
    enum: [
        'lh',
        'rh',
        'apu',
        'a',
        'b',
        'single',
        'other'
    ],
    title: 'FluidPosition',
    type: 'string'
} as const;

export const FluidTypeSchema = {
    enum: [
        'engine_oil',
        'hydraulic',
        'idg_oil',
        'oil',
        'other'
    ],
    title: 'FluidType',
    type: 'string'
} as const;

export const FluidUnitSchema = {
    enum: [
        'quarts',
        'litres',
        'us_gallons'
    ],
    title: 'FluidUnit',
    type: 'string'
} as const;

export const FluidUpliftOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateFluidUplift',
            remove: '#/components/schemas/RemoveFluidUplift',
            update: '#/components/schemas/UpdateFluidUplift'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateFluidUplift'
        },
        {
            $ref: '#/components/schemas/UpdateFluidUplift'
        },
        {
            $ref: '#/components/schemas/RemoveFluidUplift'
        }
    ]
} as const;

export const ForecastBasisSchema = {
    enum: [
        'average_utilization',
        'planned_utilization'
    ],
    title: 'ForecastBasis',
    type: 'string'
} as const;

export const ForecastConfirmationCreateSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        basis: {
            $ref: '#/components/schemas/ForecastBasis'
        },
        task_id: {
            format: 'uuid',
            title: 'Task Id',
            type: 'string'
        }
    },
    required: [
        'aircraft_id',
        'task_id',
        'basis'
    ],
    title: 'ForecastConfirmationCreate',
    type: 'object'
} as const;

export const ForecastCreateSchema = {
    properties: {
        basis: {
            $ref: '#/components/schemas/ForecastBasis'
        },
        name: {
            maxLength: 200,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        note: {
            anyOf: [
                {
                    maxLength: 2000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        period: {
            $ref: '#/components/schemas/ForecastPeriod'
        },
        scope: {
            $ref: '#/components/schemas/ForecastScope'
        }
    },
    required: [
        'scope',
        'period',
        'basis',
        'name'
    ],
    title: 'ForecastCreate',
    type: 'object'
} as const;

export const ForecastDetailPublicSchema = {
    properties: {
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        basis: {
            $ref: '#/components/schemas/ForecastBasis'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        period: {
            $ref: '#/components/schemas/ForecastPeriod'
        },
        registrations: {
            description: 'Registrations of the scoped aircraft; empty for the whole fleet',
            items: {
                type: 'string'
            },
            title: 'Registrations',
            type: 'array'
        },
        result: {
            $ref: '#/components/schemas/ForecastResultPublic'
        },
        scope: {
            $ref: '#/components/schemas/ForecastScope'
        },
        status: {
            $ref: '#/components/schemas/ForecastStatus'
        },
        summary: {
            $ref: '#/components/schemas/ForecastSummaryPublic'
        }
    },
    required: [
        'id',
        'number',
        'name',
        'note',
        'period',
        'basis',
        'status',
        'archived_at',
        'scope',
        'registrations',
        'created_at',
        'created_by',
        'summary',
        'result'
    ],
    title: 'ForecastDetailPublic',
    type: 'object'
} as const;

export const ForecastExclusionCreateSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        basis: {
            $ref: '#/components/schemas/ForecastBasis'
        },
        reason: {
            maxLength: 2000,
            minLength: 1,
            title: 'Reason',
            type: 'string'
        },
        task_id: {
            format: 'uuid',
            title: 'Task Id',
            type: 'string'
        }
    },
    required: [
        'aircraft_id',
        'task_id',
        'basis',
        'reason'
    ],
    title: 'ForecastExclusionCreate',
    type: 'object'
} as const;

export const ForecastExclusionPublicSchema = {
    properties: {
        excluded_at: {
            format: 'date-time',
            title: 'Excluded At',
            type: 'string'
        },
        excluded_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        reason: {
            title: 'Reason',
            type: 'string'
        }
    },
    required: [
        'id',
        'reason',
        'excluded_at',
        'excluded_by'
    ],
    title: 'ForecastExclusionPublic',
    type: 'object'
} as const;

export const ForecastItemKindSchema = {
    enum: [
        'task',
        'check'
    ],
    title: 'ForecastItemKind',
    type: 'string'
} as const;

export const ForecastItemPublicSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        check_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Check Id'
        },
        check_ids: {
            description: 'For a task, the checks that cover it, with the checks that include them',
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Check Ids',
            type: 'array'
        },
        findings: {
            items: {
                $ref: '#/components/schemas/FindingPublic'
            },
            title: 'Findings',
            type: 'array'
        },
        kind: {
            $ref: '#/components/schemas/ForecastItemKind'
        },
        last_done: {
            anyOf: [
                {
                    $ref: '#/components/schemas/LastDonePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        man_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Man Hours'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        programme_id: {
            format: 'uuid',
            title: 'Programme Id',
            type: 'string'
        },
        programme_number: {
            title: 'Programme Number',
            type: 'string'
        },
        programme_title: {
            title: 'Programme Title',
            type: 'string'
        },
        registration: {
            title: 'Registration',
            type: 'string'
        },
        revision_id: {
            format: 'uuid',
            title: 'Revision Id',
            type: 'string'
        },
        schedule: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Schedule-Output'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The interval the item follows; empty when inherited from several checks'
        },
        task_code: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskCode'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Id'
        },
        title: {
            title: 'Title',
            type: 'string'
        }
    },
    required: [
        'aircraft_id',
        'registration',
        'programme_id',
        'programme_number',
        'programme_title',
        'revision_id',
        'kind',
        'task_id',
        'check_id',
        'number',
        'title',
        'task_code',
        'schedule',
        'man_hours',
        'last_done',
        'findings',
        'check_ids'
    ],
    title: 'ForecastItemPublic',
    type: 'object'
} as const;

export const ForecastParametersSchema = {
    properties: {
        basis: {
            $ref: '#/components/schemas/ForecastBasis'
        },
        period: {
            $ref: '#/components/schemas/ForecastPeriod'
        },
        scope: {
            $ref: '#/components/schemas/ForecastScope'
        }
    },
    required: [
        'scope',
        'period',
        'basis'
    ],
    title: 'ForecastParameters',
    type: 'object'
} as const;

export const ForecastPeriodSchema = {
    properties: {
        ends_on: {
            format: 'date',
            title: 'Ends On',
            type: 'string'
        },
        starts_on: {
            format: 'date',
            title: 'Starts On',
            type: 'string'
        }
    },
    required: [
        'starts_on',
        'ends_on'
    ],
    title: 'ForecastPeriod',
    type: 'object'
} as const;

export const ForecastPinSchema = {
    properties: {
        forecast_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Forecast Id'
        }
    },
    required: [
        'forecast_id'
    ],
    title: 'ForecastPin',
    type: 'object'
} as const;

export const ForecastPinPublicSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        forecast_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Forecast Id'
        }
    },
    required: [
        'aircraft_id',
        'forecast_id'
    ],
    title: 'ForecastPinPublic',
    type: 'object'
} as const;

export const ForecastPublicSchema = {
    properties: {
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        basis: {
            $ref: '#/components/schemas/ForecastBasis'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        period: {
            $ref: '#/components/schemas/ForecastPeriod'
        },
        registrations: {
            description: 'Registrations of the scoped aircraft; empty for the whole fleet',
            items: {
                type: 'string'
            },
            title: 'Registrations',
            type: 'array'
        },
        scope: {
            $ref: '#/components/schemas/ForecastScope'
        },
        status: {
            $ref: '#/components/schemas/ForecastStatus'
        }
    },
    required: [
        'id',
        'number',
        'name',
        'note',
        'period',
        'basis',
        'status',
        'archived_at',
        'scope',
        'registrations',
        'created_at',
        'created_by'
    ],
    title: 'ForecastPublic',
    type: 'object'
} as const;

export const ForecastResultPublicSchema = {
    properties: {
        aircraft: {
            items: {
                $ref: '#/components/schemas/AircraftUsagePublic'
            },
            title: 'Aircraft',
            type: 'array'
        },
        as_of: {
            format: 'date',
            title: 'As Of',
            type: 'string'
        },
        basis: {
            $ref: '#/components/schemas/ForecastBasis'
        },
        excluded: {
            description: 'Tasks the automatic check could not decide that a recorded decision ruled out for the aircraft',
            items: {
                $ref: '#/components/schemas/ExcludedItemPublic'
            },
            title: 'Excluded',
            type: 'array'
        },
        period: {
            $ref: '#/components/schemas/ForecastPeriod'
        },
        rows: {
            items: {
                $ref: '#/components/schemas/DueRowPublic'
            },
            title: 'Rows',
            type: 'array'
        },
        summary: {
            $ref: '#/components/schemas/ForecastSummaryPublic'
        },
        undetermined: {
            items: {
                $ref: '#/components/schemas/ForecastItemPublic'
            },
            title: 'Undetermined',
            type: 'array'
        }
    },
    required: [
        'as_of',
        'period',
        'basis',
        'aircraft',
        'rows',
        'undetermined',
        'excluded',
        'summary'
    ],
    title: 'ForecastResultPublic',
    type: 'object'
} as const;

export const ForecastScopeSchema = {
    discriminator: {
        mapping: {
            aircraft: '#/components/schemas/AircraftScope',
            fleet: '#/components/schemas/FleetScope'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/FleetScope'
        },
        {
            $ref: '#/components/schemas/AircraftScope'
        }
    ]
} as const;

export const ForecastStatusSchema = {
    enum: [
        'active',
        'archived'
    ],
    title: 'ForecastStatus',
    type: 'string'
} as const;

export const ForecastSummariesPublicSchema = {
    properties: {
        data: {
            items: {
                $ref: '#/components/schemas/ForecastSummaryEntryPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data'
    ],
    title: 'ForecastSummariesPublic',
    type: 'object'
} as const;

export const ForecastSummariesRequestSchema = {
    properties: {
        forecast_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 200,
            minItems: 1,
            title: 'Forecast Ids',
            type: 'array'
        }
    },
    required: [
        'forecast_ids'
    ],
    title: 'ForecastSummariesRequest',
    type: 'object'
} as const;

export const ForecastSummaryEntryPublicSchema = {
    properties: {
        forecast_id: {
            format: 'uuid',
            title: 'Forecast Id',
            type: 'string'
        },
        summary: {
            $ref: '#/components/schemas/ForecastSummaryPublic'
        }
    },
    required: [
        'forecast_id',
        'summary'
    ],
    title: 'ForecastSummaryEntryPublic',
    type: 'object'
} as const;

export const ForecastSummaryPublicSchema = {
    properties: {
        aircraft: {
            title: 'Aircraft',
            type: 'integer'
        },
        due: {
            title: 'Due',
            type: 'integer'
        },
        due_soon: {
            title: 'Due Soon',
            type: 'integer'
        },
        man_hours: {
            title: 'Man Hours',
            type: 'string'
        },
        overdue: {
            title: 'Overdue',
            type: 'integer'
        },
        undetermined: {
            title: 'Undetermined',
            type: 'integer'
        }
    },
    required: [
        'due',
        'overdue',
        'due_soon',
        'undetermined',
        'man_hours',
        'aircraft'
    ],
    title: 'ForecastSummaryPublic',
    type: 'object'
} as const;

export const ForecastUpdateSchema = {
    properties: {
        basis: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ForecastBasis'
                },
                {
                    type: 'null'
                }
            ]
        },
        name: {
            anyOf: [
                {
                    maxLength: 200,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        note: {
            anyOf: [
                {
                    maxLength: 2000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        period: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ForecastPeriod'
                },
                {
                    type: 'null'
                }
            ]
        },
        scope: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ForecastScope'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    title: 'ForecastUpdate',
    type: 'object'
} as const;

export const ForecastWorkOrderCreateSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        check_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            title: 'Check Ids',
            type: 'array'
        },
        task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 2000,
            title: 'Task Ids',
            type: 'array'
        }
    },
    required: [
        'aircraft_id',
        'task_ids',
        'check_ids'
    ],
    title: 'ForecastWorkOrderCreate',
    type: 'object'
} as const;

export const ForecastsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ForecastPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ForecastsPublic',
    type: 'object'
} as const;

export const ForwardingAddressPublicSchema = {
    properties: {
        address: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address'
        }
    },
    required: [
        'address'
    ],
    title: 'ForwardingAddressPublic',
    type: 'object'
} as const;

export const FoundWorkTaskPublicSchema = {
    properties: {
        actual_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Actual Hrs'
        },
        aircraft: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft'
        },
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        complied_with_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Complied With Date'
        },
        cost: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        description: {
            default: '',
            title: 'Description',
            type: 'string'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        estimated_cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost'
        },
        estimated_cost_currency: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost Currency'
        },
        estimated_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Hrs'
        },
        external_billing_method: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Billing Method'
        },
        external_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Created At'
        },
        external_ended_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ended At'
        },
        external_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        external_is_warranty: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Is Warranty'
        },
        external_labor_hrs_taken: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Labor Hrs Taken'
        },
        external_started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Started At'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_deleted: {
            default: false,
            title: 'Is Deleted',
            type: 'boolean'
        },
        item_corr_action_synced: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Item Corr Action Synced'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        major_assembly: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Major Assembly'
        },
        manhours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manhours'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_info: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SourceInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_synced_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Source Synced At'
        },
        status: {
            $ref: '#/components/schemas/WorkTaskStatus'
        },
        status_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Note'
        },
        task_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskType'
                },
                {
                    type: 'null'
                }
            ]
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'external_id',
        'external_url',
        'source_synced_at',
        'source_info',
        'item_corr_action_synced',
        'external_created_at',
        'external_labor_hrs_taken',
        'external_billing_method',
        'external_is_warranty',
        'external_started_at',
        'external_ended_at',
        'estimated_hrs',
        'actual_hrs',
        'cost',
        'id',
        'created_at',
        'updated_at',
        'status',
        'status_note',
        'aircraft',
        'hours'
    ],
    title: 'FoundWorkTaskPublic',
    type: 'object'
} as const;

export const FulfillmentProgressSchema = {
    properties: {
        awaiting_parts: {
            default: 0,
            title: 'Awaiting Parts',
            type: 'integer'
        },
        closed: {
            default: 0,
            title: 'Closed',
            type: 'integer'
        },
        complete: {
            default: 0,
            title: 'Complete',
            type: 'integer'
        },
        deferred: {
            default: 0,
            title: 'Deferred',
            type: 'integer'
        },
        in_progress: {
            default: 0,
            title: 'In Progress',
            type: 'integer'
        },
        not_started: {
            default: 0,
            title: 'Not Started',
            type: 'integer'
        },
        on_hold: {
            default: 0,
            title: 'On Hold',
            type: 'integer'
        },
        signed_off: {
            default: 0,
            title: 'Signed Off',
            type: 'integer'
        },
        total_tasks: {
            default: 0,
            title: 'Total Tasks',
            type: 'integer'
        }
    },
    required: [
        'total_tasks',
        'not_started',
        'in_progress',
        'on_hold',
        'awaiting_parts',
        'complete',
        'signed_off',
        'deferred',
        'closed'
    ],
    title: 'FulfillmentProgress',
    type: 'object'
} as const;

export const GeneratedComplianceNoteResponseSchema = {
    properties: {
        content: {
            title: 'Content',
            type: 'string'
        },
        format_options: {
            anyOf: [
                {
                    additionalProperties: {
                        items: {
                            type: 'string'
                        },
                        type: 'array'
                    },
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Format Options'
        },
        relevant_references: {
            default: [],
            description: 'List of the most relevant reference tasks ids. Maximum 3-4',
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 4,
            title: 'Relevant References',
            type: 'array'
        },
        suggestion_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Suggestion Id'
        },
        work_task_references: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/WorkTaskRef'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task References'
        }
    },
    required: [
        'content',
        'suggestion_id'
    ],
    title: 'GeneratedComplianceNoteResponse',
    type: 'object'
} as const;

export const GroupCountPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        included: {
            title: 'Included',
            type: 'integer'
        },
        key: {
            title: 'Key',
            type: 'string'
        },
        subgroups: {
            items: {
                $ref: '#/components/schemas/SubgroupCountPublic'
            },
            title: 'Subgroups',
            type: 'array'
        }
    },
    required: [
        'key',
        'count',
        'subgroups',
        'included'
    ],
    title: 'GroupCountPublic',
    type: 'object'
} as const;

export const GroupedWorkPackagesSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/GroupedWorkPackagesGroup'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'groups',
        'count'
    ],
    title: 'GroupedWorkPackages',
    type: 'object'
} as const;

export const GroupedWorkPackagesGroupSchema = {
    properties: {
        data: {
            items: {
                $ref: '#/components/schemas/WorkPackagePublic'
            },
            title: 'Data',
            type: 'array'
        },
        heading: {
            title: 'Heading',
            type: 'string'
        }
    },
    required: [
        'data',
        'heading'
    ],
    title: 'GroupedWorkPackagesGroup',
    type: 'object'
} as const;

export const HTTPValidationErrorSchema = {
    properties: {
        detail: {
            items: {
                $ref: '#/components/schemas/ValidationError'
            },
            title: 'Detail',
            type: 'array'
        }
    },
    title: 'HTTPValidationError',
    type: 'object'
} as const;

export const HoldWorkTasksSchema = {
    properties: {
        ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Ids',
            type: 'array'
        },
        note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        status: {
            enum: [
                'on_hold',
                'awaiting_parts'
            ],
            title: 'Status',
            type: 'string'
        }
    },
    required: [
        'ids',
        'status'
    ],
    title: 'HoldWorkTasks',
    type: 'object'
} as const;

export const HubSpotAttachmentSchema = {
    properties: {
        file_name: {
            title: 'File Name',
            type: 'string'
        },
        id: {
            pattern: '^[0-9]+$',
            title: 'Id',
            type: 'string'
        },
        size: {
            title: 'Size',
            type: 'integer'
        }
    },
    required: [
        'id',
        'file_name',
        'size'
    ],
    title: 'HubSpotAttachment',
    type: 'object'
} as const;

export const HubSpotContextSchema = {
    properties: {
        attachments: {
            items: {
                $ref: '#/components/schemas/HubSpotAttachment'
            },
            title: 'Attachments',
            type: 'array'
        },
        notes: {
            items: {
                $ref: '#/components/schemas/HubSpotNote'
            },
            title: 'Notes',
            type: 'array'
        },
        unreadable_attachment_ids: {
            items: {
                pattern: '^[0-9]+$',
                type: 'string'
            },
            title: 'Unreadable Attachment Ids',
            type: 'array'
        },
        warnings: {
            items: {
                $ref: '#/components/schemas/HubSpotContextWarning'
            },
            title: 'Warnings',
            type: 'array'
        }
    },
    title: 'HubSpotContext',
    type: 'object'
} as const;

export const HubSpotContextWarningSchema = {
    enum: [
        'notes_truncated',
        'notes_partially_read',
        'attachments_truncated'
    ],
    title: 'HubSpotContextWarning',
    type: 'string'
} as const;

export const HubSpotDealDetailPublicSchema = {
    properties: {
        context: {
            $ref: '#/components/schemas/HubSpotContext'
        },
        deal: {
            $ref: '#/components/schemas/HubSpotDealPublic'
        },
        linked_quote: {
            anyOf: [
                {
                    $ref: '#/components/schemas/LinkedQuotePublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'deal',
        'context',
        'linked_quote'
    ],
    title: 'HubSpotDealDetailPublic',
    type: 'object'
} as const;

export const HubSpotDealPublicSchema = {
    properties: {
        fields: {
            $ref: '#/components/schemas/QuoteDealFields'
        },
        id: {
            pattern: '^[0-9]+$',
            title: 'Id',
            type: 'string'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        pipeline: {
            title: 'Pipeline',
            type: 'string'
        },
        stage: {
            title: 'Stage',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        url: {
            title: 'Url',
            type: 'string'
        }
    },
    required: [
        'id',
        'url',
        'name',
        'pipeline',
        'stage',
        'updated_at',
        'fields'
    ],
    title: 'HubSpotDealPublic',
    type: 'object'
} as const;

export const HubSpotDealsPublicSchema = {
    properties: {
        data: {
            items: {
                $ref: '#/components/schemas/HubSpotDealPublic'
            },
            title: 'Data',
            type: 'array'
        },
        next_after: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next After'
        }
    },
    required: [
        'data',
        'next_after'
    ],
    title: 'HubSpotDealsPublic',
    type: 'object'
} as const;

export const HubSpotEligibilityPublicSchema = {
    properties: {
        filters: {
            items: {
                $ref: '#/components/schemas/DealFilter'
            },
            title: 'Filters',
            type: 'array'
        },
        stages: {
            items: {
                $ref: '#/components/schemas/QuotableStage'
            },
            title: 'Stages',
            type: 'array'
        }
    },
    required: [
        'stages',
        'filters'
    ],
    title: 'HubSpotEligibilityPublic',
    type: 'object'
} as const;

export const HubSpotEligibilityUpsertSchema = {
    properties: {
        filters: {
            items: {
                $ref: '#/components/schemas/DealFilter'
            },
            title: 'Filters',
            type: 'array'
        },
        stages: {
            items: {
                $ref: '#/components/schemas/QuotableStage'
            },
            title: 'Stages',
            type: 'array'
        }
    },
    required: [
        'stages'
    ],
    title: 'HubSpotEligibilityUpsert',
    type: 'object'
} as const;

export const HubSpotIntegrationConfigPublicSchema = {
    properties: {
        config_id: {
            format: 'uuid',
            title: 'Config Id',
            type: 'string'
        },
        created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created At'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        updated_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At'
        },
        webhook_configured: {
            title: 'Webhook Configured',
            type: 'boolean'
        }
    },
    required: [
        'config_id',
        'webhook_configured'
    ],
    title: 'HubSpotIntegrationConfigPublic',
    type: 'object'
} as const;

export const HubSpotIntegrationConfigUpsertSchema = {
    properties: {
        webhook_secret: {
            format: 'password',
            minLength: 1,
            title: 'Webhook Secret',
            type: 'string',
            writeOnly: true
        }
    },
    required: [
        'webhook_secret'
    ],
    title: 'HubSpotIntegrationConfigUpsert',
    type: 'object'
} as const;

export const HubSpotNoteSchema = {
    properties: {
        body: {
            title: 'Body',
            type: 'string'
        },
        id: {
            pattern: '^[0-9]+$',
            title: 'Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'body'
    ],
    title: 'HubSpotNote',
    type: 'object'
} as const;

export const HubSpotPropertyMappingPublicSchema = {
    properties: {
        mappings: {
            items: {
                $ref: '#/components/schemas/PropertyMapping'
            },
            title: 'Mappings',
            type: 'array'
        }
    },
    required: [
        'mappings'
    ],
    title: 'HubSpotPropertyMappingPublic',
    type: 'object'
} as const;

export const HubSpotPropertyMappingUpsertSchema = {
    properties: {
        mappings: {
            items: {
                $ref: '#/components/schemas/PropertyMapping'
            },
            title: 'Mappings',
            type: 'array'
        }
    },
    required: [
        'mappings'
    ],
    title: 'HubSpotPropertyMappingUpsert',
    type: 'object'
} as const;

export const HubSpotQuoteCreateSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        kind: {
            enum: [
                'aircraft',
                'rfp'
            ],
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind'
    ],
    title: 'HubSpotQuoteCreate',
    type: 'object'
} as const;

export const HubSpotQuotingConfigPublicSchema = {
    properties: {
        auto_create_quotes: {
            title: 'Auto Create Quotes',
            type: 'boolean'
        },
        automation_user_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Automation User Id'
        },
        config_id: {
            format: 'uuid',
            title: 'Config Id',
            type: 'string'
        },
        created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created At'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        updated_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updated At'
        }
    },
    required: [
        'config_id',
        'auto_create_quotes'
    ],
    title: 'HubSpotQuotingConfigPublic',
    type: 'object'
} as const;

export const HubSpotQuotingConfigUpsertSchema = {
    properties: {
        auto_create_quotes: {
            title: 'Auto Create Quotes',
            type: 'boolean'
        },
        automation_user_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Automation User Id'
        }
    },
    required: [
        'auto_create_quotes'
    ],
    title: 'HubSpotQuotingConfigUpsert',
    type: 'object'
} as const;

export const IdConditionValueSchema = {
    properties: {
        found_in: {
            title: 'Found In',
            type: 'string'
        },
        kind: {
            const: 'id',
            title: 'Kind',
            type: 'string'
        },
        record: {
            $ref: '#/components/schemas/NotificationConditionRecord'
        }
    },
    required: [
        'kind',
        'record',
        'found_in'
    ],
    title: 'IdConditionValue',
    type: 'object'
} as const;

export const ImportedAircraftSchema = {
    properties: {
        manufacturer: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            maxLength: 255,
            title: 'Model',
            type: 'string'
        },
        registration_no: {
            maxLength: 255,
            title: 'Registration No',
            type: 'string'
        },
        serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial No'
        }
    },
    required: [
        'registration_no',
        'model'
    ],
    title: 'ImportedAircraft',
    type: 'object'
} as const;

export const ImportedAmountChargeSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        type: {
            enum: [
                'part_flat_rate',
                'misc'
            ],
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type'
    ],
    title: 'ImportedAmountCharge',
    type: 'object'
} as const;

export const ImportedChargeSchema = {
    discriminator: {
        mapping: {
            labour: '#/components/schemas/ImportedLabourCharge',
            labour_flat_rate: '#/components/schemas/ImportedLabourFlatRateCharge',
            misc: '#/components/schemas/ImportedAmountCharge',
            part: '#/components/schemas/ImportedPartCharge',
            part_flat_rate: '#/components/schemas/ImportedAmountCharge'
        },
        propertyName: 'type'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/ImportedLabourCharge'
        },
        {
            $ref: '#/components/schemas/ImportedLabourFlatRateCharge'
        },
        {
            $ref: '#/components/schemas/ImportedAmountCharge'
        },
        {
            $ref: '#/components/schemas/ImportedPartCharge'
        }
    ]
} as const;

export const ImportedCustomerSchema = {
    properties: {
        external_id: {
            maxLength: 100,
            minLength: 1,
            title: 'External Id',
            type: 'string'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'external_id',
        'name'
    ],
    title: 'ImportedCustomer',
    type: 'object'
} as const;

export const ImportedInstallationSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        data_source: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Data Source'
        },
        installed_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Cycles'
        },
        installed_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Date'
        },
        installed_days: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Days'
        },
        installed_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Hours'
        },
        installed_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Landings'
        },
        installed_months: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installed Months'
        },
        location_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location Number'
        },
        major_assembly: {
            anyOf: [
                {
                    $ref: '#/components/schemas/MajorAssemblyKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        overhauled_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Overhauled Cycles'
        },
        overhauled_days: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Overhauled Days'
        },
        overhauled_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Overhauled Hours'
        },
        overhauled_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Overhauled Landings'
        },
        overhauled_months: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Overhauled Months'
        },
        part_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Description'
        },
        part_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        position: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        since_repair_cycles: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Since Repair Cycles'
        },
        since_repair_days: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Since Repair Days'
        },
        since_repair_hours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Since Repair Hours'
        },
        since_repair_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Since Repair Landings'
        },
        since_repair_months: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Since Repair Months'
        },
        status_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Effective Date'
        }
    },
    title: 'ImportedInstallation',
    type: 'object'
} as const;

export const ImportedLabourChargeSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Hours'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        type: {
            const: 'labour',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'hours'
    ],
    title: 'ImportedLabourCharge',
    type: 'object'
} as const;

export const ImportedLabourFlatRateChargeSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        type: {
            const: 'labour_flat_rate',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type'
    ],
    title: 'ImportedLabourFlatRateCharge',
    type: 'object'
} as const;

export const ImportedPartChargeSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        part_number: {
            minLength: 1,
            title: 'Part Number',
            type: 'string'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        type: {
            const: 'part',
            title: 'Type',
            type: 'string'
        },
        unit_of_measure: {
            minLength: 1,
            title: 'Unit Of Measure',
            type: 'string'
        }
    },
    required: [
        'type',
        'part_number',
        'quantity',
        'unit_of_measure'
    ],
    title: 'ImportedPartCharge',
    type: 'object'
} as const;

export const ImportedQuoteSchema = {
    properties: {
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ImportedAircraft'
                },
                {
                    type: 'null'
                }
            ]
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ImportedCustomer'
                },
                {
                    type: 'null'
                }
            ]
        },
        estimated_close_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Close On'
        },
        external_id: {
            maxLength: 100,
            minLength: 1,
            title: 'External Id',
            type: 'string'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        kind: {
            enum: [
                'aircraft',
                'traveller'
            ],
            title: 'Kind',
            type: 'string'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        promised_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised On'
        },
        requested_delivery_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested Delivery On'
        },
        requested_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested On'
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/ImportedTask'
            },
            title: 'Tasks',
            type: 'array'
        },
        title: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        valid_until: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Valid Until'
        },
        work_order_external_id: {
            anyOf: [
                {
                    maxLength: 100,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Order External Id'
        }
    },
    required: [
        'external_id',
        'number',
        'kind',
        'currency'
    ],
    title: 'ImportedQuote',
    type: 'object'
} as const;

export const ImportedQuotePublicSchema = {
    properties: {
        external_id: {
            title: 'External Id',
            type: 'string'
        },
        outcome: {
            enum: [
                'created',
                'updated',
                'unchanged'
            ],
            title: 'Outcome',
            type: 'string'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        }
    },
    required: [
        'outcome',
        'external_id',
        'quote_id'
    ],
    title: 'ImportedQuotePublic',
    type: 'object'
} as const;

export const ImportedStepSchema = {
    properties: {
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        inspection_required: {
            default: false,
            title: 'Inspection Required',
            type: 'boolean'
        }
    },
    required: [
        'description'
    ],
    title: 'ImportedStep',
    type: 'object'
} as const;

export const ImportedTaskSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/ImportedCharge'
            },
            title: 'Charges',
            type: 'array'
        },
        description: {
            default: '',
            title: 'Description',
            type: 'string'
        },
        external_id: {
            maxLength: 100,
            minLength: 1,
            title: 'External Id',
            type: 'string'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        phases: {
            items: {
                maxLength: 255,
                minLength: 1,
                type: 'string'
            },
            title: 'Phases',
            type: 'array'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        steps: {
            items: {
                $ref: '#/components/schemas/ImportedStep'
            },
            title: 'Steps',
            type: 'array'
        },
        task_group: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group'
        }
    },
    required: [
        'external_id',
        'number'
    ],
    title: 'ImportedTask',
    type: 'object'
} as const;

export const IngestNewPackageSchema = {
    properties: {
        operation_type: {
            const: 'new_package',
            title: 'Operation Type',
            type: 'string'
        },
        package_info: {
            $ref: '#/components/schemas/IngestPackageInfo'
        }
    },
    required: [
        'operation_type',
        'package_info'
    ],
    title: 'IngestNewPackage',
    type: 'object'
} as const;

export const IngestNewVersionSchema = {
    properties: {
        operation_type: {
            const: 'new_version',
            title: 'Operation Type',
            type: 'string'
        },
        version_info: {
            $ref: '#/components/schemas/IngestVersionInfo'
        }
    },
    required: [
        'operation_type',
        'version_info'
    ],
    title: 'IngestNewVersion',
    type: 'object'
} as const;

export const IngestPackageInfoSchema = {
    properties: {
        name: {
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        type_certificate_model_variant_id: {
            format: 'uuid',
            title: 'Type Certificate Model Variant Id',
            type: 'string'
        }
    },
    required: [
        'name',
        'number',
        'type_certificate_model_variant_id'
    ],
    title: 'IngestPackageInfo',
    type: 'object'
} as const;

export const IngestRatesItemSchema = {
    properties: {
        canned_work_package: {
            discriminator: {
                mapping: {
                    new_package: '#/components/schemas/IngestNewPackage',
                    new_version: '#/components/schemas/IngestNewVersion'
                },
                propertyName: 'operation_type'
            },
            oneOf: [
                {
                    $ref: '#/components/schemas/IngestNewPackage'
                },
                {
                    $ref: '#/components/schemas/IngestNewVersion'
                }
            ],
            title: 'Canned Work Package'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/CannedWorkTaskChargeCreate'
            },
            title: 'Charges',
            type: 'array'
        }
    },
    required: [
        'canned_work_package',
        'charges'
    ],
    title: 'IngestRatesItem',
    type: 'object'
} as const;

export const IngestVersionInfoSchema = {
    properties: {
        canned_work_package_id: {
            format: 'uuid',
            title: 'Canned Work Package Id',
            type: 'string'
        },
        type_certificate_model_variant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Type Certificate Model Variant Id'
        }
    },
    required: [
        'canned_work_package_id'
    ],
    title: 'IngestVersionInfo',
    type: 'object'
} as const;

export const InspectionComplianceInfoSchema = {
    description: 'Use if task_type is inspection',
    properties: {
        other_findings: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Other Findings'
        },
        task_findings: {
            items: {
                $ref: '#/components/schemas/TaskFindings'
            },
            title: 'Task Findings',
            type: 'array'
        },
        tsi: {
            $ref: '#/components/schemas/TimeGrouping'
        }
    },
    required: [
        'task_findings',
        'tsi'
    ],
    title: 'InspectionComplianceInfo',
    type: 'object'
} as const;

export const IntakeTaskSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        step_name: {
            title: 'Step Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'step_name'
    ],
    title: 'IntakeTask',
    type: 'object'
} as const;

export const IntegrationCheckpointContextSchema = {
    properties: {},
    title: 'IntegrationCheckpointContext',
    type: 'object'
} as const;

export const IntegrationCheckpointCreateSchema = {
    properties: {
        checkpoint_key: {
            maxLength: 255,
            title: 'Checkpoint Key',
            type: 'string'
        },
        checkpoint_value: {
            maxLength: 255,
            title: 'Checkpoint Value',
            type: 'string'
        },
        context: {
            anyOf: [
                {
                    $ref: '#/components/schemas/IntegrationCheckpointContext'
                },
                {
                    type: 'null'
                }
            ]
        },
        entity: {
            maxLength: 255,
            title: 'Entity',
            type: 'string'
        },
        external_source: {
            maxLength: 255,
            title: 'External Source',
            type: 'string'
        }
    },
    required: [
        'external_source',
        'entity',
        'checkpoint_key',
        'checkpoint_value'
    ],
    title: 'IntegrationCheckpointCreate',
    type: 'object'
} as const;

export const IntegrationCheckpointPublicSchema = {
    properties: {
        checkpoint_key: {
            maxLength: 255,
            title: 'Checkpoint Key',
            type: 'string'
        },
        checkpoint_value: {
            maxLength: 255,
            title: 'Checkpoint Value',
            type: 'string'
        },
        context: {
            anyOf: [
                {
                    $ref: '#/components/schemas/IntegrationCheckpointContext'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        entity: {
            maxLength: 255,
            title: 'Entity',
            type: 'string'
        },
        external_source: {
            maxLength: 255,
            title: 'External Source',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'external_source',
        'entity',
        'checkpoint_key',
        'checkpoint_value',
        'id',
        'created_at',
        'updated_at'
    ],
    title: 'IntegrationCheckpointPublic',
    type: 'object'
} as const;

export const IntegrationCredentialsCreateWithPlaintextPasswordSchema = {
    properties: {
        client_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Id'
        },
        client_secret: {
            anyOf: [
                {
                    maxLength: 2048,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Secret'
        },
        credential_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CredentialType'
                },
                {
                    type: 'null'
                }
            ]
        },
        domain: {
            anyOf: [
                {
                    maxLength: 500,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        },
        erp_vendor: {
            $ref: '#/components/schemas/ERPCredentialVendor',
            maxLength: 255
        },
        password: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Password'
        },
        tenant_erp_config_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Erp Config Id'
        },
        username: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Username'
        }
    },
    required: [
        'erp_vendor'
    ],
    title: 'IntegrationCredentialsCreateWithPlaintextPassword',
    type: 'object'
} as const;

export const IntegrationCredentialsPublicSchema = {
    properties: {
        client_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        credential_type: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Credential Type'
        },
        domain: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        },
        erp_vendor: {
            $ref: '#/components/schemas/ERPCredentialVendor'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        tenant_erp_config_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Erp Config Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'erp_vendor',
        'created_at',
        'updated_at'
    ],
    title: 'IntegrationCredentialsPublic',
    type: 'object'
} as const;

export const IntegrationCredentialsUpdateWithPlaintextPasswordSchema = {
    properties: {
        client_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Id'
        },
        client_secret: {
            anyOf: [
                {
                    maxLength: 2048,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Secret'
        },
        credential_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CredentialType'
                },
                {
                    type: 'null'
                }
            ]
        },
        domain: {
            anyOf: [
                {
                    maxLength: 500,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        },
        erp_vendor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ERPCredentialVendor',
                    maxLength: 255
                },
                {
                    type: 'null'
                }
            ]
        },
        password: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Password'
        },
        tenant_erp_config_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Erp Config Id'
        },
        username: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Username'
        }
    },
    title: 'IntegrationCredentialsUpdateWithPlaintextPassword',
    type: 'object'
} as const;

export const IntegrationKindSchema = {
    enum: [
        'hubspot',
        'salesforce'
    ],
    title: 'IntegrationKind',
    type: 'string'
} as const;

export const InventoryPriceSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        date: {
            format: 'date-time',
            title: 'Date',
            type: 'string'
        },
        source: {
            const: 'inventory',
            default: 'inventory',
            title: 'Source',
            type: 'string'
        },
        user: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'amount',
        'date',
        'user'
    ],
    title: 'InventoryPrice',
    type: 'object'
} as const;

export const IssueWorkTaskPartSchema = {
    properties: {
        certificate: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ReleaseCertificate'
                },
                {
                    type: 'null'
                }
            ]
        },
        lot_number: {
            anyOf: [
                {
                    maxLength: 100,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        part_balance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Balance Id'
        },
        quantity: {
            maximum: 100000,
            minimum: 1,
            title: 'Quantity',
            type: 'integer'
        },
        serial_number: {
            anyOf: [
                {
                    maxLength: 100,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    required: [
        'quantity'
    ],
    title: 'IssueWorkTaskPart',
    type: 'object'
} as const;

export const JsonValueSchema = {} as const;

export const LabourAircraftPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        model: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Model'
        },
        registration_no: {
            title: 'Registration No',
            type: 'string'
        }
    },
    required: [
        'registration_no',
        'id',
        'model'
    ],
    title: 'LabourAircraftPublic',
    type: 'object'
} as const;

export const LabourPublicSchema = {
    properties: {
        maximum: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Maximum'
        },
        median: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Median'
        },
        minimum: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Minimum'
        },
        similar: {
            items: {
                $ref: '#/components/schemas/LabourSourcePublic'
            },
            title: 'Similar',
            type: 'array'
        },
        sources: {
            items: {
                $ref: '#/components/schemas/LabourSourcePublic'
            },
            title: 'Sources',
            type: 'array'
        }
    },
    required: [
        'minimum',
        'median',
        'maximum',
        'sources',
        'similar'
    ],
    title: 'LabourPublic',
    type: 'object'
} as const;

export const LabourSourcePublicSchema = {
    properties: {
        actual_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Actual Hrs'
        },
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/LabourAircraftPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        completed_at: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Completed At'
        },
        corrective_action: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corrective Action'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        estimated_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Hrs'
        },
        external_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Created At'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        part_count: {
            title: 'Part Count',
            type: 'integer'
        },
        work_package: {
            anyOf: [
                {
                    $ref: '#/components/schemas/LabourWorkPackagePublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'id',
        'number',
        'description',
        'corrective_action',
        'actual_hrs',
        'estimated_hrs',
        'external_created_at',
        'completed_at',
        'external_url',
        'part_count',
        'aircraft',
        'work_package'
    ],
    title: 'LabourSourcePublic',
    type: 'object'
} as const;

export const LabourWorkPackagePublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        }
    },
    required: [
        'number',
        'id'
    ],
    title: 'LabourWorkPackagePublic',
    type: 'object'
} as const;

export const LastDonePublicSchema = {
    properties: {
        cycles: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cycles'
        },
        hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours'
        },
        landings: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landings'
        },
        performed_on: {
            format: 'date',
            title: 'Performed On',
            type: 'string'
        }
    },
    required: [
        'performed_on',
        'hours',
        'cycles',
        'landings'
    ],
    title: 'LastDonePublic',
    type: 'object'
} as const;

export const LimitExprSchema = {
    additionalProperties: false,
    properties: {
        component: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComponentMatch'
                },
                {
                    type: 'null'
                }
            ]
        },
        on: {
            $ref: '#/components/schemas/Measured',
            default: 'aircraft'
        },
        op: {
            const: 'limit',
            title: 'Op',
            type: 'string'
        },
        tolerance: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Tolerance'
                },
                {
                    const: 'none',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tolerance'
        },
        unit: {
            $ref: '#/components/schemas/Unit'
        },
        value: {
            exclusiveMinimum: 0,
            title: 'Value',
            type: 'number'
        }
    },
    required: [
        'op',
        'value',
        'unit'
    ],
    title: 'LimitExpr',
    type: 'object'
} as const;

export const LimitOperationSchema = {
    discriminator: {
        mapping: {
            clear: '#/components/schemas/ClearLimits',
            create: '#/components/schemas/CreateLimit',
            remove: '#/components/schemas/RemoveLimit',
            update: '#/components/schemas/UpdateLimit'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateLimit'
        },
        {
            $ref: '#/components/schemas/UpdateLimit'
        },
        {
            $ref: '#/components/schemas/RemoveLimit'
        },
        {
            $ref: '#/components/schemas/ClearLimits'
        }
    ]
} as const;

export const LinkDirectionSchema = {
    enum: [
        'outgoing',
        'incoming'
    ],
    title: 'LinkDirection',
    type: 'string'
} as const;

export const LinkWorkPackageSchema = {
    properties: {
        kind: {
            const: 'work_package',
            title: 'Kind',
            type: 'string'
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'work_package_id'
    ],
    title: 'LinkWorkPackage',
    type: 'object'
} as const;

export const LinkWorkTaskSchema = {
    properties: {
        kind: {
            const: 'work_task',
            title: 'Kind',
            type: 'string'
        },
        work_task_id: {
            format: 'uuid',
            title: 'Work Task Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'work_task_id'
    ],
    title: 'LinkWorkTask',
    type: 'object'
} as const;

export const LinkedQuotePublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/QuoteKind'
        },
        number: {
            title: 'Number',
            type: 'string'
        }
    },
    required: [
        'id',
        'number',
        'kind'
    ],
    title: 'LinkedQuotePublic',
    type: 'object'
} as const;

export const LocationCreateSchema = {
    properties: {
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        parent_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Id'
        }
    },
    required: [
        'name'
    ],
    title: 'LocationCreate',
    type: 'object'
} as const;

export const LocationPublicSchema = {
    properties: {
        accepts_children: {
            readOnly: true,
            title: 'Accepts Children',
            type: 'boolean'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        depth: {
            title: 'Depth',
            type: 'integer'
        },
        facility_id: {
            format: 'uuid',
            title: 'Facility Id',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        parent_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'facility_id',
        'parent_id',
        'name',
        'depth',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at',
        'accepts_children'
    ],
    title: 'LocationPublic',
    type: 'object'
} as const;

export const LocationUpdateSchema = {
    properties: {
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    title: 'LocationUpdate',
    type: 'object'
} as const;

export const LocationsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/LocationPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'LocationsPublic',
    type: 'object'
} as const;

export const MailgunRequestSchema = {
    properties: {
        'attachment-count': {
            default: 0,
            title: 'Attachment-Count',
            type: 'integer'
        },
        'body-html': {
            items: {
                type: 'string'
            },
            title: 'Body-Html',
            type: 'array'
        },
        'body-plain': {
            title: 'Body-Plain',
            type: 'string'
        },
        'content-id-map': {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content-Id-Map'
        },
        from: {
            title: 'From',
            type: 'string'
        },
        'message-headers': {
            title: 'Message-Headers',
            type: 'string'
        },
        recipient: {
            title: 'Recipient',
            type: 'string'
        },
        sender: {
            title: 'Sender',
            type: 'string'
        },
        signature: {
            title: 'Signature',
            type: 'string'
        },
        'stripped-html': {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Stripped-Html'
        },
        'stripped-signature': {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Stripped-Signature'
        },
        'stripped-text': {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Stripped-Text'
        },
        subject: {
            title: 'Subject',
            type: 'string'
        },
        timestamp: {
            title: 'Timestamp',
            type: 'integer'
        },
        token: {
            title: 'Token',
            type: 'string'
        }
    },
    required: [
        'signature',
        'timestamp',
        'token',
        'sender',
        'recipient',
        'from',
        'subject',
        'message-headers',
        'body-plain'
    ],
    title: 'MailgunRequest',
    type: 'object'
} as const;

export const MajorAssemblyKindSchema = {
    enum: [
        'apu',
        'engine',
        'landing_gear',
        'propeller_rotor'
    ],
    title: 'MajorAssemblyKind',
    type: 'string'
} as const;

export const MatchSchema = {
    additionalProperties: false,
    properties: {
        in: {
            default: [],
            items: {
                type: 'string'
            },
            title: 'In',
            type: 'array'
        },
        pattern: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pattern'
        }
    },
    title: 'Match',
    type: 'object'
} as const;

export const MatchConditionSchema = {
    additionalProperties: false,
    properties: {
        match: {
            $ref: '#/components/schemas/Match'
        },
        op: {
            enum: [
                'model',
                'variant'
            ],
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'match'
    ],
    title: 'MatchCondition',
    type: 'object'
} as const;

export const MatchTierSchema = {
    enum: [
        'exact',
        'similar_type',
        'any_type',
        'other_type'
    ],
    title: 'MatchTier',
    type: 'string'
} as const;

export const MatchedTextPublicSchema = {
    properties: {
        highlight: {
            title: 'Highlight',
            type: 'string'
        },
        sentence: {
            title: 'Sentence',
            type: 'string'
        }
    },
    required: [
        'sentence',
        'highlight'
    ],
    title: 'MatchedTextPublic',
    type: 'object'
} as const;

export const MeasuredSchema = {
    enum: [
        'aircraft',
        'engine',
        'apu',
        'propeller',
        'component'
    ],
    title: 'Measured',
    type: 'string'
} as const;

export const MergeQuoteTasksSchema = {
    properties: {
        task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            minItems: 2,
            title: 'Task Ids',
            type: 'array'
        }
    },
    required: [
        'task_ids'
    ],
    title: 'MergeQuoteTasks',
    type: 'object'
} as const;

export const MergedQuoteTaskPublicSchema = {
    properties: {
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        task: {
            $ref: '#/components/schemas/QuoteTaskDetailPublic'
        }
    },
    required: [
        'quote_id',
        'task'
    ],
    title: 'MergedQuoteTaskPublic',
    type: 'object'
} as const;

export const MessageSchema = {
    properties: {
        message: {
            title: 'Message',
            type: 'string'
        }
    },
    required: [
        'message'
    ],
    title: 'Message',
    type: 'object'
} as const;

export const MethodOfComplianceSchema = {
    enum: [
        'C/W - No Further Action Required',
        'C/W - Further Action Required',
        'Not Applicable',
        'Superseded',
        'Deferred',
        'Declined'
    ],
    title: 'MethodOfCompliance',
    type: 'string'
} as const;

export const ModDataSourceSchema = {
    enum: [
        'C_CHECK_RECORDS',
        'OEM_RELEASE',
        'CAMO_ARCHIVE',
        'LESSOR_RECORDS',
        'OTHER'
    ],
    title: 'ModDataSource',
    type: 'string'
} as const;

export const ModNatureSchema = {
    enum: [
        'MAINTENANCE',
        'INSPECTION',
        'OTHER'
    ],
    title: 'ModNature',
    type: 'string'
} as const;

export const ModStatusCreateSchema = {
    properties: {
        aircraft_association: {
            anyOf: [
                {
                    $ref: '#/components/schemas/app__aircraft__mod_status__schemas__AircraftAssociation'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Section of aircraft type design the SB/Mod affects'
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        anti_mod_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Identifier of superseding modification',
            title: 'Anti Mod Number'
        },
        anti_mod_status: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Whether a later action cancels/supersedes this mod',
            title: 'Anti Mod Status'
        },
        applicability_notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Basis for applicability judgement',
            title: 'Applicability Notes'
        },
        ata_chapter: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ATA code defining affected system',
            title: 'Ata Chapter'
        },
        certification_reference: {
            anyOf: [
                {
                    maxLength: 500,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Reference to certification document',
            title: 'Certification Reference'
        },
        data_source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModDataSource'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Compliance evidence origin'
        },
        data_source_reference: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'File/archive link to source',
            title: 'Data Source Reference'
        },
        import_status: {
            $ref: '#/components/schemas/UploadStatus'
        },
        last_embodiment_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date when modification embodiment was certified',
            title: 'Last Embodiment Date'
        },
        mod_applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApplicabilityStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering applicability determination'
        },
        mod_nature: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModNature'
                },
                {
                    type: 'null'
                }
            ],
            description: 'What type of work the SB or Mod refers to'
        },
        mod_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mod Number'
        },
        mod_title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mod Title'
        },
        modification_impact: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering impact statement',
            title: 'Modification Impact'
        },
        modification_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModificationType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Defines whether configuration change occurred at production or in-service'
        },
        reference_documentation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Configuration evidence documents',
            title: 'Reference Documentation'
        },
        related_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'AD number mandating embodiment',
            title: 'Related Ad Number'
        },
        remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering justification and notes',
            title: 'Remarks'
        },
        sb_compliance_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SBComplianceType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'OEM prescribed urgency or requirement category'
        },
        sb_imposed_by_ad: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Indicates if embodiment is compulsory due to AD',
            title: 'Sb Imposed By Ad'
        },
        sb_mod_status_value: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModStatusEnum'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Active compliance state'
        },
        sb_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'OEM Service Bulletin reference number',
            title: 'Sb Number'
        },
        sb_status_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Controlled record identifier',
            title: 'Sb Status Id'
        },
        sb_title: {
            anyOf: [
                {
                    maxLength: 1024,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'SB heading as issued',
            title: 'Sb Title'
        },
        status_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date from which current status is valid',
            title: 'Status Effective Date'
        }
    },
    required: [
        'import_status'
    ],
    title: 'ModStatusCreate',
    type: 'object'
} as const;

export const ModStatusDetailPublicSchema = {
    properties: {
        aircraft_association: {
            anyOf: [
                {
                    $ref: '#/components/schemas/app__aircraft__mod_status__schemas__AircraftAssociation'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Section of aircraft type design the SB/Mod affects'
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        anti_mod_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Identifier of superseding modification',
            title: 'Anti Mod Number'
        },
        anti_mod_status: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Whether a later action cancels/supersedes this mod',
            title: 'Anti Mod Status'
        },
        applicability_notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Basis for applicability judgement',
            title: 'Applicability Notes'
        },
        ata_chapter: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ATA code defining affected system',
            title: 'Ata Chapter'
        },
        certification_reference: {
            anyOf: [
                {
                    maxLength: 500,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Reference to certification document',
            title: 'Certification Reference'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        data_source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModDataSource'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Compliance evidence origin'
        },
        data_source_reference: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'File/archive link to source',
            title: 'Data Source Reference'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        import_status: {
            $ref: '#/components/schemas/UploadStatus'
        },
        last_embodiment_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date when modification embodiment was certified',
            title: 'Last Embodiment Date'
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        mod_applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApplicabilityStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering applicability determination'
        },
        mod_nature: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModNature'
                },
                {
                    type: 'null'
                }
            ],
            description: 'What type of work the SB or Mod refers to'
        },
        mod_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mod Number'
        },
        mod_title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mod Title'
        },
        modification_impact: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering impact statement',
            title: 'Modification Impact'
        },
        modification_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModificationType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Defines whether configuration change occurred at production or in-service'
        },
        reference_documentation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Configuration evidence documents',
            title: 'Reference Documentation'
        },
        related_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'AD number mandating embodiment',
            title: 'Related Ad Number'
        },
        remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering justification and notes',
            title: 'Remarks'
        },
        sb_compliance_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SBComplianceType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'OEM prescribed urgency or requirement category'
        },
        sb_imposed_by_ad: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Indicates if embodiment is compulsory due to AD',
            title: 'Sb Imposed By Ad'
        },
        sb_mod_status_value: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModStatusEnum'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Active compliance state'
        },
        sb_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'OEM Service Bulletin reference number',
            title: 'Sb Number'
        },
        sb_status_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Controlled record identifier',
            title: 'Sb Status Id'
        },
        sb_title: {
            anyOf: [
                {
                    maxLength: 1024,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'SB heading as issued',
            title: 'Sb Title'
        },
        status_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date from which current status is valid',
            title: 'Status Effective Date'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'import_status',
        'id',
        'tenant_id',
        'created_at',
        'updated_at',
        'last_modified_by'
    ],
    title: 'ModStatusDetailPublic',
    type: 'object'
} as const;

export const ModStatusEnumSchema = {
    enum: [
        'SB_SCHEDULED',
        'SB_REJECTED',
        'SB_FULLY_EMBODIED',
        'SB_PARTIALLY_EMBODIED',
        'SB_NOT_YET_ISSUED',
        'MOD_NOT_APPLICABLE_IN_SB_SOLUTION',
        'MOD_DONE_IN_PRODUCTION',
        'MOD_PLANNED_IN_PRODUCTION',
        'EQUIVALENT_MOD_FACTORY_INCORPORATED'
    ],
    title: 'ModStatusEnum',
    type: 'string'
} as const;

export const ModStatusPublicSchema = {
    properties: {
        aircraft_association: {
            anyOf: [
                {
                    $ref: '#/components/schemas/app__aircraft__mod_status__schemas__AircraftAssociation'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Section of aircraft type design the SB/Mod affects'
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        anti_mod_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Identifier of superseding modification',
            title: 'Anti Mod Number'
        },
        anti_mod_status: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Whether a later action cancels/supersedes this mod',
            title: 'Anti Mod Status'
        },
        applicability_notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Basis for applicability judgement',
            title: 'Applicability Notes'
        },
        ata_chapter: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ATA code defining affected system',
            title: 'Ata Chapter'
        },
        certification_reference: {
            anyOf: [
                {
                    maxLength: 500,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Reference to certification document',
            title: 'Certification Reference'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        data_source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModDataSource'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Compliance evidence origin'
        },
        data_source_reference: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'File/archive link to source',
            title: 'Data Source Reference'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        import_status: {
            $ref: '#/components/schemas/UploadStatus'
        },
        last_embodiment_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date when modification embodiment was certified',
            title: 'Last Embodiment Date'
        },
        mod_applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApplicabilityStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering applicability determination'
        },
        mod_nature: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModNature'
                },
                {
                    type: 'null'
                }
            ],
            description: 'What type of work the SB or Mod refers to'
        },
        mod_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mod Number'
        },
        mod_title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mod Title'
        },
        modification_impact: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering impact statement',
            title: 'Modification Impact'
        },
        modification_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModificationType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Defines whether configuration change occurred at production or in-service'
        },
        reference_documentation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Configuration evidence documents',
            title: 'Reference Documentation'
        },
        related_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'AD number mandating embodiment',
            title: 'Related Ad Number'
        },
        remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering justification and notes',
            title: 'Remarks'
        },
        sb_compliance_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SBComplianceType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'OEM prescribed urgency or requirement category'
        },
        sb_imposed_by_ad: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Indicates if embodiment is compulsory due to AD',
            title: 'Sb Imposed By Ad'
        },
        sb_mod_status_value: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModStatusEnum'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Active compliance state'
        },
        sb_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'OEM Service Bulletin reference number',
            title: 'Sb Number'
        },
        sb_status_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Controlled record identifier',
            title: 'Sb Status Id'
        },
        sb_title: {
            anyOf: [
                {
                    maxLength: 1024,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'SB heading as issued',
            title: 'Sb Title'
        },
        status_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date from which current status is valid',
            title: 'Status Effective Date'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'import_status',
        'id',
        'tenant_id',
        'created_at',
        'updated_at'
    ],
    title: 'ModStatusPublic',
    type: 'object'
} as const;

export const ModStatusUpdateSchema = {
    properties: {
        aircraft_association: {
            anyOf: [
                {
                    $ref: '#/components/schemas/app__aircraft__mod_status__schemas__AircraftAssociation'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Section of aircraft type design the SB/Mod affects'
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        anti_mod_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Identifier of superseding modification',
            title: 'Anti Mod Number'
        },
        anti_mod_status: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Whether a later action cancels/supersedes this mod',
            title: 'Anti Mod Status'
        },
        applicability_notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Basis for applicability judgement',
            title: 'Applicability Notes'
        },
        ata_chapter: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ATA code defining affected system',
            title: 'Ata Chapter'
        },
        certification_reference: {
            anyOf: [
                {
                    maxLength: 500,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Reference to certification document',
            title: 'Certification Reference'
        },
        data_source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModDataSource'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Compliance evidence origin'
        },
        data_source_reference: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'File/archive link to source',
            title: 'Data Source Reference'
        },
        import_status: {
            $ref: '#/components/schemas/UploadStatus'
        },
        last_embodiment_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date when modification embodiment was certified',
            title: 'Last Embodiment Date'
        },
        mod_applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApplicabilityStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering applicability determination'
        },
        mod_nature: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModNature'
                },
                {
                    type: 'null'
                }
            ],
            description: 'What type of work the SB or Mod refers to'
        },
        mod_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mod Number'
        },
        mod_title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mod Title'
        },
        modification_impact: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering impact statement',
            title: 'Modification Impact'
        },
        modification_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModificationType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Defines whether configuration change occurred at production or in-service'
        },
        reference_documentation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Configuration evidence documents',
            title: 'Reference Documentation'
        },
        related_ad_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'AD number mandating embodiment',
            title: 'Related Ad Number'
        },
        remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Engineering justification and notes',
            title: 'Remarks'
        },
        sb_compliance_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SBComplianceType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'OEM prescribed urgency or requirement category'
        },
        sb_imposed_by_ad: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Indicates if embodiment is compulsory due to AD',
            title: 'Sb Imposed By Ad'
        },
        sb_mod_status_value: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ModStatusEnum'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Active compliance state'
        },
        sb_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'OEM Service Bulletin reference number',
            title: 'Sb Number'
        },
        sb_status_id: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Controlled record identifier',
            title: 'Sb Status Id'
        },
        sb_title: {
            anyOf: [
                {
                    maxLength: 1024,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'SB heading as issued',
            title: 'Sb Title'
        },
        status_effective_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Date from which current status is valid',
            title: 'Status Effective Date'
        }
    },
    required: [
        'import_status'
    ],
    title: 'ModStatusUpdate',
    type: 'object'
} as const;

export const ModStatusesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ModStatusDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ModStatusesPublic',
    type: 'object'
} as const;

export const ModeSchema = {
    enum: [
        'suggestion'
    ],
    title: 'Mode',
    type: 'string'
} as const;

export const ModificationConditionSchema = {
    additionalProperties: false,
    properties: {
        op: {
            enum: [
                'mod',
                'sb'
            ],
            title: 'Op',
            type: 'string'
        },
        ref: {
            title: 'Ref',
            type: 'string'
        }
    },
    required: [
        'op',
        'ref'
    ],
    title: 'ModificationCondition',
    type: 'object'
} as const;

export const ModificationTypeSchema = {
    enum: [
        'PRODUCTION',
        'IN_SERVICE'
    ],
    title: 'ModificationType',
    type: 'string'
} as const;

export const ModulesEnabledSchema = {
    enum: [
        'all',
        'trace',
        'sonic'
    ],
    title: 'ModulesEnabled',
    type: 'string'
} as const;

export const MoveOutsideServiceSchema = {
    discriminator: {
        mapping: {
            accept: '#/components/schemas/AcceptOutsideService',
            order: '#/components/schemas/OrderOutsideService',
            receive: '#/components/schemas/ReceiveOutsideService',
            reinstall: '#/components/schemas/ReinstallOutsideService',
            ship: '#/components/schemas/ShipOutsideService',
            start: '#/components/schemas/StartOutsideService',
            verify: '#/components/schemas/VerifyOutsideService'
        },
        propertyName: 'action'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/OrderOutsideService'
        },
        {
            $ref: '#/components/schemas/ShipOutsideService'
        },
        {
            $ref: '#/components/schemas/StartOutsideService'
        },
        {
            $ref: '#/components/schemas/ReceiveOutsideService'
        },
        {
            $ref: '#/components/schemas/VerifyOutsideService'
        },
        {
            $ref: '#/components/schemas/ReinstallOutsideService'
        },
        {
            $ref: '#/components/schemas/AcceptOutsideService'
        }
    ],
    title: 'MoveOutsideService'
} as const;

export const MoveWorkPackageSchema = {
    properties: {
        action: {
            enum: [
                'release',
                'start',
                'complete',
                'reopen'
            ],
            title: 'Action',
            type: 'string'
        }
    },
    required: [
        'action'
    ],
    title: 'MoveWorkPackage',
    type: 'object'
} as const;

export const NewPartSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        is_consumable: {
            default: false,
            title: 'Is Consumable',
            type: 'boolean'
        },
        is_rotable: {
            default: false,
            title: 'Is Rotable',
            type: 'boolean'
        },
        is_serialised: {
            default: false,
            title: 'Is Serialised',
            type: 'boolean'
        },
        is_traceable: {
            default: false,
            title: 'Is Traceable',
            type: 'boolean'
        },
        kind: {
            const: 'new_part',
            title: 'Kind',
            type: 'string'
        },
        manufacturer_cage: {
            anyOf: [
                {
                    maxLength: 50,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Cage'
        },
        manufacturer_name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Name'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        reorder_point: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reorder Point'
        },
        unit_of_measure: {
            anyOf: [
                {
                    maxLength: 100,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'number',
        'kind'
    ],
    title: 'NewPart',
    type: 'object'
} as const;

export const NewPasswordSchema = {
    properties: {
        new_password: {
            maxLength: 128,
            minLength: 12,
            title: 'New Password',
            type: 'string'
        },
        token: {
            title: 'Token',
            type: 'string'
        }
    },
    required: [
        'token',
        'new_password'
    ],
    title: 'NewPassword',
    type: 'object'
} as const;

export const NotCondition_InputSchema = {
    additionalProperties: false,
    properties: {
        of: {
            $ref: '#/components/schemas/Condition-Input'
        },
        op: {
            const: 'not',
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'of'
    ],
    title: 'NotCondition',
    type: 'object'
} as const;

export const NotCondition_OutputSchema = {
    additionalProperties: false,
    properties: {
        of: {
            $ref: '#/components/schemas/Condition-Output'
        },
        op: {
            const: 'not',
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'of'
    ],
    title: 'NotCondition',
    type: 'object'
} as const;

export const NoteCategorySchema = {
    enum: [
        'AI Generated',
        'Suggested',
        'Imported',
        'Manual'
    ],
    title: 'NoteCategory',
    type: 'string'
} as const;

export const NoteGenerationStatusSchema = {
    enum: [
        'Pending',
        'In Progress',
        'Completed',
        'Failed'
    ],
    title: 'NoteGenerationStatus',
    type: 'string'
} as const;

export const NotificationActorPublicSchema = {
    properties: {
        first_name: {
            title: 'First Name',
            type: 'string'
        },
        last_name: {
            title: 'Last Name',
            type: 'string'
        }
    },
    required: [
        'first_name',
        'last_name'
    ],
    title: 'NotificationActorPublic',
    type: 'object'
} as const;

export const NotificationAudienceDocumentSchema = {
    discriminator: {
        mapping: {
            actor_team_members: '#/components/schemas/ActorTeamMembersAudience',
            department: '#/components/schemas/DepartmentAudience',
            facility: '#/components/schemas/FacilityAudience',
            permission: '#/components/schemas/PermissionAudience',
            person: '#/components/schemas/PersonAudience',
            position: '#/components/schemas/PositionAudience',
            record_role: '#/components/schemas/RecordRoleAudience',
            relative_position: '#/components/schemas/RelativePositionAudience',
            role: '#/components/schemas/RoleAudience',
            team: '#/components/schemas/TeamAudience'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/PersonAudience'
        },
        {
            $ref: '#/components/schemas/PositionAudience'
        },
        {
            $ref: '#/components/schemas/TeamAudience'
        },
        {
            $ref: '#/components/schemas/DepartmentAudience'
        },
        {
            $ref: '#/components/schemas/FacilityAudience'
        },
        {
            $ref: '#/components/schemas/RoleAudience'
        },
        {
            $ref: '#/components/schemas/PermissionAudience'
        },
        {
            $ref: '#/components/schemas/RecordRoleAudience'
        },
        {
            $ref: '#/components/schemas/RelativePositionAudience'
        },
        {
            $ref: '#/components/schemas/ActorTeamMembersAudience'
        }
    ]
} as const;

export const NotificationConditionFieldSchema = {
    enum: [
        'actor',
        'actor_team',
        'source',
        'work_package',
        'department',
        'facility',
        'customer',
        'aircraft',
        'signed',
        'has_questions',
        'visibility',
        'mailbox',
        'status',
        'decision',
        'assignee',
        'condition',
        'result'
    ],
    title: 'NotificationConditionField',
    type: 'string'
} as const;

export const NotificationConditionOpSchema = {
    enum: [
        'is',
        'is_any_of',
        'is_not',
        'changed_to',
        'changed_from',
        'is_set'
    ],
    title: 'NotificationConditionOp',
    type: 'string'
} as const;

export const NotificationConditionRecordSchema = {
    enum: [
        'user',
        'team',
        'department',
        'facility',
        'customer',
        'aircraft',
        'work_order'
    ],
    title: 'NotificationConditionRecord',
    type: 'string'
} as const;

export const NotificationConditionReferenceSchema = {
    properties: {
        field: {
            $ref: '#/components/schemas/NotificationConditionField'
        },
        operators: {
            items: {
                $ref: '#/components/schemas/NotificationConditionOp'
            },
            title: 'Operators',
            type: 'array'
        },
        value: {
            $ref: '#/components/schemas/NotificationConditionValue'
        }
    },
    required: [
        'field',
        'operators',
        'value'
    ],
    title: 'NotificationConditionReference',
    type: 'object'
} as const;

export const NotificationConditionValueSchema = {
    discriminator: {
        mapping: {
            choice: '#/components/schemas/ChoiceConditionValue',
            flag: '#/components/schemas/FlagConditionValue',
            id: '#/components/schemas/IdConditionValue',
            text: '#/components/schemas/TextConditionValue'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/ChoiceConditionValue'
        },
        {
            $ref: '#/components/schemas/IdConditionValue'
        },
        {
            $ref: '#/components/schemas/FlagConditionValue'
        },
        {
            $ref: '#/components/schemas/TextConditionValue'
        }
    ]
} as const;

export const NotificationDeliverySchema = {
    enum: [
        'off',
        'in_app',
        'email',
        'in_app_and_email'
    ],
    title: 'NotificationDelivery',
    type: 'string'
} as const;

export const NotificationEventReferenceSchema = {
    properties: {
        extra_conditions: {
            items: {
                $ref: '#/components/schemas/NotificationConditionReference'
            },
            title: 'Extra Conditions',
            type: 'array'
        },
        read_permissions: {
            items: {
                type: 'string'
            },
            title: 'Read Permissions',
            type: 'array'
        },
        record_roles: {
            items: {
                $ref: '#/components/schemas/NotificationRecordRole'
            },
            title: 'Record Roles',
            type: 'array'
        },
        type: {
            $ref: '#/components/schemas/NotificationEventType'
        }
    },
    required: [
        'type',
        'read_permissions',
        'record_roles',
        'extra_conditions'
    ],
    title: 'NotificationEventReference',
    type: 'object'
} as const;

export const NotificationEventTypeSchema = {
    enum: [
        'squawk_created',
        'squawk_status_changed',
        'squawk_moved',
        'squawk_comment_added',
        'email_received',
        'customer_responded',
        'comment_added',
        'review_requested',
        'quote_created',
        'quote_details_updated',
        'quote_tasks_added',
        'quote_tasks_removed',
        'quote_tasks_merged',
        'quote_task_statuses_changed',
        'quote_tasks_reviewed',
        'quote_disposition_changed',
        'quote_customer_opened',
        'quote_report_generated',
        'quote_email_failed',
        'work_order_created',
        'work_order_details_updated',
        'work_order_status_changed',
        'work_order_aog_marked',
        'work_order_aog_cleared',
        'work_order_tasks_added',
        'work_order_tasks_removed',
        'work_task_statuses_changed',
        'work_tasks_assigned',
        'work_task_signed_off',
        'work_task_sign_off_undone',
        'work_task_inspected',
        'work_task_inspection_undone',
        'work_task_note_added',
        'programme_created',
        'programme_archived',
        'programme_restored',
        'programme_updated',
        'programme_revision_created',
        'programme_revision_released',
        'programme_revision_updated',
        'programme_task_added',
        'programme_task_updated',
        'programme_task_removed',
        'programme_phase_added',
        'programme_phase_updated',
        'programme_phase_removed',
        'programme_aircraft_enrolled',
        'programme_aircraft_removed',
        'atl_page_drafted',
        'atl_page_flagged',
        'atl_page_recorded',
        'atl_page_voided',
        'atl_deferral_raised',
        'atl_deferral_cleared',
        'atl_deferral_due_soon',
        'atl_deferral_overdue',
        'tool_issued',
        'tool_returned',
        'tool_issue_undone',
        'tool_loan_overdue',
        'tool_sent_for_calibration',
        'tool_calibrated',
        'tool_calibration_due_soon',
        'tool_calibration_overdue',
        'tool_condition_changed',
        'tool_retired',
        'tool_restored',
        'part_reserved',
        'part_reservation_changed',
        'part_reservation_released',
        'part_stock_low',
        'work_task_part_requested',
        'work_task_part_withdrawn',
        'work_task_part_issued',
        'outside_service_requested',
        'outside_service_moved',
        'outside_service_withdrawn',
        'document_processed',
        'email_shared',
        'mentioned',
        'approval_requested'
    ],
    title: 'NotificationEventType',
    type: 'string'
} as const;

export const NotificationPreferencePublicSchema = {
    properties: {
        default_delivery: {
            $ref: '#/components/schemas/NotificationDelivery'
        },
        delivery: {
            $ref: '#/components/schemas/NotificationDelivery'
        },
        is_mandatory: {
            title: 'Is Mandatory',
            type: 'boolean'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        reasons: {
            items: {
                type: 'string'
            },
            title: 'Reasons',
            type: 'array'
        },
        rule_id: {
            format: 'uuid',
            title: 'Rule Id',
            type: 'string'
        },
        system_key: {
            anyOf: [
                {
                    $ref: '#/components/schemas/NotificationType'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'rule_id',
        'name',
        'system_key',
        'delivery',
        'default_delivery',
        'is_mandatory',
        'reasons'
    ],
    title: 'NotificationPreferencePublic',
    type: 'object'
} as const;

export const NotificationPreferenceUpsertSchema = {
    properties: {
        delivery: {
            $ref: '#/components/schemas/NotificationDelivery'
        },
        rule_id: {
            format: 'uuid',
            title: 'Rule Id',
            type: 'string'
        }
    },
    required: [
        'rule_id',
        'delivery'
    ],
    title: 'NotificationPreferenceUpsert',
    type: 'object'
} as const;

export const NotificationPublicSchema = {
    properties: {
        actor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/NotificationActorPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        atl_page_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Atl Page Id'
        },
        body: {
            title: 'Body',
            type: 'string'
        },
        canned_work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Task Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        email_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        programme_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Programme Id'
        },
        quote_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Id'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        seen_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Seen At'
        },
        squawk_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Squawk Id'
        },
        title: {
            title: 'Title',
            type: 'string'
        },
        tool_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tool Id'
        },
        type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/NotificationType'
                },
                {
                    $ref: '#/components/schemas/NotificationEventType'
                }
            ],
            title: 'Type'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'id',
        'type',
        'created_at',
        'updated_at',
        'seen_at',
        'title',
        'body',
        'actor',
        'quote_task_id',
        'email_id',
        'squawk_id',
        'quote_id',
        'work_package_id',
        'programme_id',
        'atl_page_id',
        'tool_id',
        'part_id',
        'document_id',
        'canned_work_task_id'
    ],
    title: 'NotificationPublic',
    type: 'object'
} as const;

export const NotificationRecordRoleSchema = {
    enum: [
        'subscribers',
        'participants',
        'requested_reviewers',
        'estimator',
        'sales_rep',
        'lead_technician',
        'inspector',
        'reporter',
        'assignee',
        'creator',
        'requester',
        'custodian',
        'owner',
        'mentioned',
        'approvers'
    ],
    title: 'NotificationRecordRole',
    type: 'string'
} as const;

export const NotificationRuleConditionSchema = {
    additionalProperties: false,
    properties: {
        field: {
            $ref: '#/components/schemas/NotificationConditionField'
        },
        op: {
            $ref: '#/components/schemas/NotificationConditionOp',
            description: 'is_any_of takes a list. is_set takes true or false and only works on ids, the only values that can be empty. changed_to and changed_from only work where the reference value has records_change true.'
        },
        value: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'boolean'
                }
            ],
            description: 'The exact stored value listed in the reference, never the label shown in the app.',
            title: 'Value'
        }
    },
    required: [
        'field',
        'op',
        'value'
    ],
    title: 'NotificationRuleCondition',
    type: 'object'
} as const;

export const NotificationRuleCreateSchema = {
    additionalProperties: false,
    properties: {
        audiences: {
            items: {
                $ref: '#/components/schemas/NotificationAudienceDocument'
            },
            minItems: 1,
            title: 'Audiences',
            type: 'array'
        },
        conditions: {
            default: [],
            items: {
                $ref: '#/components/schemas/NotificationRuleCondition'
            },
            title: 'Conditions',
            type: 'array'
        },
        delivery: {
            $ref: '#/components/schemas/NotificationDelivery'
        },
        event_type: {
            $ref: '#/components/schemas/NotificationEventType'
        },
        include_actor: {
            default: false,
            title: 'Include Actor',
            type: 'boolean'
        },
        is_enabled: {
            default: true,
            title: 'Is Enabled',
            type: 'boolean'
        },
        is_mandatory: {
            default: false,
            title: 'Is Mandatory',
            type: 'boolean'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        sources: {
            default: [],
            items: {
                $ref: '#/components/schemas/ChangedBy'
            },
            title: 'Sources',
            type: 'array'
        }
    },
    required: [
        'name',
        'event_type',
        'delivery',
        'audiences'
    ],
    title: 'NotificationRuleCreate',
    type: 'object'
} as const;

export const NotificationRuleDocumentSchema = {
    additionalProperties: false,
    properties: {
        audiences: {
            description: 'Who is notified. Only people who can read the record get it, and each person gets it once.',
            items: {
                $ref: '#/components/schemas/NotificationAudienceDocument'
            },
            minItems: 1,
            title: 'Audiences',
            type: 'array'
        },
        conditions: {
            default: [],
            description: 'Every condition must hold. The reference lists the fields, operators and exact values: conditions_on_every_event, plus each event\'s extra_conditions.',
            items: {
                $ref: '#/components/schemas/NotificationRuleCondition'
            },
            title: 'Conditions',
            type: 'array'
        },
        delivery: {
            $ref: '#/components/schemas/NotificationDelivery',
            description: 'The default delivery. Each user\'s own setting overrides it.'
        },
        event_type: {
            $ref: '#/components/schemas/NotificationEventType'
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Leave out for a new rule. Keep it on an existing rule; a rule missing from the set is removed.',
            title: 'Id'
        },
        include_actor: {
            default: false,
            description: 'Also notify the person who caused the event.',
            title: 'Include Actor',
            type: 'boolean'
        },
        is_enabled: {
            default: true,
            title: 'Is Enabled',
            type: 'boolean'
        },
        is_mandatory: {
            default: false,
            description: 'Users can\'t switch in-app delivery off. They can still choose email.',
            title: 'Is Mandatory',
            type: 'boolean'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        sources: {
            default: [],
            description: 'Fire only for changes made this way. Empty means any way.',
            items: {
                $ref: '#/components/schemas/ChangedBy'
            },
            title: 'Sources',
            type: 'array'
        },
        system_key: {
            anyOf: [
                {
                    $ref: '#/components/schemas/NotificationType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Set on built-in rules only. Leave it as it is.'
        }
    },
    required: [
        'name',
        'event_type',
        'delivery',
        'audiences'
    ],
    title: 'NotificationRuleDocument',
    type: 'object'
} as const;

export const NotificationRuleOptionsSchema = {
    properties: {
        conditions_on_every_event: {
            items: {
                $ref: '#/components/schemas/NotificationConditionReference'
            },
            title: 'Conditions On Every Event',
            type: 'array'
        },
        departments: {
            items: {
                $ref: '#/components/schemas/DepartmentReference'
            },
            title: 'Departments',
            type: 'array'
        },
        events: {
            items: {
                $ref: '#/components/schemas/NotificationEventReference'
            },
            title: 'Events',
            type: 'array'
        },
        facilities: {
            items: {
                $ref: '#/components/schemas/FacilityReference'
            },
            title: 'Facilities',
            type: 'array'
        },
        permissions: {
            items: {
                type: 'string'
            },
            title: 'Permissions',
            type: 'array'
        },
        positions: {
            items: {
                $ref: '#/components/schemas/PositionReference'
            },
            title: 'Positions',
            type: 'array'
        },
        roles: {
            items: {
                $ref: '#/components/schemas/RoleReference'
            },
            title: 'Roles',
            type: 'array'
        },
        teams: {
            items: {
                $ref: '#/components/schemas/TeamReference'
            },
            title: 'Teams',
            type: 'array'
        },
        users: {
            items: {
                $ref: '#/components/schemas/UserReference'
            },
            title: 'Users',
            type: 'array'
        }
    },
    required: [
        'conditions_on_every_event',
        'events',
        'teams',
        'departments',
        'facilities',
        'roles',
        'positions',
        'users',
        'permissions'
    ],
    title: 'NotificationRuleOptions',
    type: 'object'
} as const;

export const NotificationRuleReferenceSchema = {
    properties: {
        conditions_on_every_event: {
            items: {
                $ref: '#/components/schemas/NotificationConditionReference'
            },
            title: 'Conditions On Every Event',
            type: 'array'
        },
        departments: {
            items: {
                $ref: '#/components/schemas/DepartmentReference'
            },
            title: 'Departments',
            type: 'array'
        },
        events: {
            items: {
                $ref: '#/components/schemas/NotificationEventReference'
            },
            title: 'Events',
            type: 'array'
        },
        facilities: {
            items: {
                $ref: '#/components/schemas/FacilityReference'
            },
            title: 'Facilities',
            type: 'array'
        },
        json_schema: {
            $ref: '#/components/schemas/JsonValue'
        },
        permissions: {
            items: {
                type: 'string'
            },
            title: 'Permissions',
            type: 'array'
        },
        positions: {
            items: {
                $ref: '#/components/schemas/PositionReference'
            },
            title: 'Positions',
            type: 'array'
        },
        roles: {
            items: {
                $ref: '#/components/schemas/RoleReference'
            },
            title: 'Roles',
            type: 'array'
        },
        teams: {
            items: {
                $ref: '#/components/schemas/TeamReference'
            },
            title: 'Teams',
            type: 'array'
        },
        users: {
            items: {
                $ref: '#/components/schemas/UserReference'
            },
            title: 'Users',
            type: 'array'
        }
    },
    required: [
        'conditions_on_every_event',
        'events',
        'teams',
        'departments',
        'facilities',
        'roles',
        'positions',
        'users',
        'permissions',
        'json_schema'
    ],
    title: 'NotificationRuleReference',
    type: 'object'
} as const;

export const NotificationRuleSetSchema = {
    additionalProperties: false,
    properties: {
        rules: {
            items: {
                $ref: '#/components/schemas/NotificationRuleDocument'
            },
            title: 'Rules',
            type: 'array'
        }
    },
    required: [
        'rules'
    ],
    title: 'NotificationRuleSet',
    type: 'object'
} as const;

export const NotificationRuleSetPublicSchema = {
    properties: {
        names: {
            additionalProperties: {
                type: 'string'
            },
            propertyNames: {
                format: 'uuid'
            },
            title: 'Names',
            type: 'object'
        },
        rules: {
            items: {
                $ref: '#/components/schemas/NotificationRuleDocument'
            },
            title: 'Rules',
            type: 'array'
        }
    },
    required: [
        'rules',
        'names'
    ],
    title: 'NotificationRuleSetPublic',
    type: 'object'
} as const;

export const NotificationRuleSetUpdateSchema = {
    properties: {
        document: {
            title: 'Document',
            type: 'string'
        }
    },
    required: [
        'document'
    ],
    title: 'NotificationRuleSetUpdate',
    type: 'object'
} as const;

export const NotificationRuleUpdateSchema = {
    additionalProperties: false,
    properties: {
        audiences: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/NotificationAudienceDocument'
                    },
                    minItems: 1,
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Audiences'
        },
        conditions: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/NotificationRuleCondition'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Conditions'
        },
        delivery: {
            anyOf: [
                {
                    $ref: '#/components/schemas/NotificationDelivery'
                },
                {
                    type: 'null'
                }
            ]
        },
        event_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/NotificationEventType'
                },
                {
                    type: 'null'
                }
            ]
        },
        include_actor: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Include Actor'
        },
        is_enabled: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Enabled'
        },
        is_mandatory: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Mandatory'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        sources: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/ChangedBy'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sources'
        }
    },
    title: 'NotificationRuleUpdate',
    type: 'object'
} as const;

export const NotificationTypeSchema = {
    enum: [
        'squawk_created',
        'subscribed_squawk_created',
        'email_received',
        'customer_responded',
        'review_requested',
        'comment_added',
        'mentioned',
        'approval_requested'
    ],
    title: 'NotificationType',
    type: 'string'
} as const;

export const OnConditionSchema = {
    enum: [
        'New',
        'Repaired',
        'Modified',
        'Serviceable',
        'Overhauled or Restored',
        'Tested or Inspected',
        'Upgraded',
        'Loaner'
    ],
    title: 'OnCondition',
    type: 'string'
} as const;

export const OnExistingSchema = {
    enum: [
        'run_extract',
        'skip_extract'
    ],
    title: 'OnExisting',
    type: 'string'
} as const;

export const OperatorSchema = {
    properties: {
        iata_code: {
            title: 'Iata Code',
            type: 'string'
        },
        icao_code: {
            title: 'Icao Code',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'icao_code',
        'iata_code',
        'name'
    ],
    title: 'Operator',
    type: 'object'
} as const;

export const Option_InputSchema = {
    additionalProperties: false,
    properties: {
        key: {
            title: 'Key',
            type: 'string'
        },
        then: {
            $ref: '#/components/schemas/Expr-Input'
        }
    },
    required: [
        'key',
        'then'
    ],
    title: 'Option',
    type: 'object'
} as const;

export const Option_OutputSchema = {
    additionalProperties: false,
    properties: {
        key: {
            title: 'Key',
            type: 'string'
        },
        then: {
            $ref: '#/components/schemas/Expr-Output'
        }
    },
    required: [
        'key',
        'then'
    ],
    title: 'Option',
    type: 'object'
} as const;

export const OptionExpr_InputSchema = {
    additionalProperties: false,
    properties: {
        op: {
            const: 'option',
            title: 'Op',
            type: 'string'
        },
        options: {
            items: {
                $ref: '#/components/schemas/Option-Input'
            },
            minItems: 1,
            title: 'Options',
            type: 'array'
        }
    },
    required: [
        'op',
        'options'
    ],
    title: 'OptionExpr',
    type: 'object'
} as const;

export const OptionExpr_OutputSchema = {
    additionalProperties: false,
    properties: {
        op: {
            const: 'option',
            title: 'Op',
            type: 'string'
        },
        options: {
            items: {
                $ref: '#/components/schemas/Option-Output'
            },
            minItems: 1,
            title: 'Options',
            type: 'array'
        }
    },
    required: [
        'op',
        'options'
    ],
    title: 'OptionExpr',
    type: 'object'
} as const;

export const OrderOutsideServiceSchema = {
    properties: {
        action: {
            const: 'order',
            title: 'Action',
            type: 'string'
        },
        note: {
            anyOf: [
                {
                    maxLength: 4000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        promised_back_on: {
            format: 'date',
            title: 'Promised Back On',
            type: 'string'
        },
        purchase_order: {
            maxLength: 200,
            minLength: 1,
            title: 'Purchase Order',
            type: 'string'
        },
        vendor_id: {
            format: 'uuid',
            title: 'Vendor Id',
            type: 'string'
        }
    },
    required: [
        'action',
        'vendor_id',
        'purchase_order',
        'promised_back_on'
    ],
    title: 'OrderOutsideService',
    type: 'object'
} as const;

export const OutsideServiceSchema = {
    properties: {
        currency: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        list_price: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'List Price'
        },
        purchase_price: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Price'
        },
        sale_price: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Price'
        }
    },
    required: [
        'description'
    ],
    title: 'OutsideService',
    type: 'object'
} as const;

export const OutsideServiceActionSchema = {
    enum: [
        'order',
        'ship',
        'start',
        'receive',
        'verify',
        'reinstall',
        'accept'
    ],
    title: 'OutsideServiceAction',
    type: 'string'
} as const;

export const OutsideServiceCheckSchema = {
    enum: [
        'component_removed',
        'handed_to_shipping',
        'certificate_received',
        'report_reviewed',
        'condition_acceptable',
        'installed_per_manual',
        'functional_check',
        'leak_check',
        'vendor_report_received',
        'work_accepted'
    ],
    title: 'OutsideServiceCheck',
    type: 'string'
} as const;

export const OutsideServiceKindSchema = {
    enum: [
        'overhaul',
        'repair',
        'inspection',
        'ndt',
        'test',
        'plating',
        'paint',
        'other'
    ],
    title: 'OutsideServiceKind',
    type: 'string'
} as const;

export const OutsideServiceLineSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        locator: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locator'
        },
        part_number: {
            minLength: 1,
            title: 'Part Number',
            type: 'string'
        },
        price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Price'
        }
    },
    required: [
        'part_number'
    ],
    title: 'OutsideServiceLine',
    type: 'object'
} as const;

export const OutsideServicePricePublicSchema = {
    properties: {
        currency: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        purchase_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Price'
        },
        raised_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Raised At'
        }
    },
    required: [
        'description',
        'currency',
        'purchase_price',
        'raised_at'
    ],
    title: 'OutsideServicePricePublic',
    type: 'object'
} as const;

export const OutsideServicePricesPublicSchema = {
    properties: {
        prices: {
            items: {
                $ref: '#/components/schemas/OutsideServicePricePublic'
            },
            title: 'Prices',
            type: 'array'
        }
    },
    required: [
        'prices'
    ],
    title: 'OutsideServicePricesPublic',
    type: 'object'
} as const;

export const OutsideServiceStageSchema = {
    enum: [
        'requested',
        'ordered',
        'shipped_out',
        'in_work',
        'received_back',
        'reinstalled',
        'complete'
    ],
    title: 'OutsideServiceStage',
    type: 'string'
} as const;

export const OutsideServiceVendorPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'name'
    ],
    title: 'OutsideServiceVendorPublic',
    type: 'object'
} as const;

export const PartSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        lot_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    required: [
        'part_number'
    ],
    title: 'Part',
    type: 'object'
} as const;

export const PartAlternateCreateSchema = {
    properties: {
        alternate_part_id: {
            format: 'uuid',
            title: 'Alternate Part Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/PartAlternateKind'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        }
    },
    required: [
        'part_id',
        'alternate_part_id',
        'kind'
    ],
    title: 'PartAlternateCreate',
    type: 'object'
} as const;

export const PartAlternateDetailPublicSchema = {
    properties: {
        alternate_part: {
            $ref: '#/components/schemas/PartPublic'
        },
        alternate_part_id: {
            format: 'uuid',
            title: 'Alternate Part Id',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/PartAlternateKind'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        part: {
            $ref: '#/components/schemas/PartPublic'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'part_id',
        'alternate_part_id',
        'kind',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at',
        'part',
        'alternate_part'
    ],
    title: 'PartAlternateDetailPublic',
    type: 'object'
} as const;

export const PartAlternateKindSchema = {
    enum: [
        'alternative',
        'parts_manufacturer_approval',
        'superseded'
    ],
    title: 'PartAlternateKind',
    type: 'string'
} as const;

export const PartAlternateUpdateSchema = {
    properties: {
        kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartAlternateKind'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    title: 'PartAlternateUpdate',
    type: 'object'
} as const;

export const PartAlternatesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PartAlternateDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PartAlternatesPublic',
    type: 'object'
} as const;

export const PartApplicabilityCreateSchema = {
    properties: {
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        subject: {
            const: 'part',
            title: 'Subject',
            type: 'string'
        }
    },
    required: [
        'subject',
        'part_id'
    ],
    title: 'PartApplicabilityCreate',
    type: 'object'
} as const;

export const PartArchiveScopeSchema = {
    enum: [
        'live',
        'archived',
        'all'
    ],
    title: 'PartArchiveScope',
    type: 'string'
} as const;

export const PartBalanceCreateSchema = {
    properties: {
        condition: {
            $ref: '#/components/schemas/PartCondition'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        facility_id: {
            format: 'uuid',
            title: 'Facility Id',
            type: 'string'
        },
        last_counted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Counted At'
        },
        lot_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Instance Id'
        },
        quantity_on_hand: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            default: '0',
            title: 'Quantity On Hand'
        },
        serial_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        unit_cost: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Cost'
        }
    },
    required: [
        'part_id',
        'facility_id',
        'condition'
    ],
    title: 'PartBalanceCreate',
    type: 'object'
} as const;

export const PartBalanceDetailPublicSchema = {
    properties: {
        condition: {
            $ref: '#/components/schemas/PartCondition'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        facility: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FacilityPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        facility_id: {
            format: 'uuid',
            title: 'Facility Id',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_counted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Counted At'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        part: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        part_instance: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartInstanceSummaryPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Instance Id'
        },
        quantity_on_hand: {
            title: 'Quantity On Hand',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        unit_cost: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Cost'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'part_id',
        'facility_id',
        'condition',
        'quantity_on_hand',
        'part_instance_id',
        'unit_cost',
        'currency',
        'last_counted_at',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at',
        'part',
        'facility',
        'part_instance'
    ],
    title: 'PartBalanceDetailPublic',
    type: 'object'
} as const;

export const PartBalanceUpdateSchema = {
    properties: {
        condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        last_counted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Counted At'
        },
        quantity_on_hand: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity On Hand'
        },
        unit_cost: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Cost'
        }
    },
    title: 'PartBalanceUpdate',
    type: 'object'
} as const;

export const PartBalancesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PartBalanceDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PartBalancesPublic',
    type: 'object'
} as const;

export const PartBulkDeletePublicSchema = {
    properties: {
        deleted: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Deleted',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'deleted',
        'skipped'
    ],
    title: 'PartBulkDeletePublic',
    type: 'object'
} as const;

export const PartBulkIdsSchema = {
    properties: {
        part_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 500,
            minItems: 1,
            title: 'Part Ids',
            type: 'array'
        }
    },
    required: [
        'part_ids'
    ],
    title: 'PartBulkIds',
    type: 'object'
} as const;

export const PartComplianceInfoSchema = {
    description: 'Use if task_type is part',
    properties: {
        part_off: {
            $ref: '#/components/schemas/PartOff'
        },
        part_on: {
            $ref: '#/components/schemas/PartOn'
        },
        warranty_info: {
            $ref: '#/components/schemas/WarrantyInfo'
        }
    },
    required: [
        'part_off',
        'part_on',
        'warranty_info'
    ],
    title: 'PartComplianceInfo',
    type: 'object'
} as const;

export const PartConditionSchema = {
    enum: [
        'new',
        'serviceable',
        'overhauled',
        'repaired',
        'inspected',
        'as_removed',
        'unserviceable'
    ],
    title: 'PartCondition',
    type: 'string'
} as const;

export const PartDetailsSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        is_consumable: {
            default: false,
            title: 'Is Consumable',
            type: 'boolean'
        },
        is_rotable: {
            default: false,
            title: 'Is Rotable',
            type: 'boolean'
        },
        is_serialised: {
            default: false,
            title: 'Is Serialised',
            type: 'boolean'
        },
        is_traceable: {
            default: false,
            title: 'Is Traceable',
            type: 'boolean'
        },
        manufacturer_cage: {
            anyOf: [
                {
                    maxLength: 50,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Cage'
        },
        manufacturer_name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Name'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        reorder_point: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reorder Point'
        },
        unit_of_measure: {
            anyOf: [
                {
                    maxLength: 100,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'number'
    ],
    title: 'PartDetails',
    type: 'object'
} as const;

export const PartInstancePublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        lot_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        part: {
            $ref: '#/components/schemas/PartPublic'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    required: [
        'id',
        'serial_number',
        'lot_number',
        'part'
    ],
    title: 'PartInstancePublic',
    type: 'object'
} as const;

export const PartInstanceSummaryPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        lot_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    required: [
        'id',
        'serial_number',
        'lot_number'
    ],
    title: 'PartInstanceSummaryPublic',
    type: 'object'
} as const;

export const PartInstanceWorkHistoryEntryCreateSchema = {
    discriminator: {
        mapping: {
            work_package: '#/components/schemas/LinkWorkPackage',
            work_task: '#/components/schemas/LinkWorkTask'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/LinkWorkPackage'
        },
        {
            $ref: '#/components/schemas/LinkWorkTask'
        }
    ],
    title: 'PartInstanceWorkHistoryEntryCreate'
} as const;

export const PartInstanceWorkHistoryEntryDetailPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        part_instance_id: {
            format: 'uuid',
            title: 'Part Instance Id',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_package: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackagePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        },
        work_task: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkTaskPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        }
    },
    required: [
        'id',
        'tenant_id',
        'part_instance_id',
        'work_package_id',
        'work_task_id',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'work_package',
        'work_task'
    ],
    title: 'PartInstanceWorkHistoryEntryDetailPublic',
    type: 'object'
} as const;

export const PartInstanceWorkHistoryPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PartInstanceWorkHistoryEntryDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PartInstanceWorkHistoryPublic',
    type: 'object'
} as const;

export const PartManufacturersPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                type: 'string'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PartManufacturersPublic',
    type: 'object'
} as const;

export const PartOffSchema = {
    properties: {
        pn_off: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pn Off'
        },
        reason_for_removal: {
            $ref: '#/components/schemas/ReasonForRemoval'
        },
        sn_off: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sn Off'
        }
    },
    required: [
        'reason_for_removal'
    ],
    title: 'PartOff',
    type: 'object'
} as const;

export const PartOnSchema = {
    properties: {
        on_condition: {
            $ref: '#/components/schemas/OnCondition'
        },
        pn_on: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pn On'
        },
        sn_on: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sn On'
        },
        tsn: {
            $ref: '#/components/schemas/TimeGrouping'
        },
        tso: {
            $ref: '#/components/schemas/TimeGrouping'
        },
        tsr: {
            $ref: '#/components/schemas/TimeGrouping'
        }
    },
    required: [
        'on_condition',
        'tsn',
        'tso',
        'tsr'
    ],
    title: 'PartOn',
    type: 'object'
} as const;

export const PartPriceCreateSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Amount'
        },
        condition: {
            $ref: '#/components/schemas/PartCondition'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        kind: {
            $ref: '#/components/schemas/PartPriceKind'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        priced_at: {
            format: 'date',
            title: 'Priced At',
            type: 'string'
        }
    },
    required: [
        'part_id',
        'condition',
        'kind',
        'currency',
        'amount'
    ],
    title: 'PartPriceCreate',
    type: 'object'
} as const;

export const PartPriceDetailPublicSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        condition: {
            $ref: '#/components/schemas/PartCondition'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/PartPriceKind'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        part: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        priced_at: {
            format: 'date',
            title: 'Priced At',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'part_id',
        'condition',
        'kind',
        'currency',
        'amount',
        'priced_at',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at',
        'part'
    ],
    title: 'PartPriceDetailPublic',
    type: 'object'
} as const;

export const PartPriceKindSchema = {
    enum: [
        'listing',
        'reference',
        'sale',
        'purchase'
    ],
    title: 'PartPriceKind',
    type: 'string'
} as const;

export const PartPriceUpdateSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amount'
        },
        condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartPriceKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        priced_at: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Priced At'
        }
    },
    title: 'PartPriceUpdate',
    type: 'object'
} as const;

export const PartPriceUpsertSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Amount'
        },
        condition: {
            $ref: '#/components/schemas/PartCondition'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        kind: {
            $ref: '#/components/schemas/PartPriceKind'
        },
        priced_at: {
            format: 'date',
            title: 'Priced At',
            type: 'string'
        }
    },
    required: [
        'condition',
        'kind',
        'currency',
        'amount',
        'priced_at'
    ],
    title: 'PartPriceUpsert',
    type: 'object'
} as const;

export const PartPricesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PartPriceDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PartPricesPublic',
    type: 'object'
} as const;

export const PartPublicSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_consumable: {
            title: 'Is Consumable',
            type: 'boolean'
        },
        is_rotable: {
            title: 'Is Rotable',
            type: 'boolean'
        },
        is_serialised: {
            title: 'Is Serialised',
            type: 'boolean'
        },
        is_traceable: {
            title: 'Is Traceable',
            type: 'boolean'
        },
        manufacturer_cage: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Cage'
        },
        manufacturer_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Name'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        reorder_point: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reorder Point'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'manufacturer_name',
        'manufacturer_cage',
        'unit_of_measure',
        'reorder_point',
        'is_serialised',
        'is_rotable',
        'is_consumable',
        'is_traceable'
    ],
    title: 'PartPublic',
    type: 'object'
} as const;

export const PartReservationCreateSchema = {
    properties: {
        condition: {
            $ref: '#/components/schemas/PartCondition'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        quantity: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Quantity'
        },
        quote_task_id: {
            format: 'uuid',
            title: 'Quote Task Id',
            type: 'string'
        }
    },
    required: [
        'quote_task_id',
        'part_id',
        'condition',
        'quantity'
    ],
    title: 'PartReservationCreate',
    type: 'object'
} as const;

export const PartReservationDetailPublicSchema = {
    properties: {
        condition: {
            $ref: '#/components/schemas/PartCondition'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        lock: {
            $ref: '#/components/schemas/PartReservationLock'
        },
        part: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        quantity: {
            title: 'Quantity',
            type: 'string'
        },
        quote_task: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartReservationTaskPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        reserved_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        reserved_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reserved By Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_task: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartReservationWorkTaskPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_task_part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Part Id'
        }
    },
    required: [
        'id',
        'tenant_id',
        'quote_task_id',
        'work_task_part_id',
        'part_id',
        'condition',
        'quantity',
        'lock',
        'reserved_by_id',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at',
        'part',
        'quote_task',
        'work_task',
        'reserved_by'
    ],
    title: 'PartReservationDetailPublic',
    type: 'object'
} as const;

export const PartReservationLockSchema = {
    enum: [
        'soft',
        'hard'
    ],
    title: 'PartReservationLock',
    type: 'string'
} as const;

export const PartReservationPublicSchema = {
    properties: {
        condition: {
            $ref: '#/components/schemas/PartCondition'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        lock: {
            $ref: '#/components/schemas/PartReservationLock'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        quantity: {
            title: 'Quantity',
            type: 'string'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        reserved_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reserved By Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_task_part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Part Id'
        }
    },
    required: [
        'id',
        'tenant_id',
        'quote_task_id',
        'work_task_part_id',
        'part_id',
        'condition',
        'quantity',
        'lock',
        'reserved_by_id',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at'
    ],
    title: 'PartReservationPublic',
    type: 'object'
} as const;

export const PartReservationQuotePublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        }
    },
    required: [
        'id',
        'number'
    ],
    title: 'PartReservationQuotePublic',
    type: 'object'
} as const;

export const PartReservationTaskPublicSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        quote: {
            $ref: '#/components/schemas/PartReservationQuotePublic'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'quote_id',
        'number',
        'description',
        'quote'
    ],
    title: 'PartReservationTaskPublic',
    type: 'object'
} as const;

export const PartReservationUpdateSchema = {
    properties: {
        quantity: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        }
    },
    title: 'PartReservationUpdate',
    type: 'object'
} as const;

export const PartReservationWorkOrderPublicSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        }
    },
    required: [
        'id',
        'number',
        'description'
    ],
    title: 'PartReservationWorkOrderPublic',
    type: 'object'
} as const;

export const PartReservationWorkOrdersPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PartReservationWorkOrderPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PartReservationWorkOrdersPublic',
    type: 'object'
} as const;

export const PartReservationWorkTaskPublicSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        work_package: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartReservationWorkOrderPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'work_package_id',
        'number',
        'description',
        'work_package'
    ],
    title: 'PartReservationWorkTaskPublic',
    type: 'object'
} as const;

export const PartReservationsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PartReservationDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PartReservationsPublic',
    type: 'object'
} as const;

export const PartStockDetailPublicSchema = {
    properties: {
        archived: {
            title: 'Archived',
            type: 'boolean'
        },
        available: {
            title: 'Available',
            type: 'string'
        },
        conditions: {
            items: {
                $ref: '#/components/schemas/PartCondition'
            },
            title: 'Conditions',
            type: 'array'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        facilities: {
            items: {
                $ref: '#/components/schemas/FacilityPublic'
            },
            title: 'Facilities',
            type: 'array'
        },
        on_hand: {
            title: 'On Hand',
            type: 'string'
        },
        part: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        reserved: {
            title: 'Reserved',
            type: 'string'
        },
        reserved_hard: {
            title: 'Reserved Hard',
            type: 'string'
        },
        reserved_soft: {
            title: 'Reserved Soft',
            type: 'string'
        },
        short: {
            title: 'Short',
            type: 'string'
        },
        status: {
            $ref: '#/components/schemas/PartStockStatus'
        },
        unit_cost: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Cost'
        },
        unusable: {
            title: 'Unusable',
            type: 'string'
        },
        usable: {
            title: 'Usable',
            type: 'string'
        },
        work_order_numbers: {
            items: {
                type: 'string'
            },
            title: 'Work Order Numbers',
            type: 'array'
        }
    },
    required: [
        'part_id',
        'on_hand',
        'usable',
        'unusable',
        'reserved',
        'reserved_hard',
        'reserved_soft',
        'available',
        'short',
        'status',
        'archived',
        'conditions',
        'unit_cost',
        'currency',
        'work_order_numbers',
        'part',
        'facilities'
    ],
    title: 'PartStockDetailPublic',
    type: 'object'
} as const;

export const PartStockGroupingSchema = {
    enum: [
        'availability',
        'manufacturer'
    ],
    title: 'PartStockGrouping',
    type: 'string'
} as const;

export const PartStockSortSchema = {
    enum: [
        'number',
        'description',
        'manufacturer',
        'on_hand',
        'usable',
        'reserved',
        'available',
        'unit_of_measure',
        'unit_cost'
    ],
    title: 'PartStockSort',
    type: 'string'
} as const;

export const PartStockStatusSchema = {
    enum: [
        'available',
        'low',
        'fully_reserved',
        'out_of_stock'
    ],
    title: 'PartStockStatus',
    type: 'string'
} as const;

export const PartStockViewSchema = {
    enum: [
        'in_stock',
        'needs_attention',
        'reserved',
        'rotable',
        'consumable'
    ],
    title: 'PartStockView',
    type: 'string'
} as const;

export const PartStocksPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PartStockDetailPublic'
            },
            title: 'Data',
            type: 'array'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/GroupCountPublic'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'data',
        'count',
        'groups'
    ],
    title: 'PartStocksPublic',
    type: 'object'
} as const;

export const PartSuggestionPublicSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        }
    },
    required: [
        'part_number',
        'description'
    ],
    title: 'PartSuggestionPublic',
    type: 'object'
} as const;

export const PartUpdateSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        is_consumable: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Consumable'
        },
        is_rotable: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Rotable'
        },
        is_serialised: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Serialised'
        },
        is_traceable: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Traceable'
        },
        manufacturer_cage: {
            anyOf: [
                {
                    maxLength: 50,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Cage'
        },
        manufacturer_name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Name'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        reorder_point: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reorder Point'
        },
        unit_of_measure: {
            anyOf: [
                {
                    maxLength: 100,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    title: 'PartUpdate',
    type: 'object'
} as const;

export const PartUpsertSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        is_consumable: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Consumable'
        },
        is_rotable: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Rotable'
        },
        is_serialised: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Serialised'
        },
        is_traceable: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Traceable'
        },
        manufacturer_cage: {
            anyOf: [
                {
                    maxLength: 50,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Cage'
        },
        manufacturer_name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer Name'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        prices: {
            items: {
                $ref: '#/components/schemas/PartPriceUpsert'
            },
            title: 'Prices',
            type: 'array'
        },
        reorder_point: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reorder Point'
        },
        unit_of_measure: {
            anyOf: [
                {
                    maxLength: 100,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'number'
    ],
    title: 'PartUpsert',
    type: 'object'
} as const;

export const PartUpsertErrorSchema = {
    properties: {
        index: {
            title: 'Index',
            type: 'integer'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        reason: {
            $ref: '#/components/schemas/PartUpsertErrorReason'
        }
    },
    required: [
        'index',
        'number',
        'reason'
    ],
    title: 'PartUpsertError',
    type: 'object'
} as const;

export const PartUpsertErrorReasonSchema = {
    enum: [
        'duplicate_number',
        'duplicate_price',
        'unit_change_blocked',
        'serialisation_blocked'
    ],
    title: 'PartUpsertErrorReason',
    type: 'string'
} as const;

export const PartsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PartPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PartsPublic',
    type: 'object'
} as const;

export const PartsRfpExtractionCreateSchema = {
    properties: {
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        },
        sheets: {
            items: {
                type: 'string'
            },
            title: 'Sheets',
            type: 'array'
        }
    },
    required: [
        'document_id'
    ],
    title: 'PartsRfpExtractionCreate',
    type: 'object'
} as const;

export const PartsUpsertSchema = {
    properties: {
        parts: {
            items: {
                $ref: '#/components/schemas/PartUpsert'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Parts',
            type: 'array'
        },
        tenant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Id'
        }
    },
    required: [
        'parts'
    ],
    title: 'PartsUpsert',
    type: 'object'
} as const;

export const PartsUpsertPublicSchema = {
    properties: {
        errors: {
            items: {
                $ref: '#/components/schemas/PartUpsertError'
            },
            title: 'Errors',
            type: 'array'
        },
        parts: {
            $ref: '#/components/schemas/UpsertCounts'
        },
        prices: {
            $ref: '#/components/schemas/UpsertCounts'
        }
    },
    required: [
        'parts',
        'prices',
        'errors'
    ],
    title: 'PartsUpsertPublic',
    type: 'object'
} as const;

export const PasswordPolicyPublicSchema = {
    properties: {
        max_length: {
            title: 'Max Length',
            type: 'integer'
        },
        min_character_classes: {
            title: 'Min Character Classes',
            type: 'integer'
        },
        min_length: {
            title: 'Min Length',
            type: 'integer'
        }
    },
    required: [
        'min_length',
        'max_length',
        'min_character_classes'
    ],
    title: 'PasswordPolicyPublic',
    type: 'object'
} as const;

export const PastPartPublicSchema = {
    properties: {
        condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        currency: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        last_purchase_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Purchase Price'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        },
        uses: {
            items: {
                $ref: '#/components/schemas/PastPartUsePublic'
            },
            title: 'Uses',
            type: 'array'
        },
        work_tasks: {
            title: 'Work Tasks',
            type: 'integer'
        }
    },
    required: [
        'part_number',
        'description',
        'unit_of_measure',
        'work_tasks',
        'quantity',
        'last_purchase_price',
        'currency',
        'condition',
        'uses'
    ],
    title: 'PastPartPublic',
    type: 'object'
} as const;

export const PastPartUsePublicSchema = {
    properties: {
        completed_at: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Completed At'
        },
        condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        currency: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        purchase_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Price'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        work_order: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Order'
        }
    },
    required: [
        'id',
        'work_order',
        'completed_at',
        'quantity',
        'condition',
        'purchase_price',
        'currency'
    ],
    title: 'PastPartUsePublic',
    type: 'object'
} as const;

export const PastPartsPublicSchema = {
    properties: {
        parts: {
            items: {
                $ref: '#/components/schemas/PastPartPublic'
            },
            title: 'Parts',
            type: 'array'
        },
        work_tasks: {
            title: 'Work Tasks',
            type: 'integer'
        }
    },
    required: [
        'work_tasks',
        'parts'
    ],
    title: 'PastPartsPublic',
    type: 'object'
} as const;

export const PermissionAudienceSchema = {
    additionalProperties: false,
    properties: {
        kind: {
            const: 'permission',
            title: 'Kind',
            type: 'string'
        },
        permission: {
            title: 'Permission',
            type: 'string'
        }
    },
    required: [
        'kind',
        'permission'
    ],
    title: 'PermissionAudience',
    type: 'object'
} as const;

export const PersonAudienceSchema = {
    additionalProperties: false,
    properties: {
        kind: {
            const: 'person',
            title: 'Kind',
            type: 'string'
        },
        user_id: {
            format: 'uuid',
            title: 'User Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'user_id'
    ],
    title: 'PersonAudience',
    type: 'object'
} as const;

export const PositionAudienceSchema = {
    additionalProperties: false,
    properties: {
        kind: {
            const: 'position',
            title: 'Kind',
            type: 'string'
        },
        position_id: {
            format: 'uuid',
            title: 'Position Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'position_id'
    ],
    title: 'PositionAudience',
    type: 'object'
} as const;

export const PositionCreateSchema = {
    properties: {
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        team_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Team Id'
        },
        user_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'User Ids',
            type: 'array'
        }
    },
    required: [
        'name'
    ],
    title: 'PositionCreate',
    type: 'object'
} as const;

export const PositionDetailPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        holders: {
            items: {
                $ref: '#/components/schemas/UserBasicInfo'
            },
            title: 'Holders',
            type: 'array'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        team_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Team Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'name',
        'team_id',
        'department_id',
        'facility_id',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at',
        'holders'
    ],
    title: 'PositionDetailPublic',
    type: 'object'
} as const;

export const PositionReferenceSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        owner: {
            title: 'Owner',
            type: 'string'
        },
        scopes: {
            items: {
                $ref: '#/components/schemas/AudienceScope'
            },
            title: 'Scopes',
            type: 'array'
        }
    },
    required: [
        'id',
        'name',
        'owner',
        'scopes'
    ],
    title: 'PositionReference',
    type: 'object'
} as const;

export const PositionUpdateSchema = {
    properties: {
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        user_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Ids'
        }
    },
    title: 'PositionUpdate',
    type: 'object'
} as const;

export const PositionsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PositionDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PositionsPublic',
    type: 'object'
} as const;

export const PreviewRecordSchema = {
    discriminator: {
        mapping: {
            due_list: '#/components/schemas/DueListPreviewRecord',
            quote: '#/components/schemas/QuotePreviewRecord',
            sample: '#/components/schemas/SamplePreviewRecord',
            squawk_card: '#/components/schemas/SquawkCardPreviewRecord',
            squawk_list: '#/components/schemas/SquawkListPreviewRecord',
            task_card: '#/components/schemas/TaskCardPreviewRecord',
            work_order: '#/components/schemas/WorkOrderPreviewRecord'
        },
        propertyName: 'source'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/SamplePreviewRecord'
        },
        {
            $ref: '#/components/schemas/QuotePreviewRecord'
        },
        {
            $ref: '#/components/schemas/WorkOrderPreviewRecord'
        },
        {
            $ref: '#/components/schemas/TaskCardPreviewRecord'
        },
        {
            $ref: '#/components/schemas/DueListPreviewRecord'
        },
        {
            $ref: '#/components/schemas/SquawkCardPreviewRecord'
        },
        {
            $ref: '#/components/schemas/SquawkListPreviewRecord'
        }
    ]
} as const;

export const PrintDueListSchema = {
    properties: {
        basis: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ForecastBasis'
                },
                {
                    type: 'null'
                }
            ]
        },
        items: {
            items: {
                $ref: '#/components/schemas/DueListItem'
            },
            minItems: 1,
            title: 'Items',
            type: 'array'
        }
    },
    required: [
        'basis',
        'items'
    ],
    title: 'PrintDueList',
    type: 'object'
} as const;

export const PrintSquawkCardsSchema = {
    properties: {
        squawk_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 100,
            minItems: 1,
            title: 'Squawk Ids',
            type: 'array'
        }
    },
    required: [
        'squawk_ids'
    ],
    title: 'PrintSquawkCards',
    type: 'object'
} as const;

export const PrintSquawkListSchema = {
    properties: {
        squawk_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    maxItems: 1000,
                    minItems: 1,
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Squawk Ids'
        },
        statuses: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FilterableSquawkStatus'
                    },
                    minItems: 1,
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Statuses'
        },
        work_package_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    minItems: 1,
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Ids'
        }
    },
    title: 'PrintSquawkList',
    type: 'object'
} as const;

export const PrintTaskCardsSchema = {
    properties: {
        task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 100,
            minItems: 1,
            title: 'Task Ids',
            type: 'array'
        }
    },
    required: [
        'task_ids'
    ],
    title: 'PrintTaskCards',
    type: 'object'
} as const;

export const ProgrammeAccomplishmentCreateSchema = {
    properties: {
        cycles: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Airframe cycles when the work was done',
            title: 'Cycles'
        },
        hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Airframe flight hours when the work was done',
            title: 'Hours'
        },
        item: {
            $ref: '#/components/schemas/AccomplishedItem'
        },
        landings: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Airframe landings when the work was done',
            title: 'Landings'
        },
        note: {
            anyOf: [
                {
                    maxLength: 2000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        performed_on: {
            format: 'date',
            title: 'Performed On',
            type: 'string'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'item',
        'performed_on'
    ],
    title: 'ProgrammeAccomplishmentCreate',
    type: 'object'
} as const;

export const ProgrammeAccomplishmentPublicSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        check_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Check Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        cycles: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cycles'
        },
        hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        landings: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landings'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        performed_on: {
            format: 'date',
            title: 'Performed On',
            type: 'string'
        },
        task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Id'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'id',
        'aircraft_id',
        'task_id',
        'check_id',
        'performed_on',
        'hours',
        'cycles',
        'landings',
        'work_package_id',
        'note',
        'created_at',
        'last_modified_by_id'
    ],
    title: 'ProgrammeAccomplishmentPublic',
    type: 'object'
} as const;

export const ProgrammeAccomplishmentsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ProgrammeAccomplishmentPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ProgrammeAccomplishmentsPublic',
    type: 'object'
} as const;

export const ProgrammeAircraftDetailPublicSchema = {
    properties: {
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        effective_from: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Effective From'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'effective_from',
        'aircraft'
    ],
    title: 'ProgrammeAircraftDetailPublic',
    type: 'object'
} as const;

export const ProgrammeAircraftEnrolledEventSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        effective_from: {
            format: 'date',
            title: 'Effective From',
            type: 'string'
        },
        registration: {
            title: 'Registration',
            type: 'string'
        },
        type: {
            const: 'aircraft_enrolled',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'aircraft_id',
        'registration',
        'effective_from'
    ],
    title: 'ProgrammeAircraftEnrolledEvent',
    type: 'object'
} as const;

export const ProgrammeAircraftListPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ProgrammeAircraftDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ProgrammeAircraftListPublic',
    type: 'object'
} as const;

export const ProgrammeAircraftPublicSchema = {
    properties: {
        effective_from: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Effective From'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'effective_from'
    ],
    title: 'ProgrammeAircraftPublic',
    type: 'object'
} as const;

export const ProgrammeAircraftRemovedEventSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        registration: {
            title: 'Registration',
            type: 'string'
        },
        type: {
            const: 'aircraft_removed',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'aircraft_id',
        'registration'
    ],
    title: 'ProgrammeAircraftRemovedEvent',
    type: 'object'
} as const;

export const ProgrammeArchivedEventSchema = {
    properties: {
        type: {
            const: 'programme_archived',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type'
    ],
    title: 'ProgrammeArchivedEvent',
    type: 'object'
} as const;

export const ProgrammeChangesPublicSchema = {
    properties: {
        released: {
            title: 'Released',
            type: 'integer'
        },
        tasks_added: {
            title: 'Tasks Added',
            type: 'integer'
        },
        tasks_removed: {
            title: 'Tasks Removed',
            type: 'integer'
        }
    },
    required: [
        'released',
        'tasks_added',
        'tasks_removed'
    ],
    title: 'ProgrammeChangesPublic',
    type: 'object'
} as const;

export const ProgrammeCheckBaseSchema = {
    properties: {
        code: {
            minLength: 1,
            title: 'Code',
            type: 'string'
        },
        included_check_ids: {
            default: [],
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            title: 'Included Check Ids',
            type: 'array'
        },
        schedule: {
            $ref: '#/components/schemas/Schedule-Input'
        },
        title: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        }
    },
    required: [
        'code',
        'schedule'
    ],
    title: 'ProgrammeCheckBase',
    type: 'object'
} as const;

export const ProgrammeCheckDetailPublicSchema = {
    properties: {
        code: {
            title: 'Code',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        included_check_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Included Check Ids',
            type: 'array'
        },
        schedule: {
            $ref: '#/components/schemas/Schedule-Output'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        version_id: {
            format: 'uuid',
            title: 'Version Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'version_id',
        'code',
        'title',
        'schedule',
        'included_check_ids'
    ],
    title: 'ProgrammeCheckDetailPublic',
    type: 'object'
} as const;

export const ProgrammeCheckOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateProgrammeCheck',
            remove: '#/components/schemas/RemoveProgrammeCheck',
            update: '#/components/schemas/UpdateProgrammeCheck'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateProgrammeCheck'
        },
        {
            $ref: '#/components/schemas/UpdateProgrammeCheck'
        },
        {
            $ref: '#/components/schemas/RemoveProgrammeCheck'
        }
    ]
} as const;

export const ProgrammeChecksPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ProgrammeCheckDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ProgrammeChecksPublic',
    type: 'object'
} as const;

export const ProgrammeCreateSchema = {
    properties: {
        model_variant_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            minItems: 1,
            title: 'Model Variant Ids',
            type: 'array'
        },
        revision: {
            $ref: '#/components/schemas/ProgrammeRevisionCreate'
        },
        status: {
            $ref: '#/components/schemas/ProgrammeStatus'
        },
        title: {
            minLength: 1,
            title: 'Title',
            type: 'string'
        }
    },
    required: [
        'title',
        'status',
        'model_variant_ids',
        'revision'
    ],
    title: 'ProgrammeCreate',
    type: 'object'
} as const;

export const ProgrammeCreatedEventSchema = {
    properties: {
        type: {
            const: 'programme_created',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type'
    ],
    title: 'ProgrammeCreatedEvent',
    type: 'object'
} as const;

export const ProgrammeDetailPublicSchema = {
    properties: {
        aircraft_count: {
            title: 'Aircraft Count',
            type: 'integer'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        current_revision: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ProgrammeRevisionDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        manufacturer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model_variants: {
            items: {
                $ref: '#/components/schemas/TypeCertificateModelVariantPublic'
            },
            title: 'Model Variants',
            type: 'array'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        salesforce_opportunity_id: {
            anyOf: [
                {
                    pattern: '^[a-zA-Z0-9]{15,18}$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Id'
        },
        salesforce_opportunity_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Url'
        },
        status: {
            $ref: '#/components/schemas/ProgrammeStatus'
        },
        title: {
            title: 'Title',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'number',
        'title',
        'status',
        'salesforce_opportunity_id',
        'salesforce_opportunity_url',
        'created_at',
        'updated_at',
        'deleted_at',
        'archived_at',
        'manufacturer',
        'model_variants',
        'aircraft_count',
        'current_revision',
        'last_modified_by'
    ],
    title: 'ProgrammeDetailPublic',
    type: 'object'
} as const;

export const ProgrammeDraftRevisionCreateSchema = {
    properties: {
        based_on_revision_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Based On Revision Id'
        },
        change_summary: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Change Summary'
        },
        document_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Number'
        },
        issue: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue'
        },
        issue_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue Date'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        }
    },
    required: [
        'number'
    ],
    title: 'ProgrammeDraftRevisionCreate',
    type: 'object'
} as const;

export const ProgrammeEnrolmentCreateSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        effective_from: {
            format: 'date',
            title: 'Effective From',
            type: 'string'
        }
    },
    required: [
        'aircraft_id',
        'effective_from'
    ],
    title: 'ProgrammeEnrolmentCreate',
    type: 'object'
} as const;

export const ProgrammeEventPublicSchema = {
    properties: {
        actor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        event: {
            $ref: '#/components/schemas/ProgrammeEventValue'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        occurred_at: {
            format: 'date-time',
            title: 'Occurred At',
            type: 'string'
        },
        revision_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision Number'
        },
        source: {
            $ref: '#/components/schemas/ChangedBy'
        }
    },
    required: [
        'id',
        'occurred_at',
        'source',
        'actor',
        'revision_number',
        'event'
    ],
    title: 'ProgrammeEventPublic',
    type: 'object'
} as const;

export const ProgrammeEventValueSchema = {
    discriminator: {
        mapping: {
            aircraft_enrolled: '#/components/schemas/ProgrammeAircraftEnrolledEvent',
            aircraft_removed: '#/components/schemas/ProgrammeAircraftRemovedEvent',
            phase_added: '#/components/schemas/ProgrammePhaseChangedEvent',
            phase_removed: '#/components/schemas/ProgrammePhaseChangedEvent',
            phase_updated: '#/components/schemas/ProgrammePhaseChangedEvent',
            programme_archived: '#/components/schemas/ProgrammeArchivedEvent',
            programme_created: '#/components/schemas/ProgrammeCreatedEvent',
            programme_restored: '#/components/schemas/ProgrammeRestoredEvent',
            programme_updated: '#/components/schemas/ProgrammeUpdatedEvent',
            revision_created: '#/components/schemas/ProgrammeRevisionCreatedEvent',
            revision_released: '#/components/schemas/ProgrammeRevisionReleasedEvent',
            revision_updated: '#/components/schemas/ProgrammeRevisionUpdatedEvent',
            task_added: '#/components/schemas/ProgrammeTaskChangedEvent',
            task_removed: '#/components/schemas/ProgrammeTaskChangedEvent',
            task_updated: '#/components/schemas/ProgrammeTaskChangedEvent'
        },
        propertyName: 'type'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/ProgrammeCreatedEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammeArchivedEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammeRestoredEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammeUpdatedEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammeRevisionCreatedEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammeRevisionReleasedEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammeRevisionUpdatedEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammeTaskChangedEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammePhaseChangedEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammeAircraftEnrolledEvent'
        },
        {
            $ref: '#/components/schemas/ProgrammeAircraftRemovedEvent'
        }
    ]
} as const;

export const ProgrammeEventsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ProgrammeEventPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ProgrammeEventsPublic',
    type: 'object'
} as const;

export const ProgrammeExtractionAcceptedSchema = {
    properties: {
        status: {
            const: 'scheduled',
            default: 'scheduled',
            title: 'Status',
            type: 'string'
        }
    },
    title: 'ProgrammeExtractionAccepted',
    type: 'object'
} as const;

export const ProgrammeFieldSchema = {
    enum: [
        'title',
        'status',
        'models'
    ],
    title: 'ProgrammeField',
    type: 'string'
} as const;

export const ProgrammeManufacturerPublicSchema = {
    properties: {
        aircraft: {
            title: 'Aircraft',
            type: 'integer'
        },
        manufacturer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        programmes: {
            title: 'Programmes',
            type: 'integer'
        }
    },
    required: [
        'manufacturer',
        'programmes',
        'aircraft'
    ],
    title: 'ProgrammeManufacturerPublic',
    type: 'object'
} as const;

export const ProgrammeMonthPublicSchema = {
    properties: {
        changes: {
            $ref: '#/components/schemas/ProgrammeChangesPublic'
        },
        month: {
            format: 'date',
            title: 'Month',
            type: 'string'
        }
    },
    required: [
        'month',
        'changes'
    ],
    title: 'ProgrammeMonthPublic',
    type: 'object'
} as const;

export const ProgrammeNumberPublicSchema = {
    properties: {
        number: {
            title: 'Number',
            type: 'string'
        }
    },
    required: [
        'number'
    ],
    title: 'ProgrammeNumberPublic',
    type: 'object'
} as const;

export const ProgrammeOverviewPublicSchema = {
    properties: {
        active: {
            title: 'Active',
            type: 'integer'
        },
        aircraft: {
            title: 'Aircraft',
            type: 'integer'
        },
        manufacturers: {
            items: {
                $ref: '#/components/schemas/ProgrammeManufacturerPublic'
            },
            title: 'Manufacturers',
            type: 'array'
        },
        months: {
            items: {
                $ref: '#/components/schemas/ProgrammeMonthPublic'
            },
            title: 'Months',
            type: 'array'
        },
        programmes: {
            title: 'Programmes',
            type: 'integer'
        },
        quarter: {
            $ref: '#/components/schemas/ProgrammeChangesPublic'
        },
        stages: {
            items: {
                $ref: '#/components/schemas/ProgrammeStagePublic'
            },
            title: 'Stages',
            type: 'array'
        },
        taking_effect: {
            title: 'Taking Effect',
            type: 'integer'
        },
        without_aircraft: {
            title: 'Without Aircraft',
            type: 'integer'
        },
        without_revision: {
            title: 'Without Revision',
            type: 'integer'
        }
    },
    required: [
        'programmes',
        'active',
        'aircraft',
        'stages',
        'taking_effect',
        'without_revision',
        'without_aircraft',
        'quarter',
        'months',
        'manufacturers'
    ],
    title: 'ProgrammeOverviewPublic',
    type: 'object'
} as const;

export const ProgrammePhaseChangedEventSchema = {
    properties: {
        check_id: {
            format: 'uuid',
            title: 'Check Id',
            type: 'string'
        },
        code: {
            title: 'Code',
            type: 'string'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        type: {
            enum: [
                'phase_added',
                'phase_updated',
                'phase_removed'
            ],
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'check_id',
        'code'
    ],
    title: 'ProgrammePhaseChangedEvent',
    type: 'object'
} as const;

export const ProgrammePublicSchema = {
    properties: {
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        salesforce_opportunity_id: {
            anyOf: [
                {
                    pattern: '^[a-zA-Z0-9]{15,18}$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Id'
        },
        salesforce_opportunity_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Url'
        },
        status: {
            $ref: '#/components/schemas/ProgrammeStatus'
        },
        title: {
            title: 'Title',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'number',
        'title',
        'status',
        'salesforce_opportunity_id',
        'salesforce_opportunity_url',
        'created_at',
        'updated_at',
        'deleted_at',
        'archived_at'
    ],
    title: 'ProgrammePublic',
    type: 'object'
} as const;

export const ProgrammeRestoredEventSchema = {
    properties: {
        type: {
            const: 'programme_restored',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type'
    ],
    title: 'ProgrammeRestoredEvent',
    type: 'object'
} as const;

export const ProgrammeRevisionCreateSchema = {
    properties: {
        change_summary: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Change Summary'
        },
        document_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Number'
        },
        effective_from: {
            format: 'date',
            title: 'Effective From',
            type: 'string'
        },
        issue: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue'
        },
        issue_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue Date'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        status: {
            enum: [
                'draft',
                'submitted',
                'released'
            ],
            title: 'Status',
            type: 'string'
        }
    },
    required: [
        'number',
        'status',
        'effective_from'
    ],
    title: 'ProgrammeRevisionCreate',
    type: 'object'
} as const;

export const ProgrammeRevisionCreatedEventSchema = {
    properties: {
        based_on: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Based On'
        },
        type: {
            const: 'revision_created',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'based_on'
    ],
    title: 'ProgrammeRevisionCreatedEvent',
    type: 'object'
} as const;

export const ProgrammeRevisionDetailPublicSchema = {
    properties: {
        added_count: {
            title: 'Added Count',
            type: 'integer'
        },
        document_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Number'
        },
        effective_from: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Effective From'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        in_effect: {
            title: 'In Effect',
            type: 'boolean'
        },
        issue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue'
        },
        issue_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue Date'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        removed_count: {
            title: 'Removed Count',
            type: 'integer'
        },
        source_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Source Document Id'
        },
        status: {
            $ref: '#/components/schemas/ProgrammeRevisionStatus'
        },
        summary: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Summary'
        },
        task_count: {
            title: 'Task Count',
            type: 'integer'
        }
    },
    required: [
        'id',
        'number',
        'status',
        'document_number',
        'issue',
        'issue_date',
        'effective_from',
        'source_document_id',
        'in_effect',
        'task_count',
        'added_count',
        'removed_count',
        'summary'
    ],
    title: 'ProgrammeRevisionDetailPublic',
    type: 'object'
} as const;

export const ProgrammeRevisionPatchResultSchema = {
    properties: {
        created_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Created Ids',
            type: 'array'
        }
    },
    required: [
        'created_ids'
    ],
    title: 'ProgrammeRevisionPatchResult',
    type: 'object'
} as const;

export const ProgrammeRevisionPublicSchema = {
    properties: {
        document_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Number'
        },
        effective_from: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Effective From'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        issue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue'
        },
        issue_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue Date'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        source_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Source Document Id'
        },
        status: {
            $ref: '#/components/schemas/ProgrammeRevisionStatus'
        }
    },
    required: [
        'id',
        'number',
        'status',
        'document_number',
        'issue',
        'issue_date',
        'effective_from',
        'source_document_id'
    ],
    title: 'ProgrammeRevisionPublic',
    type: 'object'
} as const;

export const ProgrammeRevisionReleaseSchema = {
    properties: {
        effective_from: {
            format: 'date',
            title: 'Effective From',
            type: 'string'
        }
    },
    required: [
        'effective_from'
    ],
    title: 'ProgrammeRevisionRelease',
    type: 'object'
} as const;

export const ProgrammeRevisionReleasedEventSchema = {
    properties: {
        effective_from: {
            format: 'date',
            title: 'Effective From',
            type: 'string'
        },
        type: {
            const: 'revision_released',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'effective_from'
    ],
    title: 'ProgrammeRevisionReleasedEvent',
    type: 'object'
} as const;

export const ProgrammeRevisionStatusSchema = {
    enum: [
        'draft',
        'submitted',
        'released',
        'superseded'
    ],
    title: 'ProgrammeRevisionStatus',
    type: 'string'
} as const;

export const ProgrammeRevisionUpdatedEventSchema = {
    properties: {
        fields: {
            items: {
                $ref: '#/components/schemas/RevisionField'
            },
            title: 'Fields',
            type: 'array'
        },
        type: {
            const: 'revision_updated',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'fields'
    ],
    title: 'ProgrammeRevisionUpdatedEvent',
    type: 'object'
} as const;

export const ProgrammeRevisionsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ProgrammeRevisionDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ProgrammeRevisionsPublic',
    type: 'object'
} as const;

export const ProgrammeStagePublicSchema = {
    properties: {
        revisions: {
            title: 'Revisions',
            type: 'integer'
        },
        stage: {
            $ref: '#/components/schemas/RevisionStage'
        },
        tasks: {
            title: 'Tasks',
            type: 'integer'
        }
    },
    required: [
        'stage',
        'revisions',
        'tasks'
    ],
    title: 'ProgrammeStagePublic',
    type: 'object'
} as const;

export const ProgrammeStatusSchema = {
    enum: [
        'draft',
        'active'
    ],
    title: 'ProgrammeStatus',
    type: 'string'
} as const;

export const ProgrammeTaskBaseSchema = {
    properties: {
        access: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Access'
        },
        access_man_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Access Man Hours'
        },
        applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Condition-Input'
                },
                {
                    type: 'null'
                }
            ]
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        check_ids: {
            default: [],
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            title: 'Check Ids',
            type: 'array'
        },
        cmr_escalation_allowed: {
            default: false,
            title: 'Cmr Escalation Allowed',
            type: 'boolean'
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        man_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Man Hours'
        },
        men: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Men'
        },
        on_condition: {
            default: false,
            title: 'On Condition',
            type: 'boolean'
        },
        preparation: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Preparation'
        },
        preparation_man_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Preparation Man Hours'
        },
        references: {
            default: [],
            items: {
                $ref: '#/components/schemas/ProgrammeTaskReferenceBase'
            },
            maxItems: 50,
            title: 'References',
            type: 'array'
        },
        schedule: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Schedule-Input'
                },
                {
                    type: 'null'
                }
            ]
        },
        section: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Section'
        },
        skill_codes: {
            default: [],
            items: {
                $ref: '#/components/schemas/SkillCode'
            },
            title: 'Skill Codes',
            type: 'array'
        },
        sources: {
            default: [],
            items: {
                $ref: '#/components/schemas/ProgrammeTaskSource'
            },
            title: 'Sources',
            type: 'array'
        },
        task_code: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskCode'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_number: {
            minLength: 1,
            title: 'Task Number',
            type: 'string'
        },
        time_controlled_item: {
            default: false,
            title: 'Time Controlled Item',
            type: 'boolean'
        },
        title: {
            minLength: 1,
            title: 'Title',
            type: 'string'
        },
        zones: {
            default: [],
            items: {
                minLength: 1,
                type: 'string'
            },
            title: 'Zones',
            type: 'array'
        }
    },
    required: [
        'task_number',
        'title'
    ],
    title: 'ProgrammeTaskBase',
    type: 'object'
} as const;

export const ProgrammeTaskChangedEventSchema = {
    properties: {
        task_id: {
            format: 'uuid',
            title: 'Task Id',
            type: 'string'
        },
        task_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Number'
        },
        title: {
            title: 'Title',
            type: 'string'
        },
        type: {
            enum: [
                'task_added',
                'task_updated',
                'task_removed'
            ],
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'task_id',
        'task_number',
        'title'
    ],
    title: 'ProgrammeTaskChangedEvent',
    type: 'object'
} as const;

export const ProgrammeTaskDetailPublicSchema = {
    properties: {
        access: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Access'
        },
        access_man_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Access Man Hours'
        },
        applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Condition-Output'
                },
                {
                    type: 'null'
                }
            ]
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        check_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Check Ids',
            type: 'array'
        },
        cmr_escalation_allowed: {
            title: 'Cmr Escalation Allowed',
            type: 'boolean'
        },
        created_in_revision_id: {
            format: 'uuid',
            title: 'Created In Revision Id',
            type: 'string'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        man_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Man Hours'
        },
        men: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Men'
        },
        on_condition: {
            title: 'On Condition',
            type: 'boolean'
        },
        preparation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Preparation'
        },
        preparation_man_hours: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Preparation Man Hours'
        },
        references: {
            items: {
                $ref: '#/components/schemas/ProgrammeTaskReferencePublic'
            },
            title: 'References',
            type: 'array'
        },
        schedule: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Schedule-Output'
                },
                {
                    type: 'null'
                }
            ]
        },
        section: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Section'
        },
        skill_codes: {
            items: {
                $ref: '#/components/schemas/SkillCode'
            },
            title: 'Skill Codes',
            type: 'array'
        },
        sources: {
            items: {
                $ref: '#/components/schemas/ProgrammeTaskSource'
            },
            title: 'Sources',
            type: 'array'
        },
        task_code: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskCode'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Number'
        },
        time_controlled_item: {
            title: 'Time Controlled Item',
            type: 'boolean'
        },
        title: {
            title: 'Title',
            type: 'string'
        },
        version_id: {
            format: 'uuid',
            title: 'Version Id',
            type: 'string'
        },
        zones: {
            items: {
                type: 'string'
            },
            title: 'Zones',
            type: 'array'
        }
    },
    required: [
        'id',
        'version_id',
        'created_in_revision_id',
        'task_number',
        'title',
        'section',
        'description',
        'ata_chapter',
        'sources',
        'cmr_escalation_allowed',
        'zones',
        'skill_codes',
        'task_code',
        'preparation',
        'access',
        'men',
        'man_hours',
        'access_man_hours',
        'preparation_man_hours',
        'time_controlled_item',
        'on_condition',
        'applicability',
        'schedule',
        'references',
        'check_ids'
    ],
    title: 'ProgrammeTaskDetailPublic',
    type: 'object'
} as const;

export const ProgrammeTaskOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateProgrammeTask',
            remove: '#/components/schemas/RemoveProgrammeTask',
            update: '#/components/schemas/UpdateProgrammeTask'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateProgrammeTask'
        },
        {
            $ref: '#/components/schemas/UpdateProgrammeTask'
        },
        {
            $ref: '#/components/schemas/RemoveProgrammeTask'
        }
    ]
} as const;

export const ProgrammeTaskReferenceBaseSchema = {
    properties: {
        kind: {
            $ref: '#/components/schemas/ReferenceKind'
        },
        value: {
            minLength: 1,
            title: 'Value',
            type: 'string'
        }
    },
    required: [
        'kind',
        'value'
    ],
    title: 'ProgrammeTaskReferenceBase',
    type: 'object'
} as const;

export const ProgrammeTaskReferencePublicSchema = {
    properties: {
        kind: {
            $ref: '#/components/schemas/ReferenceKind'
        },
        value: {
            title: 'Value',
            type: 'string'
        }
    },
    required: [
        'kind',
        'value'
    ],
    title: 'ProgrammeTaskReferencePublic',
    type: 'object'
} as const;

export const ProgrammeTaskSourceSchema = {
    enum: [
        'ad',
        'cn',
        'ali',
        'asm',
        'isb',
        'sil',
        'aot',
        'mrb',
        'cmp',
        'cmr',
        'cpcp',
        'fal',
        'lur',
        'ezap',
        'wfd',
        'fmp',
        'semr',
        'vsb',
        'l_hirf',
        'other'
    ],
    title: 'ProgrammeTaskSource',
    type: 'string'
} as const;

export const ProgrammeTasksPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ProgrammeTaskDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ProgrammeTasksPublic',
    type: 'object'
} as const;

export const ProgrammeUpdatedEventSchema = {
    properties: {
        fields: {
            items: {
                $ref: '#/components/schemas/ProgrammeField'
            },
            title: 'Fields',
            type: 'array'
        },
        type: {
            const: 'programme_updated',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'fields'
    ],
    title: 'ProgrammeUpdatedEvent',
    type: 'object'
} as const;

export const ProgrammesBulkChangeSchema = {
    properties: {
        programme_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Programme Ids',
            type: 'array'
        }
    },
    required: [
        'programme_ids'
    ],
    title: 'ProgrammesBulkChange',
    type: 'object'
} as const;

export const ProgrammesBulkChangeResultSchema = {
    properties: {
        changed: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Changed',
            type: 'array'
        },
        missing: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Missing',
            type: 'array'
        }
    },
    required: [
        'changed',
        'missing'
    ],
    title: 'ProgrammesBulkChangeResult',
    type: 'object'
} as const;

export const ProgrammesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ProgrammeDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ProgrammesPublic',
    type: 'object'
} as const;

export const PropertyMappingSchema = {
    properties: {
        field: {
            $ref: '#/components/schemas/QuoteDealField'
        },
        hubspot_property: {
            maxLength: 255,
            pattern: '^[a-z0-9_]+$',
            title: 'Hubspot Property',
            type: 'string'
        }
    },
    required: [
        'field',
        'hubspot_property'
    ],
    title: 'PropertyMapping',
    type: 'object'
} as const;

export const PurchaseOrderCreateSchema = {
    properties: {
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        expected_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected On'
        },
        items: {
            items: {
                $ref: '#/components/schemas/PurchaseOrderItemCreate'
            },
            maxItems: 100,
            minItems: 1,
            title: 'Items',
            type: 'array'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        ordered_on: {
            format: 'date',
            title: 'Ordered On',
            type: 'string'
        },
        vendor_id: {
            format: 'uuid',
            title: 'Vendor Id',
            type: 'string'
        }
    },
    required: [
        'vendor_id',
        'ordered_on',
        'currency',
        'items'
    ],
    title: 'PurchaseOrderCreate',
    type: 'object'
} as const;

export const PurchaseOrderDetailPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        expected_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected On'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        items: {
            items: {
                $ref: '#/components/schemas/PurchaseOrderItemDetailPublic'
            },
            title: 'Items',
            type: 'array'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        ordered_on: {
            format: 'date',
            title: 'Ordered On',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        total: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            readOnly: true,
            title: 'Total'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        vendor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApprovedVendorPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        vendor_id: {
            format: 'uuid',
            title: 'Vendor Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'number',
        'vendor_id',
        'ordered_on',
        'expected_on',
        'currency',
        'notes',
        'created_by_id',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'vendor',
        'items',
        'total'
    ],
    title: 'PurchaseOrderDetailPublic',
    type: 'object'
} as const;

export const PurchaseOrderItemCreateSchema = {
    properties: {
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        quantity: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Quantity'
        },
        unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Price'
        }
    },
    required: [
        'part_id',
        'quantity'
    ],
    title: 'PurchaseOrderItemCreate',
    type: 'object'
} as const;

export const PurchaseOrderItemDetailPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        part: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        },
        purchase_order_id: {
            format: 'uuid',
            title: 'Purchase Order Id',
            type: 'string'
        },
        quantity: {
            title: 'Quantity',
            type: 'string'
        },
        unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Price'
        }
    },
    required: [
        'id',
        'purchase_order_id',
        'part_id',
        'position',
        'quantity',
        'unit_price',
        'part'
    ],
    title: 'PurchaseOrderItemDetailPublic',
    type: 'object'
} as const;

export const PurchaseOrdersPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/PurchaseOrderDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'PurchaseOrdersPublic',
    type: 'object'
} as const;

export const QuantitySchema = {
    additionalProperties: false,
    properties: {
        unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Unit'
                },
                {
                    const: 'percent',
                    type: 'string'
                }
            ],
            title: 'Unit'
        },
        value: {
            exclusiveMinimum: 0,
            title: 'Value',
            type: 'number'
        }
    },
    required: [
        'value',
        'unit'
    ],
    title: 'Quantity',
    type: 'object'
} as const;

export const QuotableStageSchema = {
    properties: {
        pipeline: {
            maxLength: 255,
            minLength: 1,
            title: 'Pipeline',
            type: 'string'
        },
        stage: {
            maxLength: 255,
            minLength: 1,
            title: 'Stage',
            type: 'string'
        }
    },
    required: [
        'pipeline',
        'stage'
    ],
    title: 'QuotableStage',
    type: 'object'
} as const;

export const QuoteAttentionPublicSchema = {
    properties: {
        items: {
            title: 'Items',
            type: 'integer'
        },
        quotes: {
            title: 'Quotes',
            type: 'integer'
        }
    },
    required: [
        'items',
        'quotes'
    ],
    title: 'QuoteAttentionPublic',
    type: 'object'
} as const;

export const QuoteCommentAddedEventSchema = {
    properties: {
        comment_id: {
            format: 'uuid',
            title: 'Comment Id',
            type: 'string'
        },
        type: {
            const: 'comment_added',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'comment_id'
    ],
    title: 'QuoteCommentAddedEvent',
    type: 'object'
} as const;

export const QuoteCommentCreateSchema = {
    properties: {
        body: {
            minLength: 1,
            title: 'Body',
            type: 'string'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        visibility: {
            $ref: '#/components/schemas/CommentVisibility',
            default: 'internal'
        }
    },
    required: [
        'body'
    ],
    title: 'QuoteCommentCreate',
    type: 'object'
} as const;

export const QuoteCommentDetailPublicSchema = {
    properties: {
        author_contact: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerContactPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        author_contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Author Contact Id'
        },
        body: {
            title: 'Body',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        visibility: {
            $ref: '#/components/schemas/CommentVisibility'
        }
    },
    required: [
        'id',
        'quote_id',
        'quote_task_id',
        'visibility',
        'created_by_id',
        'author_contact_id',
        'body',
        'created_at',
        'updated_at',
        'deleted_at',
        'created_by',
        'author_contact'
    ],
    title: 'QuoteCommentDetailPublic',
    type: 'object'
} as const;

export const QuoteCommentUpdateSchema = {
    properties: {
        body: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Body'
        }
    },
    title: 'QuoteCommentUpdate',
    type: 'object'
} as const;

export const QuoteCommentsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteCommentDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuoteCommentsPublic',
    type: 'object'
} as const;

export const QuoteCreateSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        canned_work_package_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Canned Work Package Ids',
            type: 'array'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        kind: {
            $ref: '#/components/schemas/QuoteKind',
            default: 'aircraft'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/ExternalQuoteTaskUpsert'
            },
            title: 'Tasks',
            type: 'array'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'tasks'
    ],
    title: 'QuoteCreate',
    type: 'object'
} as const;

export const QuoteCreatedEventSchema = {
    properties: {
        task_count: {
            title: 'Task Count',
            type: 'integer'
        },
        type: {
            const: 'created',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'task_count'
    ],
    title: 'QuoteCreatedEvent',
    type: 'object'
} as const;

export const QuoteCustomerOpenedEventSchema = {
    properties: {
        type: {
            const: 'customer_opened',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type'
    ],
    title: 'QuoteCustomerOpenedEvent',
    type: 'object'
} as const;

export const QuoteCustomerOutcomePublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        customer: {
            $ref: '#/components/schemas/CustomerPublic'
        },
        totals: {
            items: {
                $ref: '#/components/schemas/CurrencyAmount'
            },
            title: 'Totals',
            type: 'array'
        },
        won: {
            title: 'Won',
            type: 'integer'
        }
    },
    required: [
        'customer',
        'count',
        'won',
        'totals'
    ],
    title: 'QuoteCustomerOutcomePublic',
    type: 'object'
} as const;

export const QuoteCustomerRespondedEventSchema = {
    properties: {
        approved: {
            title: 'Approved',
            type: 'integer'
        },
        clarification_requested: {
            title: 'Clarification Requested',
            type: 'integer'
        },
        rejected: {
            title: 'Rejected',
            type: 'integer'
        },
        type: {
            const: 'customer_responded',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'approved',
        'rejected',
        'clarification_requested'
    ],
    title: 'QuoteCustomerRespondedEvent',
    type: 'object'
} as const;

export const QuoteCustomerReviewPublicSchema = {
    properties: {
        approved: {
            title: 'Approved',
            type: 'integer'
        },
        clarification_requested: {
            title: 'Clarification Requested',
            type: 'integer'
        },
        rejected: {
            title: 'Rejected',
            type: 'integer'
        },
        status: {
            $ref: '#/components/schemas/CustomerReviewStatus'
        }
    },
    required: [
        'status',
        'approved',
        'rejected',
        'clarification_requested'
    ],
    title: 'QuoteCustomerReviewPublic',
    type: 'object'
} as const;

export const QuoteCustomerSignedEventSchema = {
    properties: {
        approved: {
            items: {
                type: 'string'
            },
            title: 'Approved',
            type: 'array'
        },
        approved_task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Approved Task Ids',
            type: 'array'
        },
        awaiting: {
            items: {
                type: 'string'
            },
            title: 'Awaiting',
            type: 'array'
        },
        awaiting_task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Awaiting Task Ids',
            type: 'array'
        },
        rejected: {
            items: {
                type: 'string'
            },
            title: 'Rejected',
            type: 'array'
        },
        rejected_task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Rejected Task Ids',
            type: 'array'
        },
        signature_id: {
            format: 'uuid',
            title: 'Signature Id',
            type: 'string'
        },
        type: {
            const: 'customer_signed',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'signature_id',
        'approved',
        'rejected'
    ],
    title: 'QuoteCustomerSignedEvent',
    type: 'object'
} as const;

export const QuoteDealFieldSchema = {
    enum: [
        'registration',
        'serial_number',
        'model',
        'configuration'
    ],
    title: 'QuoteDealField',
    type: 'string'
} as const;

export const QuoteDealFieldsSchema = {
    properties: {
        configuration: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Configuration'
        },
        model: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Model'
        },
        registration: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Registration'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    required: [
        'registration',
        'serial_number',
        'model',
        'configuration'
    ],
    title: 'QuoteDealFields',
    type: 'object'
} as const;

export const QuoteDeliverySchema = {
    enum: [
        'manual',
        'email'
    ],
    title: 'QuoteDelivery',
    type: 'string'
} as const;

export const QuoteDepartmentOutcomePublicSchema = {
    properties: {
        department: {
            $ref: '#/components/schemas/DepartmentPublic'
        },
        lost: {
            title: 'Lost',
            type: 'integer'
        },
        won: {
            title: 'Won',
            type: 'integer'
        }
    },
    required: [
        'department',
        'won',
        'lost'
    ],
    title: 'QuoteDepartmentOutcomePublic',
    type: 'object'
} as const;

export const QuoteDetailSchema = {
    enum: [
        'number',
        'title',
        'customer_id',
        'aircraft_id',
        'estimator_id',
        'sales_rep_id',
        'sales_region',
        'department_id',
        'contact_id',
        'billing_address_id',
        'shipping_address_id',
        'rate_card_id',
        'facility_id',
        'expected_arrival_at',
        'expected_departure_at',
        'expected_start_at',
        'expected_finish_at',
        'valid_until',
        'auto_expire',
        'requested_on',
        'promised_on',
        'requested_delivery_on',
        'estimated_close_on',
        'win_probability',
        'due_horizon_months',
        'due_horizon_from',
        'tax_exempt',
        'tax_destination',
        'currency',
        'fees',
        'discounts',
        'tax_rates'
    ],
    title: 'QuoteDetail',
    type: 'string'
} as const;

export const QuoteDetailPublicSchema = {
    properties: {
        active_discounts: {
            items: {
                $ref: '#/components/schemas/QuoteDiscountPublic'
            },
            title: 'Active Discounts',
            type: 'array'
        },
        active_fees: {
            items: {
                $ref: '#/components/schemas/QuoteFeePublic'
            },
            title: 'Active Fees',
            type: 'array'
        },
        active_phases: {
            items: {
                $ref: '#/components/schemas/QuotePhasePublic'
            },
            title: 'Active Phases',
            type: 'array'
        },
        active_revisions: {
            items: {
                $ref: '#/components/schemas/QuoteRevisionPublic'
            },
            title: 'Active Revisions',
            type: 'array'
        },
        active_tasks: {
            items: {
                $ref: '#/components/schemas/QuoteTaskDetailPublic'
            },
            title: 'Active Tasks',
            type: 'array'
        },
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        auto_expire: {
            title: 'Auto Expire',
            type: 'boolean'
        },
        billing_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Billing Address Id'
        },
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        crm_deal_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Crm Deal Id'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DepartmentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        disposition: {
            $ref: '#/components/schemas/QuoteDispositionKind'
        },
        due_horizon: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Horizon'
        },
        due_horizon_from: {
            $ref: '#/components/schemas/DueHorizonFrom'
        },
        due_horizon_months: {
            title: 'Due Horizon Months',
            type: 'integer'
        },
        estimated_close_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Close On'
        },
        estimator: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        estimator_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimator Id'
        },
        expected_arrival_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Arrival At'
        },
        expected_departure_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Departure At'
        },
        expected_finish_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Finish At'
        },
        expected_start_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Start At'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/QuoteKind'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        outcome_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outcome Reason'
        },
        promised_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised On'
        },
        rate_card_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rate Card Id'
        },
        requested_delivery_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested Delivery On'
        },
        requested_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested On'
        },
        review_token: {
            title: 'Review Token',
            type: 'string'
        },
        review_url: {
            readOnly: true,
            title: 'Review Url',
            type: 'string'
        },
        reviewers: {
            items: {
                $ref: '#/components/schemas/UserBasicInfo'
            },
            title: 'Reviewers',
            type: 'array'
        },
        sales_region: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Region'
        },
        sales_rep: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        sales_rep_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Rep Id'
        },
        salesforce_opportunity_id: {
            anyOf: [
                {
                    pattern: '^[a-zA-Z0-9]{15,18}$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Id'
        },
        salesforce_opportunity_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Url'
        },
        shipping_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Shipping Address Id'
        },
        status: {
            $ref: '#/components/schemas/QuoteStatus'
        },
        tax_destination: {
            $ref: '#/components/schemas/TaxDestination'
        },
        tax_exempt: {
            title: 'Tax Exempt',
            type: 'boolean'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        valid_until: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Valid Until'
        },
        win_probability: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Win Probability'
        },
        work_package: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageWithTasksPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'id',
        'number',
        'title',
        'kind',
        'crm_deal_id',
        'salesforce_opportunity_id',
        'salesforce_opportunity_url',
        'status',
        'disposition',
        'outcome_reason',
        'customer_id',
        'aircraft_id',
        'work_package_id',
        'department_id',
        'created_by_id',
        'estimator_id',
        'sales_rep_id',
        'sales_region',
        'contact_id',
        'billing_address_id',
        'shipping_address_id',
        'rate_card_id',
        'facility_id',
        'expected_arrival_at',
        'expected_departure_at',
        'expected_start_at',
        'expected_finish_at',
        'valid_until',
        'auto_expire',
        'requested_on',
        'promised_on',
        'requested_delivery_on',
        'estimated_close_on',
        'win_probability',
        'due_horizon_months',
        'due_horizon_from',
        'tax_exempt',
        'tax_destination',
        'currency',
        'review_token',
        'created_at',
        'deleted_at',
        'archived_at',
        'customer',
        'aircraft',
        'work_package',
        'department',
        'created_by',
        'estimator',
        'sales_rep',
        'reviewers',
        'active_tasks',
        'active_phases',
        'active_revisions',
        'active_fees',
        'active_discounts',
        'review_url'
    ],
    title: 'QuoteDetailPublic',
    type: 'object'
} as const;

export const QuoteDetailsUpdatedEventSchema = {
    properties: {
        details: {
            items: {
                $ref: '#/components/schemas/QuoteDetail'
            },
            title: 'Details',
            type: 'array'
        },
        type: {
            const: 'details_updated',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'details'
    ],
    title: 'QuoteDetailsUpdatedEvent',
    type: 'object'
} as const;

export const QuoteDiscountPublicSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amount'
        },
        category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ChargeCategory'
                },
                {
                    type: 'null'
                }
            ]
        },
        charged_amount: {
            title: 'Charged Amount',
            type: 'string'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        percentage: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Percentage'
        },
        position: {
            title: 'Position',
            type: 'integer'
        },
        quote_fee_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Fee Id'
        },
        quote_task_charge_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Charge Id'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        target: {
            $ref: '#/components/schemas/DiscountTarget'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        },
        tax_amount: {
            title: 'Tax Amount',
            type: 'string'
        }
    },
    required: [
        'id',
        'target',
        'position',
        'category',
        'task_group_id',
        'quote_task_id',
        'quote_task_charge_id',
        'quote_fee_id',
        'percentage',
        'amount',
        'currency',
        'description',
        'charged_amount',
        'tax_amount'
    ],
    title: 'QuoteDiscountPublic',
    type: 'object'
} as const;

export const QuoteDispositionChangeSchema = {
    properties: {
        disposition: {
            $ref: '#/components/schemas/QuoteDispositionKind'
        },
        outcome_reason: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outcome Reason'
        },
        reviewer_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    minItems: 1,
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reviewer Ids'
        },
        send: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteSendDetails'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'disposition'
    ],
    title: 'QuoteDispositionChange',
    type: 'object'
} as const;

export const QuoteDispositionChangedEventSchema = {
    properties: {
        current: {
            $ref: '#/components/schemas/QuoteDispositionKind'
        },
        outcome_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outcome Reason'
        },
        previous: {
            $ref: '#/components/schemas/QuoteDispositionKind'
        },
        recipients: {
            items: {
                type: 'string'
            },
            title: 'Recipients',
            type: 'array'
        },
        type: {
            const: 'disposition_changed',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'previous',
        'current',
        'outcome_reason'
    ],
    title: 'QuoteDispositionChangedEvent',
    type: 'object'
} as const;

export const QuoteDispositionKindSchema = {
    enum: [
        'draft',
        'review',
        'customer_review',
        'customer_response',
        'won',
        'lost',
        'cancelled',
        'expired'
    ],
    title: 'QuoteDispositionKind',
    type: 'string'
} as const;

export const QuoteDispositionPublicSchema = {
    properties: {
        enabled: {
            title: 'Enabled',
            type: 'boolean'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/QuoteDispositionKind'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'id',
        'kind',
        'name',
        'position',
        'enabled'
    ],
    title: 'QuoteDispositionPublic',
    type: 'object'
} as const;

export const QuoteDispositionUpdateSchema = {
    properties: {
        enabled: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Enabled'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        position: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        }
    },
    title: 'QuoteDispositionUpdate',
    type: 'object'
} as const;

export const QuoteDispositionsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteDispositionPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuoteDispositionsPublic',
    type: 'object'
} as const;

export const QuoteEventPublicSchema = {
    properties: {
        actor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        actor_contact: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerContactPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        event: {
            $ref: '#/components/schemas/QuoteEventValue'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        occurred_at: {
            format: 'date-time',
            title: 'Occurred At',
            type: 'string'
        },
        revision_number: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision Number'
        },
        source: {
            $ref: '#/components/schemas/ChangedBy'
        }
    },
    required: [
        'id',
        'occurred_at',
        'source',
        'actor',
        'actor_contact',
        'revision_number',
        'event'
    ],
    title: 'QuoteEventPublic',
    type: 'object'
} as const;

export const QuoteEventValueSchema = {
    discriminator: {
        mapping: {
            comment_added: '#/components/schemas/QuoteCommentAddedEvent',
            created: '#/components/schemas/QuoteCreatedEvent',
            customer_opened: '#/components/schemas/QuoteCustomerOpenedEvent',
            customer_responded: '#/components/schemas/QuoteCustomerRespondedEvent',
            customer_signed: '#/components/schemas/QuoteCustomerSignedEvent',
            details_updated: '#/components/schemas/QuoteDetailsUpdatedEvent',
            disposition_changed: '#/components/schemas/QuoteDispositionChangedEvent',
            report_generated: '#/components/schemas/QuoteReportGeneratedEvent',
            task_statuses_changed: '#/components/schemas/QuoteTaskStatusesChangedEvent',
            tasks_added: '#/components/schemas/QuoteTasksAddedEvent',
            tasks_merged: '#/components/schemas/QuoteTasksMergedEvent',
            tasks_removed: '#/components/schemas/QuoteTasksRemovedEvent',
            tasks_reviewed: '#/components/schemas/QuoteTasksReviewedEvent'
        },
        propertyName: 'type'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/QuoteCreatedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteDetailsUpdatedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteTasksAddedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteTasksRemovedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteTasksMergedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteTaskStatusesChangedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteTasksReviewedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteDispositionChangedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteCustomerOpenedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteCustomerRespondedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteCustomerSignedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteCommentAddedEvent'
        },
        {
            $ref: '#/components/schemas/QuoteReportGeneratedEvent'
        }
    ]
} as const;

export const QuoteEventsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteEventPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuoteEventsPublic',
    type: 'object'
} as const;

export const QuoteExportFormatSchema = {
    enum: [
        'pdf',
        'xlsx',
        'csv',
        'corridor_csv',
        'work_scope'
    ],
    title: 'QuoteExportFormat',
    type: 'string'
} as const;

export const QuoteFeePublicSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        cap_amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cap Amount'
        },
        charged_amount: {
            title: 'Charged Amount',
            type: 'string'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_taxable: {
            title: 'Is Taxable',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/FeeKind'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        },
        quote_fee_template_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Fee Template Id'
        },
        tax_amount: {
            title: 'Tax Amount',
            type: 'string'
        }
    },
    required: [
        'id',
        'quote_fee_template_id',
        'name',
        'kind',
        'amount',
        'cap_amount',
        'currency',
        'is_taxable',
        'position',
        'charged_amount',
        'tax_amount'
    ],
    title: 'QuoteFeePublic',
    type: 'object'
} as const;

export const QuoteFeeTemplateCreateSchema = {
    properties: {
        add_by_default: {
            default: false,
            title: 'Add By Default',
            type: 'boolean'
        },
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amount'
        },
        cap_amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cap Amount'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        is_taxable: {
            default: true,
            title: 'Is Taxable',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/FeeKind'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'name',
        'kind'
    ],
    title: 'QuoteFeeTemplateCreate',
    type: 'object'
} as const;

export const QuoteFeeTemplateDetailPublicSchema = {
    properties: {
        add_by_default: {
            title: 'Add By Default',
            type: 'boolean'
        },
        amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amount'
        },
        cap_amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cap Amount'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_taxable: {
            title: 'Is Taxable',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/FeeKind'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'customer_id',
        'name',
        'kind',
        'amount',
        'cap_amount',
        'currency',
        'is_taxable',
        'add_by_default',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at',
        'customer'
    ],
    title: 'QuoteFeeTemplateDetailPublic',
    type: 'object'
} as const;

export const QuoteFeeTemplateUpdateSchema = {
    properties: {
        add_by_default: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Add By Default'
        },
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amount'
        },
        cap_amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cap Amount'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        is_taxable: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Taxable'
        },
        kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FeeKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    title: 'QuoteFeeTemplateUpdate',
    type: 'object'
} as const;

export const QuoteFeeTemplatesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteFeeTemplateDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuoteFeeTemplatesPublic',
    type: 'object'
} as const;

export const QuoteFilterOptionsPublicSchema = {
    properties: {
        aircraft: {
            items: {
                $ref: '#/components/schemas/AircraftPublic'
            },
            title: 'Aircraft',
            type: 'array'
        },
        aircraft_count: {
            title: 'Aircraft Count',
            type: 'integer'
        },
        part_count: {
            title: 'Part Count',
            type: 'integer'
        },
        parts: {
            items: {
                $ref: '#/components/schemas/PartPublic'
            },
            title: 'Parts',
            type: 'array'
        },
        revisions: {
            items: {
                type: 'integer'
            },
            title: 'Revisions',
            type: 'array'
        }
    },
    required: [
        'aircraft',
        'aircraft_count',
        'parts',
        'part_count',
        'revisions'
    ],
    title: 'QuoteFilterOptionsPublic',
    type: 'object'
} as const;

export const QuoteGroupPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        included: {
            title: 'Included',
            type: 'integer'
        },
        key: {
            title: 'Key',
            type: 'string'
        },
        subgroups: {
            items: {
                $ref: '#/components/schemas/SubgroupCountPublic'
            },
            title: 'Subgroups',
            type: 'array'
        },
        totals: {
            items: {
                $ref: '#/components/schemas/CurrencyAmount'
            },
            title: 'Totals',
            type: 'array'
        }
    },
    required: [
        'key',
        'count',
        'subgroups',
        'included',
        'totals'
    ],
    title: 'QuoteGroupPublic',
    type: 'object'
} as const;

export const QuoteGroupingSchema = {
    enum: [
        'status',
        'outcome',
        'customer',
        'asset',
        'department',
        'sales_rep'
    ],
    title: 'QuoteGrouping',
    type: 'string'
} as const;

export const QuoteImportFailureSchema = {
    enum: [
        'unknown_work_order',
        'work_order_kind_mismatch',
        'work_order_has_quote',
        'number_taken',
        'task_number_taken',
        'locked',
        'already_imported'
    ],
    title: 'QuoteImportFailure',
    type: 'string'
} as const;

export const QuoteImportResultPublicSchema = {
    discriminator: {
        mapping: {
            created: '#/components/schemas/ImportedQuotePublic',
            failed: '#/components/schemas/FailedQuoteImportPublic',
            unchanged: '#/components/schemas/ImportedQuotePublic',
            updated: '#/components/schemas/ImportedQuotePublic'
        },
        propertyName: 'outcome'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/ImportedQuotePublic'
        },
        {
            $ref: '#/components/schemas/FailedQuoteImportPublic'
        }
    ]
} as const;

export const QuoteKindSchema = {
    enum: [
        'aircraft',
        'traveller',
        'rfp'
    ],
    title: 'QuoteKind',
    type: 'string'
} as const;

export const QuoteMonthPublicSchema = {
    properties: {
        decision_days: {
            title: 'Decision Days',
            type: 'number'
        },
        decisions: {
            title: 'Decisions',
            type: 'integer'
        },
        lost: {
            $ref: '#/components/schemas/QuoteTallyPublic'
        },
        month: {
            format: 'date',
            title: 'Month',
            type: 'string'
        },
        quoted: {
            $ref: '#/components/schemas/QuoteTallyPublic'
        },
        won: {
            $ref: '#/components/schemas/QuoteTallyPublic'
        }
    },
    required: [
        'month',
        'quoted',
        'won',
        'lost',
        'decision_days',
        'decisions'
    ],
    title: 'QuoteMonthPublic',
    type: 'object'
} as const;

export const QuoteNumberSequencePublicSchema = {
    properties: {
        format: {
            title: 'Format',
            type: 'string'
        },
        next: {
            title: 'Next',
            type: 'integer'
        }
    },
    required: [
        'format',
        'next'
    ],
    title: 'QuoteNumberSequencePublic',
    type: 'object'
} as const;

export const QuoteNumberSequenceUpsertSchema = {
    properties: {
        format: {
            minLength: 1,
            title: 'Format',
            type: 'string'
        },
        next: {
            anyOf: [
                {
                    maximum: 2147483647,
                    minimum: 1,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next'
        }
    },
    required: [
        'format'
    ],
    title: 'QuoteNumberSequenceUpsert',
    type: 'object'
} as const;

export const QuoteOrderSchema = {
    enum: [
        'created',
        'updated'
    ],
    title: 'QuoteOrder',
    type: 'string'
} as const;

export const QuoteOverviewPublicSchema = {
    properties: {
        attention: {
            $ref: '#/components/schemas/QuoteAttentionPublic'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        customer_count: {
            title: 'Customer Count',
            type: 'integer'
        },
        customers: {
            items: {
                $ref: '#/components/schemas/QuoteCustomerOutcomePublic'
            },
            title: 'Customers',
            type: 'array'
        },
        departments: {
            items: {
                $ref: '#/components/schemas/QuoteDepartmentOutcomePublic'
            },
            title: 'Departments',
            type: 'array'
        },
        expiring: {
            $ref: '#/components/schemas/QuoteTallyPublic'
        },
        lapsed: {
            $ref: '#/components/schemas/QuoteTallyPublic'
        },
        months: {
            items: {
                $ref: '#/components/schemas/QuoteMonthPublic'
            },
            title: 'Months',
            type: 'array'
        },
        quarter: {
            $ref: '#/components/schemas/QuoteQuarterPublic'
        },
        quiet: {
            $ref: '#/components/schemas/QuoteTallyPublic'
        },
        stages: {
            items: {
                $ref: '#/components/schemas/QuoteStagePublic'
            },
            title: 'Stages',
            type: 'array'
        },
        window_end: {
            format: 'date',
            title: 'Window End',
            type: 'string'
        },
        window_start: {
            format: 'date',
            title: 'Window Start',
            type: 'string'
        }
    },
    required: [
        'currency',
        'stages',
        'expiring',
        'lapsed',
        'quiet',
        'attention',
        'quarter',
        'months',
        'window_start',
        'window_end',
        'departments',
        'customers',
        'customer_count'
    ],
    title: 'QuoteOverviewPublic',
    type: 'object'
} as const;

export const QuotePatchResultSchema = {
    properties: {
        created_task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Created Task Ids',
            type: 'array'
        }
    },
    required: [
        'created_task_ids'
    ],
    title: 'QuotePatchResult',
    type: 'object'
} as const;

export const QuotePayerAllocationCreateSchema = {
    properties: {
        category: {
            $ref: '#/components/schemas/ChargeCategory'
        },
        cost_percentage: {
            anyOf: [
                {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost Percentage'
        },
        customer_id: {
            format: 'uuid',
            title: 'Customer Id',
            type: 'string'
        },
        percentage: {
            anyOf: [
                {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Percentage'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        }
    },
    required: [
        'customer_id',
        'category',
        'percentage'
    ],
    title: 'QuotePayerAllocationCreate',
    type: 'object'
} as const;

export const QuotePayerAllocationDetailPublicSchema = {
    properties: {
        category: {
            $ref: '#/components/schemas/ChargeCategory'
        },
        cost_percentage: {
            title: 'Cost Percentage',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            format: 'uuid',
            title: 'Customer Id',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        percentage: {
            title: 'Percentage',
            type: 'string'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'quote_id',
        'quote_task_id',
        'customer_id',
        'category',
        'percentage',
        'cost_percentage',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at',
        'customer'
    ],
    title: 'QuotePayerAllocationDetailPublic',
    type: 'object'
} as const;

export const QuotePayerAllocationUpdateSchema = {
    properties: {
        category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ChargeCategory'
                },
                {
                    type: 'null'
                }
            ]
        },
        cost_percentage: {
            anyOf: [
                {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost Percentage'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        percentage: {
            anyOf: [
                {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Percentage'
        }
    },
    title: 'QuotePayerAllocationUpdate',
    type: 'object'
} as const;

export const QuotePayerAllocationsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuotePayerAllocationDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuotePayerAllocationsPublic',
    type: 'object'
} as const;

export const QuotePhaseCreateSchema = {
    properties: {
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'name'
    ],
    title: 'QuotePhaseCreate',
    type: 'object'
} as const;

export const QuotePhaseOrderSchema = {
    properties: {
        phase_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Phase Ids',
            type: 'array'
        }
    },
    required: [
        'phase_ids'
    ],
    title: 'QuotePhaseOrder',
    type: 'object'
} as const;

export const QuotePhasePublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'id',
        'name',
        'position'
    ],
    title: 'QuotePhasePublic',
    type: 'object'
} as const;

export const QuotePhaseUpdateSchema = {
    properties: {
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    title: 'QuotePhaseUpdate',
    type: 'object'
} as const;

export const QuotePreviewRecordSchema = {
    properties: {
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        source: {
            const: 'quote',
            title: 'Source',
            type: 'string'
        }
    },
    required: [
        'source',
        'quote_id'
    ],
    title: 'QuotePreviewRecord',
    type: 'object'
} as const;

export const QuotePublicSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        auto_expire: {
            title: 'Auto Expire',
            type: 'boolean'
        },
        billing_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Billing Address Id'
        },
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        crm_deal_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Crm Deal Id'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        disposition: {
            $ref: '#/components/schemas/QuoteDispositionKind'
        },
        due_horizon_from: {
            $ref: '#/components/schemas/DueHorizonFrom'
        },
        due_horizon_months: {
            title: 'Due Horizon Months',
            type: 'integer'
        },
        estimated_close_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Close On'
        },
        estimator_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimator Id'
        },
        expected_arrival_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Arrival At'
        },
        expected_departure_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Departure At'
        },
        expected_finish_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Finish At'
        },
        expected_start_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Start At'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/QuoteKind'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        outcome_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outcome Reason'
        },
        promised_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised On'
        },
        rate_card_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rate Card Id'
        },
        requested_delivery_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested Delivery On'
        },
        requested_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested On'
        },
        review_token: {
            title: 'Review Token',
            type: 'string'
        },
        review_url: {
            readOnly: true,
            title: 'Review Url',
            type: 'string'
        },
        sales_region: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Region'
        },
        sales_rep_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Rep Id'
        },
        salesforce_opportunity_id: {
            anyOf: [
                {
                    pattern: '^[a-zA-Z0-9]{15,18}$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Id'
        },
        salesforce_opportunity_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Url'
        },
        shipping_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Shipping Address Id'
        },
        status: {
            $ref: '#/components/schemas/QuoteStatus'
        },
        tax_destination: {
            $ref: '#/components/schemas/TaxDestination'
        },
        tax_exempt: {
            title: 'Tax Exempt',
            type: 'boolean'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        valid_until: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Valid Until'
        },
        win_probability: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Win Probability'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'id',
        'number',
        'title',
        'kind',
        'crm_deal_id',
        'salesforce_opportunity_id',
        'salesforce_opportunity_url',
        'status',
        'disposition',
        'outcome_reason',
        'customer_id',
        'aircraft_id',
        'work_package_id',
        'department_id',
        'created_by_id',
        'estimator_id',
        'sales_rep_id',
        'sales_region',
        'contact_id',
        'billing_address_id',
        'shipping_address_id',
        'rate_card_id',
        'facility_id',
        'expected_arrival_at',
        'expected_departure_at',
        'expected_start_at',
        'expected_finish_at',
        'valid_until',
        'auto_expire',
        'requested_on',
        'promised_on',
        'requested_delivery_on',
        'estimated_close_on',
        'win_probability',
        'due_horizon_months',
        'due_horizon_from',
        'tax_exempt',
        'tax_destination',
        'currency',
        'review_token',
        'created_at',
        'deleted_at',
        'archived_at',
        'review_url'
    ],
    title: 'QuotePublic',
    type: 'object'
} as const;

export const QuoteQuarterPublicSchema = {
    properties: {
        lost: {
            $ref: '#/components/schemas/QuoteTallyPublic'
        },
        with_work_order: {
            title: 'With Work Order',
            type: 'integer'
        },
        won: {
            $ref: '#/components/schemas/QuoteTallyPublic'
        }
    },
    required: [
        'won',
        'lost',
        'with_work_order'
    ],
    title: 'QuoteQuarterPublic',
    type: 'object'
} as const;

export const QuoteReportGeneratedEventSchema = {
    properties: {
        filename: {
            title: 'Filename',
            type: 'string'
        },
        report: {
            title: 'Report',
            type: 'string'
        },
        type: {
            const: 'report_generated',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'report',
        'filename'
    ],
    title: 'QuoteReportGeneratedEvent',
    type: 'object'
} as const;

export const QuoteReviewAircraftPublicSchema = {
    properties: {
        model: {
            title: 'Model',
            type: 'string'
        },
        registration_no: {
            title: 'Registration No',
            type: 'string'
        },
        serial_no: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial No'
        }
    },
    required: [
        'registration_no',
        'model',
        'serial_no'
    ],
    title: 'QuoteReviewAircraftPublic',
    type: 'object'
} as const;

export const QuoteReviewAmountPublicSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        label: {
            title: 'Label',
            type: 'string'
        }
    },
    required: [
        'label',
        'amount'
    ],
    title: 'QuoteReviewAmountPublic',
    type: 'object'
} as const;

export const QuoteReviewChargePublicSchema = {
    properties: {
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        estimate_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        lead_time: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        part_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        quantity: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        turnaround_time: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Turnaround Time'
        },
        type: {
            $ref: '#/components/schemas/ChargeType'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        },
        vendor_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Name'
        }
    },
    required: [
        'id',
        'description',
        'type',
        'part_number',
        'sale_unit_price',
        'currency',
        'quantity',
        'unit_of_measure',
        'tax_amount',
        'lead_time',
        'turnaround_time',
        'vendor_name',
        'estimate_kind'
    ],
    title: 'QuoteReviewChargePublic',
    type: 'object'
} as const;

export const QuoteReviewCodeRequestSchema = {
    properties: {
        email: {
            format: 'email',
            title: 'Email',
            type: 'string'
        }
    },
    required: [
        'email'
    ],
    title: 'QuoteReviewCodeRequest',
    type: 'object'
} as const;

export const QuoteReviewCommentCreateSchema = {
    properties: {
        body: {
            minLength: 1,
            title: 'Body',
            type: 'string'
        }
    },
    required: [
        'body'
    ],
    title: 'QuoteReviewCommentCreate',
    type: 'object'
} as const;

export const QuoteReviewCommentPublicSchema = {
    properties: {
        author_contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Author Contact Id'
        },
        author_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Author Name'
        },
        body: {
            title: 'Body',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        side: {
            $ref: '#/components/schemas/CommentSide'
        }
    },
    required: [
        'id',
        'body',
        'created_at',
        'side',
        'author_name',
        'author_contact_id'
    ],
    title: 'QuoteReviewCommentPublic',
    type: 'object'
} as const;

export const QuoteReviewComponentPublicSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        },
        received_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Received On'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        work_order_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Order Number'
        }
    },
    required: [
        'part_number',
        'description',
        'serial_number',
        'work_order_number',
        'received_on'
    ],
    title: 'QuoteReviewComponentPublic',
    type: 'object'
} as const;

export const QuoteReviewContactPublicSchema = {
    properties: {
        first_name: {
            title: 'First Name',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        job_title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_name: {
            title: 'Last Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'first_name',
        'last_name',
        'job_title'
    ],
    title: 'QuoteReviewContactPublic',
    type: 'object'
} as const;

export const QuoteReviewDecisionSchema = {
    properties: {
        kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            enum: [
                'pending',
                'approved',
                'rejected'
            ],
            title: 'Status',
            type: 'string'
        },
        task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Task Ids',
            type: 'array'
        }
    },
    required: [
        'task_ids',
        'status'
    ],
    title: 'QuoteReviewDecision',
    type: 'object'
} as const;

export const QuoteReviewDiscountPublicSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amount'
        },
        category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ChargeCategory'
                },
                {
                    type: 'null'
                }
            ]
        },
        charge_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Charge Id'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        fee_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fee Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        percentage: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Percentage'
        },
        target: {
            $ref: '#/components/schemas/DiscountTarget'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        },
        task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Id'
        }
    },
    required: [
        'id',
        'target',
        'category',
        'task_group_id',
        'task_id',
        'charge_id',
        'fee_id',
        'currency',
        'percentage',
        'amount',
        'description'
    ],
    title: 'QuoteReviewDiscountPublic',
    type: 'object'
} as const;

export const QuoteReviewEstimatorPublicSchema = {
    properties: {
        designation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Designation'
        },
        email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        first_name: {
            title: 'First Name',
            type: 'string'
        },
        last_name: {
            title: 'Last Name',
            type: 'string'
        }
    },
    required: [
        'first_name',
        'last_name',
        'email',
        'designation'
    ],
    title: 'QuoteReviewEstimatorPublic',
    type: 'object'
} as const;

export const QuoteReviewFeePublicSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        cap_amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cap Amount'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_taxable: {
            title: 'Is Taxable',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/FeeKind'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'name',
        'kind',
        'amount',
        'currency',
        'cap_amount',
        'is_taxable'
    ],
    title: 'QuoteReviewFeePublic',
    type: 'object'
} as const;

export const QuoteReviewFindingPublicSchema = {
    properties: {
        step: {
            title: 'Step',
            type: 'string'
        },
        text: {
            title: 'Text',
            type: 'string'
        }
    },
    required: [
        'step',
        'text'
    ],
    title: 'QuoteReviewFindingPublic',
    type: 'object'
} as const;

export const QuoteReviewLinkPublicSchema = {
    properties: {
        customer_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Name'
        },
        kind: {
            $ref: '#/components/schemas/QuoteKind'
        },
        part_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        quote_number: {
            title: 'Quote Number',
            type: 'string'
        },
        registration_no: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Registration No'
        },
        revision_id: {
            format: 'uuid',
            title: 'Revision Id',
            type: 'string'
        },
        revision_number: {
            title: 'Revision Number',
            type: 'integer'
        },
        shop: {
            $ref: '#/components/schemas/QuoteReviewShopPublic'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        tenant_slug: {
            title: 'Tenant Slug',
            type: 'string'
        }
    },
    required: [
        'tenant_id',
        'tenant_slug',
        'quote_id',
        'revision_id',
        'shop',
        'quote_number',
        'revision_number',
        'kind',
        'customer_name',
        'registration_no',
        'part_number'
    ],
    title: 'QuoteReviewLinkPublic',
    type: 'object'
} as const;

export const QuoteReviewPublicSchema = {
    properties: {
        accepting: {
            title: 'Accepting',
            type: 'boolean'
        },
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteReviewAircraftPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        approval_contact: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteReviewContactPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        approver: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteReviewContactPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        component: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteReviewComponentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Name'
        },
        discounts: {
            items: {
                $ref: '#/components/schemas/QuoteReviewDiscountPublic'
            },
            title: 'Discounts',
            type: 'array'
        },
        estimator: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteReviewEstimatorPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        expected_finish_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Finish At'
        },
        expected_start_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Start At'
        },
        fees: {
            items: {
                $ref: '#/components/schemas/QuoteReviewFeePublic'
            },
            title: 'Fees',
            type: 'array'
        },
        findings: {
            items: {
                $ref: '#/components/schemas/QuoteReviewFindingPublic'
            },
            title: 'Findings',
            type: 'array'
        },
        kind: {
            $ref: '#/components/schemas/QuoteKind'
        },
        parts_quote: {
            title: 'Parts Quote',
            type: 'boolean'
        },
        proposal_letter: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Proposal Letter'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        quote_number: {
            title: 'Quote Number',
            type: 'string'
        },
        recipient: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteReviewContactPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        responded_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Responded At'
        },
        revision_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision Id'
        },
        revision_number: {
            title: 'Revision Number',
            type: 'integer'
        },
        sent_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent At'
        },
        shop: {
            $ref: '#/components/schemas/QuoteReviewShopPublic'
        },
        signatures: {
            items: {
                $ref: '#/components/schemas/QuoteReviewSignaturePublic'
            },
            title: 'Signatures',
            type: 'array'
        },
        status: {
            $ref: '#/components/schemas/RevisionStatus'
        },
        summary: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteReviewSummaryPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/QuoteReviewTaskPublic'
            },
            title: 'Tasks',
            type: 'array'
        },
        tax_rates: {
            items: {
                $ref: '#/components/schemas/QuoteReviewTaxRatePublic'
            },
            title: 'Tax Rates',
            type: 'array'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        terms_and_conditions: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Terms And Conditions'
        },
        terms_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Terms Url'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        valid_until: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Valid Until'
        }
    },
    required: [
        'tenant_id',
        'quote_id',
        'revision_id',
        'shop',
        'quote_number',
        'title',
        'revision_number',
        'status',
        'accepting',
        'sent_at',
        'responded_at',
        'valid_until',
        'customer_name',
        'recipient',
        'estimator',
        'aircraft',
        'component',
        'kind',
        'parts_quote',
        'findings',
        'expected_start_at',
        'expected_finish_at',
        'proposal_letter',
        'terms_and_conditions',
        'terms_url',
        'approver',
        'approval_contact',
        'tasks',
        'signatures',
        'fees',
        'discounts',
        'tax_rates',
        'summary'
    ],
    title: 'QuoteReviewPublic',
    type: 'object'
} as const;

export const QuoteReviewSessionCreateSchema = {
    properties: {
        code: {
            pattern: '^\\d{6}$',
            title: 'Code',
            type: 'string'
        },
        email: {
            format: 'email',
            title: 'Email',
            type: 'string'
        }
    },
    required: [
        'email',
        'code'
    ],
    title: 'QuoteReviewSessionCreate',
    type: 'object'
} as const;

export const QuoteReviewSessionPublicSchema = {
    properties: {
        approver: {
            $ref: '#/components/schemas/QuoteReviewContactPublic'
        },
        expires_at: {
            format: 'date-time',
            title: 'Expires At',
            type: 'string'
        },
        session_token: {
            title: 'Session Token',
            type: 'string'
        }
    },
    required: [
        'session_token',
        'expires_at',
        'approver'
    ],
    title: 'QuoteReviewSessionPublic',
    type: 'object'
} as const;

export const QuoteReviewShopPublicSchema = {
    properties: {
        address: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address'
        },
        email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        phone: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        }
    },
    required: [
        'name',
        'address',
        'phone',
        'email'
    ],
    title: 'QuoteReviewShopPublic',
    type: 'object'
} as const;

export const QuoteReviewSignatureCreateSchema = {
    properties: {
        accepts_terms: {
            const: true,
            title: 'Accepts Terms',
            type: 'boolean'
        },
        po_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Po Number'
        },
        signer_name: {
            minLength: 1,
            title: 'Signer Name',
            type: 'string'
        },
        signer_title: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Signer Title'
        }
    },
    required: [
        'signer_name',
        'accepts_terms'
    ],
    title: 'QuoteReviewSignatureCreate',
    type: 'object'
} as const;

export const QuoteReviewSignaturePublicSchema = {
    properties: {
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        po_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Po Number'
        },
        signed_at: {
            format: 'date-time',
            title: 'Signed At',
            type: 'string'
        },
        signer_name: {
            title: 'Signer Name',
            type: 'string'
        },
        signer_title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Signer Title'
        }
    },
    required: [
        'id',
        'signer_name',
        'signer_title',
        'po_number',
        'signed_at',
        'contact_id'
    ],
    title: 'QuoteReviewSignaturePublic',
    type: 'object'
} as const;

export const QuoteReviewSummaryPublicSchema = {
    properties: {
        approved: {
            $ref: '#/components/schemas/QuoteReviewTotalsPublic'
        },
        awaiting: {
            $ref: '#/components/schemas/QuoteReviewTotalsPublic'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        quote: {
            $ref: '#/components/schemas/QuoteReviewTotalsPublic'
        },
        signing: {
            $ref: '#/components/schemas/QuoteReviewTotalsPublic'
        }
    },
    required: [
        'currency',
        'approved',
        'awaiting',
        'quote',
        'signing'
    ],
    title: 'QuoteReviewSummaryPublic',
    type: 'object'
} as const;

export const QuoteReviewTaskPublicSchema = {
    properties: {
        approval: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApprovalProgressPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        awarded_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        carried_over: {
            title: 'Carried Over',
            type: 'boolean'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/QuoteReviewChargePublic'
            },
            title: 'Charges',
            type: 'array'
        },
        comments: {
            items: {
                $ref: '#/components/schemas/QuoteReviewCommentPublic'
            },
            title: 'Comments',
            type: 'array'
        },
        decided_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteReviewContactPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        group_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Group Name'
        },
        group_position: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Group Position'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        part_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Description'
        },
        part_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        pre_approved: {
            title: 'Pre Approved',
            type: 'boolean'
        },
        responded_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Responded At'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        signature_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Signature Id'
        },
        signatures: {
            items: {
                $ref: '#/components/schemas/QuoteReviewTaskSignaturePublic'
            },
            title: 'Signatures',
            type: 'array'
        },
        status: {
            $ref: '#/components/schemas/RevisionTaskStatus'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'severity',
        'status',
        'carried_over',
        'pre_approved',
        'responded_at',
        'group_name',
        'group_position',
        'task_group_id',
        'decided_by',
        'signature_id',
        'signatures',
        'approval',
        'part_number',
        'part_description',
        'awarded_kind',
        'charges',
        'comments'
    ],
    title: 'QuoteReviewTaskPublic',
    type: 'object'
} as const;

export const QuoteReviewTaskSignaturePublicSchema = {
    properties: {
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        signature_id: {
            format: 'uuid',
            title: 'Signature Id',
            type: 'string'
        },
        signer_name: {
            title: 'Signer Name',
            type: 'string'
        },
        status: {
            $ref: '#/components/schemas/RevisionTaskStatus'
        }
    },
    required: [
        'signature_id',
        'contact_id',
        'signer_name',
        'status'
    ],
    title: 'QuoteReviewTaskSignaturePublic',
    type: 'object'
} as const;

export const QuoteReviewTaxRatePublicSchema = {
    properties: {
        name: {
            title: 'Name',
            type: 'string'
        },
        rate: {
            title: 'Rate',
            type: 'string'
        },
        tax_class: {
            $ref: '#/components/schemas/TaxClass'
        }
    },
    required: [
        'tax_class',
        'name',
        'rate'
    ],
    title: 'QuoteReviewTaxRatePublic',
    type: 'object'
} as const;

export const QuoteReviewTotalsPublicSchema = {
    properties: {
        categories: {
            items: {
                $ref: '#/components/schemas/QuoteReviewAmountPublic'
            },
            title: 'Categories',
            type: 'array'
        },
        discounts: {
            items: {
                $ref: '#/components/schemas/QuoteReviewAmountPublic'
            },
            title: 'Discounts',
            type: 'array'
        },
        fees: {
            items: {
                $ref: '#/components/schemas/QuoteReviewAmountPublic'
            },
            title: 'Fees',
            type: 'array'
        },
        subtotal: {
            title: 'Subtotal',
            type: 'string'
        },
        tax: {
            title: 'Tax',
            type: 'string'
        },
        tax_label: {
            title: 'Tax Label',
            type: 'string'
        },
        total: {
            title: 'Total',
            type: 'string'
        }
    },
    required: [
        'categories',
        'subtotal',
        'discounts',
        'fees',
        'tax_label',
        'tax',
        'total'
    ],
    title: 'QuoteReviewTotalsPublic',
    type: 'object'
} as const;

export const QuoteReviewersChangeSchema = {
    properties: {
        reviewer_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Reviewer Ids',
            type: 'array'
        }
    },
    required: [
        'reviewer_ids'
    ],
    title: 'QuoteReviewersChange',
    type: 'object'
} as const;

export const QuoteRevisionDetailPublicSchema = {
    properties: {
        active_tasks: {
            items: {
                $ref: '#/components/schemas/QuoteRevisionTaskDetailPublic'
            },
            title: 'Active Tasks',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        email_failed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email Failed At'
        },
        emailed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emailed At'
        },
        expires_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expires At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/RevisionKind'
        },
        message: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Message'
        },
        number: {
            title: 'Number',
            type: 'integer'
        },
        quote: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuotePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        recipients: {
            items: {
                $ref: '#/components/schemas/QuoteRevisionRecipientPublic'
            },
            title: 'Recipients',
            type: 'array'
        },
        responded_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Responded At'
        },
        sent_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent At'
        },
        sent_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent By Id'
        },
        status: {
            $ref: '#/components/schemas/RevisionStatus'
        },
        subject: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subject'
        }
    },
    required: [
        'id',
        'quote_id',
        'kind',
        'number',
        'status',
        'sent_at',
        'sent_by_id',
        'emailed_at',
        'email_failed_at',
        'responded_at',
        'expires_at',
        'created_at',
        'deleted_at',
        'subject',
        'message',
        'recipients',
        'active_tasks',
        'quote'
    ],
    title: 'QuoteRevisionDetailPublic',
    type: 'object'
} as const;

export const QuoteRevisionPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        email_failed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email Failed At'
        },
        emailed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emailed At'
        },
        expires_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expires At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/RevisionKind'
        },
        message: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Message'
        },
        number: {
            title: 'Number',
            type: 'integer'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        recipients: {
            items: {
                $ref: '#/components/schemas/QuoteRevisionRecipientPublic'
            },
            title: 'Recipients',
            type: 'array'
        },
        responded_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Responded At'
        },
        sent_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent At'
        },
        sent_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent By Id'
        },
        status: {
            $ref: '#/components/schemas/RevisionStatus'
        },
        subject: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subject'
        }
    },
    required: [
        'id',
        'quote_id',
        'kind',
        'number',
        'status',
        'sent_at',
        'sent_by_id',
        'emailed_at',
        'email_failed_at',
        'responded_at',
        'expires_at',
        'created_at',
        'deleted_at',
        'subject',
        'message',
        'recipients'
    ],
    title: 'QuoteRevisionPublic',
    type: 'object'
} as const;

export const QuoteRevisionRecipientPublicSchema = {
    properties: {
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        email: {
            title: 'Email',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/RecipientKind'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    required: [
        'id',
        'kind',
        'email',
        'name',
        'contact_id'
    ],
    title: 'QuoteRevisionRecipientPublic',
    type: 'object'
} as const;

export const QuoteRevisionTaskChargePublicSchema = {
    properties: {
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        estimate_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        lead_time: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        part_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        type: {
            $ref: '#/components/schemas/ChargeType'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'id',
        'description',
        'type',
        'part_number',
        'purchase_unit_price',
        'sale_unit_price',
        'currency',
        'quantity',
        'unit_of_measure',
        'tax_amount',
        'lead_time',
        'estimate_kind'
    ],
    title: 'QuoteRevisionTaskChargePublic',
    type: 'object'
} as const;

export const QuoteRevisionTaskDetailPublicSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        awarded_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        canned_work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Task Id'
        },
        carried_over: {
            title: 'Carried Over',
            type: 'boolean'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/QuoteRevisionTaskChargePublic'
            },
            title: 'Charges',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        manual_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        },
        pre_approved: {
            title: 'Pre Approved',
            type: 'boolean'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        responded_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Responded At'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            $ref: '#/components/schemas/RevisionTaskStatus'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'severity',
        'position',
        'status',
        'carried_over',
        'pre_approved',
        'note',
        'quote_task_id',
        'canned_work_task_id',
        'manual_reference',
        'ata_chapter',
        'ata_subchapter',
        'ata_zone',
        'awarded_kind',
        'responded_at',
        'work_task_id',
        'created_at',
        'deleted_at',
        'charges'
    ],
    title: 'QuoteRevisionTaskDetailPublic',
    type: 'object'
} as const;

export const QuoteRulesetCreateSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        version: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteRulesetVersionCreate'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'name'
    ],
    title: 'QuoteRulesetCreate',
    type: 'object'
} as const;

export const QuoteRulesetDetailPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        latest_version: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteRulesetVersionDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'name',
        'created_at',
        'updated_at',
        'created_by',
        'last_modified_by'
    ],
    title: 'QuoteRulesetDetailPublic',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationCreateSchema = {
    properties: {
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        quote_ruleset_version_id: {
            format: 'uuid',
            title: 'Quote Ruleset Version Id',
            type: 'string'
        }
    },
    required: [
        'quote_id',
        'quote_ruleset_version_id'
    ],
    title: 'QuoteRulesetEvaluationCreate',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationDetailPublicSchema = {
    properties: {
        active_results: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetEvaluationResultDetailPublic'
            },
            title: 'Active Results',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        quote: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuotePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        quote_ruleset_version_id: {
            format: 'uuid',
            title: 'Quote Ruleset Version Id',
            type: 'string'
        },
        ruleset: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteRulesetPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        version: {
            $ref: '#/components/schemas/QuoteRulesetEvaluationVersionPublic'
        }
    },
    required: [
        'id',
        'tenant_id',
        'quote_id',
        'quote_ruleset_version_id',
        'created_at',
        'version',
        'active_results'
    ],
    title: 'QuoteRulesetEvaluationDetailPublic',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationPendingRulesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetVersionRulePublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuoteRulesetEvaluationPendingRulesPublic',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        quote_ruleset_version_id: {
            format: 'uuid',
            title: 'Quote Ruleset Version Id',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'quote_id',
        'quote_ruleset_version_id',
        'created_at'
    ],
    title: 'QuoteRulesetEvaluationPublic',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationResultCreateSchema = {
    properties: {
        justification: {
            title: 'Justification',
            type: 'string'
        },
        quote_ruleset_version_rule_id: {
            format: 'uuid',
            title: 'Quote Ruleset Version Rule Id',
            type: 'string'
        },
        references: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetEvaluationResultReferenceCreate'
            },
            title: 'References',
            type: 'array'
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetEvaluationResultTaskCreate'
            },
            title: 'Tasks',
            type: 'array'
        },
        verdict: {
            $ref: '#/components/schemas/RuleVerdict'
        }
    },
    required: [
        'quote_ruleset_version_rule_id',
        'verdict',
        'justification'
    ],
    title: 'QuoteRulesetEvaluationResultCreate',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationResultDetailPublicSchema = {
    properties: {
        active_document_references: {
            items: {
                $ref: '#/components/schemas/DocumentReferencePublic'
            },
            title: 'Active Document References',
            type: 'array'
        },
        active_tasks: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetEvaluationResultTaskPublic'
            },
            title: 'Active Tasks',
            type: 'array'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        justification: {
            title: 'Justification',
            type: 'string'
        },
        quote_ruleset_evaluation_id: {
            format: 'uuid',
            title: 'Quote Ruleset Evaluation Id',
            type: 'string'
        },
        quote_ruleset_version_rule_id: {
            format: 'uuid',
            title: 'Quote Ruleset Version Rule Id',
            type: 'string'
        },
        verdict: {
            $ref: '#/components/schemas/RuleVerdict'
        }
    },
    required: [
        'id',
        'quote_ruleset_evaluation_id',
        'quote_ruleset_version_rule_id',
        'verdict',
        'justification',
        'active_tasks',
        'active_document_references'
    ],
    title: 'QuoteRulesetEvaluationResultDetailPublic',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationResultReferenceCreateSchema = {
    properties: {
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        },
        value: {
            $ref: '#/components/schemas/DocumentReferenceValue'
        }
    },
    required: [
        'document_id',
        'value'
    ],
    title: 'QuoteRulesetEvaluationResultReferenceCreate',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationResultTaskCreateSchema = {
    properties: {
        justification: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Justification'
        },
        quote_task_charge_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Charge Id'
        },
        quote_task_id: {
            format: 'uuid',
            title: 'Quote Task Id',
            type: 'string'
        }
    },
    required: [
        'quote_task_id'
    ],
    title: 'QuoteRulesetEvaluationResultTaskCreate',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationResultTaskPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        justification: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Justification'
        },
        quote_ruleset_evaluation_result_id: {
            format: 'uuid',
            title: 'Quote Ruleset Evaluation Result Id',
            type: 'string'
        },
        quote_task_charge_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Charge Id'
        },
        quote_task_id: {
            format: 'uuid',
            title: 'Quote Task Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'quote_ruleset_evaluation_result_id',
        'quote_task_id'
    ],
    title: 'QuoteRulesetEvaluationResultTaskPublic',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationVersionPublicSchema = {
    properties: {
        active_rules: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetVersionRulePublic'
            },
            title: 'Active Rules',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        number: {
            title: 'Number',
            type: 'integer'
        },
        quote_ruleset_id: {
            format: 'uuid',
            title: 'Quote Ruleset Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'quote_ruleset_id',
        'number',
        'created_at',
        'active_rules'
    ],
    title: 'QuoteRulesetEvaluationVersionPublic',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationsCreateSchema = {
    properties: {
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        }
    },
    required: [
        'quote_id'
    ],
    title: 'QuoteRulesetEvaluationsCreate',
    type: 'object'
} as const;

export const QuoteRulesetEvaluationsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetEvaluationDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuoteRulesetEvaluationsPublic',
    type: 'object'
} as const;

export const QuoteRulesetPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'name',
        'created_at',
        'updated_at'
    ],
    title: 'QuoteRulesetPublic',
    type: 'object'
} as const;

export const QuoteRulesetUpdateSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    title: 'QuoteRulesetUpdate',
    type: 'object'
} as const;

export const QuoteRulesetVersionApplicabilityDetailPublicSchema = {
    properties: {
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        part: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        quote_ruleset_version_id: {
            format: 'uuid',
            title: 'Quote Ruleset Version Id',
            type: 'string'
        },
        subject: {
            enum: [
                'aircraft',
                'customer',
                'part'
            ],
            readOnly: true,
            title: 'Subject',
            type: 'string'
        },
        type_certificate_model_variant: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TypeCertificateModelVariantPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        type_certificate_model_variant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Type Certificate Model Variant Id'
        }
    },
    required: [
        'id',
        'quote_ruleset_version_id',
        'type_certificate_model_variant',
        'customer',
        'part',
        'subject'
    ],
    title: 'QuoteRulesetVersionApplicabilityDetailPublic',
    type: 'object'
} as const;

export const QuoteRulesetVersionCreateSchema = {
    properties: {
        applicability: {
            items: {
                discriminator: {
                    mapping: {
                        aircraft: '#/components/schemas/AircraftApplicabilityCreate',
                        customer: '#/components/schemas/CustomerApplicabilityCreate',
                        part: '#/components/schemas/PartApplicabilityCreate'
                    },
                    propertyName: 'subject'
                },
                oneOf: [
                    {
                        $ref: '#/components/schemas/AircraftApplicabilityCreate'
                    },
                    {
                        $ref: '#/components/schemas/CustomerApplicabilityCreate'
                    },
                    {
                        $ref: '#/components/schemas/PartApplicabilityCreate'
                    }
                ]
            },
            title: 'Applicability',
            type: 'array'
        },
        previous_version_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Previous Version Id'
        },
        rules: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetVersionRuleCreate'
            },
            minItems: 1,
            title: 'Rules',
            type: 'array'
        }
    },
    required: [
        'rules'
    ],
    title: 'QuoteRulesetVersionCreate',
    type: 'object'
} as const;

export const QuoteRulesetVersionDetailPublicSchema = {
    properties: {
        active_applicability: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetVersionApplicabilityDetailPublic'
            },
            title: 'Active Applicability',
            type: 'array'
        },
        active_rules: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetVersionRulePublic'
            },
            title: 'Active Rules',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        number: {
            title: 'Number',
            type: 'integer'
        },
        quote_ruleset_id: {
            format: 'uuid',
            title: 'Quote Ruleset Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'quote_ruleset_id',
        'number',
        'created_at',
        'last_modified_by',
        'active_rules',
        'active_applicability'
    ],
    title: 'QuoteRulesetVersionDetailPublic',
    type: 'object'
} as const;

export const QuoteRulesetVersionRuleCreateSchema = {
    properties: {
        content: {
            minLength: 1,
            title: 'Content',
            type: 'string'
        },
        lineage_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lineage Id'
        },
        position: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        }
    },
    required: [
        'content'
    ],
    title: 'QuoteRulesetVersionRuleCreate',
    type: 'object'
} as const;

export const QuoteRulesetVersionRulePublicSchema = {
    properties: {
        content: {
            title: 'Content',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        lineage_id: {
            format: 'uuid',
            title: 'Lineage Id',
            type: 'string'
        },
        position: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        },
        quote_ruleset_version_id: {
            format: 'uuid',
            title: 'Quote Ruleset Version Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'quote_ruleset_version_id',
        'content',
        'lineage_id',
        'created_at'
    ],
    title: 'QuoteRulesetVersionRulePublic',
    type: 'object'
} as const;

export const QuoteRulesetVersionsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetVersionDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuoteRulesetVersionsPublic',
    type: 'object'
} as const;

export const QuoteRulesetsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteRulesetDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuoteRulesetsPublic',
    type: 'object'
} as const;

export const QuoteSendDetailsSchema = {
    properties: {
        cc: {
            items: {
                format: 'email',
                type: 'string'
            },
            title: 'Cc',
            type: 'array'
        },
        delivery: {
            $ref: '#/components/schemas/QuoteDelivery',
            default: 'manual'
        },
        message: {
            minLength: 1,
            title: 'Message',
            type: 'string'
        },
        subject: {
            minLength: 1,
            title: 'Subject',
            type: 'string'
        },
        to: {
            items: {
                format: 'email',
                type: 'string'
            },
            minItems: 1,
            title: 'To',
            type: 'array'
        }
    },
    required: [
        'to',
        'subject',
        'message'
    ],
    title: 'QuoteSendDetails',
    type: 'object'
} as const;

export const QuoteSortSchema = {
    enum: [
        'number',
        'customer',
        'asset',
        'title',
        'total',
        'outcome',
        'revision',
        'work_order',
        'department',
        'valid_until',
        'sales_rep',
        'created',
        'updated'
    ],
    title: 'QuoteSort',
    type: 'string'
} as const;

export const QuoteStagePublicSchema = {
    properties: {
        disposition: {
            $ref: '#/components/schemas/QuoteDispositionKind'
        },
        tally: {
            $ref: '#/components/schemas/QuoteTallyPublic'
        }
    },
    required: [
        'disposition',
        'tally'
    ],
    title: 'QuoteStagePublic',
    type: 'object'
} as const;

export const QuoteStatusSchema = {
    enum: [
        'draft',
        'completed'
    ],
    title: 'QuoteStatus',
    type: 'string'
} as const;

export const QuoteTallyPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        parts_cost: {
            title: 'Parts Cost',
            type: 'string'
        },
        parts_sale: {
            title: 'Parts Sale',
            type: 'string'
        },
        totals: {
            items: {
                $ref: '#/components/schemas/CurrencyAmount'
            },
            title: 'Totals',
            type: 'array'
        }
    },
    required: [
        'count',
        'totals',
        'parts_sale',
        'parts_cost'
    ],
    title: 'QuoteTallyPublic',
    type: 'object'
} as const;

export const QuoteTaskBaseSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/QuoteTaskChargeUpsert'
            },
            title: 'Charges',
            type: 'array'
        },
        description: {
            default: '',
            title: 'Description',
            type: 'string'
        },
        due_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteTaskDueStatusUpsert'
                },
                {
                    type: 'null'
                }
            ]
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'charges'
    ],
    title: 'QuoteTaskBase',
    type: 'object'
} as const;

export const QuoteTaskChargePublicSchema = {
    properties: {
        active_document_references: {
            items: {
                $ref: '#/components/schemas/DocumentReferencePublic'
            },
            title: 'Active Document References',
            type: 'array'
        },
        cost_quantity: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost Quantity'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        estimate_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        lead_time: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        part_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        turnaround_time: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Turnaround Time'
        },
        type: {
            $ref: '#/components/schemas/ChargeType'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        vendor_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Id'
        }
    },
    required: [
        'id',
        'description',
        'type',
        'part_number',
        'purchase_unit_price',
        'sale_unit_price',
        'currency',
        'quantity',
        'unit_of_measure',
        'tax_amount',
        'lead_time',
        'turnaround_time',
        'estimate_kind',
        'cost_quantity',
        'vendor_id',
        'created_at',
        'updated_at',
        'deleted_at',
        'active_document_references'
    ],
    title: 'QuoteTaskChargePublic',
    type: 'object'
} as const;

export const QuoteTaskChargeUpsertSchema = {
    properties: {
        cost_quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost Quantity'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        estimate_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        lead_time: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        part_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        type: {
            $ref: '#/components/schemas/ChargeType'
        },
        unit_of_measure: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'type'
    ],
    title: 'QuoteTaskChargeUpsert',
    type: 'object'
} as const;

export const QuoteTaskCommentCountPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        quote_task_id: {
            format: 'uuid',
            title: 'Quote Task Id',
            type: 'string'
        }
    },
    required: [
        'quote_task_id',
        'count'
    ],
    title: 'QuoteTaskCommentCountPublic',
    type: 'object'
} as const;

export const QuoteTaskDetailPublicSchema = {
    properties: {
        active_charges: {
            items: {
                $ref: '#/components/schemas/QuoteTaskChargePublic'
            },
            title: 'Active Charges',
            type: 'array'
        },
        active_document_references: {
            items: {
                $ref: '#/components/schemas/DocumentReferencePublic'
            },
            title: 'Active Document References',
            type: 'array'
        },
        active_due_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteTaskDueStatusPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        active_steps: {
            items: {
                $ref: '#/components/schemas/QuoteTaskStepPublic'
            },
            title: 'Active Steps',
            type: 'array'
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        awarded_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        canned_work_task: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CannedWorkTaskPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        canned_work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Task Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        due_outlook: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DueOutlook'
                },
                {
                    type: 'null'
                }
            ]
        },
        history_count: {
            default: 0,
            title: 'History Count',
            type: 'integer'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        manual_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        original_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original Description'
        },
        part: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        phase_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Phase Ids',
            type: 'array'
        },
        resolution: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            $ref: '#/components/schemas/QuoteTaskStatus'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'status',
        'number',
        'description',
        'original_description',
        'severity',
        'canned_work_task_id',
        'part_id',
        'task_group_id',
        'department_id',
        'phase_ids',
        'manual_reference',
        'resolution',
        'ata_chapter',
        'ata_subchapter',
        'ata_zone',
        'awarded_kind',
        'created_by_id',
        'created_at',
        'updated_at',
        'deleted_at',
        'canned_work_task',
        'part',
        'active_charges',
        'active_document_references',
        'active_due_status',
        'active_steps'
    ],
    title: 'QuoteTaskDetailPublic',
    type: 'object'
} as const;

export const QuoteTaskDocumentDownloadUrlSchema = {
    properties: {
        download_url: {
            title: 'Download Url',
            type: 'string'
        }
    },
    required: [
        'download_url'
    ],
    title: 'QuoteTaskDocumentDownloadUrl',
    type: 'object'
} as const;

export const QuoteTaskDocumentWithDownloadUrlSchema = {
    properties: {
        active_airworthiness_directive: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentAirworthinessDirectivePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        active_attributes: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentAttributesPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        canonical_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canonical Document Id'
        },
        content_type: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content Type'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        download_url: {
            title: 'Download Url',
            type: 'string'
        },
        file_name: {
            title: 'File Name',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        links: {
            default: [],
            items: {
                $ref: '#/components/schemas/DocumentLinkPublic'
            },
            title: 'Links',
            type: 'array'
        },
        owner_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Id'
        },
        search: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentSearchInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        thumbnail_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thumbnail Url'
        },
        upload_result: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentUploadResult'
                },
                {
                    type: 'null'
                }
            ]
        },
        used_by: {
            default: [],
            items: {
                $ref: '#/components/schemas/UserBasicInfo'
            },
            title: 'Used By',
            type: 'array'
        },
        visibility: {
            $ref: '#/components/schemas/Visibility'
        }
    },
    required: [
        'id',
        'file_name',
        'content_type',
        'visibility',
        'owner_id',
        'created_at',
        'deleted_at',
        'archived_at',
        'download_url'
    ],
    title: 'QuoteTaskDocumentWithDownloadUrl',
    type: 'object'
} as const;

export const QuoteTaskDueLimitPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        due_at: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        remaining: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Remaining'
        },
        unit: {
            $ref: '#/components/schemas/DueUnit'
        }
    },
    required: [
        'id',
        'unit',
        'due_at',
        'remaining',
        'created_at',
        'deleted_at'
    ],
    title: 'QuoteTaskDueLimitPublic',
    type: 'object'
} as const;

export const QuoteTaskDueLimitUpsertSchema = {
    properties: {
        due_at: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due At'
        },
        remaining: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Remaining'
        },
        unit: {
            $ref: '#/components/schemas/DueUnit'
        }
    },
    required: [
        'unit'
    ],
    title: 'QuoteTaskDueLimitUpsert',
    type: 'object'
} as const;

export const QuoteTaskDueStatusPublicSchema = {
    properties: {
        active_limits: {
            items: {
                $ref: '#/components/schemas/QuoteTaskDueLimitPublic'
            },
            title: 'Active Limits',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_overdue: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Overdue'
        },
        raw: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Raw'
        }
    },
    required: [
        'id',
        'is_overdue',
        'raw',
        'created_at',
        'deleted_at',
        'active_limits'
    ],
    title: 'QuoteTaskDueStatusPublic',
    type: 'object'
} as const;

export const QuoteTaskDueStatusUpsertSchema = {
    properties: {
        is_overdue: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Overdue'
        },
        limits: {
            items: {
                $ref: '#/components/schemas/QuoteTaskDueLimitUpsert'
            },
            title: 'Limits',
            type: 'array'
        },
        raw: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Raw'
        }
    },
    title: 'QuoteTaskDueStatusUpsert',
    type: 'object'
} as const;

export const QuoteTaskExtractionAcceptedSchema = {
    properties: {
        status: {
            const: 'scheduled',
            default: 'scheduled',
            title: 'Status',
            type: 'string'
        }
    },
    title: 'QuoteTaskExtractionAccepted',
    type: 'object'
} as const;

export const QuoteTaskExtractionCreateSchema = {
    properties: {
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        },
        output: {
            $ref: '#/components/schemas/ExtractionOutput',
            default: 'tasks'
        },
        scope: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Scope'
        },
        sheets: {
            items: {
                type: 'string'
            },
            title: 'Sheets',
            type: 'array'
        }
    },
    required: [
        'document_id'
    ],
    title: 'QuoteTaskExtractionCreate',
    type: 'object'
} as const;

export const QuoteTaskGroupCreateSchema = {
    properties: {
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        position: {
            maximum: 32767,
            minimum: 0,
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'name',
        'position'
    ],
    title: 'QuoteTaskGroupCreate',
    type: 'object'
} as const;

export const QuoteTaskGroupOrderSchema = {
    properties: {
        group_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Group Ids',
            type: 'array'
        }
    },
    required: [
        'group_ids'
    ],
    title: 'QuoteTaskGroupOrder',
    type: 'object'
} as const;

export const QuoteTaskGroupPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'name',
        'position',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at'
    ],
    title: 'QuoteTaskGroupPublic',
    type: 'object'
} as const;

export const QuoteTaskGroupUpdateSchema = {
    properties: {
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        position: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        }
    },
    title: 'QuoteTaskGroupUpdate',
    type: 'object'
} as const;

export const QuoteTaskGroupsCreateSchema = {
    properties: {
        names: {
            items: {
                maxLength: 255,
                minLength: 1,
                type: 'string'
            },
            maxItems: 100,
            minItems: 1,
            title: 'Names',
            type: 'array'
        }
    },
    required: [
        'names'
    ],
    title: 'QuoteTaskGroupsCreate',
    type: 'object'
} as const;

export const QuoteTaskGroupsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteTaskGroupPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'QuoteTaskGroupsPublic',
    type: 'object'
} as const;

export const QuoteTaskLinkPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'quote_id',
        'number'
    ],
    title: 'QuoteTaskLinkPublic',
    type: 'object'
} as const;

export const QuoteTaskPublicSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        awarded_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        canned_work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canned Work Task Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        manual_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        original_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original Description'
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        phase_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Phase Ids',
            type: 'array'
        },
        resolution: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            $ref: '#/components/schemas/QuoteTaskStatus'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'status',
        'number',
        'description',
        'original_description',
        'severity',
        'canned_work_task_id',
        'part_id',
        'task_group_id',
        'department_id',
        'phase_ids',
        'manual_reference',
        'resolution',
        'ata_chapter',
        'ata_subchapter',
        'ata_zone',
        'awarded_kind',
        'created_by_id',
        'created_at',
        'updated_at',
        'deleted_at'
    ],
    title: 'QuoteTaskPublic',
    type: 'object'
} as const;

export const QuoteTaskReviewSchema = {
    properties: {
        comment: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Comment'
        },
        decision: {
            $ref: '#/components/schemas/TaskReviewDecision'
        },
        task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Task Ids',
            type: 'array'
        }
    },
    required: [
        'task_ids',
        'decision'
    ],
    title: 'QuoteTaskReview',
    type: 'object'
} as const;

export const QuoteTaskReviewUndoSchema = {
    properties: {
        task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Task Ids',
            type: 'array'
        }
    },
    required: [
        'task_ids'
    ],
    title: 'QuoteTaskReviewUndo',
    type: 'object'
} as const;

export const QuoteTaskStatusSchema = {
    enum: [
        'draft',
        'ready',
        'ready_for_customer',
        'approved',
        'rejected',
        'clarification_requested',
        'excluded'
    ],
    title: 'QuoteTaskStatus',
    type: 'string'
} as const;

export const QuoteTaskStatusesChangedEventSchema = {
    properties: {
        numbers: {
            items: {
                type: 'string'
            },
            title: 'Numbers',
            type: 'array'
        },
        status: {
            $ref: '#/components/schemas/QuoteTaskStatus'
        },
        type: {
            const: 'task_statuses_changed',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'status',
        'numbers'
    ],
    title: 'QuoteTaskStatusesChangedEvent',
    type: 'object'
} as const;

export const QuoteTaskStepCreateSchema = {
    properties: {
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        parent_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Step Id'
        }
    },
    required: [
        'description'
    ],
    title: 'QuoteTaskStepCreate',
    type: 'object'
} as const;

export const QuoteTaskStepPublicSchema = {
    properties: {
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        inspection_required: {
            title: 'Inspection Required',
            type: 'boolean'
        },
        parent_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Step Id'
        },
        position: {
            title: 'Position',
            type: 'integer'
        },
        quote_task_id: {
            format: 'uuid',
            title: 'Quote Task Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'quote_task_id',
        'parent_step_id',
        'position',
        'description',
        'inspection_required'
    ],
    title: 'QuoteTaskStepPublic',
    type: 'object'
} as const;

export const QuoteTaskStepUpdateSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        inspection_required: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inspection Required'
        }
    },
    title: 'QuoteTaskStepUpdate',
    type: 'object'
} as const;

export const QuoteTasksAddedEventSchema = {
    properties: {
        numbers: {
            items: {
                type: 'string'
            },
            title: 'Numbers',
            type: 'array'
        },
        type: {
            const: 'tasks_added',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'numbers'
    ],
    title: 'QuoteTasksAddedEvent',
    type: 'object'
} as const;

export const QuoteTasksMergedEventSchema = {
    properties: {
        into: {
            title: 'Into',
            type: 'string'
        },
        numbers: {
            items: {
                type: 'string'
            },
            title: 'Numbers',
            type: 'array'
        },
        type: {
            const: 'tasks_merged',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'numbers',
        'into'
    ],
    title: 'QuoteTasksMergedEvent',
    type: 'object'
} as const;

export const QuoteTasksRemovedEventSchema = {
    properties: {
        numbers: {
            items: {
                type: 'string'
            },
            title: 'Numbers',
            type: 'array'
        },
        type: {
            const: 'tasks_removed',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'numbers'
    ],
    title: 'QuoteTasksRemovedEvent',
    type: 'object'
} as const;

export const QuoteTasksReviewedEventSchema = {
    properties: {
        decision: {
            $ref: '#/components/schemas/TaskReviewDecision'
        },
        numbers: {
            items: {
                type: 'string'
            },
            title: 'Numbers',
            type: 'array'
        },
        task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Task Ids',
            type: 'array'
        },
        type: {
            const: 'tasks_reviewed',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'decision',
        'task_ids',
        'numbers'
    ],
    title: 'QuoteTasksReviewedEvent',
    type: 'object'
} as const;

export const QuoteTaxClassPublicSchema = {
    properties: {
        managed: {
            title: 'Managed',
            type: 'boolean'
        },
        manual_rate: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Rate'
        },
        options: {
            items: {
                $ref: '#/components/schemas/TaxRatePublic'
            },
            title: 'Options',
            type: 'array'
        },
        rate: {
            title: 'Rate',
            type: 'string'
        },
        tax_class: {
            $ref: '#/components/schemas/TaxClass'
        },
        tax_rate: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaxRatePublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'tax_class',
        'managed',
        'rate',
        'tax_rate',
        'manual_rate',
        'options'
    ],
    title: 'QuoteTaxClassPublic',
    type: 'object'
} as const;

export const QuoteTaxPublicSchema = {
    properties: {
        classes: {
            items: {
                $ref: '#/components/schemas/QuoteTaxClassPublic'
            },
            title: 'Classes',
            type: 'array'
        },
        destination: {
            $ref: '#/components/schemas/TaxDestination'
        },
        exempt: {
            title: 'Exempt',
            type: 'boolean'
        },
        jurisdiction: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaxJurisdictionPublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'exempt',
        'destination',
        'jurisdiction',
        'classes'
    ],
    title: 'QuoteTaxPublic',
    type: 'object'
} as const;

export const QuoteUpdateSchema = {
    properties: {
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        tasks: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/ExternalQuoteTaskUpsert'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tasks'
        }
    },
    title: 'QuoteUpdate',
    type: 'object'
} as const;

export const QuoteWithParentPublicSchema = {
    properties: {
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        attention_count: {
            default: 0,
            title: 'Attention Count',
            type: 'integer'
        },
        auto_expire: {
            title: 'Auto Expire',
            type: 'boolean'
        },
        billing_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Billing Address Id'
        },
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        crm_deal_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Crm Deal Id'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        customer_review: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteCustomerReviewPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DepartmentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        disposition: {
            $ref: '#/components/schemas/QuoteDispositionKind'
        },
        due_horizon_from: {
            $ref: '#/components/schemas/DueHorizonFrom'
        },
        due_horizon_months: {
            title: 'Due Horizon Months',
            type: 'integer'
        },
        estimated_close_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Close On'
        },
        estimator_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimator Id'
        },
        expected_arrival_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Arrival At'
        },
        expected_departure_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Departure At'
        },
        expected_finish_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Finish At'
        },
        expected_start_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Start At'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/QuoteKind'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        outcome_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outcome Reason'
        },
        part_instance: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartInstancePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        parts: {
            items: {
                $ref: '#/components/schemas/PartPublic'
            },
            title: 'Parts',
            type: 'array'
        },
        promised_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised On'
        },
        rate_card_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rate Card Id'
        },
        requested_delivery_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested Delivery On'
        },
        requested_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested On'
        },
        review_token: {
            title: 'Review Token',
            type: 'string'
        },
        review_url: {
            readOnly: true,
            title: 'Review Url',
            type: 'string'
        },
        revision: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        sales_region: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Region'
        },
        sales_rep: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        sales_rep_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Rep Id'
        },
        salesforce_opportunity_id: {
            anyOf: [
                {
                    pattern: '^[a-zA-Z0-9]{15,18}$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Id'
        },
        salesforce_opportunity_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesforce Opportunity Url'
        },
        shipping_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Shipping Address Id'
        },
        status: {
            $ref: '#/components/schemas/QuoteStatus'
        },
        tax_destination: {
            $ref: '#/components/schemas/TaxDestination'
        },
        tax_exempt: {
            title: 'Tax Exempt',
            type: 'boolean'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        total_estimate_price: {
            items: {
                $ref: '#/components/schemas/CurrencyAmount'
            },
            title: 'Total Estimate Price',
            type: 'array'
        },
        total_labour_hours: {
            default: '0',
            title: 'Total Labour Hours',
            type: 'string'
        },
        total_labour_price: {
            items: {
                $ref: '#/components/schemas/CurrencyAmount'
            },
            title: 'Total Labour Price',
            type: 'array'
        },
        total_misc_price: {
            items: {
                $ref: '#/components/schemas/CurrencyAmount'
            },
            title: 'Total Misc Price',
            type: 'array'
        },
        total_parts_price: {
            items: {
                $ref: '#/components/schemas/CurrencyAmount'
            },
            title: 'Total Parts Price',
            type: 'array'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        updated_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        valid_until: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Valid Until'
        },
        win_probability: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Win Probability'
        },
        work_package: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageBase'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'id',
        'number',
        'title',
        'kind',
        'crm_deal_id',
        'salesforce_opportunity_id',
        'salesforce_opportunity_url',
        'status',
        'disposition',
        'outcome_reason',
        'customer_id',
        'aircraft_id',
        'work_package_id',
        'department_id',
        'created_by_id',
        'estimator_id',
        'sales_rep_id',
        'sales_region',
        'contact_id',
        'billing_address_id',
        'shipping_address_id',
        'rate_card_id',
        'facility_id',
        'expected_arrival_at',
        'expected_departure_at',
        'expected_start_at',
        'expected_finish_at',
        'valid_until',
        'auto_expire',
        'requested_on',
        'promised_on',
        'requested_delivery_on',
        'estimated_close_on',
        'win_probability',
        'due_horizon_months',
        'due_horizon_from',
        'tax_exempt',
        'tax_destination',
        'currency',
        'review_token',
        'created_at',
        'deleted_at',
        'archived_at',
        'updated_at',
        'review_url'
    ],
    title: 'QuoteWithParentPublic',
    type: 'object'
} as const;

export const QuotesImportSchema = {
    properties: {
        quotes: {
            items: {
                $ref: '#/components/schemas/ImportedQuote'
            },
            minItems: 1,
            title: 'Quotes',
            type: 'array'
        },
        tenant_erp_config_id: {
            format: 'uuid',
            title: 'Tenant Erp Config Id',
            type: 'string'
        },
        tenant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Id'
        }
    },
    required: [
        'tenant_erp_config_id',
        'quotes'
    ],
    title: 'QuotesImport',
    type: 'object'
} as const;

export const QuotesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/QuoteWithParentPublic'
            },
            title: 'Data',
            type: 'array'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/QuoteGroupPublic'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'data',
        'count',
        'groups'
    ],
    title: 'QuotesPublic',
    type: 'object'
} as const;

export const RangeSchema = {
    additionalProperties: false,
    properties: {
        from: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'From'
        },
        in: {
            default: [],
            items: {
                type: 'string'
            },
            title: 'In',
            type: 'array'
        },
        to: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'To'
        }
    },
    title: 'Range',
    type: 'object'
} as const;

export const RangeConditionSchema = {
    additionalProperties: false,
    properties: {
        op: {
            const: 'serial',
            title: 'Op',
            type: 'string'
        },
        range: {
            $ref: '#/components/schemas/Range'
        }
    },
    required: [
        'op',
        'range'
    ],
    title: 'RangeCondition',
    type: 'object'
} as const;

export const RateCardCreateSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Amount'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        type_certificate_model_variant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Type Certificate Model Variant Id'
        }
    },
    required: [
        'name',
        'currency',
        'amount'
    ],
    title: 'RateCardCreate',
    type: 'object'
} as const;

export const RateCardDetailPublicSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        type_certificate_model_variant: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TypeCertificateModelVariantPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        type_certificate_model_variant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Type Certificate Model Variant Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'name',
        'currency',
        'amount',
        'customer_id',
        'type_certificate_model_variant_id',
        'created_at',
        'updated_at',
        'created_by_id',
        'last_modified_by_id',
        'deleted_at',
        'customer',
        'type_certificate_model_variant',
        'created_by',
        'last_modified_by'
    ],
    title: 'RateCardDetailPublic',
    type: 'object'
} as const;

export const RateCardPublicSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        type_certificate_model_variant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Type Certificate Model Variant Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'name',
        'currency',
        'amount',
        'customer_id',
        'type_certificate_model_variant_id',
        'created_at',
        'updated_at',
        'created_by_id',
        'last_modified_by_id',
        'deleted_at'
    ],
    title: 'RateCardPublic',
    type: 'object'
} as const;

export const RateCardUpdateSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amount'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        type_certificate_model_variant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Type Certificate Model Variant Id'
        }
    },
    title: 'RateCardUpdate',
    type: 'object'
} as const;

export const RateCardsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/RateCardDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'RateCardsPublic',
    type: 'object'
} as const;

export const RateSourceSchema = {
    enum: [
        'average',
        'planned',
        'none'
    ],
    title: 'RateSource',
    type: 'string'
} as const;

export const ReasonForRemovalSchema = {
    enum: [
        'Scheduled - Expiration Life',
        'Scheduled - Service',
        'Unscheduled Failures - Damaged',
        'Unscheduled Failures - Failure',
        'Unscheduled Failures - Leak',
        'Unscheduled Failures - Test Failed',
        'Unscheduled Failures - Worn',
        'Unscheduled Others - Convenience',
        'Unscheduled Others - Loaner',
        'Unscheduled Others - Swap',
        'Unscheduled Others - Troubleshooting'
    ],
    title: 'ReasonForRemoval',
    type: 'string'
} as const;

export const ReceiveOutsideServiceSchema = {
    properties: {
        action: {
            const: 'receive',
            title: 'Action',
            type: 'string'
        },
        note: {
            anyOf: [
                {
                    maxLength: 4000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        }
    },
    required: [
        'action'
    ],
    title: 'ReceiveOutsideService',
    type: 'object'
} as const;

export const RecipientKindSchema = {
    enum: [
        'to',
        'cc'
    ],
    title: 'RecipientKind',
    type: 'string'
} as const;

export const RecordCalibrationSchema = {
    properties: {
        certificate_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certificate Document Id'
        },
        certificate_number: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certificate Number'
        },
        kind: {
            const: 'record',
            title: 'Kind',
            type: 'string'
        },
        performed_by: {
            maxLength: 2000,
            minLength: 1,
            title: 'Performed By',
            type: 'string'
        },
        performed_on: {
            format: 'date',
            title: 'Performed On',
            type: 'string'
        },
        result: {
            $ref: '#/components/schemas/ToolCalibrationResult'
        }
    },
    required: [
        'kind',
        'performed_by',
        'performed_on',
        'result'
    ],
    title: 'RecordCalibration',
    type: 'object'
} as const;

export const RecordRoleAudienceSchema = {
    additionalProperties: false,
    properties: {
        kind: {
            const: 'record_role',
            title: 'Kind',
            type: 'string'
        },
        record_role: {
            $ref: '#/components/schemas/NotificationRecordRole'
        }
    },
    required: [
        'kind',
        'record_role'
    ],
    title: 'RecordRoleAudience',
    type: 'object'
} as const;

export const RectificationCategorySchema = {
    enum: [
        'a',
        'b',
        'c',
        'd'
    ],
    title: 'RectificationCategory',
    type: 'string'
} as const;

export const RectificationUnitSchema = {
    enum: [
        'calendar_days',
        'flight_days',
        'flight_hours',
        'flight_cycles'
    ],
    title: 'RectificationUnit',
    type: 'string'
} as const;

export const ReferenceKindSchema = {
    enum: [
        'procedure',
        'source',
        'ad',
        'sb',
        'credits_task',
        'covered_by',
        'alternative_to',
        'other'
    ],
    title: 'ReferenceKind',
    type: 'string'
} as const;

export const RegistryConditionSchema = {
    additionalProperties: false,
    properties: {
        in: {
            items: {
                type: 'string'
            },
            minItems: 1,
            title: 'In',
            type: 'array'
        },
        op: {
            const: 'registry',
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'in'
    ],
    title: 'RegistryCondition',
    type: 'object'
} as const;

export const RegulatoryAuthoritySchema = {
    enum: [
        'FAA',
        'EASA',
        'CASA',
        'TCCA',
        'CAA-UK',
        'ANAC',
        'OTHER'
    ],
    title: 'RegulatoryAuthority',
    type: 'string'
} as const;

export const ReinstallOutsideServiceSchema = {
    properties: {
        action: {
            const: 'reinstall',
            title: 'Action',
            type: 'string'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/OutsideServiceCheck'
            },
            title: 'Checks',
            type: 'array'
        },
        note: {
            anyOf: [
                {
                    maxLength: 4000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        serial_number: {
            maxLength: 200,
            minLength: 1,
            title: 'Serial Number',
            type: 'string'
        }
    },
    required: [
        'checks',
        'action',
        'serial_number'
    ],
    title: 'ReinstallOutsideService',
    type: 'object'
} as const;

export const RelativePositionAudienceSchema = {
    additionalProperties: false,
    properties: {
        kind: {
            const: 'relative_position',
            title: 'Kind',
            type: 'string'
        },
        position_name: {
            maxLength: 255,
            minLength: 1,
            title: 'Position Name',
            type: 'string'
        },
        scope: {
            $ref: '#/components/schemas/AudienceScope'
        }
    },
    required: [
        'kind',
        'position_name',
        'scope'
    ],
    title: 'RelativePositionAudience',
    type: 'object'
} as const;

export const ReleaseCertificateSchema = {
    enum: [
        'faa_8130_3',
        'easa_form_1',
        'certificate_of_conformity'
    ],
    title: 'ReleaseCertificate',
    type: 'string'
} as const;

export const RemoveChargeSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveCharge',
    type: 'object'
} as const;

export const RemoveCheckSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveCheck',
    type: 'object'
} as const;

export const RemoveComponentChangeSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveComponentChange',
    type: 'object'
} as const;

export const RemoveDefectSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveDefect',
    type: 'object'
} as const;

export const RemoveDiscountSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveDiscount',
    type: 'object'
} as const;

export const RemoveDocumentReferenceSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveDocumentReference',
    type: 'object'
} as const;

export const RemoveFeeSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveFee',
    type: 'object'
} as const;

export const RemoveFluidUpliftSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveFluidUplift',
    type: 'object'
} as const;

export const RemoveLimitSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveLimit',
    type: 'object'
} as const;

export const RemoveProgrammeCheckSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveProgrammeCheck',
    type: 'object'
} as const;

export const RemoveProgrammeTaskSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveProgrammeTask',
    type: 'object'
} as const;

export const RemoveSectorSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveSector',
    type: 'object'
} as const;

export const RemoveSigningPinSchema = {
    properties: {
        current_password: {
            maxLength: 128,
            title: 'Current Password',
            type: 'string'
        }
    },
    required: [
        'current_password'
    ],
    title: 'RemoveSigningPin',
    type: 'object'
} as const;

export const RemoveTaskSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'RemoveTask',
    type: 'object'
} as const;

export const RemoveTaxRateSchema = {
    properties: {
        operation: {
            const: 'remove',
            title: 'Operation',
            type: 'string'
        },
        tax_class: {
            $ref: '#/components/schemas/TaxClass'
        }
    },
    required: [
        'operation',
        'tax_class'
    ],
    title: 'RemoveTaxRate',
    type: 'object'
} as const;

export const RequestOutsideServiceSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    maxLength: 200,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        kind: {
            $ref: '#/components/schemas/OutsideServiceKind'
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        quantity: {
            maximum: 10000,
            minimum: 1,
            title: 'Quantity',
            type: 'integer'
        },
        scope: {
            maxLength: 4000,
            minLength: 1,
            title: 'Scope',
            type: 'string'
        },
        serial_number: {
            anyOf: [
                {
                    maxLength: 200,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        ships_out: {
            title: 'Ships Out',
            type: 'boolean'
        },
        suggested_vendor: {
            anyOf: [
                {
                    maxLength: 200,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Suggested Vendor'
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    required: [
        'kind',
        'quantity',
        'ships_out',
        'scope'
    ],
    title: 'RequestOutsideService',
    type: 'object'
} as const;

export const RequestWorkTaskPartSchema = {
    properties: {
        condition: {
            $ref: '#/components/schemas/PartCondition'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        quantity: {
            maximum: 100000,
            minimum: 1,
            title: 'Quantity',
            type: 'integer'
        },
        reservation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ReservePart'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    required: [
        'part_id',
        'quantity',
        'condition'
    ],
    title: 'RequestWorkTaskPart',
    type: 'object'
} as const;

export const RequisitionLineSchema = {
    properties: {
        locator: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locator'
        },
        part_description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Description'
        },
        part_number: {
            minLength: 1,
            title: 'Part Number',
            type: 'string'
        },
        purchase_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Price'
        },
        quantity: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        }
    },
    required: [
        'part_number'
    ],
    title: 'RequisitionLine',
    type: 'object'
} as const;

export const ReservePartSchema = {
    properties: {
        lock: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartReservationLock'
                },
                {
                    type: 'null'
                }
            ]
        },
        quantity: {
            maximum: 100000,
            minimum: 1,
            title: 'Quantity',
            type: 'integer'
        }
    },
    required: [
        'quantity'
    ],
    title: 'ReservePart',
    type: 'object'
} as const;

export const ReviewDecision_InputSchema = {
    enum: [
        'approved',
        'rejected'
    ],
    type: 'string'
} as const;

export const ReviewDecision_OutputSchema = {
    enum: [
        'approved',
        'rejected'
    ],
    title: 'ReviewDecision',
    type: 'string'
} as const;

export const ReviewStatusSchema = {
    enum: [
        'approved',
        'rejected',
        'pending'
    ],
    title: 'ReviewStatus',
    type: 'string'
} as const;

export const RevisionFieldSchema = {
    enum: [
        'number',
        'document_number',
        'issue',
        'issue_date',
        'change_summary'
    ],
    title: 'RevisionField',
    type: 'string'
} as const;

export const RevisionKindSchema = {
    enum: [
        'internal',
        'customer'
    ],
    title: 'RevisionKind',
    type: 'string'
} as const;

export const RevisionStageSchema = {
    enum: [
        'draft',
        'submitted',
        'scheduled',
        'in_effect'
    ],
    title: 'RevisionStage',
    type: 'string'
} as const;

export const RevisionStatusSchema = {
    enum: [
        'submitted',
        'sent',
        'responded',
        'withdrawn'
    ],
    title: 'RevisionStatus',
    type: 'string'
} as const;

export const RevisionTaskStatusSchema = {
    enum: [
        'pending',
        'approved',
        'rejected',
        'clarification_requested'
    ],
    title: 'RevisionTaskStatus',
    type: 'string'
} as const;

export const RoleAudienceSchema = {
    additionalProperties: false,
    properties: {
        kind: {
            const: 'role',
            title: 'Kind',
            type: 'string'
        },
        role_id: {
            format: 'uuid',
            title: 'Role Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'role_id'
    ],
    title: 'RoleAudience',
    type: 'object'
} as const;

export const RoleCapabilitySchema = {
    enum: [
        'squawk',
        'squawk_management',
        'squawk_review',
        'squawk_sign_off_informational_accepted',
        'squawk_sign_off_informational_rejected',
        'squawk_sign_off_airworthiness_accepted',
        'squawk_sign_off_airworthiness_rejected',
        'work_package',
        'work_task_inspection',
        'work_package_close',
        'work_package_management',
        'work_package_subscription',
        'shop_floor_reporter',
        'tool',
        'time_entry',
        'time_entry_read',
        'team',
        'aircraft',
        'compliance',
        'erp',
        'customer',
        'quoting',
        'quote_review',
        'flat_rate',
        'sales_rep',
        'billing',
        'hubspot'
    ],
    title: 'RoleCapability',
    type: 'string'
} as const;

export const RoleKindSchema = {
    enum: [
        'default',
        'custom'
    ],
    title: 'RoleKind',
    type: 'string'
} as const;

export const RoleLabelPublicSchema = {
    properties: {
        label: {
            title: 'Label',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'name',
        'label'
    ],
    title: 'RoleLabelPublic',
    type: 'object'
} as const;

export const RolePublicSchema = {
    description: 'Schema for public role data.',
    properties: {
        capabilities: {
            items: {
                $ref: '#/components/schemas/RoleCapability'
            },
            title: 'Capabilities',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        description: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_customized: {
            title: 'Is Customized',
            type: 'boolean'
        },
        is_system_role: {
            default: false,
            title: 'Is System Role',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/RoleKind'
        },
        label: {
            readOnly: true,
            title: 'Label',
            type: 'string'
        },
        matches_capabilities: {
            readOnly: true,
            title: 'Matches Capabilities',
            type: 'boolean'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        permissions: {
            items: {
                type: 'string'
            },
            title: 'Permissions',
            type: 'array'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'name',
        'id',
        'tenant_id',
        'kind',
        'capabilities',
        'is_customized',
        'created_at',
        'updated_at',
        'matches_capabilities',
        'label'
    ],
    title: 'RolePublic',
    type: 'object'
} as const;

export const RoleReferenceSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        permissions: {
            items: {
                type: 'string'
            },
            title: 'Permissions',
            type: 'array'
        }
    },
    required: [
        'id',
        'name',
        'permissions'
    ],
    title: 'RoleReference',
    type: 'object'
} as const;

export const RolesPublicSchema = {
    description: 'Schema for list of roles with count.',
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/RolePublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'RolesPublic',
    type: 'object'
} as const;

export const RuleVerdictSchema = {
    enum: [
        'applied',
        'not_applied',
        'not_applicable',
        'cannot_determine'
    ],
    title: 'RuleVerdict',
    type: 'string'
} as const;

export const SBComplianceTypeSchema = {
    enum: [
        'MANDATORY',
        'OPTIONAL',
        'DESIRABLE',
        'RECOMMENDED',
        'IN_ABEYANCE',
        'UNKNOWN'
    ],
    title: 'SBComplianceType',
    type: 'string'
} as const;

export const SalesforceOpportunityPublicSchema = {
    properties: {
        id: {
            pattern: '^[a-zA-Z0-9]{15,18}$',
            title: 'Id',
            type: 'string'
        },
        url: {
            title: 'Url',
            type: 'string'
        }
    },
    required: [
        'id',
        'url'
    ],
    title: 'SalesforceOpportunityPublic',
    type: 'object'
} as const;

export const SamplePreviewRecordSchema = {
    properties: {
        kind: {
            $ref: '#/components/schemas/DocumentKind'
        },
        source: {
            const: 'sample',
            title: 'Source',
            type: 'string'
        }
    },
    required: [
        'source',
        'kind'
    ],
    title: 'SamplePreviewRecord',
    type: 'object'
} as const;

export const SbComplianceExportRequestSchema = {
    properties: {
        assessment_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    maxItems: 1000,
                    minItems: 1,
                    type: 'array',
                    uniqueItems: true
                },
                {
                    type: 'null'
                }
            ],
            title: 'Assessment Ids'
        }
    },
    title: 'SbComplianceExportRequest',
    type: 'object'
} as const;

export const SbComplianceListPublicSchema = {
    description: 'List response for SB Compliance table.',
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/SbComplianceRow'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'SbComplianceListPublic',
    type: 'object'
} as const;

export const SbComplianceRowSchema = {
    description: 'A single row in the SB Compliance table.',
    properties: {
        accepted_at: {
            format: 'date-time',
            title: 'Accepted At',
            type: 'string'
        },
        accepted_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        accepted_by_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accepted By Name'
        },
        aircraft_registration: {
            title: 'Aircraft Registration',
            type: 'string'
        },
        aircraft_serial_no: {
            title: 'Aircraft Serial No',
            type: 'string'
        },
        applicability: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicability'
        },
        compliance: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance'
        },
        concurrent_requirements: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Concurrent Requirements'
        },
        consumables: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Consumables'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        electrical_load_analysis: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Electrical Load Analysis'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        manpower_requirements: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manpower Requirements'
        },
        manuals_publications_affected: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manuals Publications Affected'
        },
        parts_required: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parts Required'
        },
        sb_number: {
            title: 'Sb Number',
            type: 'string'
        },
        sb_title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sb Title'
        },
        tooling_required: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tooling Required'
        },
        trace_sb_eval_report_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Trace Sb Eval Report Id'
        },
        version: {
            title: 'Version',
            type: 'integer'
        },
        weight_and_balance_impact: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Weight And Balance Impact'
        }
    },
    required: [
        'id',
        'sb_number',
        'aircraft_serial_no',
        'aircraft_registration',
        'sb_title',
        'accepted_at',
        'accepted_by_name',
        'accepted_by',
        'version',
        'trace_sb_eval_report_id'
    ],
    title: 'SbComplianceRow',
    type: 'object'
} as const;

export const SbFieldUpdateRequestSchema = {
    description: 'Unified schema for updating any SB evaluation field\'s edited value.',
    properties: {
        edited_value: {
            title: 'Edited Value',
            type: 'string'
        }
    },
    required: [
        'edited_value'
    ],
    title: 'SbFieldUpdateRequest',
    type: 'object'
} as const;

export const Schedule_InputSchema = {
    additionalProperties: false,
    properties: {
        repeat: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Expr-Input'
                },
                {
                    type: 'null'
                }
            ]
        },
        threshold: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Expr-Input'
                },
                {
                    type: 'null'
                }
            ]
        },
        v: {
            const: 1,
            title: 'V',
            type: 'integer'
        }
    },
    required: [
        'v'
    ],
    title: 'Schedule',
    type: 'object'
} as const;

export const Schedule_OutputSchema = {
    additionalProperties: false,
    properties: {
        repeat: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Expr-Output'
                },
                {
                    type: 'null'
                }
            ]
        },
        threshold: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Expr-Output'
                },
                {
                    type: 'null'
                }
            ]
        },
        v: {
            const: 1,
            title: 'V',
            type: 'integer'
        }
    },
    required: [
        'v'
    ],
    title: 'Schedule',
    type: 'object'
} as const;

export const SearchPublicSchema = {
    properties: {
        rows: {
            items: {
                $ref: '#/components/schemas/FoundWorkTaskPublic'
            },
            title: 'Rows',
            type: 'array'
        }
    },
    required: [
        'rows'
    ],
    title: 'SearchPublic',
    type: 'object'
} as const;

export const SearchRequestSchema = {
    properties: {
        description_must: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description Must'
        },
        description_must_not: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description Must Not'
        },
        description_query: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description Query'
        },
        limit: {
            default: 10,
            maximum: 100,
            minimum: 1,
            title: 'Limit',
            type: 'integer'
        },
        model: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Model'
        },
        resolution_must: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution Must'
        },
        resolution_must_not: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution Must Not'
        },
        resolution_query: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution Query'
        }
    },
    title: 'SearchRequest',
    type: 'object'
} as const;

export const SectorOperationSchema = {
    discriminator: {
        mapping: {
            create: '#/components/schemas/CreateSector',
            remove: '#/components/schemas/RemoveSector',
            update: '#/components/schemas/UpdateSector'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateSector'
        },
        {
            $ref: '#/components/schemas/UpdateSector'
        },
        {
            $ref: '#/components/schemas/RemoveSector'
        }
    ]
} as const;

export const SendForCalibrationSchema = {
    properties: {
        expected_back_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Back On'
        },
        kind: {
            const: 'send',
            title: 'Kind',
            type: 'string'
        },
        performed_by: {
            maxLength: 2000,
            minLength: 1,
            title: 'Performed By',
            type: 'string'
        },
        sent_on: {
            format: 'date',
            title: 'Sent On',
            type: 'string'
        }
    },
    required: [
        'kind',
        'performed_by',
        'sent_on'
    ],
    title: 'SendForCalibration',
    type: 'object'
} as const;

export const ServiceBulletinPublicMinimalSchema = {
    description: 'Minimal service bulletin information for display.',
    properties: {
        id: {
            title: 'Id',
            type: 'integer'
        },
        sb_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sb Number'
        },
        sb_title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sb Title'
        }
    },
    required: [
        'id'
    ],
    title: 'ServiceBulletinPublicMinimal',
    type: 'object'
} as const;

export const SessionFreshnessPublicSchema = {
    properties: {
        is_fresh: {
            title: 'Is Fresh',
            type: 'boolean'
        },
        remaining_seconds: {
            title: 'Remaining Seconds',
            type: 'integer'
        }
    },
    required: [
        'is_fresh',
        'remaining_seconds'
    ],
    title: 'SessionFreshnessPublic',
    type: 'object'
} as const;

export const SetAvrefPriceSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Amount'
        }
    },
    required: [
        'amount'
    ],
    title: 'SetAvrefPrice',
    type: 'object'
} as const;

export const SetChargeSchema = {
    properties: {
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        document_references: {
            items: {
                $ref: '#/components/schemas/CreateDocumentReference'
            },
            title: 'Document References',
            type: 'array'
        },
        estimate_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        },
        lead_time: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        operation: {
            const: 'set',
            title: 'Operation',
            type: 'string'
        },
        quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        type: {
            $ref: '#/components/schemas/ChargeType'
        },
        unit_of_measure: {
            minLength: 1,
            title: 'Unit Of Measure',
            type: 'string'
        }
    },
    required: [
        'operation',
        'type'
    ],
    title: 'SetCharge',
    type: 'object'
} as const;

export const SetInventoryPriceSchema = {
    properties: {
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        purchase: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Purchase'
        },
        sale: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale'
        }
    },
    required: [
        'purchase',
        'currency'
    ],
    title: 'SetInventoryPrice',
    type: 'object'
} as const;

export const SetSigningPinSchema = {
    properties: {
        current_password: {
            maxLength: 128,
            title: 'Current Password',
            type: 'string'
        },
        pin: {
            pattern: '^[0-9]{4}$',
            title: 'Pin',
            type: 'string'
        }
    },
    required: [
        'current_password',
        'pin'
    ],
    title: 'SetSigningPin',
    type: 'object'
} as const;

export const SetTaxRateSchema = {
    properties: {
        manual_rate: {
            anyOf: [
                {
                    maximum: 1,
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Rate'
        },
        operation: {
            const: 'set',
            title: 'Operation',
            type: 'string'
        },
        tax_class: {
            $ref: '#/components/schemas/TaxClass'
        },
        tax_rate_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Rate Id'
        }
    },
    required: [
        'operation',
        'tax_class'
    ],
    title: 'SetTaxRate',
    type: 'object'
} as const;

export const SetWorkTaskStatusSchema = {
    properties: {
        ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Ids',
            type: 'array'
        },
        status: {
            enum: [
                'not_started',
                'in_progress',
                'deferred'
            ],
            title: 'Status',
            type: 'string'
        }
    },
    required: [
        'ids',
        'status'
    ],
    title: 'SetWorkTaskStatus',
    type: 'object'
} as const;

export const SettableVisibilitySchema = {
    enum: [
        'tenant',
        'user'
    ],
    title: 'SettableVisibility',
    type: 'string'
} as const;

export const SeveritySchema = {
    enum: [
        'airworthiness',
        'informational'
    ],
    title: 'Severity',
    type: 'string'
} as const;

export const SeverityFilterSchema = {
    enum: [
        'airworthiness',
        'informational',
        'none'
    ],
    type: 'string'
} as const;

export const ShipOutsideServiceSchema = {
    properties: {
        action: {
            const: 'ship',
            title: 'Action',
            type: 'string'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/OutsideServiceCheck'
            },
            title: 'Checks',
            type: 'array'
        },
        note: {
            anyOf: [
                {
                    maxLength: 4000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        },
        tracking: {
            anyOf: [
                {
                    maxLength: 200,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tracking'
        }
    },
    required: [
        'checks',
        'action'
    ],
    title: 'ShipOutsideService',
    type: 'object'
} as const;

export const SignOffWorkTasksSchema = {
    properties: {
        ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 200,
            minItems: 1,
            title: 'Ids',
            type: 'array'
        },
        pin: {
            pattern: '^[0-9]{4}$',
            title: 'Pin',
            type: 'string'
        },
        signer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Signer Id'
        }
    },
    required: [
        'ids',
        'pin'
    ],
    title: 'SignOffWorkTasks',
    type: 'object'
} as const;

export const SignerKindSchema = {
    enum: [
        'technician',
        'inspector'
    ],
    title: 'SignerKind',
    type: 'string'
} as const;

export const SignerPublicSchema = {
    properties: {
        first_name: {
            title: 'First Name',
            type: 'string'
        },
        has_signing_pin: {
            title: 'Has Signing Pin',
            type: 'boolean'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_name: {
            title: 'Last Name',
            type: 'string'
        },
        signing_pin_locked: {
            title: 'Signing Pin Locked',
            type: 'boolean'
        }
    },
    required: [
        'id',
        'first_name',
        'last_name',
        'has_signing_pin',
        'signing_pin_locked'
    ],
    title: 'SignerPublic',
    type: 'object'
} as const;

export const SignersPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/SignerPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'SignersPublic',
    type: 'object'
} as const;

export const SimilarWorkPackagesPublicSchema = {
    properties: {
        hours: {
            $ref: '#/components/schemas/BandPublic'
        },
        revenue: {
            $ref: '#/components/schemas/BandPublic'
        },
        sources: {
            items: {
                $ref: '#/components/schemas/WorkPackageWithTasksPublic'
            },
            title: 'Sources',
            type: 'array'
        },
        tat_days: {
            $ref: '#/components/schemas/BandPublic'
        },
        warranty_rate: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Warranty Rate'
        }
    },
    required: [
        'hours',
        'tat_days',
        'revenue',
        'warranty_rate',
        'sources'
    ],
    title: 'SimilarWorkPackagesPublic',
    type: 'object'
} as const;

export const SkillCodeSchema = {
    enum: [
        'af',
        'av',
        'ca',
        'el',
        'en',
        'ndt',
        'ra',
        'ut'
    ],
    title: 'SkillCode',
    type: 'string'
} as const;

export const SnagComplianceInfoSchema = {
    description: 'Use if task_type is snag',
    properties: {
        action_taken: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Action Taken'
        },
        snag_component_info: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/SnagComponentInfo'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Snag Component Info'
        }
    },
    title: 'SnagComplianceInfo',
    type: 'object'
} as const;

export const SnagComponentInfoSchema = {
    properties: {
        component_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Component Description'
        },
        pn_off: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pn Off'
        },
        pn_on: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pn On'
        },
        sn_off: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sn Off'
        },
        sn_on: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sn On'
        }
    },
    title: 'SnagComponentInfo',
    type: 'object'
} as const;

export const SonicSettingsSchema = {
    properties: {
        enable_suggested_compliance_notes: {
            default: false,
            title: 'Enable Suggested Compliance Notes',
            type: 'boolean'
        },
        patterns_for_suggested_compliance_notes: {
            default: [],
            items: {
                type: 'string'
            },
            title: 'Patterns For Suggested Compliance Notes',
            type: 'array'
        }
    },
    title: 'SonicSettings',
    type: 'object'
} as const;

export const SortDirectionSchema = {
    enum: [
        'asc',
        'desc'
    ],
    title: 'SortDirection',
    type: 'string'
} as const;

export const SourceInfoSchema = {
    properties: {},
    title: 'SourceInfo',
    type: 'object'
} as const;

export const SquawkAttentionCategorySchema = {
    enum: [
        'responses',
        'decide',
        'verify'
    ],
    title: 'SquawkAttentionCategory',
    type: 'string'
} as const;

export const SquawkAttentionPublicSchema = {
    properties: {
        category: {
            $ref: '#/components/schemas/SquawkAttentionCategory'
        },
        count: {
            title: 'Count',
            type: 'integer'
        },
        first_id: {
            format: 'uuid',
            title: 'First Id',
            type: 'string'
        }
    },
    required: [
        'category',
        'count',
        'first_id'
    ],
    title: 'SquawkAttentionPublic',
    type: 'object'
} as const;

export const SquawkBulkArchivePublicSchema = {
    properties: {
        archived: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Archived',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'archived',
        'skipped'
    ],
    title: 'SquawkBulkArchivePublic',
    type: 'object'
} as const;

export const SquawkBulkIdsSchema = {
    properties: {
        squawk_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Squawk Ids',
            type: 'array'
        }
    },
    required: [
        'squawk_ids'
    ],
    title: 'SquawkBulkIds',
    type: 'object'
} as const;

export const SquawkBulkRestorePublicSchema = {
    properties: {
        restored: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Restored',
            type: 'array'
        },
        skipped: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Skipped',
            type: 'array'
        }
    },
    required: [
        'restored',
        'skipped'
    ],
    title: 'SquawkBulkRestorePublic',
    type: 'object'
} as const;

export const SquawkCardPreviewRecordSchema = {
    properties: {
        source: {
            const: 'squawk_card',
            title: 'Source',
            type: 'string'
        },
        squawk_id: {
            format: 'uuid',
            title: 'Squawk Id',
            type: 'string'
        }
    },
    required: [
        'source',
        'squawk_id'
    ],
    title: 'SquawkCardPreviewRecord',
    type: 'object'
} as const;

export const SquawkChargePriceHistoryPublicSchema = {
    properties: {
        charge_id: {
            format: 'uuid',
            title: 'Charge Id',
            type: 'string'
        },
        prices: {
            items: {
                $ref: '#/components/schemas/ChargePrice'
            },
            title: 'Prices',
            type: 'array'
        }
    },
    required: [
        'charge_id',
        'prices'
    ],
    title: 'SquawkChargePriceHistoryPublic',
    type: 'object'
} as const;

export const SquawkChargePublicSchema = {
    properties: {
        cost_quantity: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost Quantity'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        lead_time: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        part_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        type: {
            $ref: '#/components/schemas/CannedChargeType'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'id',
        'description',
        'type',
        'part_number',
        'purchase_unit_price',
        'sale_unit_price',
        'currency',
        'quantity',
        'unit_of_measure',
        'tax_amount',
        'lead_time',
        'cost_quantity',
        'created_at',
        'deleted_at'
    ],
    title: 'SquawkChargePublic',
    type: 'object'
} as const;

export const SquawkChargeUpsertSchema = {
    properties: {
        cost_quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost Quantity'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Required when purchase_unit_price, sale_unit_price or tax_amount is set.'
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        lead_time: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        part_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        type: {
            $ref: '#/components/schemas/CannedChargeType',
            description: 'When type is \'part\', part_number, quantity and unit_of_measure are all required; for other charge types they must be omitted. A \'misc\', \'part_flat_rate\', \'outside_service\', \'estimate\', \'freight\' or \'insurance\' charge is a single amount: quantity and unit_of_measure must be omitted and sale_unit_price is the whole charge.'
        },
        unit_of_measure: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        }
    },
    required: [
        'type'
    ],
    title: 'SquawkChargeUpsert',
    type: 'object'
} as const;

export const SquawkChoiceSuggestionPublicSchema = {
    properties: {
        kind: {
            const: 'choice',
            title: 'Kind',
            type: 'string'
        },
        options: {
            items: {
                type: 'string'
            },
            title: 'Options',
            type: 'array'
        },
        question: {
            title: 'Question',
            type: 'string'
        }
    },
    required: [
        'kind',
        'question',
        'options'
    ],
    title: 'SquawkChoiceSuggestionPublic',
    type: 'object'
} as const;

export const SquawkCommentCreateSchema = {
    properties: {
        body: {
            minLength: 1,
            title: 'Body',
            type: 'string'
        }
    },
    required: [
        'body'
    ],
    title: 'SquawkCommentCreate',
    type: 'object'
} as const;

export const SquawkCommentPublicSchema = {
    properties: {
        body: {
            title: 'Body',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        squawk_id: {
            format: 'uuid',
            title: 'Squawk Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'squawk_id',
        'body',
        'created_by_id',
        'created_by',
        'created_at'
    ],
    title: 'SquawkCommentPublic',
    type: 'object'
} as const;

export const SquawkCommentsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/SquawkCommentPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'SquawkCommentsPublic',
    type: 'object'
} as const;

export const SquawkCustomerReviewPublicSchema = {
    properties: {
        decided_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerContactPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        responded_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Responded At'
        },
        sent_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent At'
        },
        sent_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            $ref: '#/components/schemas/RevisionTaskStatus'
        }
    },
    required: [
        'sent_at',
        'sent_by',
        'status',
        'responded_at',
        'decided_by'
    ],
    title: 'SquawkCustomerReviewPublic',
    type: 'object'
} as const;

export const SquawkDetailPublicSchema = {
    properties: {
        active_charges: {
            items: {
                $ref: '#/components/schemas/SquawkChargePublic'
            },
            title: 'Active Charges',
            type: 'array'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        customer_review: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SquawkCustomerReviewPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        edited_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Edited At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        logged_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        logged_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Logged By Id'
        },
        manual_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        quote: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuotePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        quote_task: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteTaskPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        resolution: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        review_decision: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ReviewDecision-Output'
                },
                {
                    type: 'null'
                }
            ]
        },
        reviewed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reviewed At'
        },
        reviewed_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        reviewed_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reviewed By Id'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            $ref: '#/components/schemas/SquawkStatus'
        },
        verified_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Verified At'
        },
        verified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        verified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Verified By Id'
        },
        visible_documents: {
            items: {
                $ref: '#/components/schemas/DocumentPublic'
            },
            title: 'Visible Documents',
            type: 'array'
        },
        work_package: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        },
        work_task: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkTaskRef'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'severity',
        'status',
        'work_package_id',
        'work_task_id',
        'department_id',
        'quote_task_id',
        'reviewed_by_id',
        'reviewed_at',
        'review_decision',
        'verified_by_id',
        'verified_at',
        'manual_reference',
        'resolution',
        'ata_chapter',
        'ata_subchapter',
        'ata_zone',
        'created_by_id',
        'logged_by_id',
        'last_modified_by_id',
        'created_at',
        'edited_at',
        'deleted_at',
        'archived_at',
        'active_charges',
        'visible_documents',
        'created_by',
        'logged_by',
        'reviewed_by',
        'verified_by',
        'work_package',
        'work_task',
        'quote_task',
        'quote',
        'customer_review'
    ],
    title: 'SquawkDetailPublic',
    type: 'object'
} as const;

export const SquawkDuplicatesPublicSchema = {
    properties: {
        duplicates: {
            items: {
                $ref: '#/components/schemas/SquawkPublic'
            },
            title: 'Duplicates',
            type: 'array'
        }
    },
    required: [
        'duplicates'
    ],
    title: 'SquawkDuplicatesPublic',
    type: 'object'
} as const;

export const SquawkFilterOptionsPublicSchema = {
    properties: {
        ata_chapters: {
            items: {
                type: 'integer'
            },
            title: 'Ata Chapters',
            type: 'array'
        },
        work_order_count: {
            title: 'Work Order Count',
            type: 'integer'
        },
        work_orders: {
            items: {
                type: 'string'
            },
            title: 'Work Orders',
            type: 'array'
        }
    },
    required: [
        'work_orders',
        'work_order_count',
        'ata_chapters'
    ],
    title: 'SquawkFilterOptionsPublic',
    type: 'object'
} as const;

export const SquawkGroupPublicSchema = {
    properties: {
        squawks: {
            items: {
                $ref: '#/components/schemas/SquawkDetailPublic'
            },
            title: 'Squawks',
            type: 'array'
        },
        work_package: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'squawks'
    ],
    title: 'SquawkGroupPublic',
    type: 'object'
} as const;

export const SquawkGroupingSchema = {
    enum: [
        'work_order',
        'status',
        'severity',
        'customer',
        'reporter'
    ],
    title: 'SquawkGrouping',
    type: 'string'
} as const;

export const SquawkGroupsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/SquawkGroupPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'SquawkGroupsPublic',
    type: 'object'
} as const;

export const SquawkListPreviewRecordSchema = {
    properties: {
        source: {
            const: 'squawk_list',
            title: 'Source',
            type: 'string'
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        }
    },
    required: [
        'source',
        'work_package_id'
    ],
    title: 'SquawkListPreviewRecord',
    type: 'object'
} as const;

export const SquawkPriceHistoryPublicSchema = {
    properties: {
        charges: {
            items: {
                $ref: '#/components/schemas/SquawkChargePriceHistoryPublic'
            },
            title: 'Charges',
            type: 'array'
        }
    },
    required: [
        'charges'
    ],
    title: 'SquawkPriceHistoryPublic',
    type: 'object'
} as const;

export const SquawkPromptSuggestionPublicSchema = {
    properties: {
        detail: {
            title: 'Detail',
            type: 'string'
        },
        kind: {
            const: 'prompt',
            title: 'Kind',
            type: 'string'
        },
        question: {
            title: 'Question',
            type: 'string'
        }
    },
    required: [
        'kind',
        'question',
        'detail'
    ],
    title: 'SquawkPromptSuggestionPublic',
    type: 'object'
} as const;

export const SquawkPublicSchema = {
    properties: {
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        edited_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Edited At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        logged_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Logged By Id'
        },
        manual_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        quote_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quote Task Id'
        },
        resolution: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        review_decision: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ReviewDecision-Output'
                },
                {
                    type: 'null'
                }
            ]
        },
        reviewed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reviewed At'
        },
        reviewed_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reviewed By Id'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            $ref: '#/components/schemas/SquawkStatus'
        },
        verified_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Verified At'
        },
        verified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Verified By Id'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'severity',
        'status',
        'work_package_id',
        'work_task_id',
        'department_id',
        'quote_task_id',
        'reviewed_by_id',
        'reviewed_at',
        'review_decision',
        'verified_by_id',
        'verified_at',
        'manual_reference',
        'resolution',
        'ata_chapter',
        'ata_subchapter',
        'ata_zone',
        'created_by_id',
        'logged_by_id',
        'last_modified_by_id',
        'created_at',
        'edited_at',
        'deleted_at',
        'archived_at'
    ],
    title: 'SquawkPublic',
    type: 'object'
} as const;

export const SquawkQuoteCreateSchema = {
    properties: {
        squawk_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Squawk Ids',
            type: 'array'
        }
    },
    required: [
        'squawk_ids'
    ],
    title: 'SquawkQuoteCreate',
    type: 'object'
} as const;

export const SquawkQuotePublicSchema = {
    properties: {
        quote: {
            $ref: '#/components/schemas/QuotePublic'
        },
        squawks: {
            items: {
                $ref: '#/components/schemas/SquawkDetailPublic'
            },
            title: 'Squawks',
            type: 'array'
        }
    },
    required: [
        'quote',
        'squawks'
    ],
    title: 'SquawkQuotePublic',
    type: 'object'
} as const;

export const SquawkSortSchema = {
    enum: [
        'number',
        'squawk',
        'reported',
        'decision',
        'verified',
        'customer',
        'work_order',
        'value'
    ],
    title: 'SquawkSort',
    type: 'string'
} as const;

export const SquawkStatusSchema = {
    enum: [
        'draft',
        'pending_review',
        'approved',
        'rejected',
        'verified'
    ],
    title: 'SquawkStatus',
    type: 'string'
} as const;

export const SquawkStatusFailureSchema = {
    enum: [
        'not_found',
        'invalid_transition',
        'forbidden',
        'reporter_required',
        'approval_refused'
    ],
    title: 'SquawkStatusFailure',
    type: 'string'
} as const;

export const SquawkStatusFailurePublicSchema = {
    properties: {
        reason: {
            $ref: '#/components/schemas/SquawkStatusFailure'
        },
        squawk_id: {
            format: 'uuid',
            title: 'Squawk Id',
            type: 'string'
        }
    },
    required: [
        'squawk_id',
        'reason'
    ],
    title: 'SquawkStatusFailurePublic',
    type: 'object'
} as const;

export const SquawkStatusUpdateSchema = {
    properties: {
        squawk_id: {
            format: 'uuid',
            title: 'Squawk Id',
            type: 'string'
        },
        status: {
            discriminator: {
                mapping: {
                    approved: '#/components/schemas/ToApproved',
                    rejected: '#/components/schemas/ToRejected',
                    verified: '#/components/schemas/ToVerified'
                },
                propertyName: 'status'
            },
            oneOf: [
                {
                    $ref: '#/components/schemas/ToApproved'
                },
                {
                    $ref: '#/components/schemas/ToVerified'
                },
                {
                    $ref: '#/components/schemas/ToRejected'
                }
            ],
            title: 'Status'
        }
    },
    required: [
        'squawk_id',
        'status'
    ],
    title: 'SquawkStatusUpdate',
    type: 'object'
} as const;

export const SquawkStatusUpdatesSchema = {
    properties: {
        updates: {
            items: {
                $ref: '#/components/schemas/SquawkStatusUpdate'
            },
            maxItems: 1000,
            minItems: 1,
            title: 'Updates',
            type: 'array'
        }
    },
    required: [
        'updates'
    ],
    title: 'SquawkStatusUpdates',
    type: 'object'
} as const;

export const SquawkStatusUpdatesPublicSchema = {
    properties: {
        failed: {
            items: {
                $ref: '#/components/schemas/SquawkStatusFailurePublic'
            },
            title: 'Failed',
            type: 'array'
        },
        updated: {
            items: {
                $ref: '#/components/schemas/SquawkDetailPublic'
            },
            title: 'Updated',
            type: 'array'
        }
    },
    required: [
        'updated',
        'failed'
    ],
    title: 'SquawkStatusUpdatesPublic',
    type: 'object'
} as const;

export const SquawkSuggestionsPublicSchema = {
    properties: {
        suggestions: {
            items: {
                discriminator: {
                    mapping: {
                        choice: '#/components/schemas/SquawkChoiceSuggestionPublic',
                        prompt: '#/components/schemas/SquawkPromptSuggestionPublic'
                    },
                    propertyName: 'kind'
                },
                oneOf: [
                    {
                        $ref: '#/components/schemas/SquawkChoiceSuggestionPublic'
                    },
                    {
                        $ref: '#/components/schemas/SquawkPromptSuggestionPublic'
                    }
                ]
            },
            title: 'Suggestions',
            type: 'array'
        }
    },
    required: [
        'suggestions'
    ],
    title: 'SquawkSuggestionsPublic',
    type: 'object'
} as const;

export const SquawkUpdateSchema = {
    properties: {
        add_document_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Add Document Ids'
        },
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        charges: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/SquawkChargeUpsert'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Charges'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        document_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Ids'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        reported_by_user_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported By User Id'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            anyOf: [
                {
                    discriminator: {
                        mapping: {
                            approved: '#/components/schemas/ToApproved',
                            pending_review: '#/components/schemas/ToPendingReview',
                            rejected: '#/components/schemas/ToRejected',
                            verified: '#/components/schemas/ToVerified'
                        },
                        propertyName: 'status'
                    },
                    oneOf: [
                        {
                            $ref: '#/components/schemas/ToApproved'
                        },
                        {
                            $ref: '#/components/schemas/ToVerified'
                        },
                        {
                            $ref: '#/components/schemas/ToRejected'
                        },
                        {
                            $ref: '#/components/schemas/ToPendingReview'
                        }
                    ]
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        },
        work_package_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Number'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        }
    },
    title: 'SquawkUpdate',
    type: 'object'
} as const;

export const SquawkUpsertSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/SquawkChargeUpsert'
            },
            title: 'Charges',
            type: 'array'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        document_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Document Ids',
            type: 'array'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        reported_by_user_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported By User Id'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            $ref: '#/components/schemas/CreatableStatus',
            default: 'pending_review'
        },
        work_package_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Number'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        }
    },
    required: [
        'description'
    ],
    title: 'SquawkUpsert',
    type: 'object'
} as const;

export const SquawksPublicSchema = {
    properties: {
        attention: {
            items: {
                $ref: '#/components/schemas/SquawkAttentionPublic'
            },
            title: 'Attention',
            type: 'array'
        },
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/SquawkDetailPublic'
            },
            title: 'Data',
            type: 'array'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/GroupCountPublic'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'data',
        'count',
        'groups',
        'attention'
    ],
    title: 'SquawksPublic',
    type: 'object'
} as const;

export const StartOutsideServiceSchema = {
    properties: {
        action: {
            const: 'start',
            title: 'Action',
            type: 'string'
        },
        note: {
            anyOf: [
                {
                    maxLength: 4000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        }
    },
    required: [
        'action'
    ],
    title: 'StartOutsideService',
    type: 'object'
} as const;

export const StartTimerSchema = {
    properties: {
        work_task_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 20,
            minItems: 1,
            title: 'Work Task Ids',
            type: 'array'
        }
    },
    required: [
        'work_task_ids'
    ],
    title: 'StartTimer',
    type: 'object'
} as const;

export const StepDefinitionSchema = {
    properties: {
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        inspection_required: {
            default: false,
            title: 'Inspection Required',
            type: 'boolean'
        },
        steps: {
            items: {
                $ref: '#/components/schemas/StepDefinition'
            },
            title: 'Steps',
            type: 'array'
        }
    },
    required: [
        'description'
    ],
    title: 'StepDefinition',
    type: 'object'
} as const;

export const StepNoteSchema = {
    properties: {
        locator: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locator'
        },
        note: {
            minLength: 1,
            title: 'Note',
            type: 'string'
        },
        step_name: {
            minLength: 1,
            title: 'Step Name',
            type: 'string'
        }
    },
    required: [
        'step_name',
        'note'
    ],
    title: 'StepNote',
    type: 'object'
} as const;

export const SubgroupCountPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        key: {
            title: 'Key',
            type: 'string'
        }
    },
    required: [
        'key',
        'count'
    ],
    title: 'SubgroupCountPublic',
    type: 'object'
} as const;

export const SubjectSchema = {
    discriminator: {
        mapping: {
            aircraft: '#/components/schemas/AircraftSubject',
            existing_part: '#/components/schemas/ExistingPart',
            new_part: '#/components/schemas/NewPart'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/AircraftSubject'
        },
        {
            $ref: '#/components/schemas/ExistingPart'
        },
        {
            $ref: '#/components/schemas/NewPart'
        }
    ]
} as const;

export const SubtotalDiscountSchema = {
    properties: {
        kind: {
            const: 'subtotal',
            title: 'Kind',
            type: 'string'
        }
    },
    required: [
        'kind'
    ],
    title: 'SubtotalDiscount',
    type: 'object'
} as const;

export const SuggestedComplianceNotePublicSchema = {
    properties: {
        content: {
            title: 'Content',
            type: 'string'
        },
        content_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content Edited'
        },
        content_edited_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content Edited At'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        format_options: {
            anyOf: [
                {
                    additionalProperties: {
                        items: {
                            type: 'string'
                        },
                        type: 'array'
                    },
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Format Options'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        status: {
            $ref: '#/components/schemas/SuggestedComplianceNoteStatus'
        },
        type: {
            $ref: '#/components/schemas/SuggestedComplianceNoteType'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_task_id: {
            format: 'uuid',
            title: 'Work Task Id',
            type: 'string'
        }
    },
    required: [
        'type',
        'content',
        'work_task_id',
        'status',
        'id',
        'created_at',
        'updated_at'
    ],
    title: 'SuggestedComplianceNotePublic',
    type: 'object'
} as const;

export const SuggestedComplianceNoteStatusSchema = {
    enum: [
        'suggested',
        'accepted',
        'edited',
        'rejected'
    ],
    title: 'SuggestedComplianceNoteStatus',
    type: 'string'
} as const;

export const SuggestedComplianceNoteTypeSchema = {
    enum: [
        'log_entry',
        'task_card_entry'
    ],
    title: 'SuggestedComplianceNoteType',
    type: 'string'
} as const;

export const SuggestedComplianceNoteUpdateSchema = {
    properties: {
        content: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content'
        },
        content_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content Edited'
        },
        content_edited_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content Edited At'
        },
        format_options: {
            anyOf: [
                {
                    additionalProperties: {
                        items: {
                            type: 'string'
                        },
                        type: 'array'
                    },
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Format Options'
        },
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SuggestedComplianceNoteStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        suggested_from: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Suggested From'
        },
        type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SuggestedComplianceNoteType'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        },
        work_task_reference_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Reference Ids'
        }
    },
    title: 'SuggestedComplianceNoteUpdate',
    type: 'object'
} as const;

export const SyncErrorSchema = {
    properties: {
        entity_type: {
            title: 'Entity Type',
            type: 'string'
        },
        error_message: {
            title: 'Error Message',
            type: 'string'
        },
        external_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        is_retryable: {
            default: false,
            title: 'Is Retryable',
            type: 'boolean'
        }
    },
    required: [
        'entity_type',
        'external_id',
        'error_message'
    ],
    title: 'SyncError',
    type: 'object'
} as const;

export const SyncResultSchema = {
    properties: {
        billing_records: {
            default: 0,
            title: 'Billing Records',
            type: 'integer'
        },
        customers: {
            default: 0,
            title: 'Customers',
            type: 'integer'
        },
        duration_seconds: {
            default: 0,
            title: 'Duration Seconds',
            type: 'number'
        },
        errors: {
            default: [],
            items: {
                $ref: '#/components/schemas/SyncError'
            },
            title: 'Errors',
            type: 'array'
        },
        master_parts: {
            default: 0,
            title: 'Master Parts',
            type: 'integer'
        },
        work_packages: {
            default: 0,
            title: 'Work Packages',
            type: 'integer'
        },
        work_task_billing_records: {
            default: 0,
            title: 'Work Task Billing Records',
            type: 'integer'
        },
        work_tasks: {
            default: 0,
            title: 'Work Tasks',
            type: 'integer'
        }
    },
    title: 'SyncResult',
    type: 'object'
} as const;

export const TaskCardPreviewRecordSchema = {
    properties: {
        source: {
            const: 'task_card',
            title: 'Source',
            type: 'string'
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        },
        work_task_id: {
            format: 'uuid',
            title: 'Work Task Id',
            type: 'string'
        }
    },
    required: [
        'source',
        'work_package_id',
        'work_task_id'
    ],
    title: 'TaskCardPreviewRecord',
    type: 'object'
} as const;

export const TaskCodeSchema = {
    enum: [
        'bsi',
        'chk',
        'det',
        'dis',
        'fnc',
        'gvi',
        'lub',
        'opc',
        'rst',
        'sdi',
        'svc',
        'tps',
        'vck'
    ],
    title: 'TaskCode',
    type: 'string'
} as const;

export const TaskDiscountSchema = {
    properties: {
        kind: {
            const: 'task',
            title: 'Kind',
            type: 'string'
        },
        quote_task_id: {
            format: 'uuid',
            title: 'Quote Task Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'quote_task_id'
    ],
    title: 'TaskDiscount',
    type: 'object'
} as const;

export const TaskFindingsSchema = {
    enum: [
        'Baseline',
        'Calibrated',
        'Corrosion Level 1',
        'Corrosion Level 2',
        'Corrosion Level 3',
        'Damage',
        'Failed',
        'Failed Torque',
        'Fault Found',
        'Inspected',
        'Leak',
        'No Defects Found',
        'No Fault Found',
        'Outside Limits',
        'Requires Rework',
        'Satisfactory',
        'Torqued',
        'Unsatisfactory',
        'Updated',
        'Verified',
        'Within Limits',
        'Worn',
        'Other'
    ],
    title: 'TaskFindings',
    type: 'string'
} as const;

export const TaskGroupDiscountSchema = {
    properties: {
        kind: {
            const: 'task_group',
            title: 'Kind',
            type: 'string'
        },
        task_group_id: {
            format: 'uuid',
            title: 'Task Group Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'task_group_id'
    ],
    title: 'TaskGroupDiscount',
    type: 'object'
} as const;

export const TaskOperationSchema = {
    discriminator: {
        mapping: {
            apply_template: '#/components/schemas/ApplyTemplate',
            create: '#/components/schemas/CreateTask',
            create_from_template: '#/components/schemas/CreateTaskFromTemplate',
            remove: '#/components/schemas/RemoveTask',
            update: '#/components/schemas/UpdateTask'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/CreateTask'
        },
        {
            $ref: '#/components/schemas/CreateTaskFromTemplate'
        },
        {
            $ref: '#/components/schemas/UpdateTask'
        },
        {
            $ref: '#/components/schemas/ApplyTemplate'
        },
        {
            $ref: '#/components/schemas/RemoveTask'
        }
    ]
} as const;

export const TaskPriceHistoryPublicSchema = {
    properties: {
        charges: {
            items: {
                $ref: '#/components/schemas/ChargePriceHistoryPublic'
            },
            title: 'Charges',
            type: 'array'
        }
    },
    required: [
        'charges'
    ],
    title: 'TaskPriceHistoryPublic',
    type: 'object'
} as const;

export const TaskReviewDecisionSchema = {
    enum: [
        'approved',
        'changes_requested',
        'excluded'
    ],
    title: 'TaskReviewDecision',
    type: 'string'
} as const;

export const TaskTimePublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        entries: {
            items: {
                $ref: '#/components/schemas/TimeEntryDetailPublic'
            },
            title: 'Entries',
            type: 'array'
        },
        minutes: {
            title: 'Minutes',
            type: 'integer'
        },
        running: {
            items: {
                $ref: '#/components/schemas/TimerDetailPublic'
            },
            title: 'Running',
            type: 'array'
        }
    },
    required: [
        'entries',
        'count',
        'minutes',
        'running'
    ],
    title: 'TaskTimePublic',
    type: 'object'
} as const;

export const TaskTranscriptCategorySchema = {
    enum: [
        'tie_in',
        'troubleshooting_note',
        'service_note',
        'work_performed',
        'unclassified'
    ],
    title: 'TaskTranscriptCategory',
    type: 'string'
} as const;

export const TaskTranscriptPublicSchema = {
    properties: {
        accepted: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accepted'
        },
        ai_summary: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ai Summary'
        },
        category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskTranscriptCategory'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        final_text: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Final Text'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        original_text: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original Text'
        },
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskTranscriptStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        use_for_note_gen: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Use For Note Gen'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        }
    },
    required: [
        'id',
        'created_at',
        'updated_at'
    ],
    title: 'TaskTranscriptPublic',
    type: 'object'
} as const;

export const TaskTranscriptStatusSchema = {
    enum: [
        'pending',
        'accepted_without_edit',
        'accepted_with_edit',
        'rejected'
    ],
    title: 'TaskTranscriptStatus',
    type: 'string'
} as const;

export const TaskTranscriptUpdateSchema = {
    properties: {
        accepted: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accepted'
        },
        ai_summary: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ai Summary'
        },
        final_text: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Final Text'
        },
        original_text: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original Text'
        },
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskTranscriptStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        use_for_note_gen: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Use For Note Gen'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        }
    },
    title: 'TaskTranscriptUpdate',
    type: 'object'
} as const;

export const TaskTranscriptsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TaskTranscriptPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TaskTranscriptsPublic',
    type: 'object'
} as const;

export const TaskTypeSchema = {
    enum: [
        'Inspection',
        'Airworthiness Directive',
        'Service Bulletin',
        'Part',
        'Snag',
        'Other',
        'Draft'
    ],
    title: 'TaskType',
    type: 'string'
} as const;

export const TaxClassSchema = {
    enum: [
        'labour',
        'flat_rate_labour',
        'component_workscopes',
        'parts',
        'services',
        'misc',
        'freight',
        'insurance'
    ],
    title: 'TaxClass',
    type: 'string'
} as const;

export const TaxDestinationSchema = {
    enum: [
        'facility',
        'billing_address',
        'shipping_address'
    ],
    title: 'TaxDestination',
    type: 'string'
} as const;

export const TaxJurisdictionPublicSchema = {
    properties: {
        country: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        locality: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locality'
        },
        region: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Region'
        }
    },
    required: [
        'country',
        'region',
        'locality'
    ],
    title: 'TaxJurisdictionPublic',
    type: 'object'
} as const;

export const TaxRateCreateSchema = {
    properties: {
        code: {
            maxLength: 64,
            minLength: 1,
            title: 'Code',
            type: 'string'
        },
        country: {
            anyOf: [
                {
                    maxLength: 2,
                    minLength: 2,
                    pattern: '^[A-Za-z]{2}$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        locality: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locality'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        rate: {
            anyOf: [
                {
                    maximum: 1,
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Rate'
        },
        region: {
            anyOf: [
                {
                    maxLength: 64,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Region'
        },
        tax_class: {
            $ref: '#/components/schemas/TaxClass'
        }
    },
    required: [
        'code',
        'name',
        'rate',
        'tax_class'
    ],
    title: 'TaxRateCreate',
    type: 'object'
} as const;

export const TaxRateDetailPublicSchema = {
    properties: {
        code: {
            title: 'Code',
            type: 'string'
        },
        country: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        locality: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locality'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        rate: {
            title: 'Rate',
            type: 'string'
        },
        region: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Region'
        },
        tax_class: {
            $ref: '#/components/schemas/TaxClass'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'code',
        'name',
        'rate',
        'tax_class',
        'country',
        'region',
        'locality',
        'created_at',
        'updated_at',
        'created_by_id',
        'last_modified_by_id',
        'deleted_at',
        'created_by',
        'last_modified_by'
    ],
    title: 'TaxRateDetailPublic',
    type: 'object'
} as const;

export const TaxRateOperationSchema = {
    discriminator: {
        mapping: {
            remove: '#/components/schemas/RemoveTaxRate',
            set: '#/components/schemas/SetTaxRate'
        },
        propertyName: 'operation'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/SetTaxRate'
        },
        {
            $ref: '#/components/schemas/RemoveTaxRate'
        }
    ]
} as const;

export const TaxRatePublicSchema = {
    properties: {
        code: {
            title: 'Code',
            type: 'string'
        },
        country: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        locality: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locality'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        rate: {
            title: 'Rate',
            type: 'string'
        },
        region: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Region'
        },
        tax_class: {
            $ref: '#/components/schemas/TaxClass'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'code',
        'name',
        'rate',
        'tax_class',
        'country',
        'region',
        'locality',
        'created_at',
        'updated_at',
        'created_by_id',
        'last_modified_by_id',
        'deleted_at'
    ],
    title: 'TaxRatePublic',
    type: 'object'
} as const;

export const TaxRateUpdateSchema = {
    properties: {
        code: {
            anyOf: [
                {
                    maxLength: 64,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Code'
        },
        country: {
            anyOf: [
                {
                    maxLength: 2,
                    minLength: 2,
                    pattern: '^[A-Za-z]{2}$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        locality: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locality'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        rate: {
            anyOf: [
                {
                    maximum: 1,
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rate'
        },
        region: {
            anyOf: [
                {
                    maxLength: 64,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Region'
        },
        tax_class: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaxClass'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    title: 'TaxRateUpdate',
    type: 'object'
} as const;

export const TaxRatesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TaxRateDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TaxRatesPublic',
    type: 'object'
} as const;

export const TeamAudienceSchema = {
    additionalProperties: false,
    properties: {
        kind: {
            const: 'team',
            title: 'Kind',
            type: 'string'
        },
        team_id: {
            format: 'uuid',
            title: 'Team Id',
            type: 'string'
        }
    },
    required: [
        'kind',
        'team_id'
    ],
    title: 'TeamAudience',
    type: 'object'
} as const;

export const TeamCreateSchema = {
    properties: {
        department_id: {
            format: 'uuid',
            title: 'Department Id',
            type: 'string'
        },
        member_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Member Ids',
            type: 'array'
        },
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'name',
        'department_id'
    ],
    title: 'TeamCreate',
    type: 'object'
} as const;

export const TeamDetailPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        department: {
            $ref: '#/components/schemas/DepartmentPublic'
        },
        department_id: {
            format: 'uuid',
            title: 'Department Id',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        members: {
            items: {
                $ref: '#/components/schemas/UserBasicInfo'
            },
            title: 'Members',
            type: 'array'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'name',
        'department_id',
        'created_at',
        'updated_at',
        'last_modified_by_id',
        'deleted_at',
        'department',
        'members'
    ],
    title: 'TeamDetailPublic',
    type: 'object'
} as const;

export const TeamReferenceSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'name'
    ],
    title: 'TeamReference',
    type: 'object'
} as const;

export const TeamUpdateSchema = {
    properties: {
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        member_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Member Ids'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    title: 'TeamUpdate',
    type: 'object'
} as const;

export const TeamsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TeamDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TeamsPublic',
    type: 'object'
} as const;

export const TenantCreateSchema = {
    properties: {
        afac_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Afac Cert No'
        },
        casa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Casa Cert No'
        },
        company_address_line1: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line1'
        },
        company_address_line2: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line2'
        },
        company_city: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company City'
        },
        company_country: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Country'
        },
        company_email: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Email'
        },
        company_logo_blob_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Logo Blob Name'
        },
        company_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Name'
        },
        company_phone_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Phone Number'
        },
        company_state: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company State'
        },
        company_zip: {
            anyOf: [
                {
                    maxLength: 20,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Zip'
        },
        easa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Easa Cert No'
        },
        faa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Faa Cert No'
        },
        iata_code: {
            anyOf: [
                {
                    maxLength: 12,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Iata Code'
        },
        icao_code: {
            anyOf: [
                {
                    maxLength: 12,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Icao Code'
        },
        id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Optional UUID for the tenant. If not provided, a random UUID will be generated. Useful for development to avoid creating new containers on every DB reset.',
            title: 'Id'
        },
        ip_allowlist: {
            default: [],
            items: {
                type: 'string'
            },
            title: 'Ip Allowlist',
            type: 'array'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        is_internal: {
            default: false,
            title: 'Is Internal',
            type: 'boolean'
        },
        modules_enabled: {
            default: [],
            items: {
                $ref: '#/components/schemas/ModulesEnabled'
            },
            title: 'Modules Enabled',
            type: 'array'
        },
        name: {
            maxLength: 255,
            title: 'Name',
            type: 'string'
        },
        slug: {
            description: 'Lowercase alphanumeric slug for username prefixes (no spaces or hyphens)',
            maxLength: 50,
            minLength: 2,
            pattern: '^[a-z0-9]+$',
            title: 'Slug',
            type: 'string'
        },
        sonic_settings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SonicSettings'
                },
                {
                    type: 'null'
                }
            ]
        },
        tcca_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tcca Cert No'
        },
        trace_settings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TraceSettings'
                },
                {
                    type: 'null'
                }
            ]
        },
        type: {
            $ref: '#/components/schemas/TenantType'
        },
        website: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Website'
        }
    },
    required: [
        'name',
        'slug',
        'type'
    ],
    title: 'TenantCreate',
    type: 'object'
} as const;

export const TenantERPConfigCreateSchema = {
    properties: {
        display_name: {
            maxLength: 100,
            title: 'Display Name',
            type: 'string'
        },
        domain: {
            maxLength: 255,
            title: 'Domain',
            type: 'string'
        },
        erp_vendor: {
            $ref: '#/components/schemas/ERPVendor',
            maxLength: 50
        },
        integration_start_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Integration Start Date'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        vendor_config: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Config'
        }
    },
    required: [
        'erp_vendor',
        'display_name',
        'domain'
    ],
    title: 'TenantERPConfigCreate',
    type: 'object'
} as const;

export const TenantERPConfigPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        display_name: {
            maxLength: 100,
            title: 'Display Name',
            type: 'string'
        },
        domain: {
            maxLength: 255,
            title: 'Domain',
            type: 'string'
        },
        erp_vendor: {
            $ref: '#/components/schemas/ERPVendor',
            maxLength: 50
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        integration_start_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Integration Start Date'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        is_editable: {
            default: false,
            title: 'Is Editable',
            type: 'boolean'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        vendor_config: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Config'
        }
    },
    required: [
        'erp_vendor',
        'display_name',
        'domain',
        'id',
        'tenant_id',
        'created_at',
        'updated_at'
    ],
    title: 'TenantERPConfigPublic',
    type: 'object'
} as const;

export const TenantERPConfigUpdateSchema = {
    properties: {
        display_name: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Display Name'
        },
        domain: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        },
        erp_vendor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ERPVendor',
                    maxLength: 50
                },
                {
                    type: 'null'
                }
            ]
        },
        integration_start_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Integration Start Date'
        },
        is_active: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Active'
        },
        vendor_config: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Config'
        }
    },
    title: 'TenantERPConfigUpdate',
    type: 'object'
} as const;

export const TenantERPConfigsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TenantERPConfigPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TenantERPConfigsPublic',
    type: 'object'
} as const;

export const TenantIntegrationConfigCreateSchema = {
    properties: {
        client_id: {
            maxLength: 255,
            minLength: 1,
            title: 'Client Id',
            type: 'string'
        },
        client_secret: {
            format: 'password',
            minLength: 1,
            title: 'Client Secret',
            type: 'string',
            writeOnly: true
        },
        domain: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        },
        enabled: {
            default: true,
            title: 'Enabled',
            type: 'boolean'
        },
        integration: {
            $ref: '#/components/schemas/IntegrationKind'
        }
    },
    required: [
        'integration',
        'client_id',
        'client_secret'
    ],
    title: 'TenantIntegrationConfigCreate',
    type: 'object'
} as const;

export const TenantIntegrationConfigPublicSchema = {
    properties: {
        client_id: {
            title: 'Client Id',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        domain: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        },
        enabled: {
            title: 'Enabled',
            type: 'boolean'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        integration: {
            $ref: '#/components/schemas/IntegrationKind'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'integration',
        'client_id',
        'enabled',
        'created_at',
        'updated_at'
    ],
    title: 'TenantIntegrationConfigPublic',
    type: 'object'
} as const;

export const TenantIntegrationConfigUpdateSchema = {
    properties: {
        client_id: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Id'
        },
        client_secret: {
            anyOf: [
                {
                    format: 'password',
                    minLength: 1,
                    type: 'string',
                    writeOnly: true
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Secret'
        },
        domain: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        },
        enabled: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Enabled'
        }
    },
    title: 'TenantIntegrationConfigUpdate',
    type: 'object'
} as const;

export const TenantIntegrationConfigsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TenantIntegrationConfigPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TenantIntegrationConfigsPublic',
    type: 'object'
} as const;

export const TenantModulesEnabledSchema = {
    properties: {
        modules_enabled: {
            items: {
                $ref: '#/components/schemas/ModulesEnabled'
            },
            title: 'Modules Enabled',
            type: 'array'
        }
    },
    required: [
        'modules_enabled'
    ],
    title: 'TenantModulesEnabled',
    type: 'object'
} as const;

export const TenantOwnerAssignSchema = {
    properties: {
        user_id: {
            format: 'uuid',
            title: 'User Id',
            type: 'string'
        }
    },
    required: [
        'user_id'
    ],
    title: 'TenantOwnerAssign',
    type: 'object'
} as const;

export const TenantOwnerPublicSchema = {
    properties: {
        owner: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserPublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'owner'
    ],
    title: 'TenantOwnerPublic',
    type: 'object'
} as const;

export const TenantProfileSchema = {
    properties: {
        company_address_line1: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line1'
        },
        company_address_line2: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line2'
        },
        company_city: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company City'
        },
        company_country: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Country'
        },
        company_email: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Email'
        },
        company_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Name'
        },
        company_phone_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Phone Number'
        },
        company_state: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company State'
        },
        company_zip: {
            anyOf: [
                {
                    maxLength: 20,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Zip'
        }
    },
    required: [
        'company_name',
        'company_address_line1',
        'company_address_line2',
        'company_city',
        'company_state',
        'company_zip',
        'company_country',
        'company_phone_number',
        'company_email'
    ],
    title: 'TenantProfile',
    type: 'object'
} as const;

export const TenantPublicSchema = {
    properties: {
        afac_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Afac Cert No'
        },
        casa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Casa Cert No'
        },
        company_address_line1: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line1'
        },
        company_address_line2: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line2'
        },
        company_city: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company City'
        },
        company_country: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Country'
        },
        company_email: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Email'
        },
        company_logo_blob_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Logo Blob Name'
        },
        company_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Name'
        },
        company_phone_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Phone Number'
        },
        company_state: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company State'
        },
        company_zip: {
            anyOf: [
                {
                    maxLength: 20,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Zip'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        easa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Easa Cert No'
        },
        faa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Faa Cert No'
        },
        iata_code: {
            anyOf: [
                {
                    maxLength: 12,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Iata Code'
        },
        icao_code: {
            anyOf: [
                {
                    maxLength: 12,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Icao Code'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        is_internal: {
            default: false,
            title: 'Is Internal',
            type: 'boolean'
        },
        modules_enabled: {
            items: {
                type: 'string'
            },
            title: 'Modules Enabled',
            type: 'array'
        },
        name: {
            maxLength: 255,
            title: 'Name',
            type: 'string'
        },
        slug: {
            description: 'Lowercase alphanumeric slug for username prefixes (no spaces or hyphens)',
            maxLength: 50,
            minLength: 2,
            pattern: '^[a-z0-9]+$',
            title: 'Slug',
            type: 'string'
        },
        sonic_settings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SonicSettings'
                },
                {
                    type: 'null'
                }
            ]
        },
        tcca_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tcca Cert No'
        },
        type: {
            $ref: '#/components/schemas/TenantType'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        website: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Website'
        }
    },
    required: [
        'name',
        'slug',
        'type',
        'id',
        'created_at',
        'updated_at'
    ],
    title: 'TenantPublic',
    type: 'object'
} as const;

export const TenantQuotingSettingsPublicSchema = {
    properties: {
        default_currency: {
            $ref: '#/components/schemas/Currency'
        },
        default_due_horizon_from: {
            $ref: '#/components/schemas/DueHorizonFrom'
        },
        default_due_horizon_months: {
            title: 'Default Due Horizon Months',
            type: 'integer'
        },
        default_parts_markup: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Default Parts Markup'
        },
        default_validity_days: {
            title: 'Default Validity Days',
            type: 'integer'
        },
        due_list_task_prefix: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due List Task Prefix'
        },
        phases_enabled: {
            title: 'Phases Enabled',
            type: 'boolean'
        },
        proposal_letter: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Proposal Letter'
        },
        terms_and_conditions: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Terms And Conditions'
        },
        terms_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Terms Url'
        },
        win_on_customer_approval: {
            title: 'Win On Customer Approval',
            type: 'boolean'
        }
    },
    required: [
        'default_validity_days',
        'default_currency',
        'proposal_letter',
        'terms_and_conditions',
        'terms_url',
        'default_parts_markup',
        'due_list_task_prefix',
        'phases_enabled',
        'win_on_customer_approval',
        'default_due_horizon_months',
        'default_due_horizon_from'
    ],
    title: 'TenantQuotingSettingsPublic',
    type: 'object'
} as const;

export const TenantQuotingSettingsUpsertSchema = {
    properties: {
        default_currency: {
            $ref: '#/components/schemas/Currency'
        },
        default_due_horizon_from: {
            $ref: '#/components/schemas/DueHorizonFrom',
            default: 'arrival'
        },
        default_due_horizon_months: {
            default: 6,
            maximum: 60,
            minimum: 1,
            title: 'Default Due Horizon Months',
            type: 'integer'
        },
        default_parts_markup: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Default Parts Markup'
        },
        default_validity_days: {
            maximum: 32767,
            minimum: 1,
            title: 'Default Validity Days',
            type: 'integer'
        },
        due_list_task_prefix: {
            anyOf: [
                {
                    maxLength: 50,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due List Task Prefix'
        },
        phases_enabled: {
            default: false,
            title: 'Phases Enabled',
            type: 'boolean'
        },
        proposal_letter: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Proposal Letter'
        },
        terms_and_conditions: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Terms And Conditions'
        },
        terms_url: {
            anyOf: [
                {
                    format: 'uri',
                    maxLength: 2083,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Terms Url'
        },
        win_on_customer_approval: {
            default: true,
            title: 'Win On Customer Approval',
            type: 'boolean'
        }
    },
    required: [
        'default_validity_days',
        'default_currency'
    ],
    title: 'TenantQuotingSettingsUpsert',
    type: 'object'
} as const;

export const TenantSummaryPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_internal: {
            title: 'Is Internal',
            type: 'boolean'
        },
        logo_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Logo Url'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        slug: {
            title: 'Slug',
            type: 'string'
        }
    },
    required: [
        'id',
        'name',
        'slug',
        'is_internal'
    ],
    title: 'TenantSummaryPublic',
    type: 'object'
} as const;

export const TenantSystemPublicSchema = {
    properties: {
        afac_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Afac Cert No'
        },
        casa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Casa Cert No'
        },
        company_address_line1: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line1'
        },
        company_address_line2: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line2'
        },
        company_city: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company City'
        },
        company_country: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Country'
        },
        company_email: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Email'
        },
        company_logo_blob_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Logo Blob Name'
        },
        company_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Name'
        },
        company_phone_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Phone Number'
        },
        company_state: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company State'
        },
        company_zip: {
            anyOf: [
                {
                    maxLength: 20,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Zip'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        easa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Easa Cert No'
        },
        faa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Faa Cert No'
        },
        iata_code: {
            anyOf: [
                {
                    maxLength: 12,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Iata Code'
        },
        icao_code: {
            anyOf: [
                {
                    maxLength: 12,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Icao Code'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        ip_allowlist: {
            items: {
                type: 'string'
            },
            title: 'Ip Allowlist',
            type: 'array'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        is_internal: {
            default: false,
            title: 'Is Internal',
            type: 'boolean'
        },
        modules_enabled: {
            items: {
                type: 'string'
            },
            title: 'Modules Enabled',
            type: 'array'
        },
        name: {
            maxLength: 255,
            title: 'Name',
            type: 'string'
        },
        slug: {
            description: 'Lowercase alphanumeric slug for username prefixes (no spaces or hyphens)',
            maxLength: 50,
            minLength: 2,
            pattern: '^[a-z0-9]+$',
            title: 'Slug',
            type: 'string'
        },
        sonic_settings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SonicSettings'
                },
                {
                    type: 'null'
                }
            ]
        },
        tcca_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tcca Cert No'
        },
        trace_settings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TraceSettings'
                },
                {
                    type: 'null'
                }
            ]
        },
        type: {
            $ref: '#/components/schemas/TenantType'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        website: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Website'
        }
    },
    required: [
        'name',
        'slug',
        'type',
        'id',
        'created_at',
        'updated_at',
        'ip_allowlist',
        'trace_settings'
    ],
    title: 'TenantSystemPublic',
    type: 'object'
} as const;

export const TenantTypeSchema = {
    enum: [
        'airline',
        'independent_camo',
        'maintenance_organisation',
        'other'
    ],
    title: 'TenantType',
    type: 'string'
} as const;

export const TenantUpdateSchema = {
    properties: {
        afac_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Afac Cert No'
        },
        casa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Casa Cert No'
        },
        company_address_line1: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line1'
        },
        company_address_line2: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Address Line2'
        },
        company_city: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company City'
        },
        company_country: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Country'
        },
        company_email: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Email'
        },
        company_logo_blob_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Logo Blob Name'
        },
        company_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Name'
        },
        company_phone_number: {
            anyOf: [
                {
                    maxLength: 50,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Phone Number'
        },
        company_state: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company State'
        },
        company_zip: {
            anyOf: [
                {
                    maxLength: 20,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Company Zip'
        },
        easa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Easa Cert No'
        },
        faa_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Faa Cert No'
        },
        iata_code: {
            anyOf: [
                {
                    maxLength: 12,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Iata Code'
        },
        icao_code: {
            anyOf: [
                {
                    maxLength: 12,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Icao Code'
        },
        ip_allowlist: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ip Allowlist'
        },
        is_active: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Active'
        },
        modules_enabled: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/ModulesEnabled'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Modules Enabled'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        slug: {
            anyOf: [
                {
                    maxLength: 50,
                    minLength: 2,
                    pattern: '^[a-z0-9]+$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Slug'
        },
        sonic_settings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SonicSettings'
                },
                {
                    type: 'null'
                }
            ]
        },
        tcca_cert_no: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tcca Cert No'
        },
        trace_settings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TraceSettings'
                },
                {
                    type: 'null'
                }
            ]
        },
        type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TenantType'
                },
                {
                    type: 'null'
                }
            ]
        },
        website: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Website'
        }
    },
    title: 'TenantUpdate',
    type: 'object'
} as const;

export const TenantsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TenantPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TenantsPublic',
    type: 'object'
} as const;

export const TextConditionSchema = {
    additionalProperties: false,
    properties: {
        op: {
            const: 'text',
            title: 'Op',
            type: 'string'
        },
        text: {
            title: 'Text',
            type: 'string'
        }
    },
    required: [
        'op',
        'text'
    ],
    title: 'TextCondition',
    type: 'object'
} as const;

export const TextConditionValueSchema = {
    properties: {
        kind: {
            const: 'text',
            title: 'Kind',
            type: 'string'
        },
        meaning: {
            title: 'Meaning',
            type: 'string'
        }
    },
    required: [
        'kind',
        'meaning'
    ],
    title: 'TextConditionValue',
    type: 'object'
} as const;

export const TextReferenceSchema = {
    properties: {
        page: {
            minimum: 1,
            title: 'Page',
            type: 'integer'
        },
        text: {
            minLength: 1,
            title: 'Text',
            type: 'string'
        },
        type: {
            const: 'text',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'page',
        'text'
    ],
    title: 'TextReference',
    type: 'object'
} as const;

export const TieInAgentCreateSchema = {
    properties: {
        content: {
            title: 'Content',
            type: 'string'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        }
    },
    required: [
        'content'
    ],
    title: 'TieInAgentCreate',
    type: 'object'
} as const;

export const TieInAssignmentSchema = {
    properties: {
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        type: {
            $ref: '#/components/schemas/TieInReferenceType'
        }
    },
    required: [
        'type',
        'number'
    ],
    title: 'TieInAssignment',
    type: 'object'
} as const;

export const TieInListItemSchema = {
    properties: {
        assignment: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TieInAssignment'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        final_text: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Final Text'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        original_text: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Original Text'
        }
    },
    required: [
        'id',
        'created_at',
        'final_text',
        'original_text'
    ],
    title: 'TieInListItem',
    type: 'object'
} as const;

export const TieInListPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TieInListItem'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TieInListPublic',
    type: 'object'
} as const;

export const TieInReferenceSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        latest_tie_in_at: {
            format: 'date-time',
            title: 'Latest Tie In At',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        reference_type: {
            $ref: '#/components/schemas/TieInReferenceType'
        },
        tie_ins: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/TaskTranscriptPublic'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tie Ins'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'latest_tie_in_at',
        'reference_type'
    ],
    title: 'TieInReference',
    type: 'object'
} as const;

export const TieInReferenceTypeSchema = {
    enum: [
        'work_task',
        'work_package'
    ],
    title: 'TieInReferenceType',
    type: 'string'
} as const;

export const TieInReferencesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TieInReference'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TieInReferencesPublic',
    type: 'object'
} as const;

export const TimeEntriesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TimeEntryDetailPublic'
            },
            title: 'Data',
            type: 'array'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/TimeEntryGroupPublic'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'data',
        'count',
        'groups'
    ],
    title: 'TimeEntriesPublic',
    type: 'object'
} as const;

export const TimeEntryCreateSchema = {
    properties: {
        ended_at: {
            format: 'date-time',
            title: 'Ended At',
            type: 'string'
        },
        started_at: {
            format: 'date-time',
            title: 'Started At',
            type: 'string'
        },
        work_task_id: {
            format: 'uuid',
            title: 'Work Task Id',
            type: 'string'
        }
    },
    required: [
        'work_task_id',
        'started_at',
        'ended_at'
    ],
    title: 'TimeEntryCreate',
    type: 'object'
} as const;

export const TimeEntryDetailPublicSchema = {
    properties: {
        duration: {
            title: 'Duration',
            type: 'number'
        },
        ended_at: {
            format: 'date-time',
            title: 'Ended At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        started_at: {
            format: 'date-time',
            title: 'Started At',
            type: 'string'
        },
        task: {
            $ref: '#/components/schemas/TimeEntryTaskPublic'
        },
        user: {
            $ref: '#/components/schemas/UserBasicInfo'
        },
        work_task_id: {
            format: 'uuid',
            title: 'Work Task Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'work_task_id',
        'started_at',
        'ended_at',
        'duration',
        'task',
        'user'
    ],
    title: 'TimeEntryDetailPublic',
    type: 'object'
} as const;

export const TimeEntryFilterOptionsPublicSchema = {
    properties: {
        aircraft: {
            items: {
                type: 'string'
            },
            title: 'Aircraft',
            type: 'array'
        },
        work_orders: {
            items: {
                $ref: '#/components/schemas/TimeEntryWorkOrderOptionPublic'
            },
            title: 'Work Orders',
            type: 'array'
        }
    },
    required: [
        'work_orders',
        'aircraft'
    ],
    title: 'TimeEntryFilterOptionsPublic',
    type: 'object'
} as const;

export const TimeEntryGroupPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        included: {
            title: 'Included',
            type: 'integer'
        },
        key: {
            title: 'Key',
            type: 'string'
        },
        minutes: {
            title: 'Minutes',
            type: 'integer'
        },
        subgroups: {
            items: {
                $ref: '#/components/schemas/SubgroupCountPublic'
            },
            title: 'Subgroups',
            type: 'array'
        }
    },
    required: [
        'key',
        'count',
        'minutes',
        'subgroups',
        'included'
    ],
    title: 'TimeEntryGroupPublic',
    type: 'object'
} as const;

export const TimeEntryGroupingSchema = {
    enum: [
        'work_order',
        'aircraft',
        'day'
    ],
    title: 'TimeEntryGrouping',
    type: 'string'
} as const;

export const TimeEntryStatusSchema = {
    enum: [
        'running',
        'logged'
    ],
    title: 'TimeEntryStatus',
    type: 'string'
} as const;

export const TimeEntryTaskPublicSchema = {
    properties: {
        asset: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Asset'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        work_package_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Description'
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        },
        work_package_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Number'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'work_package_id',
        'work_package_number',
        'work_package_description',
        'asset'
    ],
    title: 'TimeEntryTaskPublic',
    type: 'object'
} as const;

export const TimeEntryTasksPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TimeEntryTaskPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TimeEntryTasksPublic',
    type: 'object'
} as const;

export const TimeEntryWorkOrderOptionPublicSchema = {
    properties: {
        asset: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Asset'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        }
    },
    required: [
        'id',
        'number',
        'asset'
    ],
    title: 'TimeEntryWorkOrderOptionPublic',
    type: 'object'
} as const;

export const TimeGroupingSchema = {
    properties: {
        hrs: {
            title: 'Hrs',
            type: 'string'
        },
        ldg: {
            title: 'Ldg',
            type: 'string'
        },
        mos: {
            title: 'Mos',
            type: 'string'
        }
    },
    required: [
        'mos',
        'hrs',
        'ldg'
    ],
    title: 'TimeGrouping',
    type: 'object'
} as const;

export const TimerDetailPublicSchema = {
    properties: {
        elapsed: {
            title: 'Elapsed',
            type: 'number'
        },
        since: {
            format: 'date-time',
            title: 'Since',
            type: 'string'
        },
        status: {
            $ref: '#/components/schemas/TimerStatus'
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/TimerTaskDetailPublic'
            },
            title: 'Tasks',
            type: 'array'
        },
        user: {
            $ref: '#/components/schemas/UserBasicInfo'
        }
    },
    required: [
        'status',
        'since',
        'elapsed',
        'user',
        'tasks'
    ],
    title: 'TimerDetailPublic',
    type: 'object'
} as const;

export const TimerStatusSchema = {
    enum: [
        'running',
        'paused'
    ],
    title: 'TimerStatus',
    type: 'string'
} as const;

export const TimerTaskDetailPublicSchema = {
    properties: {
        booked: {
            title: 'Booked',
            type: 'number'
        },
        started_at: {
            format: 'date-time',
            title: 'Started At',
            type: 'string'
        },
        task: {
            $ref: '#/components/schemas/TimeEntryTaskPublic'
        },
        work_task_id: {
            format: 'uuid',
            title: 'Work Task Id',
            type: 'string'
        }
    },
    required: [
        'work_task_id',
        'started_at',
        'booked',
        'task'
    ],
    title: 'TimerTaskDetailPublic',
    type: 'object'
} as const;

export const ToApprovedSchema = {
    properties: {
        status: {
            const: 'approved',
            title: 'Status',
            type: 'string'
        }
    },
    required: [
        'status'
    ],
    title: 'ToApproved',
    type: 'object'
} as const;

export const ToPendingReviewSchema = {
    properties: {
        status: {
            const: 'pending_review',
            title: 'Status',
            type: 'string'
        }
    },
    required: [
        'status'
    ],
    title: 'ToPendingReview',
    type: 'object'
} as const;

export const ToRejectedSchema = {
    properties: {
        status: {
            const: 'rejected',
            title: 'Status',
            type: 'string'
        }
    },
    required: [
        'status'
    ],
    title: 'ToRejected',
    type: 'object'
} as const;

export const ToVerifiedSchema = {
    properties: {
        status: {
            const: 'verified',
            title: 'Status',
            type: 'string'
        }
    },
    required: [
        'status'
    ],
    title: 'ToVerified',
    type: 'object'
} as const;

export const TokenSchema = {
    properties: {
        access_token: {
            title: 'Access Token',
            type: 'string'
        },
        must_change_password: {
            default: false,
            title: 'Must Change Password',
            type: 'boolean'
        },
        token_type: {
            default: 'bearer',
            title: 'Token Type',
            type: 'string'
        }
    },
    required: [
        'access_token'
    ],
    title: 'Token',
    type: 'object'
} as const;

export const ToleranceSchema = {
    additionalProperties: false,
    properties: {
        minus: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Quantity'
                },
                {
                    type: 'null'
                }
            ]
        },
        plus: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Quantity'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    title: 'Tolerance',
    type: 'object'
} as const;

export const ToolAvailabilitySchema = {
    enum: [
        'permanent',
        'occasional'
    ],
    title: 'ToolAvailability',
    type: 'string'
} as const;

export const ToolCalibrationCompleteSchema = {
    properties: {
        certificate_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certificate Document Id'
        },
        certificate_number: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certificate Number'
        },
        performed_on: {
            format: 'date',
            title: 'Performed On',
            type: 'string'
        },
        result: {
            $ref: '#/components/schemas/ToolCalibrationResult'
        }
    },
    required: [
        'performed_on',
        'result'
    ],
    title: 'ToolCalibrationComplete',
    type: 'object'
} as const;

export const ToolCalibrationCreateSchema = {
    discriminator: {
        mapping: {
            record: '#/components/schemas/RecordCalibration',
            send: '#/components/schemas/SendForCalibration'
        },
        propertyName: 'kind'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/SendForCalibration'
        },
        {
            $ref: '#/components/schemas/RecordCalibration'
        }
    ],
    title: 'ToolCalibrationCreate'
} as const;

export const ToolCalibrationDetailPublicSchema = {
    properties: {
        certificate_document: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        certificate_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certificate Document Id'
        },
        certificate_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certificate Number'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        expected_back_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Back On'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        performed_by: {
            title: 'Performed By',
            type: 'string'
        },
        performed_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Performed On'
        },
        result: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ToolCalibrationResult'
                },
                {
                    type: 'null'
                }
            ]
        },
        sent_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sent On'
        },
        tool_id: {
            format: 'uuid',
            title: 'Tool Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'tool_id',
        'performed_by',
        'sent_on',
        'expected_back_on',
        'performed_on',
        'result',
        'certificate_number',
        'certificate_document_id',
        'created_at',
        'certificate_document'
    ],
    title: 'ToolCalibrationDetailPublic',
    type: 'object'
} as const;

export const ToolCalibrationResultSchema = {
    enum: [
        'pass',
        'adjusted',
        'fail'
    ],
    title: 'ToolCalibrationResult',
    type: 'string'
} as const;

export const ToolCalibrationStatusSchema = {
    enum: [
        'not_required',
        'current',
        'due_soon',
        'overdue'
    ],
    title: 'ToolCalibrationStatus',
    type: 'string'
} as const;

export const ToolCategoriesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ToolCategoryPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ToolCategoriesPublic',
    type: 'object'
} as const;

export const ToolCategoryCreateSchema = {
    properties: {
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'name'
    ],
    title: 'ToolCategoryCreate',
    type: 'object'
} as const;

export const ToolCategoryPublicSchema = {
    properties: {
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'id',
        'name',
        'position',
        'deleted_at'
    ],
    title: 'ToolCategoryPublic',
    type: 'object'
} as const;

export const ToolCategoryUpdateSchema = {
    properties: {
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        position: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        }
    },
    title: 'ToolCategoryUpdate',
    type: 'object'
} as const;

export const ToolClassificationSchema = {
    enum: [
        'calibration_controlled',
        'accountable',
        'untracked'
    ],
    title: 'ToolClassification',
    type: 'string'
} as const;

export const ToolConditionSchema = {
    enum: [
        'serviceable',
        'unserviceable',
        'quarantined'
    ],
    title: 'ToolCondition',
    type: 'string'
} as const;

export const ToolCreateSchema = {
    properties: {
        calibration_interval_months: {
            anyOf: [
                {
                    maximum: 240,
                    minimum: 1,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Interval Months'
        },
        calibration_standard: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Standard'
        },
        calibration_traceability: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Traceability'
        },
        category_id: {
            format: 'uuid',
            title: 'Category Id',
            type: 'string'
        },
        classification: {
            $ref: '#/components/schemas/ToolClassification'
        },
        description: {
            maxLength: 2000,
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        facility_id: {
            format: 'uuid',
            title: 'Facility Id',
            type: 'string'
        },
        home_location_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Home Location Id'
        },
        is_precision: {
            default: false,
            title: 'Is Precision',
            type: 'boolean'
        },
        manufacturer: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Model'
        },
        number: {
            maxLength: 64,
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        serial_number: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    required: [
        'number',
        'description',
        'classification',
        'category_id',
        'facility_id'
    ],
    title: 'ToolCreate',
    type: 'object'
} as const;

export const ToolDetailPublicSchema = {
    properties: {
        active_calibrations: {
            items: {
                $ref: '#/components/schemas/ToolCalibrationDetailPublic'
            },
            title: 'Active Calibrations',
            type: 'array'
        },
        active_documents: {
            items: {
                $ref: '#/components/schemas/ToolDocumentDetailPublic'
            },
            title: 'Active Documents',
            type: 'array'
        },
        active_loans: {
            items: {
                $ref: '#/components/schemas/ToolLoanDetailPublic'
            },
            title: 'Active Loans',
            type: 'array'
        },
        availability: {
            $ref: '#/components/schemas/ToolAvailability'
        },
        availability_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Availability Note'
        },
        blocks_issue_out_of_calibration: {
            title: 'Blocks Issue Out Of Calibration',
            type: 'boolean'
        },
        calibration_due_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Due On'
        },
        calibration_interval_months: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Interval Months'
        },
        calibration_standard: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Standard'
        },
        calibration_status: {
            $ref: '#/components/schemas/ToolCalibrationStatus'
        },
        calibration_traceability: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Traceability'
        },
        category: {
            $ref: '#/components/schemas/ToolCategoryPublic'
        },
        category_id: {
            format: 'uuid',
            title: 'Category Id',
            type: 'string'
        },
        classification: {
            $ref: '#/components/schemas/ToolClassification'
        },
        condition: {
            $ref: '#/components/schemas/ToolCondition'
        },
        condition_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Condition Note'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        custodian: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        facility_id: {
            format: 'uuid',
            title: 'Facility Id',
            type: 'string'
        },
        fod_controlled: {
            title: 'Fod Controlled',
            type: 'boolean'
        },
        home_location_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Home Location Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        inspect_on_return: {
            title: 'Inspect On Return',
            type: 'boolean'
        },
        is_precision: {
            title: 'Is Precision',
            type: 'boolean'
        },
        issuability: {
            $ref: '#/components/schemas/ToolIssuability'
        },
        last_calibrated_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Calibrated On'
        },
        loan_due_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Loan Due On'
        },
        manufacturer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Model'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        owner: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        owner_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Id'
        },
        ownership: {
            $ref: '#/components/schemas/ToolOwnership'
        },
        ownership_approval: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ownership Approval'
        },
        restricted_use: {
            title: 'Restricted Use',
            type: 'boolean'
        },
        retired_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Retired At'
        },
        retired_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        status: {
            $ref: '#/components/schemas/ToolStatus'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        vendor_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Name'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'classification',
        'category_id',
        'facility_id',
        'serial_number',
        'manufacturer',
        'model',
        'home_location_id',
        'is_precision',
        'calibration_interval_months',
        'calibration_standard',
        'calibration_traceability',
        'condition',
        'condition_note',
        'ownership',
        'owner_id',
        'ownership_approval',
        'vendor_name',
        'availability',
        'availability_note',
        'blocks_issue_out_of_calibration',
        'inspect_on_return',
        'restricted_use',
        'fod_controlled',
        'retired_at',
        'created_at',
        'updated_at',
        'status',
        'issuability',
        'calibration_status',
        'last_calibrated_on',
        'calibration_due_on',
        'custodian',
        'loan_due_on',
        'category',
        'owner',
        'retired_by',
        'active_loans',
        'active_calibrations',
        'active_documents'
    ],
    title: 'ToolDetailPublic',
    type: 'object'
} as const;

export const ToolDocumentCreateSchema = {
    properties: {
        caption: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Caption'
        },
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        }
    },
    required: [
        'document_id'
    ],
    title: 'ToolDocumentCreate',
    type: 'object'
} as const;

export const ToolDocumentDetailPublicSchema = {
    properties: {
        added_by: {
            $ref: '#/components/schemas/UserBasicInfo'
        },
        added_by_id: {
            format: 'uuid',
            title: 'Added By Id',
            type: 'string'
        },
        caption: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Caption'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        document: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        document_id: {
            format: 'uuid',
            title: 'Document Id',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        tool_id: {
            format: 'uuid',
            title: 'Tool Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'tool_id',
        'document_id',
        'added_by_id',
        'caption',
        'created_at',
        'added_by',
        'document'
    ],
    title: 'ToolDocumentDetailPublic',
    type: 'object'
} as const;

export const ToolIssuabilitySchema = {
    enum: [
        'issuable',
        'unavailable',
        'untracked',
        'out_of_calibration'
    ],
    title: 'ToolIssuability',
    type: 'string'
} as const;

export const ToolIssueSchema = {
    properties: {
        custodian_id: {
            format: 'uuid',
            title: 'Custodian Id',
            type: 'string'
        },
        due_on: {
            format: 'date',
            title: 'Due On',
            type: 'string'
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    required: [
        'custodian_id',
        'work_package_id',
        'due_on'
    ],
    title: 'ToolIssue',
    type: 'object'
} as const;

export const ToolLoanDetailPublicSchema = {
    properties: {
        custodian: {
            $ref: '#/components/schemas/UserBasicInfo'
        },
        custodian_id: {
            format: 'uuid',
            title: 'Custodian Id',
            type: 'string'
        },
        due_on: {
            format: 'date',
            title: 'Due On',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_overdue: {
            title: 'Is Overdue',
            type: 'boolean'
        },
        issued_at: {
            format: 'date-time',
            title: 'Issued At',
            type: 'string'
        },
        issued_by: {
            $ref: '#/components/schemas/UserBasicInfo'
        },
        issued_by_id: {
            format: 'uuid',
            title: 'Issued By Id',
            type: 'string'
        },
        received_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        received_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Received By Id'
        },
        return_condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ToolReturnCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        return_document: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DocumentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        return_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Return Document Id'
        },
        return_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Return Note'
        },
        returned_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Returned At'
        },
        tool_id: {
            format: 'uuid',
            title: 'Tool Id',
            type: 'string'
        },
        work_package: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackagePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        },
        work_task: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkTaskPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    required: [
        'id',
        'tool_id',
        'custodian_id',
        'work_package_id',
        'work_task_id',
        'work_task_step_id',
        'issued_by_id',
        'issued_at',
        'due_on',
        'returned_at',
        'received_by_id',
        'return_condition',
        'return_note',
        'return_document_id',
        'is_overdue',
        'custodian',
        'issued_by',
        'received_by',
        'work_package',
        'work_task',
        'return_document'
    ],
    title: 'ToolLoanDetailPublic',
    type: 'object'
} as const;

export const ToolLoanUpdateSchema = {
    properties: {
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    title: 'ToolLoanUpdate',
    type: 'object'
} as const;

export const ToolOwnershipSchema = {
    enum: [
        'shop',
        'personal',
        'vendor'
    ],
    title: 'ToolOwnership',
    type: 'string'
} as const;

export const ToolPublicSchema = {
    properties: {
        availability: {
            $ref: '#/components/schemas/ToolAvailability'
        },
        availability_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Availability Note'
        },
        blocks_issue_out_of_calibration: {
            title: 'Blocks Issue Out Of Calibration',
            type: 'boolean'
        },
        calibration_due_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Due On'
        },
        calibration_interval_months: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Interval Months'
        },
        calibration_standard: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Standard'
        },
        calibration_status: {
            $ref: '#/components/schemas/ToolCalibrationStatus'
        },
        calibration_traceability: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Traceability'
        },
        category_id: {
            format: 'uuid',
            title: 'Category Id',
            type: 'string'
        },
        classification: {
            $ref: '#/components/schemas/ToolClassification'
        },
        condition: {
            $ref: '#/components/schemas/ToolCondition'
        },
        condition_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Condition Note'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        custodian: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        facility_id: {
            format: 'uuid',
            title: 'Facility Id',
            type: 'string'
        },
        fod_controlled: {
            title: 'Fod Controlled',
            type: 'boolean'
        },
        home_location_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Home Location Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        inspect_on_return: {
            title: 'Inspect On Return',
            type: 'boolean'
        },
        is_precision: {
            title: 'Is Precision',
            type: 'boolean'
        },
        issuability: {
            $ref: '#/components/schemas/ToolIssuability'
        },
        last_calibrated_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Calibrated On'
        },
        loan_due_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Loan Due On'
        },
        manufacturer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Model'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        owner_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Id'
        },
        ownership: {
            $ref: '#/components/schemas/ToolOwnership'
        },
        ownership_approval: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ownership Approval'
        },
        restricted_use: {
            title: 'Restricted Use',
            type: 'boolean'
        },
        retired_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Retired At'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        status: {
            $ref: '#/components/schemas/ToolStatus'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        vendor_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Name'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'classification',
        'category_id',
        'facility_id',
        'serial_number',
        'manufacturer',
        'model',
        'home_location_id',
        'is_precision',
        'calibration_interval_months',
        'calibration_standard',
        'calibration_traceability',
        'condition',
        'condition_note',
        'ownership',
        'owner_id',
        'ownership_approval',
        'vendor_name',
        'availability',
        'availability_note',
        'blocks_issue_out_of_calibration',
        'inspect_on_return',
        'restricted_use',
        'fod_controlled',
        'retired_at',
        'created_at',
        'updated_at',
        'status',
        'issuability',
        'calibration_status',
        'last_calibrated_on',
        'calibration_due_on',
        'custodian',
        'loan_due_on'
    ],
    title: 'ToolPublic',
    type: 'object'
} as const;

export const ToolReceiveSchema = {
    properties: {
        condition: {
            $ref: '#/components/schemas/ToolReturnCondition'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        note: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        }
    },
    required: [
        'condition'
    ],
    title: 'ToolReceive',
    type: 'object'
} as const;

export const ToolReturnConditionSchema = {
    enum: [
        'serviceable',
        'damaged',
        'quarantine'
    ],
    title: 'ToolReturnCondition',
    type: 'string'
} as const;

export const ToolStatusSchema = {
    enum: [
        'available',
        'on_loan',
        'in_calibration',
        'out_of_service',
        'retired'
    ],
    title: 'ToolStatus',
    type: 'string'
} as const;

export const ToolSummaryPublicSchema = {
    properties: {
        calibration_due_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Due On'
        },
        calibration_status: {
            $ref: '#/components/schemas/ToolCalibrationStatus'
        },
        classification: {
            $ref: '#/components/schemas/ToolClassification'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'serial_number',
        'classification',
        'calibration_due_on',
        'calibration_status'
    ],
    title: 'ToolSummaryPublic',
    type: 'object'
} as const;

export const ToolUpdateSchema = {
    properties: {
        availability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ToolAvailability'
                },
                {
                    type: 'null'
                }
            ]
        },
        availability_note: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Availability Note'
        },
        blocks_issue_out_of_calibration: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Blocks Issue Out Of Calibration'
        },
        calibration_interval_months: {
            anyOf: [
                {
                    maximum: 240,
                    minimum: 1,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Interval Months'
        },
        calibration_standard: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Standard'
        },
        calibration_traceability: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Calibration Traceability'
        },
        category_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Category Id'
        },
        classification: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ToolClassification'
                },
                {
                    type: 'null'
                }
            ]
        },
        condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ToolCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        condition_note: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Condition Note'
        },
        description: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        fod_controlled: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fod Controlled'
        },
        home_location_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Home Location Id'
        },
        inspect_on_return: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inspect On Return'
        },
        is_precision: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Precision'
        },
        manufacturer: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manufacturer'
        },
        model: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Model'
        },
        number: {
            anyOf: [
                {
                    maxLength: 64,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        owner_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Id'
        },
        ownership: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ToolOwnership'
                },
                {
                    type: 'null'
                }
            ]
        },
        ownership_approval: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ownership Approval'
        },
        restricted_use: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Restricted Use'
        },
        serial_number: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        vendor_name: {
            anyOf: [
                {
                    maxLength: 2000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Name'
        }
    },
    title: 'ToolUpdate',
    type: 'object'
} as const;

export const ToolsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/ToolPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'ToolsPublic',
    type: 'object'
} as const;

export const TraceActivityPublicSchema = {
    properties: {
        busy_keys: {
            items: {
                type: 'string'
            },
            title: 'Busy Keys',
            type: 'array'
        },
        idle: {
            title: 'Idle',
            type: 'boolean'
        }
    },
    required: [
        'idle',
        'busy_keys'
    ],
    title: 'TraceActivityPublic',
    type: 'object'
} as const;

export const TraceAdEvalReportCreateSchema = {
    description: 'Schema for creating a new AD trace evaluation report.',
    properties: {
        ad_reason: {
            title: 'Ad Reason',
            type: 'string'
        },
        ad_reason_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Reason Edited'
        },
        ad_reason_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Reason References'
        },
        ad_record_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Record Id'
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        applicable_msn: {
            title: 'Applicable Msn',
            type: 'boolean'
        },
        applicable_msn_edited: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicable Msn Edited'
        },
        applicable_msn_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicable Msn References'
        },
        compliance_requirements: {
            title: 'Compliance Requirements',
            type: 'string'
        },
        compliance_requirements_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Requirements Edited'
        },
        compliance_requirements_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Requirements References'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        due_date: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        due_date_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date Edited'
        },
        due_date_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date References'
        },
        initial_assessment: {
            title: 'Initial Assessment',
            type: 'string'
        },
        initial_assessment_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Initial Assessment Edited'
        },
        initial_assessment_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Initial Assessment References'
        },
        recurrent_ad: {
            title: 'Recurrent Ad',
            type: 'boolean'
        },
        recurrent_ad_edited: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Recurrent Ad Edited'
        },
        recurrent_ad_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Recurrent Ad References'
        },
        status: {
            default: 'pending',
            enum: [
                'pending',
                'in_progress'
            ],
            title: 'Status',
            type: 'string'
        }
    },
    required: [
        'initial_assessment',
        'applicable_msn',
        'ad_reason',
        'compliance_requirements',
        'recurrent_ad'
    ],
    title: 'TraceAdEvalReportCreate',
    type: 'object'
} as const;

export const TraceAdEvalReportPublicSchema = {
    description: 'Schema for public AD trace evaluation report.',
    properties: {
        ad_reason: {
            title: 'Ad Reason',
            type: 'string'
        },
        ad_reason_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Reason Edited'
        },
        ad_reason_finalised: {
            title: 'Ad Reason Finalised',
            type: 'boolean'
        },
        ad_reason_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Reason References'
        },
        ad_record_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Record Id'
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        applicable_msn: {
            title: 'Applicable Msn',
            type: 'boolean'
        },
        applicable_msn_edited: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicable Msn Edited'
        },
        applicable_msn_finalised: {
            title: 'Applicable Msn Finalised',
            type: 'boolean'
        },
        applicable_msn_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicable Msn References'
        },
        compliance_requirements: {
            title: 'Compliance Requirements',
            type: 'string'
        },
        compliance_requirements_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Requirements Edited'
        },
        compliance_requirements_finalised: {
            title: 'Compliance Requirements Finalised',
            type: 'boolean'
        },
        compliance_requirements_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Requirements References'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        due_date: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        due_date_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date Edited'
        },
        due_date_finalised: {
            title: 'Due Date Finalised',
            type: 'boolean'
        },
        due_date_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date References'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        initial_assessment: {
            title: 'Initial Assessment',
            type: 'string'
        },
        initial_assessment_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Initial Assessment Edited'
        },
        initial_assessment_finalised: {
            title: 'Initial Assessment Finalised',
            type: 'boolean'
        },
        initial_assessment_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Initial Assessment References'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        recurrent_ad: {
            title: 'Recurrent Ad',
            type: 'boolean'
        },
        recurrent_ad_edited: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Recurrent Ad Edited'
        },
        recurrent_ad_finalised: {
            title: 'Recurrent Ad Finalised',
            type: 'boolean'
        },
        recurrent_ad_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Recurrent Ad References'
        },
        status: {
            enum: [
                'pending',
                'in_progress',
                'completed'
            ],
            title: 'Status',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        trace_id: {
            format: 'uuid',
            title: 'Trace Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'initial_assessment',
        'applicable_msn',
        'ad_reason',
        'compliance_requirements',
        'recurrent_ad',
        'id',
        'trace_id',
        'tenant_id',
        'status',
        'initial_assessment_finalised',
        'applicable_msn_finalised',
        'ad_reason_finalised',
        'compliance_requirements_finalised',
        'recurrent_ad_finalised',
        'due_date_finalised',
        'created_at',
        'updated_at'
    ],
    title: 'TraceAdEvalReportPublic',
    type: 'object'
} as const;

export const TraceAdEvalReportPublicMinimalSchema = {
    description: 'Minimal trace AD eval report information for display.',
    properties: {
        ad_reason: {
            title: 'Ad Reason',
            type: 'string'
        },
        ad_reason_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ad Reason Edited'
        },
        ad_reason_finalised: {
            title: 'Ad Reason Finalised',
            type: 'boolean'
        },
        applicable_msn: {
            title: 'Applicable Msn',
            type: 'boolean'
        },
        applicable_msn_edited: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicable Msn Edited'
        },
        applicable_msn_finalised: {
            title: 'Applicable Msn Finalised',
            type: 'boolean'
        },
        compliance_requirements: {
            title: 'Compliance Requirements',
            type: 'string'
        },
        compliance_requirements_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Requirements Edited'
        },
        compliance_requirements_finalised: {
            title: 'Compliance Requirements Finalised',
            type: 'boolean'
        },
        due_date: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        due_date_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date Edited'
        },
        due_date_finalised: {
            title: 'Due Date Finalised',
            type: 'boolean'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        initial_assessment: {
            title: 'Initial Assessment',
            type: 'string'
        },
        initial_assessment_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Initial Assessment Edited'
        },
        initial_assessment_finalised: {
            title: 'Initial Assessment Finalised',
            type: 'boolean'
        },
        recurrent_ad: {
            title: 'Recurrent Ad',
            type: 'boolean'
        },
        recurrent_ad_edited: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Recurrent Ad Edited'
        },
        recurrent_ad_finalised: {
            title: 'Recurrent Ad Finalised',
            type: 'boolean'
        },
        status: {
            enum: [
                'pending',
                'in_progress',
                'completed'
            ],
            title: 'Status',
            type: 'string'
        }
    },
    required: [
        'id',
        'status',
        'initial_assessment',
        'applicable_msn',
        'ad_reason',
        'compliance_requirements',
        'recurrent_ad',
        'initial_assessment_finalised',
        'applicable_msn_finalised',
        'ad_reason_finalised',
        'compliance_requirements_finalised',
        'recurrent_ad_finalised',
        'due_date_finalised'
    ],
    title: 'TraceAdEvalReportPublicMinimal',
    type: 'object'
} as const;

export const TraceMessagePublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        role: {
            $ref: '#/components/schemas/TraceMessageRole'
        },
        text: {
            title: 'Text',
            type: 'string'
        }
    },
    required: [
        'role',
        'text',
        'created_at'
    ],
    title: 'TraceMessagePublic',
    type: 'object'
} as const;

export const TraceMessageRoleSchema = {
    enum: [
        'user',
        'assistant'
    ],
    title: 'TraceMessageRole',
    type: 'string'
} as const;

export const TraceMessagesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TraceMessagePublic'
            },
            title: 'Data',
            type: 'array'
        },
        trace: {
            $ref: '#/components/schemas/TracePublic'
        }
    },
    required: [
        'trace',
        'data',
        'count'
    ],
    title: 'TraceMessagesPublic',
    type: 'object'
} as const;

export const TracePublicSchema = {
    properties: {
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        status: {
            $ref: '#/components/schemas/TraceStatus'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        title: {
            title: 'Title',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        }
    },
    required: [
        'title',
        'status',
        'id',
        'tenant_id',
        'created_at',
        'updated_at'
    ],
    title: 'TracePublic',
    type: 'object'
} as const;

export const TraceSbEvalReportCreateSchema = {
    description: 'Schema for creating a new SB trace evaluation report.',
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        applicability: {
            title: 'Applicability',
            type: 'string'
        },
        applicability_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicability Edited'
        },
        applicability_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicability References'
        },
        compliance: {
            title: 'Compliance',
            type: 'string'
        },
        compliance_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Edited'
        },
        compliance_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance References'
        },
        concurrent_requirements: {
            title: 'Concurrent Requirements',
            type: 'string'
        },
        concurrent_requirements_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Concurrent Requirements Edited'
        },
        concurrent_requirements_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Concurrent Requirements References'
        },
        consumables: {
            title: 'Consumables',
            type: 'string'
        },
        consumables_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Consumables Edited'
        },
        consumables_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Consumables References'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        electrical_load_analysis: {
            title: 'Electrical Load Analysis',
            type: 'string'
        },
        electrical_load_analysis_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Electrical Load Analysis Edited'
        },
        electrical_load_analysis_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Electrical Load Analysis References'
        },
        manpower_requirements: {
            title: 'Manpower Requirements',
            type: 'string'
        },
        manpower_requirements_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manpower Requirements Edited'
        },
        manpower_requirements_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manpower Requirements References'
        },
        manuals_publications_affected: {
            title: 'Manuals Publications Affected',
            type: 'string'
        },
        manuals_publications_affected_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manuals Publications Affected Edited'
        },
        manuals_publications_affected_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manuals Publications Affected References'
        },
        parts_required: {
            title: 'Parts Required',
            type: 'string'
        },
        parts_required_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parts Required Edited'
        },
        parts_required_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parts Required References'
        },
        service_bulletin_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Service Bulletin Id'
        },
        status: {
            default: 'pending',
            enum: [
                'pending',
                'in_progress'
            ],
            title: 'Status',
            type: 'string'
        },
        tooling_required: {
            title: 'Tooling Required',
            type: 'string'
        },
        tooling_required_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tooling Required Edited'
        },
        tooling_required_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tooling Required References'
        },
        weight_and_balance_impact: {
            title: 'Weight And Balance Impact',
            type: 'string'
        },
        weight_and_balance_impact_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Weight And Balance Impact Edited'
        },
        weight_and_balance_impact_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Input'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Input'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Weight And Balance Impact References'
        }
    },
    required: [
        'applicability',
        'manpower_requirements',
        'electrical_load_analysis',
        'weight_and_balance_impact',
        'parts_required',
        'tooling_required',
        'compliance',
        'concurrent_requirements',
        'consumables',
        'manuals_publications_affected'
    ],
    title: 'TraceSbEvalReportCreate',
    type: 'object'
} as const;

export const TraceSbEvalReportPublicSchema = {
    description: 'Schema for public SB trace evaluation report.',
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        applicability: {
            title: 'Applicability',
            type: 'string'
        },
        applicability_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicability Edited'
        },
        applicability_finalised: {
            title: 'Applicability Finalised',
            type: 'boolean'
        },
        applicability_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicability References'
        },
        compliance: {
            title: 'Compliance',
            type: 'string'
        },
        compliance_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Edited'
        },
        compliance_finalised: {
            title: 'Compliance Finalised',
            type: 'boolean'
        },
        compliance_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance References'
        },
        concurrent_requirements: {
            title: 'Concurrent Requirements',
            type: 'string'
        },
        concurrent_requirements_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Concurrent Requirements Edited'
        },
        concurrent_requirements_finalised: {
            title: 'Concurrent Requirements Finalised',
            type: 'boolean'
        },
        concurrent_requirements_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Concurrent Requirements References'
        },
        consumables: {
            title: 'Consumables',
            type: 'string'
        },
        consumables_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Consumables Edited'
        },
        consumables_finalised: {
            title: 'Consumables Finalised',
            type: 'boolean'
        },
        consumables_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Consumables References'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        electrical_load_analysis: {
            title: 'Electrical Load Analysis',
            type: 'string'
        },
        electrical_load_analysis_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Electrical Load Analysis Edited'
        },
        electrical_load_analysis_finalised: {
            title: 'Electrical Load Analysis Finalised',
            type: 'boolean'
        },
        electrical_load_analysis_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Electrical Load Analysis References'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        manpower_requirements: {
            title: 'Manpower Requirements',
            type: 'string'
        },
        manpower_requirements_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manpower Requirements Edited'
        },
        manpower_requirements_finalised: {
            title: 'Manpower Requirements Finalised',
            type: 'boolean'
        },
        manpower_requirements_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manpower Requirements References'
        },
        manuals_publications_affected: {
            title: 'Manuals Publications Affected',
            type: 'string'
        },
        manuals_publications_affected_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manuals Publications Affected Edited'
        },
        manuals_publications_affected_finalised: {
            title: 'Manuals Publications Affected Finalised',
            type: 'boolean'
        },
        manuals_publications_affected_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manuals Publications Affected References'
        },
        parts_required: {
            title: 'Parts Required',
            type: 'string'
        },
        parts_required_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parts Required Edited'
        },
        parts_required_finalised: {
            title: 'Parts Required Finalised',
            type: 'boolean'
        },
        parts_required_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parts Required References'
        },
        service_bulletin_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Service Bulletin Id'
        },
        status: {
            enum: [
                'pending',
                'in_progress',
                'completed'
            ],
            title: 'Status',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        tooling_required: {
            title: 'Tooling Required',
            type: 'string'
        },
        tooling_required_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tooling Required Edited'
        },
        tooling_required_finalised: {
            title: 'Tooling Required Finalised',
            type: 'boolean'
        },
        tooling_required_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tooling Required References'
        },
        trace_id: {
            format: 'uuid',
            title: 'Trace Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        weight_and_balance_impact: {
            title: 'Weight And Balance Impact',
            type: 'string'
        },
        weight_and_balance_impact_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Weight And Balance Impact Edited'
        },
        weight_and_balance_impact_finalised: {
            title: 'Weight And Balance Impact Finalised',
            type: 'boolean'
        },
        weight_and_balance_impact_references: {
            anyOf: [
                {
                    items: {
                        anyOf: [
                            {
                                $ref: '#/components/schemas/DatabaseReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReference-Output'
                            },
                            {
                                $ref: '#/components/schemas/DocumentRegionReferenceV2-Output'
                            }
                        ]
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Weight And Balance Impact References'
        }
    },
    required: [
        'applicability',
        'manpower_requirements',
        'electrical_load_analysis',
        'weight_and_balance_impact',
        'parts_required',
        'tooling_required',
        'compliance',
        'concurrent_requirements',
        'consumables',
        'manuals_publications_affected',
        'id',
        'trace_id',
        'tenant_id',
        'status',
        'applicability_finalised',
        'manpower_requirements_finalised',
        'electrical_load_analysis_finalised',
        'weight_and_balance_impact_finalised',
        'parts_required_finalised',
        'tooling_required_finalised',
        'compliance_finalised',
        'concurrent_requirements_finalised',
        'consumables_finalised',
        'manuals_publications_affected_finalised',
        'created_at',
        'updated_at'
    ],
    title: 'TraceSbEvalReportPublic',
    type: 'object'
} as const;

export const TraceSbEvalReportPublicMinimalSchema = {
    description: 'Minimal trace SB eval report information for display.',
    properties: {
        applicability: {
            title: 'Applicability',
            type: 'string'
        },
        applicability_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicability Edited'
        },
        applicability_finalised: {
            title: 'Applicability Finalised',
            type: 'boolean'
        },
        compliance: {
            title: 'Compliance',
            type: 'string'
        },
        compliance_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Compliance Edited'
        },
        compliance_finalised: {
            title: 'Compliance Finalised',
            type: 'boolean'
        },
        concurrent_requirements: {
            title: 'Concurrent Requirements',
            type: 'string'
        },
        concurrent_requirements_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Concurrent Requirements Edited'
        },
        concurrent_requirements_finalised: {
            title: 'Concurrent Requirements Finalised',
            type: 'boolean'
        },
        consumables: {
            title: 'Consumables',
            type: 'string'
        },
        consumables_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Consumables Edited'
        },
        consumables_finalised: {
            title: 'Consumables Finalised',
            type: 'boolean'
        },
        electrical_load_analysis: {
            title: 'Electrical Load Analysis',
            type: 'string'
        },
        electrical_load_analysis_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Electrical Load Analysis Edited'
        },
        electrical_load_analysis_finalised: {
            title: 'Electrical Load Analysis Finalised',
            type: 'boolean'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        manpower_requirements: {
            title: 'Manpower Requirements',
            type: 'string'
        },
        manpower_requirements_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manpower Requirements Edited'
        },
        manpower_requirements_finalised: {
            title: 'Manpower Requirements Finalised',
            type: 'boolean'
        },
        manuals_publications_affected: {
            title: 'Manuals Publications Affected',
            type: 'string'
        },
        manuals_publications_affected_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manuals Publications Affected Edited'
        },
        manuals_publications_affected_finalised: {
            title: 'Manuals Publications Affected Finalised',
            type: 'boolean'
        },
        parts_required: {
            title: 'Parts Required',
            type: 'string'
        },
        parts_required_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parts Required Edited'
        },
        parts_required_finalised: {
            title: 'Parts Required Finalised',
            type: 'boolean'
        },
        status: {
            enum: [
                'pending',
                'in_progress',
                'completed'
            ],
            title: 'Status',
            type: 'string'
        },
        tooling_required: {
            title: 'Tooling Required',
            type: 'string'
        },
        tooling_required_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tooling Required Edited'
        },
        tooling_required_finalised: {
            title: 'Tooling Required Finalised',
            type: 'boolean'
        },
        weight_and_balance_impact: {
            title: 'Weight And Balance Impact',
            type: 'string'
        },
        weight_and_balance_impact_edited: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Weight And Balance Impact Edited'
        },
        weight_and_balance_impact_finalised: {
            title: 'Weight And Balance Impact Finalised',
            type: 'boolean'
        }
    },
    required: [
        'id',
        'status',
        'applicability',
        'manpower_requirements',
        'electrical_load_analysis',
        'weight_and_balance_impact',
        'parts_required',
        'tooling_required',
        'compliance',
        'concurrent_requirements',
        'consumables',
        'manuals_publications_affected',
        'applicability_finalised',
        'manpower_requirements_finalised',
        'electrical_load_analysis_finalised',
        'weight_and_balance_impact_finalised',
        'parts_required_finalised',
        'tooling_required_finalised',
        'compliance_finalised',
        'concurrent_requirements_finalised',
        'consumables_finalised',
        'manuals_publications_affected_finalised'
    ],
    title: 'TraceSbEvalReportPublicMinimal',
    type: 'object'
} as const;

export const TraceScopeSchema = {
    enum: [
        'active',
        'archived'
    ],
    title: 'TraceScope',
    type: 'string'
} as const;

export const TraceSearchHitPublicSchema = {
    properties: {
        messages: {
            items: {
                $ref: '#/components/schemas/TraceMessagePublic'
            },
            title: 'Messages',
            type: 'array'
        },
        trace: {
            $ref: '#/components/schemas/TracePublic'
        }
    },
    required: [
        'trace',
        'messages'
    ],
    title: 'TraceSearchHitPublic',
    type: 'object'
} as const;

export const TraceSearchPublicSchema = {
    properties: {
        data: {
            items: {
                $ref: '#/components/schemas/TraceSearchHitPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data'
    ],
    title: 'TraceSearchPublic',
    type: 'object'
} as const;

export const TraceSettingsSchema = {
    properties: {
        agents_md: {
            anyOf: [
                {
                    maxLength: 8000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Agents Md'
        }
    },
    title: 'TraceSettings',
    type: 'object'
} as const;

export const TraceStatusSchema = {
    description: 'Status of a trace.',
    enum: [
        'draft',
        'active',
        'archived'
    ],
    title: 'TraceStatus',
    type: 'string'
} as const;

export const TraceUpdateSchema = {
    properties: {
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        }
    },
    title: 'TraceUpdate',
    type: 'object'
} as const;

export const TraceWorkTasksUpdateSchema = {
    description: 'Request payload to set WorkTask associations for a trace.\nReplaces all existing associations with the provided list.',
    properties: {
        work_task_ids: {
            default: [],
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Work Task Ids',
            type: 'array'
        }
    },
    title: 'TraceWorkTasksUpdate',
    type: 'object'
} as const;

export const TracesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/TracePublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'TracesPublic',
    type: 'object'
} as const;

export const TrackedComponentPublicSchema = {
    properties: {
        aircraft_id: {
            format: 'uuid',
            title: 'Aircraft Id',
            type: 'string'
        },
        fitted_component_id: {
            format: 'uuid',
            title: 'Fitted Component Id',
            type: 'string'
        },
        major_assembly: {
            anyOf: [
                {
                    $ref: '#/components/schemas/MajorAssemblyKind'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Description'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        },
        position: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        },
        programme_id: {
            format: 'uuid',
            title: 'Programme Id',
            type: 'string'
        },
        programme_number: {
            title: 'Programme Number',
            type: 'string'
        },
        registration: {
            title: 'Registration',
            type: 'string'
        },
        revision_id: {
            format: 'uuid',
            title: 'Revision Id',
            type: 'string'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        task_id: {
            format: 'uuid',
            title: 'Task Id',
            type: 'string'
        },
        task_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Number'
        },
        title: {
            title: 'Title',
            type: 'string'
        }
    },
    required: [
        'aircraft_id',
        'registration',
        'fitted_component_id',
        'major_assembly',
        'part_number',
        'serial_number',
        'part_description',
        'position',
        'programme_id',
        'programme_number',
        'revision_id',
        'task_id',
        'task_number',
        'title'
    ],
    title: 'TrackedComponentPublic',
    type: 'object'
} as const;

export const TrackedComponentsPublicSchema = {
    properties: {
        data: {
            items: {
                $ref: '#/components/schemas/TrackedComponentPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data'
    ],
    title: 'TrackedComponentsPublic',
    type: 'object'
} as const;

export const TranscriptionPublicSchema = {
    properties: {
        text: {
            title: 'Text',
            type: 'string'
        }
    },
    required: [
        'text'
    ],
    title: 'TranscriptionPublic',
    type: 'object'
} as const;

export const TypeCertificateModelPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        model_designation: {
            title: 'Model Designation',
            type: 'string'
        },
        type_certificate: {
            $ref: '#/components/schemas/TypeCertificatePublic'
        }
    },
    required: [
        'id',
        'model_designation',
        'type_certificate'
    ],
    title: 'TypeCertificateModelPublic',
    type: 'object'
} as const;

export const TypeCertificateModelVariantGroupSchema = {
    properties: {
        current_holder_name: {
            title: 'Current Holder Name',
            type: 'string'
        },
        model_designation: {
            title: 'Model Designation',
            type: 'string'
        },
        variants: {
            items: {
                $ref: '#/components/schemas/TypeCertificateModelVariantPublic'
            },
            title: 'Variants',
            type: 'array'
        }
    },
    required: [
        'current_holder_name',
        'model_designation',
        'variants'
    ],
    title: 'TypeCertificateModelVariantGroup',
    type: 'object'
} as const;

export const TypeCertificateModelVariantPublicSchema = {
    properties: {
        icao_type_designator: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Icao Type Designator'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        marketing_name: {
            title: 'Marketing Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'marketing_name',
        'icao_type_designator'
    ],
    title: 'TypeCertificateModelVariantPublic',
    type: 'object'
} as const;

export const TypeCertificateModelVariantWithParentPublicSchema = {
    properties: {
        icao_type_designator: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Icao Type Designator'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        marketing_name: {
            title: 'Marketing Name',
            type: 'string'
        },
        type_certificate_model: {
            $ref: '#/components/schemas/TypeCertificateModelPublic'
        }
    },
    required: [
        'id',
        'marketing_name',
        'icao_type_designator',
        'type_certificate_model'
    ],
    title: 'TypeCertificateModelVariantWithParentPublic',
    type: 'object'
} as const;

export const TypeCertificatePublicSchema = {
    properties: {
        authority: {
            title: 'Authority',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            title: 'Number',
            type: 'string'
        }
    },
    required: [
        'id',
        'authority',
        'number'
    ],
    title: 'TypeCertificatePublic',
    type: 'object'
} as const;

export const UnitSchema = {
    enum: [
        'hours',
        'calendar_hours',
        'cycles',
        'landings',
        'days',
        'months',
        'years'
    ],
    title: 'Unit',
    type: 'string'
} as const;

export const UpdateAtlPageSchema = {
    properties: {
        aircraft_registration: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Registration'
        },
        aircraft_type: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Type'
        },
        cabin_crew: {
            items: {
                minLength: 1,
                type: 'string'
            },
            title: 'Cabin Crew',
            type: 'array'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/CheckOperation'
            },
            title: 'Checks',
            type: 'array'
        },
        commander: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Commander'
        },
        component_changes: {
            items: {
                $ref: '#/components/schemas/ComponentChangeOperation'
            },
            title: 'Component Changes',
            type: 'array'
        },
        confirmed: {
            items: {
                type: 'string'
            },
            title: 'Confirmed',
            type: 'array'
        },
        current_crs_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Current Crs Reference'
        },
        defects: {
            items: {
                $ref: '#/components/schemas/DefectOperation'
            },
            title: 'Defects',
            type: 'array'
        },
        document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Id'
        },
        first_officer: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'First Officer'
        },
        flagged_fields: {
            items: {
                type: 'string'
            },
            title: 'Flagged Fields',
            type: 'array'
        },
        fluid_uplifts: {
            items: {
                $ref: '#/components/schemas/FluidUpliftOperation'
            },
            title: 'Fluid Uplifts',
            type: 'array'
        },
        form_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Form Reference'
        },
        log_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Log Number'
        },
        maintenance_status_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Maintenance Status Reference'
        },
        operator: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Operator'
        },
        purser: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purser'
        },
        sectors: {
            items: {
                $ref: '#/components/schemas/SectorOperation'
            },
            title: 'Sectors',
            type: 'array'
        }
    },
    title: 'UpdateAtlPage',
    type: 'object'
} as const;

export const UpdateChargeSchema = {
    properties: {
        cost_quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost Quantity'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        document_references: {
            items: {
                $ref: '#/components/schemas/DocumentReferenceOperation'
            },
            title: 'Document References',
            type: 'array'
        },
        estimate_kind: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimate Kind'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        lead_time: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Time'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        part_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        purchase_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Unit Price'
        },
        quantity: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Quantity'
        },
        sale_unit_price: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Unit Price'
        },
        tax_amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tax Amount'
        },
        turnaround_time: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Turnaround Time'
        },
        type: {
            $ref: '#/components/schemas/ChargeType',
            title: 'Type'
        },
        unit_of_measure: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        },
        vendor_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vendor Id'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateCharge',
    type: 'object'
} as const;

export const UpdateCheckSchema = {
    properties: {
        approval_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certified_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified On'
        },
        certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        check_name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Check Name'
        },
        confirmed: {
            items: {
                type: 'string'
            },
            title: 'Confirmed',
            type: 'array'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        station_code: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Station Code'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateCheck',
    type: 'object'
} as const;

export const UpdateCheckResponseSchema = {
    properties: {
        installer_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Installer Url'
        },
        release_date: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Release Date'
        },
        sha512: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sha512'
        },
        update_available: {
            title: 'Update Available',
            type: 'boolean'
        },
        version: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Version'
        }
    },
    required: [
        'update_available'
    ],
    title: 'UpdateCheckResponse',
    type: 'object'
} as const;

export const UpdateComponentChangeSchema = {
    properties: {
        component_name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Component Name'
        },
        confirmed: {
            items: {
                type: 'string'
            },
            title: 'Confirmed',
            type: 'array'
        },
        defect_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Defect Id'
        },
        form1_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Form1 Reference'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        part_number_off: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number Off'
        },
        part_number_on: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number On'
        },
        removal_note: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Removal Note'
        },
        serial_number_off: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number Off'
        },
        serial_number_on: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number On'
        },
        tag_number_off: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tag Number Off'
        },
        tag_number_on: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tag Number On'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateComponentChange',
    type: 'object'
} as const;

export const UpdateDefectSchema = {
    properties: {
        accomplished_iaw: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Accomplished Iaw'
        },
        approval_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        ata_chapter: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certified_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified On'
        },
        certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        complaint_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Complaint Number'
        },
        confirmed: {
            items: {
                type: 'string'
            },
            title: 'Confirmed',
            type: 'array'
        },
        corrective_action: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corrective Action'
        },
        deferral_kind: {
            $ref: '#/components/schemas/DeferralKind',
            title: 'Deferral Kind'
        },
        deferral_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferral Number'
        },
        deferred_at_cycles: {
            anyOf: [
                {
                    maximum: 2147483647,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Cycles'
        },
        deferred_at_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deferred At Hours'
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        disposition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDefectDisposition'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Disposition'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        fault_code: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fault Code'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        item_number: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Item Number'
        },
        limitations: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Limitations'
        },
        maintenance_completed: {
            title: 'Maintenance Completed',
            type: 'boolean'
        },
        mel_category: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationCategory'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mel Category'
        },
        mel_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mel Reference'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        procedure_tasks: {
            items: {
                $ref: '#/components/schemas/AtlProcedureTaskEntry-Input'
            },
            title: 'Procedure Tasks',
            type: 'array'
        },
        rectification_unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/RectificationUnit'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rectification Unit'
        },
        rectification_value: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rectification Value'
        },
        reported_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AtlDefectSource'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported By'
        },
        reported_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported Date'
        },
        reported_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reported Time'
        },
        rie_applied: {
            title: 'Rie Applied',
            type: 'boolean'
        },
        rie_approval_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Approval Date'
        },
        rie_original_due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Original Due Date'
        },
        rie_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rie Reference'
        },
        sector_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sector Id'
        },
        work_order_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Order Number'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateDefect',
    type: 'object'
} as const;

export const UpdateDiscountSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Amount'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        percentage: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    maximum: 100,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Percentage'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateDiscount',
    type: 'object'
} as const;

export const UpdateDueStatusSchema = {
    properties: {
        is_overdue: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Overdue'
        },
        limits: {
            items: {
                $ref: '#/components/schemas/LimitOperation'
            },
            title: 'Limits',
            type: 'array'
        },
        raw: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Raw'
        }
    },
    title: 'UpdateDueStatus',
    type: 'object'
} as const;

export const UpdateFeeSchema = {
    properties: {
        amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Amount'
        },
        cap_amount: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cap Amount'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_taxable: {
            title: 'Is Taxable',
            type: 'boolean'
        },
        name: {
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateFee',
    type: 'object'
} as const;

export const UpdateFluidUpliftSchema = {
    properties: {
        approval_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Reference'
        },
        certified_at: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certified At'
        },
        certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certifier'
        },
        confirmed: {
            items: {
                type: 'string'
            },
            title: 'Confirmed',
            type: 'array'
        },
        fluid_type: {
            $ref: '#/components/schemas/FluidType',
            title: 'Fluid Type'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        position: {
            $ref: '#/components/schemas/FluidPosition',
            title: 'Position'
        },
        quantity: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Quantity'
        },
        sector_id: {
            format: 'uuid',
            title: 'Sector Id',
            type: 'string'
        },
        unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FluidUnit'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateFluidUplift',
    type: 'object'
} as const;

export const UpdateLimitSchema = {
    properties: {
        due_at: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        remaining: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Remaining'
        },
        unit: {
            $ref: '#/components/schemas/DueUnit',
            title: 'Unit'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateLimit',
    type: 'object'
} as const;

export const UpdatePasswordSchema = {
    properties: {
        current_password: {
            maxLength: 128,
            minLength: 8,
            title: 'Current Password',
            type: 'string'
        },
        new_password: {
            maxLength: 128,
            minLength: 12,
            title: 'New Password',
            type: 'string'
        }
    },
    required: [
        'current_password',
        'new_password'
    ],
    title: 'UpdatePassword',
    type: 'object'
} as const;

export const UpdateProgrammeSchema = {
    properties: {
        model_variant_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            minItems: 1,
            title: 'Model Variant Ids',
            type: 'array'
        },
        status: {
            $ref: '#/components/schemas/ProgrammeStatus',
            title: 'Status'
        },
        title: {
            minLength: 1,
            title: 'Title',
            type: 'string'
        }
    },
    title: 'UpdateProgramme',
    type: 'object'
} as const;

export const UpdateProgrammeCheckSchema = {
    properties: {
        code: {
            minLength: 1,
            title: 'Code',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        included_check_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            title: 'Included Check Ids',
            type: 'array'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        schedule: {
            $ref: '#/components/schemas/Schedule-Input'
        },
        title: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateProgrammeCheck',
    type: 'object'
} as const;

export const UpdateProgrammeRevisionSchema = {
    properties: {
        change_summary: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Change Summary'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/ProgrammeCheckOperation'
            },
            maxItems: 100,
            title: 'Checks',
            type: 'array'
        },
        document_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Document Number'
        },
        issue: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue'
        },
        issue_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issue Date'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/ProgrammeTaskOperation'
            },
            maxItems: 100,
            title: 'Tasks',
            type: 'array'
        }
    },
    title: 'UpdateProgrammeRevision',
    type: 'object'
} as const;

export const UpdateProgrammeTaskSchema = {
    properties: {
        access: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Access'
        },
        access_man_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Access Man Hours'
        },
        applicability: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Condition-Input'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Applicability'
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        check_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            maxItems: 50,
            title: 'Check Ids',
            type: 'array'
        },
        cmr_escalation_allowed: {
            title: 'Cmr Escalation Allowed',
            type: 'boolean'
        },
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        man_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Man Hours'
        },
        men: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Men'
        },
        on_condition: {
            title: 'On Condition',
            type: 'boolean'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        preparation: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Preparation'
        },
        preparation_man_hours: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Preparation Man Hours'
        },
        references: {
            items: {
                $ref: '#/components/schemas/ProgrammeTaskReferenceBase'
            },
            maxItems: 50,
            title: 'References',
            type: 'array'
        },
        schedule: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Schedule-Input'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Schedule'
        },
        section: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Section'
        },
        skill_codes: {
            items: {
                $ref: '#/components/schemas/SkillCode'
            },
            title: 'Skill Codes',
            type: 'array'
        },
        sources: {
            items: {
                $ref: '#/components/schemas/ProgrammeTaskSource'
            },
            title: 'Sources',
            type: 'array'
        },
        task_code: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskCode'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Code'
        },
        task_number: {
            minLength: 1,
            title: 'Task Number',
            type: 'string'
        },
        time_controlled_item: {
            title: 'Time Controlled Item',
            type: 'boolean'
        },
        title: {
            minLength: 1,
            title: 'Title',
            type: 'string'
        },
        zones: {
            items: {
                minLength: 1,
                type: 'string'
            },
            title: 'Zones',
            type: 'array'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateProgrammeTask',
    type: 'object'
} as const;

export const UpdateQuoteSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        auto_expire: {
            title: 'Auto Expire',
            type: 'boolean'
        },
        billing_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Billing Address Id'
        },
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        currency: {
            $ref: '#/components/schemas/Currency'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        discounts: {
            items: {
                $ref: '#/components/schemas/DiscountOperation'
            },
            title: 'Discounts',
            type: 'array'
        },
        due_horizon_from: {
            $ref: '#/components/schemas/DueHorizonFrom',
            title: 'Due Horizon From'
        },
        due_horizon_months: {
            maximum: 60,
            minimum: 1,
            title: 'Due Horizon Months',
            type: 'integer'
        },
        estimated_close_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Close On'
        },
        estimator_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimator Id'
        },
        expected_arrival_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Arrival At'
        },
        expected_departure_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Departure At'
        },
        expected_finish_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Finish At'
        },
        expected_start_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expected Start At'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        fees: {
            items: {
                $ref: '#/components/schemas/FeeOperation'
            },
            title: 'Fees',
            type: 'array'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        promised_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised On'
        },
        rate_card_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rate Card Id'
        },
        requested_delivery_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested Delivery On'
        },
        requested_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requested On'
        },
        sales_region: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Region'
        },
        sales_rep_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Rep Id'
        },
        shipping_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Shipping Address Id'
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/TaskOperation'
            },
            title: 'Tasks',
            type: 'array'
        },
        tax_destination: {
            $ref: '#/components/schemas/TaxDestination',
            title: 'Tax Destination'
        },
        tax_exempt: {
            title: 'Tax Exempt',
            type: 'boolean'
        },
        tax_rates: {
            items: {
                $ref: '#/components/schemas/TaxRateOperation'
            },
            title: 'Tax Rates',
            type: 'array'
        },
        title: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        valid_until: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Valid Until'
        },
        win_probability: {
            anyOf: [
                {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Win Probability'
        }
    },
    title: 'UpdateQuote',
    type: 'object'
} as const;

export const UpdateSectorSchema = {
    properties: {
        autoland: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Autoland'
        },
        block_minutes: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block Minutes'
        },
        block_off: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block Off'
        },
        block_on: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Block On'
        },
        commander_acceptance: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Commander Acceptance'
        },
        confirmed: {
            items: {
                type: 'string'
            },
            title: 'Confirmed',
            type: 'array'
        },
        cycles_since_new: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cycles Since New'
        },
        deicing_mix_ratio: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Mix Ratio'
        },
        deicing_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Time'
        },
        deicing_type: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deicing Type'
        },
        flight_cycles: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Cycles'
        },
        flight_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Date'
        },
        flight_minutes: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Minutes'
        },
        flight_nature: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Nature'
        },
        flight_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Number'
        },
        flight_off: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight Off'
        },
        flight_on: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flight On'
        },
        from_station: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'From Station'
        },
        fuel_arrival_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Arrival Kg'
        },
        fuel_density: {
            anyOf: [
                {
                    exclusiveMinimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Density'
        },
        fuel_departure_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Departure Kg'
        },
        fuel_extra_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Extra Kg'
        },
        fuel_extra_reason: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Extra Reason'
        },
        fuel_min_required_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Min Required Kg'
        },
        fuel_uplift_kg: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Uplift Kg'
        },
        fuel_uplift_litres: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fuel Uplift Litres'
        },
        go_arounds: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Go Arounds'
        },
        hours_since_new: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours Since New'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        landing_pilot: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landing Pilot'
        },
        landings: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Landings'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        pre_flight_certifier: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pre Flight Certifier'
        },
        security_check_time: {
            anyOf: [
                {
                    format: 'time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Security Check Time'
        },
        takeoff_pilot: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Takeoff Pilot'
        },
        thrust_setting: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thrust Setting'
        },
        time_correction_minutes: {
            anyOf: [
                {
                    maximum: 1440,
                    minimum: -1440,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Time Correction Minutes'
        },
        to_station: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'To Station'
        },
        touch_and_go: {
            anyOf: [
                {
                    maximum: 32767,
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Touch And Go'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateSector',
    type: 'object'
} as const;

export const UpdateTaskSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        canned_work_task_id: {
            format: 'uuid',
            title: 'Canned Work Task Id',
            type: 'string'
        },
        charges: {
            items: {
                $ref: '#/components/schemas/ChargeOperation'
            },
            title: 'Charges',
            type: 'array'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        document_references: {
            items: {
                $ref: '#/components/schemas/DocumentReferenceOperation'
            },
            title: 'Document References',
            type: 'array'
        },
        due_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UpdateDueStatus'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Status'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            minLength: 1,
            title: 'Number',
            type: 'string'
        },
        operation: {
            const: 'update',
            title: 'Operation',
            type: 'string'
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        phase_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Phase Ids',
            type: 'array'
        },
        resolution: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Severity'
        },
        status: {
            $ref: '#/components/schemas/QuoteTaskStatus',
            title: 'Status'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        }
    },
    required: [
        'operation',
        'id'
    ],
    title: 'UpdateTask',
    type: 'object'
} as const;

export const UploadStatusSchema = {
    enum: [
        'pending',
        'processing',
        'completed',
        'failed'
    ],
    title: 'UploadStatus',
    type: 'string'
} as const;

export const UpsertCountsSchema = {
    properties: {
        created: {
            title: 'Created',
            type: 'integer'
        },
        unchanged: {
            title: 'Unchanged',
            type: 'integer'
        },
        updated: {
            title: 'Updated',
            type: 'integer'
        }
    },
    required: [
        'created',
        'updated',
        'unchanged'
    ],
    title: 'UpsertCounts',
    type: 'object'
} as const;

export const UsageConditionSchema = {
    additionalProperties: false,
    properties: {
        component: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComponentMatch'
                },
                {
                    type: 'null'
                }
            ]
        },
        on: {
            $ref: '#/components/schemas/Measured',
            default: 'aircraft'
        },
        op: {
            const: 'usage',
            title: 'Op',
            type: 'string'
        },
        over: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Over'
        },
        unit: {
            $ref: '#/components/schemas/Unit'
        },
        up_to: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Up To'
        }
    },
    required: [
        'op',
        'unit'
    ],
    title: 'UsageCondition',
    type: 'object'
} as const;

export const UserBasicInfoSchema = {
    properties: {
        designation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserDesignation'
                },
                {
                    type: 'null'
                }
            ]
        },
        first_name: {
            title: 'First Name',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_name: {
            title: 'Last Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'first_name',
        'last_name',
        'designation'
    ],
    title: 'UserBasicInfo',
    type: 'object'
} as const;

export const UserBulkCreateSchema = {
    properties: {
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        designation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserDesignation'
                },
                {
                    type: 'null'
                }
            ]
        },
        email: {
            anyOf: [
                {
                    format: 'email',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        first_name: {
            maxLength: 255,
            title: 'First Name',
            type: 'string'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        is_system_user: {
            default: false,
            title: 'Is System User',
            type: 'boolean'
        },
        job_title: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_name: {
            maxLength: 255,
            title: 'Last Name',
            type: 'string'
        },
        must_change_password: {
            default: true,
            title: 'Must Change Password',
            type: 'boolean'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        role_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Role Ids'
        },
        username: {
            description: 'Lowercase alphanumeric username (prefix added automatically)',
            maxLength: 49,
            minLength: 2,
            pattern: '^[a-z0-9_]+$',
            title: 'Username',
            type: 'string'
        }
    },
    required: [
        'username',
        'first_name',
        'last_name'
    ],
    title: 'UserBulkCreate',
    type: 'object'
} as const;

export const UserCreateSchema = {
    properties: {
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        designation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserDesignation'
                },
                {
                    type: 'null'
                }
            ]
        },
        email: {
            anyOf: [
                {
                    format: 'email',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        first_name: {
            maxLength: 255,
            title: 'First Name',
            type: 'string'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        is_system_user: {
            default: false,
            title: 'Is System User',
            type: 'boolean'
        },
        job_title: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_name: {
            maxLength: 255,
            title: 'Last Name',
            type: 'string'
        },
        password: {
            maxLength: 128,
            minLength: 12,
            title: 'Password',
            type: 'string'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        role_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Role Ids'
        },
        username: {
            description: 'Lowercase alphanumeric username (prefix added automatically)',
            maxLength: 49,
            minLength: 2,
            pattern: '^[a-z0-9_]+$',
            title: 'Username',
            type: 'string'
        }
    },
    required: [
        'username',
        'first_name',
        'last_name',
        'password'
    ],
    title: 'UserCreate',
    type: 'object'
} as const;

export const UserCreateFailureSchema = {
    properties: {
        errors: {
            items: {
                $ref: '#/components/schemas/UserFieldError'
            },
            title: 'Errors',
            type: 'array'
        },
        message: {
            title: 'Message',
            type: 'string'
        },
        username: {
            title: 'Username',
            type: 'string'
        }
    },
    required: [
        'username',
        'message',
        'errors'
    ],
    title: 'UserCreateFailure',
    type: 'object'
} as const;

export const UserCreateFieldSchema = {
    enum: [
        'username',
        'email'
    ],
    title: 'UserCreateField',
    type: 'string'
} as const;

export const UserDesignationSchema = {
    enum: [
        'technician',
        'inspector',
        'administrative_staff',
        'other'
    ],
    title: 'UserDesignation',
    type: 'string'
} as const;

export const UserFieldErrorSchema = {
    properties: {
        field: {
            $ref: '#/components/schemas/UserCreateField'
        },
        message: {
            title: 'Message',
            type: 'string'
        }
    },
    required: [
        'field',
        'message'
    ],
    title: 'UserFieldError',
    type: 'object'
} as const;

export const UserPriceSchema = {
    properties: {
        amount: {
            title: 'Amount',
            type: 'string'
        },
        date: {
            format: 'date-time',
            title: 'Date',
            type: 'string'
        },
        source: {
            const: 'user',
            default: 'user',
            title: 'Source',
            type: 'string'
        },
        user: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'amount',
        'date',
        'user'
    ],
    title: 'UserPrice',
    type: 'object'
} as const;

export const UserPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        designation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserDesignation'
                },
                {
                    type: 'null'
                }
            ]
        },
        email: {
            anyOf: [
                {
                    format: 'email',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        first_name: {
            maxLength: 255,
            title: 'First Name',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        is_system_user: {
            default: false,
            title: 'Is System User',
            type: 'boolean'
        },
        is_tenant_owner: {
            title: 'Is Tenant Owner',
            type: 'boolean'
        },
        job_title: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_login_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Login At'
        },
        last_name: {
            maxLength: 255,
            title: 'Last Name',
            type: 'string'
        },
        must_change_password: {
            title: 'Must Change Password',
            type: 'boolean'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        role_labels: {
            items: {
                $ref: '#/components/schemas/RoleLabelPublic'
            },
            readOnly: true,
            title: 'Role Labels',
            type: 'array'
        },
        role_names: {
            items: {
                type: 'string'
            },
            title: 'Role Names',
            type: 'array'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        username: {
            description: 'Lowercase alphanumeric username (prefix added automatically)',
            maxLength: 49,
            minLength: 2,
            pattern: '^[a-z0-9_]+$',
            title: 'Username',
            type: 'string'
        }
    },
    required: [
        'username',
        'first_name',
        'last_name',
        'id',
        'tenant_id',
        'is_tenant_owner',
        'last_login_at',
        'must_change_password',
        'created_at',
        'updated_at',
        'role_names',
        'role_labels'
    ],
    title: 'UserPublic',
    type: 'object'
} as const;

export const UserPublicMeSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        designation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserDesignation'
                },
                {
                    type: 'null'
                }
            ]
        },
        email: {
            anyOf: [
                {
                    format: 'email',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        first_name: {
            maxLength: 255,
            title: 'First Name',
            type: 'string'
        },
        has_signing_pin: {
            title: 'Has Signing Pin',
            type: 'boolean'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_active: {
            default: true,
            title: 'Is Active',
            type: 'boolean'
        },
        is_internal: {
            title: 'Is Internal',
            type: 'boolean'
        },
        is_superuser: {
            readOnly: true,
            title: 'Is Superuser',
            type: 'boolean'
        },
        is_system_user: {
            default: false,
            title: 'Is System User',
            type: 'boolean'
        },
        job_title: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_login_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Login At'
        },
        last_name: {
            maxLength: 255,
            title: 'Last Name',
            type: 'string'
        },
        must_change_password: {
            title: 'Must Change Password',
            type: 'boolean'
        },
        permissions: {
            items: {
                type: 'string'
            },
            title: 'Permissions',
            type: 'array'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        role_labels: {
            items: {
                $ref: '#/components/schemas/RoleLabelPublic'
            },
            readOnly: true,
            title: 'Role Labels',
            type: 'array'
        },
        role_names: {
            items: {
                type: 'string'
            },
            title: 'Role Names',
            type: 'array'
        },
        signing_pin_changed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Signing Pin Changed At'
        },
        signing_pin_last_used_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Signing Pin Last Used At'
        },
        signing_pin_locked: {
            title: 'Signing Pin Locked',
            type: 'boolean'
        },
        tenant: {
            $ref: '#/components/schemas/TenantSummaryPublic'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        username: {
            description: 'Lowercase alphanumeric username (prefix added automatically)',
            maxLength: 49,
            minLength: 2,
            pattern: '^[a-z0-9_]+$',
            title: 'Username',
            type: 'string'
        }
    },
    required: [
        'username',
        'first_name',
        'last_name',
        'id',
        'tenant',
        'last_login_at',
        'must_change_password',
        'has_signing_pin',
        'signing_pin_locked',
        'signing_pin_changed_at',
        'signing_pin_last_used_at',
        'is_internal',
        'created_at',
        'updated_at',
        'role_names',
        'permissions',
        'is_superuser',
        'role_labels'
    ],
    title: 'UserPublicMe',
    type: 'object'
} as const;

export const UserPublicMinimalSchema = {
    description: 'Minimal user information for display.',
    properties: {
        email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        full_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Full Name'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        }
    },
    required: [
        'id'
    ],
    title: 'UserPublicMinimal',
    type: 'object'
} as const;

export const UserReferenceSchema = {
    properties: {
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        position_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Position Ids',
            type: 'array'
        },
        role_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Role Ids',
            type: 'array'
        },
        team_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Team Ids',
            type: 'array'
        }
    },
    required: [
        'id',
        'name',
        'email',
        'department_id',
        'facility_id',
        'team_ids',
        'role_ids',
        'position_ids'
    ],
    title: 'UserReference',
    type: 'object'
} as const;

export const UserRoleCreateSchema = {
    description: 'Schema for assigning roles to users.',
    properties: {
        role_id: {
            format: 'uuid',
            title: 'Role Id',
            type: 'string'
        },
        user_id: {
            format: 'uuid',
            title: 'User Id',
            type: 'string'
        }
    },
    required: [
        'user_id',
        'role_id'
    ],
    title: 'UserRoleCreate',
    type: 'object'
} as const;

export const UserRolePublicSchema = {
    description: 'Schema for public user-role assignment data.',
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        role_id: {
            format: 'uuid',
            title: 'Role Id',
            type: 'string'
        },
        role_name: {
            title: 'Role Name',
            type: 'string'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        user_id: {
            format: 'uuid',
            title: 'User Id',
            type: 'string'
        }
    },
    required: [
        'user_id',
        'role_id',
        'role_name',
        'tenant_id',
        'created_at',
        'updated_at'
    ],
    title: 'UserRolePublic',
    type: 'object'
} as const;

export const UserSortFieldSchema = {
    enum: [
        'name',
        'username',
        'email',
        'created_at'
    ],
    title: 'UserSortField',
    type: 'string'
} as const;

export const UserUpdateSchema = {
    properties: {
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        designation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserDesignation'
                },
                {
                    type: 'null'
                }
            ]
        },
        email: {
            anyOf: [
                {
                    format: 'email',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        first_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'First Name'
        },
        is_active: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Active'
        },
        is_system_user: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is System User'
        },
        job_title: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Name'
        },
        password: {
            anyOf: [
                {
                    maxLength: 128,
                    minLength: 12,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Password'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        role_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Role Ids'
        },
        username: {
            anyOf: [
                {
                    maxLength: 49,
                    minLength: 2,
                    pattern: '^[a-z0-9_]+$',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Username'
        }
    },
    title: 'UserUpdate',
    type: 'object'
} as const;

export const UserUpdateMeSchema = {
    description: 'Schema for users updating their own profile - NO username changes',
    properties: {
        email: {
            anyOf: [
                {
                    format: 'email',
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        first_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'First Name'
        },
        job_title: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Job Title'
        },
        last_name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Name'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        }
    },
    title: 'UserUpdateMe',
    type: 'object'
} as const;

export const UsersBulkCreateSchema = {
    properties: {
        owner_username: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Username'
        },
        users: {
            items: {
                $ref: '#/components/schemas/UserBulkCreate'
            },
            maxItems: 100,
            minItems: 1,
            title: 'Users',
            type: 'array'
        }
    },
    required: [
        'users'
    ],
    title: 'UsersBulkCreate',
    type: 'object'
} as const;

export const UsersBulkCreateResultSchema = {
    properties: {
        created: {
            items: {
                $ref: '#/components/schemas/UserPublic'
            },
            title: 'Created',
            type: 'array'
        },
        failed: {
            items: {
                $ref: '#/components/schemas/UserCreateFailure'
            },
            title: 'Failed',
            type: 'array'
        }
    },
    required: [
        'created',
        'failed'
    ],
    title: 'UsersBulkCreateResult',
    type: 'object'
} as const;

export const UsersPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/UserPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'UsersPublic',
    type: 'object'
} as const;

export const UtilizationCreateSchema = {
    properties: {
        as_of: {
            format: 'date',
            title: 'As Of',
            type: 'string'
        },
        event: {
            $ref: '#/components/schemas/UtilizationEvent'
        },
        unit: {
            $ref: '#/components/schemas/Unit'
        },
        value: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ],
            title: 'Value'
        }
    },
    required: [
        'event',
        'unit',
        'value',
        'as_of'
    ],
    title: 'UtilizationCreate',
    type: 'object'
} as const;

export const UtilizationEventSchema = {
    enum: [
        'new',
        'overhaul',
        'repair',
        'installation',
        'shop_visit',
        'inspection'
    ],
    title: 'UtilizationEvent',
    type: 'string'
} as const;

export const UtilizationPublicSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        as_of: {
            format: 'date',
            title: 'As Of',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        event: {
            $ref: '#/components/schemas/UtilizationEvent'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Instance Id'
        },
        tenant_id: {
            format: 'uuid',
            title: 'Tenant Id',
            type: 'string'
        },
        unit: {
            $ref: '#/components/schemas/Unit'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        value: {
            title: 'Value',
            type: 'string'
        }
    },
    required: [
        'id',
        'tenant_id',
        'aircraft_id',
        'part_instance_id',
        'event',
        'unit',
        'value',
        'as_of',
        'created_at',
        'updated_at',
        'last_modified_by_id'
    ],
    title: 'UtilizationPublic',
    type: 'object'
} as const;

export const UtilizationUpdateSchema = {
    properties: {
        as_of: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'As Of'
        },
        event: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UtilizationEvent'
                },
                {
                    type: 'null'
                }
            ]
        },
        unit: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Unit'
                },
                {
                    type: 'null'
                }
            ]
        },
        value: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Value'
        }
    },
    title: 'UtilizationUpdate',
    type: 'object'
} as const;

export const UtilizationsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/UtilizationPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'UtilizationsPublic',
    type: 'object'
} as const;

export const ValidationErrorSchema = {
    properties: {
        ctx: {
            title: 'Context',
            type: 'object'
        },
        input: {
            title: 'Input'
        },
        loc: {
            items: {
                anyOf: [
                    {
                        type: 'string'
                    },
                    {
                        type: 'integer'
                    }
                ]
            },
            title: 'Location',
            type: 'array'
        },
        msg: {
            title: 'Message',
            type: 'string'
        },
        type: {
            title: 'Error Type',
            type: 'string'
        }
    },
    required: [
        'loc',
        'msg',
        'type'
    ],
    title: 'ValidationError',
    type: 'object'
} as const;

export const VendorApprovalSchema = {
    properties: {
        authority: {
            enum: [
                'AAC CD',
                'AAC PA',
                'AAC RM',
                'AAC SV',
                'AACM',
                'AACR',
                'AAN',
                'ACAA',
                'AESA',
                'ANAC AR',
                'ANAC BR',
                'ANAC CI',
                'ANAC DJ',
                'ANAC GA',
                'ANAC GN',
                'ANAC ML',
                'ANAC MR',
                'ANAC Niger',
                'ANAC PT',
                'ANAC Senegal',
                'ANAC Togo',
                'ASECNA',
                'BHDCA',
                'CAA AL',
                'CAA BG',
                'CAA BH',
                'CAA CR',
                'CAA LT',
                'CAA LV',
                'CAA LY',
                'CAA MK',
                'CAA MNE',
                'CAA MV',
                'CAA NO',
                'CAA NZ',
                'CAA Pakistan',
                'CAA QA',
                'CAA RT',
                'CAA SI',
                'CAA SL',
                'CAA SR',
                'CAA TW',
                'CAA UK',
                'CAA Uganda',
                'CAAB BD',
                'CAAB BW',
                'CAAC',
                'CAAE',
                'CAAF',
                'CAAH',
                'CAAI',
                'CAAM MN',
                'CAAM MW',
                'CAAM MY',
                'CAAN',
                'CAAP',
                'CAAS',
                'CAASI',
                'CAAT',
                'CAAV VN',
                'CAAV VU',
                'CAAZ ZM',
                'CAAZ ZW',
                'CAD HK',
                'CAD MT',
                'CAD RS',
                'CAMA',
                'CAO.IRI',
                'CARC',
                'CASA',
                'CASA PNG',
                'CASAS',
                'CCAA',
                'DAC',
                'DCA BN',
                'DCA CY',
                'DCA LA',
                'DCA MM',
                'DGAC BO',
                'DGAC CL',
                'DGAC CR',
                'DGAC DZ',
                'DGAC EC',
                'DGAC FR',
                'DGAC GT',
                'DGAC HN',
                'DGAC MX',
                'DGAC PE',
                'DGAC TN',
                'DGCA ID',
                'DGCA IN',
                'DGCA KW',
                'DGCA LB',
                'DGCA TR',
                'DGTA/DGLV',
                'DINAC',
                'DINACIA',
                'EASA',
                'ECAA EE',
                'ECAA EG',
                'ECAA ET',
                'ENAC',
                'FAA',
                'FOCA',
                'GACA',
                'GCAA AE',
                'GCAA GE',
                'GCAA GH',
                'GCAA GM',
                'GDCA',
                'HCAA',
                'IAA',
                'IACC',
                'ICAA',
                'ICETRA',
                'IDAC',
                'ILT',
                'INAC NI',
                'INAC VE',
                'INAVIC',
                'JCAA',
                'JCAB',
                'KCAA KE',
                'KCAA KR',
                'LBA',
                'LCAA LR',
                'LCAA LS',
                'MAA',
                'MCA',
                'Ministry of Transport and Communications',
                'MoIC',
                'NCAA NA',
                'NCAA NG',
                'OACM',
                'OCA',
                'ONDA',
                'PACA',
                'RCAA',
                'Rosaviation',
                'SAA',
                'SAAU',
                'SACA',
                'SACAA',
                'SCAA AZ',
                'SCAA SC',
                'SCAA SD',
                'SCAA SY',
                'SCAST',
                'SLCAA LC',
                'SLCAA SL',
                'SMCAA',
                'SSCA',
                'SSCAA',
                'TCAA',
                'TCCA',
                'TTCAA',
                'Traficom',
                'Transportstyrelsen',
                'UAEAC',
                'ULC',
                'UzCAA'
            ],
            title: 'Authority',
            type: 'string'
        },
        certificate_number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Certificate Number'
        },
        expiry_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expiry Date'
        },
        issued_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Issued Date'
        },
        scope: {
            anyOf: [
                {
                    maxLength: 1000,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Scope'
        }
    },
    required: [
        'authority'
    ],
    title: 'VendorApproval',
    type: 'object'
} as const;

export const VendorStatusSchema = {
    enum: [
        'active',
        'inactive',
        'expired'
    ],
    title: 'VendorStatus',
    type: 'string'
} as const;

export const VerifyOutsideServiceSchema = {
    properties: {
        action: {
            const: 'verify',
            title: 'Action',
            type: 'string'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/OutsideServiceCheck'
            },
            title: 'Checks',
            type: 'array'
        },
        note: {
            anyOf: [
                {
                    maxLength: 4000,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        }
    },
    required: [
        'checks',
        'action'
    ],
    title: 'VerifyOutsideService',
    type: 'object'
} as const;

export const VisibilitySchema = {
    enum: [
        'tenant',
        'user',
        'global'
    ],
    title: 'Visibility',
    type: 'string'
} as const;

export const WarrantyInfoSchema = {
    properties: {
        part_warranty_expiration_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Warranty Expiration Date'
        },
        part_warranty_expiration_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Warranty Expiration Hrs'
        },
        part_warranty_expiration_ldg: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Warranty Expiration Ldg'
        },
        warranty_type: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/WarrantyType'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Warranty Type'
        }
    },
    title: 'WarrantyInfo',
    type: 'object'
} as const;

export const WarrantyTypeSchema = {
    enum: [
        'Hours',
        'Date',
        'Landings'
    ],
    title: 'WarrantyType',
    type: 'string'
} as const;

export const WhicheverExpr_InputSchema = {
    additionalProperties: false,
    properties: {
        of: {
            items: {
                $ref: '#/components/schemas/Expr-Input'
            },
            minItems: 2,
            title: 'Of',
            type: 'array'
        },
        op: {
            enum: [
                'first',
                'later'
            ],
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'of'
    ],
    title: 'WhicheverExpr',
    type: 'object'
} as const;

export const WhicheverExpr_OutputSchema = {
    additionalProperties: false,
    properties: {
        of: {
            items: {
                $ref: '#/components/schemas/Expr-Output'
            },
            minItems: 2,
            title: 'Of',
            type: 'array'
        },
        op: {
            enum: [
                'first',
                'later'
            ],
            title: 'Op',
            type: 'string'
        }
    },
    required: [
        'op',
        'of'
    ],
    title: 'WhicheverExpr',
    type: 'object'
} as const;

export const WorkOrderIntakeSchema = {
    properties: {
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        document_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            minItems: 1,
            title: 'Document Ids',
            type: 'array'
        },
        lines: {
            items: {
                $ref: '#/components/schemas/RequisitionLine'
            },
            title: 'Lines',
            type: 'array'
        },
        locator: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locator'
        },
        lot_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        notes: {
            items: {
                $ref: '#/components/schemas/StepNote'
            },
            title: 'Notes',
            type: 'array'
        },
        outside_services: {
            items: {
                $ref: '#/components/schemas/OutsideServiceLine'
            },
            title: 'Outside Services',
            type: 'array'
        },
        part_description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Description'
        },
        part_number: {
            minLength: 1,
            title: 'Part Number',
            type: 'string'
        },
        serial_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        work_order_number: {
            minLength: 1,
            title: 'Work Order Number',
            type: 'string'
        }
    },
    required: [
        'document_ids',
        'work_order_number',
        'part_number'
    ],
    title: 'WorkOrderIntake',
    type: 'object'
} as const;

export const WorkOrderIntakeResultSchema = {
    properties: {
        part_instance_id: {
            format: 'uuid',
            title: 'Part Instance Id',
            type: 'string'
        },
        quote_id: {
            format: 'uuid',
            title: 'Quote Id',
            type: 'string'
        },
        quote_task_id: {
            format: 'uuid',
            title: 'Quote Task Id',
            type: 'string'
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/IntakeTask'
            },
            title: 'Tasks',
            type: 'array'
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        }
    },
    required: [
        'work_package_id',
        'part_instance_id',
        'quote_id',
        'quote_task_id',
        'tasks'
    ],
    title: 'WorkOrderIntakeResult',
    type: 'object'
} as const;

export const WorkOrderPreviewRecordSchema = {
    properties: {
        source: {
            const: 'work_order',
            title: 'Source',
            type: 'string'
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        }
    },
    required: [
        'source',
        'work_package_id'
    ],
    title: 'WorkOrderPreviewRecord',
    type: 'object'
} as const;

export const WorkPackageAircraftPublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        registration_no: {
            title: 'Registration No',
            type: 'string'
        }
    },
    required: [
        'registration_no',
        'id'
    ],
    title: 'WorkPackageAircraftPublic',
    type: 'object'
} as const;

export const WorkPackageAogEventSchema = {
    properties: {
        type: {
            enum: [
                'aog_marked',
                'aog_cleared'
            ],
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type'
    ],
    title: 'WorkPackageAogEvent',
    type: 'object'
} as const;

export const WorkPackageBaseSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        aircraft_latest_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Landings'
        },
        aircraft_latest_total_time: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Total Time'
        },
        aircraft_make: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Make'
        },
        aircraft_model: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Model'
        },
        aircraft_reg_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Reg No'
        },
        aircraft_serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Serial No'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        in_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'In Date'
        },
        is_deleted: {
            default: false,
            title: 'Is Deleted',
            type: 'boolean'
        },
        number: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        out_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Out Date'
        },
        workflow_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workflow Id'
        }
    },
    title: 'WorkPackageBase',
    type: 'object'
} as const;

export const WorkPackageBillingSchema = {
    properties: {
        currency: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        customer_po_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Po Number'
        },
        date_completed: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Date Completed'
        },
        date_created: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Date Created'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        first_worked_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'First Worked On'
        },
        is_warranty: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Warranty'
        },
        last_worked_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Worked On'
        },
        misc_charges: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Misc Charges'
        },
        total_amount_billed: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Total Amount Billed'
        },
        total_hours_worked: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Total Hours Worked'
        },
        total_labor: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Total Labor'
        },
        total_num_of_parts: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Total Num Of Parts'
        },
        total_parts: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Total Parts'
        }
    },
    title: 'WorkPackageBilling',
    type: 'object'
} as const;

export const WorkPackageClassificationSetSchema = {
    properties: {
        kind: {
            $ref: '#/components/schemas/Workscope'
        }
    },
    required: [
        'kind'
    ],
    title: 'WorkPackageClassificationSet',
    type: 'object'
} as const;

export const WorkPackageCreateSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        aircraft_latest_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Landings'
        },
        aircraft_latest_total_time: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Total Time'
        },
        aircraft_make: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Make'
        },
        aircraft_model: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Model'
        },
        aircraft_reg_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Reg No'
        },
        aircraft_serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Serial No'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        in_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'In Date'
        },
        is_deleted: {
            default: false,
            title: 'Is Deleted',
            type: 'boolean'
        },
        kind: {
            $ref: '#/components/schemas/WorkPackageKind',
            default: 'aircraft'
        },
        number: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        out_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Out Date'
        },
        workflow_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workflow Id'
        }
    },
    title: 'WorkPackageCreate',
    type: 'object'
} as const;

export const WorkPackageCreatedEventSchema = {
    properties: {
        type: {
            const: 'created',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type'
    ],
    title: 'WorkPackageCreatedEvent',
    type: 'object'
} as const;

export const WorkPackageDetailSchema = {
    enum: [
        'number',
        'description',
        'customer_id',
        'contact_id',
        'billing_address_id',
        'shipping_address_id',
        'rate_card_id',
        'po_number',
        'approval_threshold',
        'approval_contact_id',
        'notify_on_findings',
        'in_date',
        'out_date',
        'aircraft_id',
        'arrival_at',
        'planned_departure_at',
        'planned_finish_at',
        'promised_on',
        'location_id',
        'department_id',
        'facility_id',
        'sales_rep_id',
        'lead_technician_id',
        'inspector_id'
    ],
    title: 'WorkPackageDetail',
    type: 'string'
} as const;

export const WorkPackageDetailPublicSchema = {
    properties: {
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        aircraft_latest_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Landings'
        },
        aircraft_latest_total_time: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Total Time'
        },
        aircraft_make: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Make'
        },
        aircraft_model: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Model'
        },
        aircraft_reg_no: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Reg No'
        },
        aircraft_serial_no: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Serial No'
        },
        aog_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aog At'
        },
        aog_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aog By Id'
        },
        approval_contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Contact Id'
        },
        approval_threshold: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Threshold'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        arrival_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arrival At'
        },
        billing_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Billing Address Id'
        },
        cancellation_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cancellation Reason'
        },
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        current_user_subscription: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageSubscriptionPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        external_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Created At'
        },
        external_ended_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ended At'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        in_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'In Date'
        },
        inspector_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inspector Id'
        },
        kind: {
            $ref: '#/components/schemas/WorkPackageKind'
        },
        lead_technician_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Technician Id'
        },
        location_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location Id'
        },
        notify_on_findings: {
            title: 'Notify On Findings',
            type: 'boolean'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        out_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Out Date'
        },
        part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Instance Id'
        },
        planned_departure_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Departure At'
        },
        planned_finish_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Finish At'
        },
        po_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Po Number'
        },
        promised_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised On'
        },
        rate_card_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rate Card Id'
        },
        sales_rep_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Rep Id'
        },
        shipping_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Shipping Address Id'
        },
        status: {
            $ref: '#/components/schemas/WorkPackageStatus'
        },
        type_certificate_model_variant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Type Certificate Model Variant Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Started At'
        },
        workflow_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workflow Id'
        }
    },
    required: [
        'id',
        'number',
        'status',
        'kind',
        'cancellation_reason',
        'archived_at',
        'work_started_at',
        'aog_at',
        'aog_by_id',
        'description',
        'customer_id',
        'contact_id',
        'billing_address_id',
        'shipping_address_id',
        'rate_card_id',
        'po_number',
        'approval_threshold',
        'approval_contact_id',
        'notify_on_findings',
        'aircraft_id',
        'part_instance_id',
        'type_certificate_model_variant_id',
        'in_date',
        'out_date',
        'aircraft_make',
        'aircraft_model',
        'aircraft_serial_no',
        'aircraft_reg_no',
        'aircraft_latest_total_time',
        'aircraft_latest_landings',
        'workflow_id',
        'external_created_at',
        'external_ended_at',
        'arrival_at',
        'planned_departure_at',
        'planned_finish_at',
        'promised_on',
        'location_id',
        'department_id',
        'facility_id',
        'sales_rep_id',
        'lead_technician_id',
        'inspector_id',
        'created_at',
        'updated_at',
        'customer',
        'aircraft'
    ],
    title: 'WorkPackageDetailPublic',
    type: 'object'
} as const;

export const WorkPackageDetailsUpdatedEventSchema = {
    properties: {
        details: {
            items: {
                $ref: '#/components/schemas/WorkPackageDetail'
            },
            title: 'Details',
            type: 'array'
        },
        type: {
            const: 'details_updated',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'details'
    ],
    title: 'WorkPackageDetailsUpdatedEvent',
    type: 'object'
} as const;

export const WorkPackageEventPublicSchema = {
    properties: {
        actor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        event: {
            $ref: '#/components/schemas/WorkPackageEventValue'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        occurred_at: {
            format: 'date-time',
            title: 'Occurred At',
            type: 'string'
        },
        source: {
            $ref: '#/components/schemas/ChangedBy'
        }
    },
    required: [
        'id',
        'occurred_at',
        'source',
        'actor',
        'event'
    ],
    title: 'WorkPackageEventPublic',
    type: 'object'
} as const;

export const WorkPackageEventValueSchema = {
    discriminator: {
        mapping: {
            aog_cleared: '#/components/schemas/WorkPackageAogEvent',
            aog_marked: '#/components/schemas/WorkPackageAogEvent',
            created: '#/components/schemas/WorkPackageCreatedEvent',
            details_updated: '#/components/schemas/WorkPackageDetailsUpdatedEvent',
            note_added: '#/components/schemas/WorkPackageNoteAddedEvent',
            status_changed: '#/components/schemas/WorkPackageStatusChangedEvent',
            task_inspected: '#/components/schemas/WorkPackageTaskSignOffEvent',
            task_inspection_undone: '#/components/schemas/WorkPackageTaskSignOffEvent',
            task_sign_off_undone: '#/components/schemas/WorkPackageTaskSignOffEvent',
            task_signed_off: '#/components/schemas/WorkPackageTaskSignOffEvent',
            task_statuses_changed: '#/components/schemas/WorkPackageTaskStatusesChangedEvent',
            tasks_added: '#/components/schemas/WorkPackageTasksChangedEvent',
            tasks_assigned: '#/components/schemas/WorkPackageTasksAssignedEvent',
            tasks_removed: '#/components/schemas/WorkPackageTasksChangedEvent'
        },
        propertyName: 'type'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/WorkPackageCreatedEvent'
        },
        {
            $ref: '#/components/schemas/WorkPackageDetailsUpdatedEvent'
        },
        {
            $ref: '#/components/schemas/WorkPackageStatusChangedEvent'
        },
        {
            $ref: '#/components/schemas/WorkPackageAogEvent'
        },
        {
            $ref: '#/components/schemas/WorkPackageTasksChangedEvent'
        },
        {
            $ref: '#/components/schemas/WorkPackageTaskStatusesChangedEvent'
        },
        {
            $ref: '#/components/schemas/WorkPackageTasksAssignedEvent'
        },
        {
            $ref: '#/components/schemas/WorkPackageTaskSignOffEvent'
        },
        {
            $ref: '#/components/schemas/WorkPackageNoteAddedEvent'
        }
    ]
} as const;

export const WorkPackageEventsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/WorkPackageEventPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'WorkPackageEventsPublic',
    type: 'object'
} as const;

export const WorkPackageFilterSchema = {
    enum: [
        'has_draft_tasks'
    ],
    title: 'WorkPackageFilter',
    type: 'string'
} as const;

export const WorkPackageGroupingSchema = {
    enum: [
        'status',
        'priority',
        'customer',
        'department'
    ],
    title: 'WorkPackageGrouping',
    type: 'string'
} as const;

export const WorkPackageKindSchema = {
    enum: [
        'aircraft',
        'traveller'
    ],
    title: 'WorkPackageKind',
    type: 'string'
} as const;

export const WorkPackageNoteAddedEventSchema = {
    properties: {
        number: {
            title: 'Number',
            type: 'string'
        },
        type: {
            const: 'note_added',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'number'
    ],
    title: 'WorkPackageNoteAddedEvent',
    type: 'object'
} as const;

export const WorkPackageNumberSequencePublicSchema = {
    properties: {
        format: {
            title: 'Format',
            type: 'string'
        },
        next: {
            title: 'Next',
            type: 'integer'
        }
    },
    required: [
        'format',
        'next'
    ],
    title: 'WorkPackageNumberSequencePublic',
    type: 'object'
} as const;

export const WorkPackageNumberSequenceUpsertSchema = {
    properties: {
        format: {
            minLength: 1,
            title: 'Format',
            type: 'string'
        },
        next: {
            anyOf: [
                {
                    maximum: 2147483647,
                    minimum: 1,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Next'
        }
    },
    required: [
        'format'
    ],
    title: 'WorkPackageNumberSequenceUpsert',
    type: 'object'
} as const;

export const WorkPackageOutcomeSchema = {
    enum: [
        'certified',
        'repaired',
        'overhauled',
        'returned_as_is',
        'scrapped'
    ],
    title: 'WorkPackageOutcome',
    type: 'string'
} as const;

export const WorkPackagePhaseCreateSchema = {
    properties: {
        name: {
            maxLength: 255,
            minLength: 1,
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'name'
    ],
    title: 'WorkPackagePhaseCreate',
    type: 'object'
} as const;

export const WorkPackagePhaseOrderSchema = {
    properties: {
        phase_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Phase Ids',
            type: 'array'
        }
    },
    required: [
        'phase_ids'
    ],
    title: 'WorkPackagePhaseOrder',
    type: 'object'
} as const;

export const WorkPackagePhasePublicSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'id',
        'name',
        'position'
    ],
    title: 'WorkPackagePhasePublic',
    type: 'object'
} as const;

export const WorkPackagePhaseUpdateSchema = {
    properties: {
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    title: 'WorkPackagePhaseUpdate',
    type: 'object'
} as const;

export const WorkPackagePrioritySchema = {
    enum: [
        'aog',
        'routine'
    ],
    title: 'WorkPackagePriority',
    type: 'string'
} as const;

export const WorkPackagePublicSchema = {
    properties: {
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/AircraftPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        aircraft_latest_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Landings'
        },
        aircraft_latest_total_time: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Total Time'
        },
        aircraft_make: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Make'
        },
        aircraft_model: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Model'
        },
        aircraft_reg_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Reg No'
        },
        aircraft_serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Serial No'
        },
        aog_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aog At'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        arrival_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arrival At'
        },
        cancellation_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cancellation Reason'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        current_user_subscription: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageSubscriptionPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        department: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DepartmentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        external_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Created At'
        },
        external_ended_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ended At'
        },
        external_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        external_started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Started At'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        flat_rate_revenue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flat Rate Revenue'
        },
        freight_revenue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Freight Revenue'
        },
        fulfillment_progress: {
            $ref: '#/components/schemas/FulfillmentProgress'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        in_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'In Date'
        },
        is_deleted: {
            default: false,
            title: 'Is Deleted',
            type: 'boolean'
        },
        is_freight_included_in_flat_rate: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Freight Included In Flat Rate'
        },
        kind: {
            $ref: '#/components/schemas/WorkPackageKind'
        },
        labour_cost: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Labour Cost'
        },
        labour_revenue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Labour Revenue'
        },
        last_modified_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        location_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location Id'
        },
        materials_cost: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Materials Cost'
        },
        materials_revenue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Materials Revenue'
        },
        misc_cost: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Misc Cost'
        },
        misc_revenue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Misc Revenue'
        },
        number: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        out_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Out Date'
        },
        part_instance: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartInstancePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Instance Id'
        },
        planned_departure_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Departure At'
        },
        planned_finish_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Finish At'
        },
        promised_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised On'
        },
        services_cost: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Services Cost'
        },
        services_revenue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Services Revenue'
        },
        source_info: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SourceInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_synced_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Source Synced At'
        },
        status: {
            $ref: '#/components/schemas/WorkPackageStatus'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Started At'
        },
        workflow_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workflow Id'
        }
    },
    required: [
        'external_id',
        'external_url',
        'external_created_at',
        'source_synced_at',
        'source_info',
        'number',
        'description',
        'customer_id',
        'in_date',
        'out_date',
        'aircraft_make',
        'aircraft_model',
        'aircraft_serial_no',
        'aircraft_reg_no',
        'aircraft_latest_total_time',
        'aircraft_latest_landings',
        'is_deleted',
        'aircraft_id',
        'workflow_id',
        'id',
        'status',
        'kind',
        'cancellation_reason',
        'work_started_at',
        'aog_at',
        'part_instance_id',
        'created_at',
        'updated_at',
        'archived_at',
        'created_by_id',
        'last_modified_by_id',
        'fulfillment_progress',
        'external_started_at',
        'external_ended_at',
        'labour_revenue',
        'labour_cost',
        'materials_revenue',
        'materials_cost',
        'services_revenue',
        'services_cost',
        'misc_revenue',
        'misc_cost',
        'flat_rate_revenue',
        'freight_revenue',
        'is_freight_included_in_flat_rate',
        'currency',
        'arrival_at',
        'planned_departure_at',
        'planned_finish_at',
        'promised_on',
        'location_id',
        'department_id',
        'facility_id',
        'department',
        'customer',
        'aircraft',
        'part_instance',
        'last_modified_by',
        'current_user_subscription'
    ],
    title: 'WorkPackagePublic',
    type: 'object'
} as const;

export const WorkPackageScopeSchema = {
    enum: [
        'all',
        'subscribed',
        'closed'
    ],
    title: 'WorkPackageScope',
    type: 'string'
} as const;

export const WorkPackageSettingsPublicSchema = {
    properties: {
        default_reservation_lock: {
            $ref: '#/components/schemas/PartReservationLock'
        },
        phases_enabled: {
            title: 'Phases Enabled',
            type: 'boolean'
        }
    },
    required: [
        'default_reservation_lock',
        'phases_enabled'
    ],
    title: 'WorkPackageSettingsPublic',
    type: 'object'
} as const;

export const WorkPackageSettingsUpsertSchema = {
    properties: {
        default_reservation_lock: {
            $ref: '#/components/schemas/PartReservationLock'
        },
        phases_enabled: {
            title: 'Phases Enabled',
            type: 'boolean'
        }
    },
    required: [
        'default_reservation_lock',
        'phases_enabled'
    ],
    title: 'WorkPackageSettingsUpsert',
    type: 'object'
} as const;

export const WorkPackageStatusSchema = {
    enum: [
        'draft',
        'scheduled',
        'in_progress',
        'complete',
        'closed',
        'cancelled'
    ],
    title: 'WorkPackageStatus',
    type: 'string'
} as const;

export const WorkPackageStatusChangedEventSchema = {
    properties: {
        current: {
            $ref: '#/components/schemas/WorkPackageStatus'
        },
        previous: {
            $ref: '#/components/schemas/WorkPackageStatus'
        },
        reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reason'
        },
        type: {
            const: 'status_changed',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'previous',
        'current'
    ],
    title: 'WorkPackageStatusChangedEvent',
    type: 'object'
} as const;

export const WorkPackageSubjectsSchema = {
    properties: {
        aircraft: {
            title: 'Aircraft',
            type: 'boolean'
        },
        part: {
            title: 'Part',
            type: 'boolean'
        }
    },
    required: [
        'aircraft',
        'part'
    ],
    title: 'WorkPackageSubjects',
    type: 'object'
} as const;

export const WorkPackageSubscriptionPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_package_number: {
            title: 'Work Package Number',
            type: 'string'
        }
    },
    required: [
        'id',
        'work_package_number',
        'created_at',
        'updated_at'
    ],
    title: 'WorkPackageSubscriptionPublic',
    type: 'object'
} as const;

export const WorkPackageTaskPublicSchema = {
    properties: {
        actual_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Actual Hrs'
        },
        assignee: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        assignee_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Assignee Id'
        },
        ata_chapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        compliance_note: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ComplianceNoteEntryPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        corrective_action: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corrective Action'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        document_references: {
            items: {
                $ref: '#/components/schemas/DocumentReferencePublic'
            },
            title: 'Document References',
            type: 'array'
        },
        estimated_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Hrs'
        },
        has_resolution: {
            title: 'Has Resolution',
            type: 'boolean'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        inspection: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ApprovalProgressPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        inspector: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        inspector_signed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inspector Signed At'
        },
        manual_reference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        notes: {
            items: {
                $ref: '#/components/schemas/WorkTaskNotePublic'
            },
            title: 'Notes',
            type: 'array'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        outside_services: {
            items: {
                $ref: '#/components/schemas/WorkTaskOutsideServicePublic'
            },
            title: 'Outside Services',
            type: 'array'
        },
        parts: {
            items: {
                $ref: '#/components/schemas/WorkTaskPartPublic'
            },
            title: 'Parts',
            type: 'array'
        },
        phase_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Phase Ids',
            type: 'array'
        },
        quote_task: {
            anyOf: [
                {
                    $ref: '#/components/schemas/QuoteTaskLinkPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        status: {
            $ref: '#/components/schemas/WorkTaskStatus'
        },
        status_moves: {
            items: {
                $ref: '#/components/schemas/WorkTaskStatus'
            },
            readOnly: true,
            title: 'Status Moves',
            type: 'array'
        },
        status_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Note'
        },
        steps: {
            items: {
                $ref: '#/components/schemas/WorkTaskStepPublic'
            },
            title: 'Steps',
            type: 'array'
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        },
        technician: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        technician_signed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Technician Signed At'
        },
        tool_loans: {
            items: {
                $ref: '#/components/schemas/WorkTaskToolLoanPublic'
            },
            title: 'Tool Loans',
            type: 'array'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        workflow_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workflow Step Id'
        }
    },
    required: [
        'id',
        'number',
        'description',
        'severity',
        'manual_reference',
        'ata_chapter',
        'ata_subchapter',
        'ata_zone',
        'estimated_hrs',
        'actual_hrs',
        'status',
        'status_note',
        'updated_at',
        'technician',
        'technician_signed_at',
        'inspector',
        'inspector_signed_at',
        'assignee_id',
        'assignee',
        'corrective_action',
        'compliance_note',
        'has_resolution',
        'workflow_step_id',
        'phase_ids',
        'task_group_id',
        'department_id',
        'quote_task',
        'parts',
        'outside_services',
        'steps',
        'notes',
        'tool_loans',
        'inspection',
        'status_moves'
    ],
    title: 'WorkPackageTaskPublic',
    type: 'object'
} as const;

export const WorkPackageTaskSignOffEventSchema = {
    properties: {
        number: {
            title: 'Number',
            type: 'string'
        },
        type: {
            enum: [
                'task_signed_off',
                'task_sign_off_undone',
                'task_inspected',
                'task_inspection_undone'
            ],
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'number'
    ],
    title: 'WorkPackageTaskSignOffEvent',
    type: 'object'
} as const;

export const WorkPackageTaskStatusesChangedEventSchema = {
    properties: {
        numbers: {
            items: {
                type: 'string'
            },
            title: 'Numbers',
            type: 'array'
        },
        status: {
            $ref: '#/components/schemas/WorkTaskStatus'
        },
        type: {
            const: 'task_statuses_changed',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'status',
        'numbers'
    ],
    title: 'WorkPackageTaskStatusesChangedEvent',
    type: 'object'
} as const;

export const WorkPackageTasksAssignedEventSchema = {
    properties: {
        assignee: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Assignee'
        },
        assignee_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Assignee Id'
        },
        numbers: {
            items: {
                type: 'string'
            },
            title: 'Numbers',
            type: 'array'
        },
        type: {
            const: 'tasks_assigned',
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'numbers'
    ],
    title: 'WorkPackageTasksAssignedEvent',
    type: 'object'
} as const;

export const WorkPackageTasksChangedEventSchema = {
    properties: {
        numbers: {
            items: {
                type: 'string'
            },
            title: 'Numbers',
            type: 'array'
        },
        type: {
            enum: [
                'tasks_added',
                'tasks_removed'
            ],
            title: 'Type',
            type: 'string'
        }
    },
    required: [
        'type',
        'numbers'
    ],
    title: 'WorkPackageTasksChangedEvent',
    type: 'object'
} as const;

export const WorkPackageTransitionSchema = {
    discriminator: {
        mapping: {
            cancel: '#/components/schemas/CancelWorkPackage',
            complete: '#/components/schemas/MoveWorkPackage',
            release: '#/components/schemas/MoveWorkPackage',
            reopen: '#/components/schemas/MoveWorkPackage',
            start: '#/components/schemas/MoveWorkPackage'
        },
        propertyName: 'action'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/MoveWorkPackage'
        },
        {
            $ref: '#/components/schemas/CancelWorkPackage'
        }
    ],
    title: 'WorkPackageTransition'
} as const;

export const WorkPackageUpdateSchema = {
    properties: {
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        aircraft_latest_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Landings'
        },
        aircraft_latest_total_time: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Total Time'
        },
        aircraft_make: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Make'
        },
        aircraft_model: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Model'
        },
        aircraft_reg_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Reg No'
        },
        aircraft_serial_no: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Serial No'
        },
        approval_contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Contact Id'
        },
        approval_threshold: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Threshold'
        },
        arrival_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arrival At'
        },
        billing_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Billing Address Id'
        },
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        in_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'In Date'
        },
        inspector_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inspector Id'
        },
        is_deleted: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Deleted'
        },
        lead_technician_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Technician Id'
        },
        location_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location Id'
        },
        notify_on_findings: {
            default: 1,
            title: 'Notify On Findings',
            type: 'boolean'
        },
        number: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        out_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Out Date'
        },
        planned_departure_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Departure At'
        },
        planned_finish_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Finish At'
        },
        po_number: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Po Number'
        },
        promised_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised On'
        },
        rate_card_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rate Card Id'
        },
        sales_rep_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Rep Id'
        },
        shipping_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Shipping Address Id'
        }
    },
    title: 'WorkPackageUpdate',
    type: 'object'
} as const;

export const WorkPackageViewSchema = {
    enum: [
        'all',
        'active',
        'aog',
        'mine',
        'archived'
    ],
    title: 'WorkPackageView',
    type: 'string'
} as const;

export const WorkPackageWithTasksPublicSchema = {
    properties: {
        active_phases: {
            items: {
                $ref: '#/components/schemas/WorkPackagePhasePublic'
            },
            title: 'Active Phases',
            type: 'array'
        },
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageAircraftPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        aircraft_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Id'
        },
        aircraft_latest_landings: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Landings'
        },
        aircraft_latest_total_time: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Latest Total Time'
        },
        aircraft_make: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Make'
        },
        aircraft_model: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Model'
        },
        aircraft_reg_no: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Reg No'
        },
        aircraft_serial_no: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aircraft Serial No'
        },
        aog_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aog At'
        },
        aog_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        aog_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aog By Id'
        },
        approval_contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Contact Id'
        },
        approval_threshold: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Approval Threshold'
        },
        archived_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        arrival_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arrival At'
        },
        billing_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Billing Address Id'
        },
        cancellation_reason: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cancellation Reason'
        },
        contact_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contact Id'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        current_user_subscription: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageSubscriptionPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/CustomerPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        customer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Customer Id'
        },
        department: {
            anyOf: [
                {
                    $ref: '#/components/schemas/DepartmentPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        external_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Created At'
        },
        external_ended_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ended At'
        },
        facility: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FacilityPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        facility_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Facility Id'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        in_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'In Date'
        },
        inspector: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        inspector_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inspector Id'
        },
        kind: {
            $ref: '#/components/schemas/WorkPackageKind'
        },
        labour_revenue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Labour Revenue'
        },
        lead_technician: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        lead_technician_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lead Technician Id'
        },
        location_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location Id'
        },
        materials_revenue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Materials Revenue'
        },
        notify_on_findings: {
            title: 'Notify On Findings',
            type: 'boolean'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        out_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Out Date'
        },
        outcome: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageOutcome'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_instance: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartInstancePublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        part_instance_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Instance Id'
        },
        planned_departure_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Departure At'
        },
        planned_finish_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Planned Finish At'
        },
        po_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Po Number'
        },
        promised_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised On'
        },
        rate_card_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rate Card Id'
        },
        sales_rep: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        sales_rep_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sales Rep Id'
        },
        shipping_address_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Shipping Address Id'
        },
        status: {
            $ref: '#/components/schemas/WorkPackageStatus'
        },
        tasks: {
            items: {
                $ref: '#/components/schemas/WorkPackageTaskPublic'
            },
            title: 'Tasks',
            type: 'array'
        },
        total_hours: {
            readOnly: true,
            title: 'Total Hours',
            type: 'number'
        },
        total_revenue: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            readOnly: true,
            title: 'Total Revenue'
        },
        type_certificate_model_variant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Type Certificate Model Variant Id'
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Started At'
        },
        workflow: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkflowDetailPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        workflow_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workflow Id'
        },
        workscope: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Workscope'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'id',
        'number',
        'status',
        'kind',
        'cancellation_reason',
        'archived_at',
        'work_started_at',
        'aog_at',
        'aog_by_id',
        'description',
        'customer_id',
        'contact_id',
        'billing_address_id',
        'shipping_address_id',
        'rate_card_id',
        'po_number',
        'approval_threshold',
        'approval_contact_id',
        'notify_on_findings',
        'aircraft_id',
        'part_instance_id',
        'type_certificate_model_variant_id',
        'in_date',
        'out_date',
        'aircraft_make',
        'aircraft_model',
        'aircraft_serial_no',
        'aircraft_reg_no',
        'aircraft_latest_total_time',
        'aircraft_latest_landings',
        'workflow_id',
        'external_created_at',
        'external_ended_at',
        'arrival_at',
        'planned_departure_at',
        'planned_finish_at',
        'promised_on',
        'location_id',
        'department_id',
        'facility_id',
        'sales_rep_id',
        'lead_technician_id',
        'inspector_id',
        'created_at',
        'updated_at',
        'active_phases',
        'total_hours',
        'total_revenue'
    ],
    title: 'WorkPackageWithTasksPublic',
    type: 'object'
} as const;

export const WorkPackagesPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/WorkPackagePublic'
            },
            title: 'Data',
            type: 'array'
        },
        groups: {
            items: {
                $ref: '#/components/schemas/GroupCountPublic'
            },
            title: 'Groups',
            type: 'array'
        }
    },
    required: [
        'data',
        'count',
        'groups'
    ],
    title: 'WorkPackagesPublic',
    type: 'object'
} as const;

export const WorkTaskBillingSchema = {
    properties: {
        bill_to_customer: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bill To Customer'
        },
        bill_to_customer_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bill To Customer Id'
        },
        billing_method: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Billing Method'
        },
        department_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        do_not_bill: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Do Not Bill'
        },
        do_not_tax_shop_labor: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Do Not Tax Shop Labor'
        },
        flat_part_charge: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flat Part Charge'
        },
        flat_part_charge_use: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flat Part Charge Use'
        },
        flat_rate: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flat Rate'
        },
        flat_rate_qty: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flat Rate Qty'
        },
        hours_estimate: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hours Estimate'
        },
        owner_auth: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Owner Auth'
        },
        ship_in: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ship In'
        },
        special_hour_rate: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Special Hour Rate'
        },
        special_hour_rate_use: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Special Hour Rate Use'
        },
        warranty_claim: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Warranty Claim'
        },
        warranty_vendor: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Warranty Vendor'
        },
        warranty_vendor_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Warranty Vendor Id'
        },
        wo_item_warranty_id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Wo Item Warranty Id'
        }
    },
    title: 'WorkTaskBilling',
    type: 'object'
} as const;

export const WorkTaskCreateSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        complied_with_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Complied With Date'
        },
        description: {
            default: '',
            title: 'Description',
            type: 'string'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        estimated_cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost'
        },
        estimated_cost_currency: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost Currency'
        },
        is_deleted: {
            default: false,
            title: 'Is Deleted',
            type: 'boolean'
        },
        item_corr_action_synced: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Item Corr Action Synced'
        },
        major_assembly: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Major Assembly'
        },
        manhours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manhours'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        phase_ids: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Phase Ids',
            type: 'array'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskType'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        },
        workflow_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workflow Step Id'
        }
    },
    title: 'WorkTaskCreate',
    type: 'object'
} as const;

export const WorkTaskDetailPublicSchema = {
    properties: {
        actual_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Actual Hrs'
        },
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        complied_with_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Complied With Date'
        },
        cost: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        description: {
            default: '',
            title: 'Description',
            type: 'string'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        estimated_cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost'
        },
        estimated_cost_currency: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost Currency'
        },
        estimated_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Hrs'
        },
        external_billing_method: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Billing Method'
        },
        external_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Created At'
        },
        external_ended_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ended At'
        },
        external_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        external_is_warranty: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Is Warranty'
        },
        external_labor_hrs_taken: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Labor Hrs Taken'
        },
        external_started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Started At'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_deleted: {
            default: false,
            title: 'Is Deleted',
            type: 'boolean'
        },
        item_corr_action_synced: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Item Corr Action Synced'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        major_assembly: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Major Assembly'
        },
        manhours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manhours'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        outside_services: {
            items: {
                $ref: '#/components/schemas/WorkTaskOutsideServicePublic'
            },
            title: 'Outside Services',
            type: 'array'
        },
        parts: {
            items: {
                $ref: '#/components/schemas/WorkTaskPartPublic'
            },
            title: 'Parts',
            type: 'array'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_info: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SourceInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_synced_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Source Synced At'
        },
        status: {
            $ref: '#/components/schemas/WorkTaskStatus'
        },
        status_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Note'
        },
        task_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskType'
                },
                {
                    type: 'null'
                }
            ]
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'external_id',
        'external_url',
        'source_synced_at',
        'source_info',
        'item_corr_action_synced',
        'external_created_at',
        'external_labor_hrs_taken',
        'external_billing_method',
        'external_is_warranty',
        'external_started_at',
        'external_ended_at',
        'estimated_hrs',
        'actual_hrs',
        'cost',
        'id',
        'created_at',
        'updated_at',
        'status',
        'status_note'
    ],
    title: 'WorkTaskDetailPublic',
    type: 'object'
} as const;

export const WorkTaskItemSourceSchema = {
    enum: [
        'erp',
        'fleetcraft'
    ],
    title: 'WorkTaskItemSource',
    type: 'string'
} as const;

export const WorkTaskNoteCreateSchema = {
    properties: {
        body: {
            maxLength: 2000,
            minLength: 1,
            title: 'Body',
            type: 'string'
        }
    },
    required: [
        'body'
    ],
    title: 'WorkTaskNoteCreate',
    type: 'object'
} as const;

export const WorkTaskNotePublicSchema = {
    properties: {
        body: {
            title: 'Body',
            type: 'string'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        work_task_id: {
            format: 'uuid',
            title: 'Work Task Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'work_task_id',
        'body',
        'created_by',
        'created_at'
    ],
    title: 'WorkTaskNotePublic',
    type: 'object'
} as const;

export const WorkTaskOutsideServiceMovePublicSchema = {
    properties: {
        action: {
            $ref: '#/components/schemas/OutsideServiceAction'
        },
        checks: {
            items: {
                $ref: '#/components/schemas/OutsideServiceCheck'
            },
            title: 'Checks',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        moved_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Note'
        }
    },
    required: [
        'id',
        'action',
        'checks',
        'note',
        'moved_by',
        'created_at'
    ],
    title: 'WorkTaskOutsideServiceMovePublic',
    type: 'object'
} as const;

export const WorkTaskOutsideServicePublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        currency: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        kind: {
            $ref: '#/components/schemas/OutsideServiceKind'
        },
        list_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'List Price'
        },
        moves: {
            items: {
                $ref: '#/components/schemas/WorkTaskOutsideServiceMovePublic'
            },
            title: 'Moves',
            type: 'array'
        },
        overdue: {
            readOnly: true,
            title: 'Overdue',
            type: 'boolean'
        },
        part_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Id'
        },
        part_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Part Number'
        },
        promised_back_on: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Promised Back On'
        },
        purchase_order: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Order'
        },
        purchase_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Price'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        requested_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        sale_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Price'
        },
        scope: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Scope'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        ships_out: {
            title: 'Ships Out',
            type: 'boolean'
        },
        source: {
            $ref: '#/components/schemas/WorkTaskItemSource'
        },
        stage: {
            $ref: '#/components/schemas/OutsideServiceStage'
        },
        suggested_vendor: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Suggested Vendor'
        },
        tracking: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tracking'
        },
        vendor: {
            anyOf: [
                {
                    $ref: '#/components/schemas/OutsideServiceVendorPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    required: [
        'id',
        'source',
        'description',
        'kind',
        'stage',
        'part_id',
        'part_number',
        'serial_number',
        'quantity',
        'work_task_step_id',
        'ships_out',
        'suggested_vendor',
        'vendor',
        'purchase_order',
        'tracking',
        'promised_back_on',
        'scope',
        'requested_by',
        'created_at',
        'moves',
        'currency',
        'purchase_price',
        'sale_price',
        'list_price',
        'overdue'
    ],
    title: 'WorkTaskOutsideServicePublic',
    type: 'object'
} as const;

export const WorkTaskOutsideServiceUpdateSchema = {
    properties: {
        promised_back_on: {
            format: 'date',
            title: 'Promised Back On',
            type: 'string'
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    title: 'WorkTaskOutsideServiceUpdate',
    type: 'object'
} as const;

export const WorkTaskPartSchema = {
    properties: {
        condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        currency: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        list_price: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'List Price'
        },
        lot_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        },
        purchase_price: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Price'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        sale_price: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Price'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        }
    },
    required: [
        'quantity',
        'part_number'
    ],
    title: 'WorkTaskPart',
    type: 'object'
} as const;

export const WorkTaskPartDetailPublicSchema = {
    properties: {
        condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        currency: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        held_by_other: {
            default: false,
            title: 'Held By Other',
            type: 'boolean'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        issued_quantity: {
            title: 'Issued Quantity',
            type: 'integer'
        },
        issues: {
            items: {
                $ref: '#/components/schemas/WorkTaskPartIssuePublic'
            },
            title: 'Issues',
            type: 'array'
        },
        list_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'List Price'
        },
        lot_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        part_instance_id: {
            format: 'uuid',
            title: 'Part Instance Id',
            type: 'string'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        },
        purchase_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Price'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        requested_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        reservation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartReservationPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        reserved_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        sale_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Price'
        },
        source: {
            $ref: '#/components/schemas/WorkTaskItemSource'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        },
        work_task: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkTaskPartWorkTaskPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    required: [
        'id',
        'source',
        'part_id',
        'part_instance_id',
        'part_number',
        'description',
        'unit_of_measure',
        'quantity',
        'issued_quantity',
        'condition',
        'work_task_step_id',
        'requested_by',
        'created_at',
        'issues',
        'reservation',
        'reserved_by',
        'lot_number',
        'currency',
        'list_price',
        'sale_price',
        'purchase_price',
        'work_task'
    ],
    title: 'WorkTaskPartDetailPublic',
    type: 'object'
} as const;

export const WorkTaskPartIssuePublicSchema = {
    properties: {
        certificate: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ReleaseCertificate'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        issued_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        lot_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        serial_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Serial Number'
        },
        source: {
            $ref: '#/components/schemas/WorkTaskItemSource'
        }
    },
    required: [
        'id',
        'source',
        'quantity',
        'lot_number',
        'serial_number',
        'certificate',
        'issued_by',
        'created_at'
    ],
    title: 'WorkTaskPartIssuePublic',
    type: 'object'
} as const;

export const WorkTaskPartPublicSchema = {
    properties: {
        condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        currency: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currency'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        held_by_other: {
            default: false,
            title: 'Held By Other',
            type: 'boolean'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        issued_quantity: {
            title: 'Issued Quantity',
            type: 'integer'
        },
        issues: {
            items: {
                $ref: '#/components/schemas/WorkTaskPartIssuePublic'
            },
            title: 'Issues',
            type: 'array'
        },
        list_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'List Price'
        },
        lot_number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lot Number'
        },
        part_id: {
            format: 'uuid',
            title: 'Part Id',
            type: 'string'
        },
        part_instance_id: {
            format: 'uuid',
            title: 'Part Instance Id',
            type: 'string'
        },
        part_number: {
            title: 'Part Number',
            type: 'string'
        },
        purchase_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Purchase Price'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        requested_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        reservation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PartReservationPublic'
                },
                {
                    type: 'null'
                }
            ]
        },
        reserved_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        sale_price: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sale Price'
        },
        source: {
            $ref: '#/components/schemas/WorkTaskItemSource'
        },
        unit_of_measure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Unit Of Measure'
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    required: [
        'id',
        'source',
        'part_id',
        'part_instance_id',
        'part_number',
        'description',
        'unit_of_measure',
        'quantity',
        'issued_quantity',
        'condition',
        'work_task_step_id',
        'requested_by',
        'created_at',
        'issues',
        'reservation',
        'reserved_by',
        'lot_number',
        'currency',
        'list_price',
        'sale_price',
        'purchase_price'
    ],
    title: 'WorkTaskPartPublic',
    type: 'object'
} as const;

export const WorkTaskPartUpdateSchema = {
    properties: {
        condition: {
            $ref: '#/components/schemas/PartCondition',
            title: 'Condition'
        },
        quantity: {
            maximum: 100000,
            minimum: 1,
            title: 'Quantity',
            type: 'integer'
        },
        reservation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ReservePart'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reservation'
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    title: 'WorkTaskPartUpdate',
    type: 'object'
} as const;

export const WorkTaskPartWorkOrderPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        external_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Created At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        }
    },
    required: [
        'id',
        'number',
        'created_at',
        'external_created_at'
    ],
    title: 'WorkTaskPartWorkOrderPublic',
    type: 'object'
} as const;

export const WorkTaskPartWorkTaskPublicSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        work_package: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkTaskPartWorkOrderPublic'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'id',
        'number',
        'description',
        'work_package'
    ],
    title: 'WorkTaskPartWorkTaskPublic',
    type: 'object'
} as const;

export const WorkTaskPartsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/WorkTaskPartDetailPublic'
            },
            title: 'Data',
            type: 'array'
        },
        work_order_count: {
            title: 'Work Order Count',
            type: 'integer'
        }
    },
    required: [
        'data',
        'count',
        'work_order_count'
    ],
    title: 'WorkTaskPartsPublic',
    type: 'object'
} as const;

export const WorkTaskPublicSchema = {
    properties: {
        actual_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Actual Hrs'
        },
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        complied_with_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Complied With Date'
        },
        cost: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        created_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created By Id'
        },
        description: {
            default: '',
            title: 'Description',
            type: 'string'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        estimated_cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost'
        },
        estimated_cost_currency: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost Currency'
        },
        estimated_hrs: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Hrs'
        },
        external_billing_method: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Billing Method'
        },
        external_created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Created At'
        },
        external_ended_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ended At'
        },
        external_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Id'
        },
        external_is_warranty: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Is Warranty'
        },
        external_labor_hrs_taken: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Labor Hrs Taken'
        },
        external_started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Started At'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_deleted: {
            default: false,
            title: 'Is Deleted',
            type: 'boolean'
        },
        item_corr_action_synced: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Item Corr Action Synced'
        },
        last_modified_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Modified By Id'
        },
        major_assembly: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Major Assembly'
        },
        manhours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manhours'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_info: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SourceInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        source_synced_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Source Synced At'
        },
        status: {
            $ref: '#/components/schemas/WorkTaskStatus'
        },
        status_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status Note'
        },
        task_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskType'
                },
                {
                    type: 'null'
                }
            ]
        },
        updated_at: {
            format: 'date-time',
            title: 'Updated At',
            type: 'string'
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    required: [
        'external_id',
        'external_url',
        'source_synced_at',
        'source_info',
        'item_corr_action_synced',
        'external_created_at',
        'external_labor_hrs_taken',
        'external_billing_method',
        'external_is_warranty',
        'external_started_at',
        'external_ended_at',
        'estimated_hrs',
        'actual_hrs',
        'cost',
        'id',
        'created_at',
        'updated_at',
        'status',
        'status_note'
    ],
    title: 'WorkTaskPublic',
    type: 'object'
} as const;

export const WorkTaskRefSchema = {
    properties: {
        description: {
            default: '',
            title: 'Description',
            type: 'string'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        item_corr_action_synced: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Item Corr Action Synced'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        }
    },
    required: [
        'id'
    ],
    title: 'WorkTaskRef',
    type: 'object'
} as const;

export const WorkTaskSignOffRefusalSchema = {
    properties: {
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        reason: {
            $ref: '#/components/schemas/ErrorCode'
        }
    },
    required: [
        'id',
        'reason'
    ],
    title: 'WorkTaskSignOffRefusal',
    type: 'object'
} as const;

export const WorkTaskSignatureSchema = {
    properties: {
        pin: {
            pattern: '^[0-9]{4}$',
            title: 'Pin',
            type: 'string'
        },
        signer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Signer Id'
        }
    },
    required: [
        'pin'
    ],
    title: 'WorkTaskSignature',
    type: 'object'
} as const;

export const WorkTaskStatusSchema = {
    enum: [
        'not_started',
        'in_progress',
        'on_hold',
        'awaiting_parts',
        'complete',
        'signed_off',
        'deferred',
        'closed'
    ],
    title: 'WorkTaskStatus',
    type: 'string'
} as const;

export const WorkTaskStatusChangeSchema = {
    discriminator: {
        mapping: {
            awaiting_parts: '#/components/schemas/HoldWorkTasks',
            deferred: '#/components/schemas/SetWorkTaskStatus',
            in_progress: '#/components/schemas/SetWorkTaskStatus',
            not_started: '#/components/schemas/SetWorkTaskStatus',
            on_hold: '#/components/schemas/HoldWorkTasks'
        },
        propertyName: 'status'
    },
    oneOf: [
        {
            $ref: '#/components/schemas/HoldWorkTasks'
        },
        {
            $ref: '#/components/schemas/SetWorkTaskStatus'
        }
    ],
    title: 'WorkTaskStatusChange'
} as const;

export const WorkTaskStepCreateSchema = {
    properties: {
        description: {
            minLength: 1,
            title: 'Description',
            type: 'string'
        },
        parent_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Step Id'
        }
    },
    required: [
        'description'
    ],
    title: 'WorkTaskStepCreate',
    type: 'object'
} as const;

export const WorkTaskStepInspectionSchema = {
    properties: {
        pin: {
            pattern: '^[0-9]{4}$',
            title: 'Pin',
            type: 'string'
        },
        remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Remarks'
        },
        signer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Signer Id'
        }
    },
    required: [
        'pin'
    ],
    title: 'WorkTaskStepInspection',
    type: 'object'
} as const;

export const WorkTaskStepPublicSchema = {
    properties: {
        description: {
            title: 'Description',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        inspection_remarks: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inspection Remarks'
        },
        inspection_required: {
            title: 'Inspection Required',
            type: 'boolean'
        },
        inspector: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        inspector_signed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inspector Signed At'
        },
        parent_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Step Id'
        },
        resolution: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        technician: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        technician_signed_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Technician Signed At'
        },
        work_task_id: {
            format: 'uuid',
            title: 'Work Task Id',
            type: 'string'
        }
    },
    required: [
        'id',
        'work_task_id',
        'parent_step_id',
        'description',
        'resolution',
        'technician',
        'technician_signed_at',
        'inspection_required',
        'inspection_remarks',
        'inspector',
        'inspector_signed_at'
    ],
    title: 'WorkTaskStepPublic',
    type: 'object'
} as const;

export const WorkTaskStepSignOffSchema = {
    properties: {
        pin: {
            pattern: '^[0-9]{4}$',
            title: 'Pin',
            type: 'string'
        },
        resolution: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resolution'
        },
        signer_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Signer Id'
        }
    },
    required: [
        'pin'
    ],
    title: 'WorkTaskStepSignOff',
    type: 'object'
} as const;

export const WorkTaskStepUpdateSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        inspection_required: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inspection Required'
        }
    },
    title: 'WorkTaskStepUpdate',
    type: 'object'
} as const;

export const WorkTaskToolLoanPublicSchema = {
    properties: {
        custodian: {
            $ref: '#/components/schemas/UserBasicInfo'
        },
        custodian_id: {
            format: 'uuid',
            title: 'Custodian Id',
            type: 'string'
        },
        due_on: {
            format: 'date',
            title: 'Due On',
            type: 'string'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_overdue: {
            title: 'Is Overdue',
            type: 'boolean'
        },
        issued_at: {
            format: 'date-time',
            title: 'Issued At',
            type: 'string'
        },
        issued_by_id: {
            format: 'uuid',
            title: 'Issued By Id',
            type: 'string'
        },
        received_by: {
            anyOf: [
                {
                    $ref: '#/components/schemas/UserBasicInfo'
                },
                {
                    type: 'null'
                }
            ]
        },
        received_by_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Received By Id'
        },
        return_condition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ToolReturnCondition'
                },
                {
                    type: 'null'
                }
            ]
        },
        return_document_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Return Document Id'
        },
        return_note: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Return Note'
        },
        returned_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Returned At'
        },
        tool: {
            $ref: '#/components/schemas/ToolSummaryPublic'
        },
        tool_id: {
            format: 'uuid',
            title: 'Tool Id',
            type: 'string'
        },
        work_package_id: {
            format: 'uuid',
            title: 'Work Package Id',
            type: 'string'
        },
        work_task_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Id'
        },
        work_task_step_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Task Step Id'
        }
    },
    required: [
        'id',
        'tool_id',
        'custodian_id',
        'work_package_id',
        'work_task_id',
        'work_task_step_id',
        'issued_by_id',
        'issued_at',
        'due_on',
        'returned_at',
        'received_by_id',
        'return_condition',
        'return_note',
        'return_document_id',
        'is_overdue',
        'tool',
        'custodian',
        'received_by'
    ],
    title: 'WorkTaskToolLoanPublic',
    type: 'object'
} as const;

export const WorkTaskUpdateSchema = {
    properties: {
        ata_chapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Chapter'
        },
        ata_subchapter: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Subchapter'
        },
        ata_zone: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ata Zone'
        },
        complied_with_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Complied With Date'
        },
        department_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Department Id'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        due_date: {
            anyOf: [
                {
                    format: 'date',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Due Date'
        },
        estimated_cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost'
        },
        estimated_cost_currency: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Cost Currency'
        },
        estimated_hrs: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Hrs'
        },
        is_deleted: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Deleted'
        },
        major_assembly: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Major Assembly'
        },
        manhours: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manhours'
        },
        manual_reference: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Manual Reference'
        },
        number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        phase_ids: {
            anyOf: [
                {
                    items: {
                        format: 'uuid',
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phase Ids'
        },
        severity: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Severity'
                },
                {
                    type: 'null'
                }
            ]
        },
        task_group_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Task Group Id'
        },
        task_type: {
            anyOf: [
                {
                    $ref: '#/components/schemas/TaskType'
                },
                {
                    type: 'null'
                }
            ]
        },
        work_package_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Work Package Id'
        }
    },
    title: 'WorkTaskUpdate',
    type: 'object'
} as const;

export const WorkTasksPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/WorkTaskPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'WorkTasksPublic',
    type: 'object'
} as const;

export const WorkTasksSignedOffSchema = {
    properties: {
        awaiting_countersign: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Awaiting Countersign',
            type: 'array'
        },
        refused: {
            items: {
                $ref: '#/components/schemas/WorkTaskSignOffRefusal'
            },
            title: 'Refused',
            type: 'array'
        },
        signed: {
            items: {
                format: 'uuid',
                type: 'string'
            },
            title: 'Signed',
            type: 'array'
        }
    },
    required: [
        'signed',
        'awaiting_countersign',
        'refused'
    ],
    title: 'WorkTasksSignedOff',
    type: 'object'
} as const;

export const WorkflowSchema = {
    properties: {
        name: {
            title: 'Name',
            type: 'string'
        },
        steps: {
            items: {
                $ref: '#/components/schemas/WorkflowStep'
            },
            title: 'Steps',
            type: 'array'
        }
    },
    required: [
        'steps',
        'name'
    ],
    title: 'Workflow',
    type: 'object'
} as const;

export const WorkflowCreateSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        name: {
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        steps: {
            items: {
                $ref: '#/components/schemas/WorkflowStepCreate'
            },
            title: 'Steps',
            type: 'array'
        }
    },
    required: [
        'name'
    ],
    title: 'WorkflowCreate',
    type: 'object'
} as const;

export const WorkflowDetailPublicSchema = {
    properties: {
        active_steps: {
            items: {
                $ref: '#/components/schemas/WorkflowStepPublic'
            },
            title: 'Active Steps',
            type: 'array'
        },
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'id',
        'name',
        'description',
        'created_at',
        'deleted_at',
        'active_steps'
    ],
    title: 'WorkflowDetailPublic',
    type: 'object'
} as const;

export const WorkflowStepSchema = {
    properties: {
        name: {
            title: 'Name',
            type: 'string'
        }
    },
    required: [
        'name'
    ],
    title: 'WorkflowStep',
    type: 'object'
} as const;

export const WorkflowStepCreateSchema = {
    properties: {
        name: {
            minLength: 1,
            title: 'Name',
            type: 'string'
        },
        position: {
            minimum: 0,
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'name',
        'position'
    ],
    title: 'WorkflowStepCreate',
    type: 'object'
} as const;

export const WorkflowStepPublicSchema = {
    properties: {
        created_at: {
            format: 'date-time',
            title: 'Created At',
            type: 'string'
        },
        deleted_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted At'
        },
        id: {
            format: 'uuid',
            title: 'Id',
            type: 'string'
        },
        is_active: {
            title: 'Is Active',
            type: 'boolean'
        },
        name: {
            title: 'Name',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'integer'
        }
    },
    required: [
        'id',
        'name',
        'position',
        'is_active',
        'created_at',
        'deleted_at'
    ],
    title: 'WorkflowStepPublic',
    type: 'object'
} as const;

export const WorkflowStepUpdateSchema = {
    properties: {
        is_active: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Active'
        },
        name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        position: {
            anyOf: [
                {
                    minimum: 0,
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        }
    },
    title: 'WorkflowStepUpdate',
    type: 'object'
} as const;

export const WorkflowUpdateSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        name: {
            anyOf: [
                {
                    minLength: 1,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    title: 'WorkflowUpdate',
    type: 'object'
} as const;

export const WorkflowsPublicSchema = {
    properties: {
        count: {
            title: 'Count',
            type: 'integer'
        },
        data: {
            items: {
                $ref: '#/components/schemas/WorkflowDetailPublic'
            },
            title: 'Data',
            type: 'array'
        }
    },
    required: [
        'data',
        'count'
    ],
    title: 'WorkflowsPublic',
    type: 'object'
} as const;

export const WorkscopeSchema = {
    enum: [
        'test',
        'repair',
        'overhaul',
        'warranty'
    ],
    title: 'Workscope',
    type: 'string'
} as const;

export const app__aircraft__ad_compliance_history__schemas__AircraftAssociationSchema = {
    enum: [
        'GENERAL',
        'AIRFRAME',
        'ENGINE',
        'APU',
        'EQUIPMENT',
        'APPLIANCES'
    ],
    title: 'AircraftAssociation',
    type: 'string'
} as const;

export const app__aircraft__mod_status__schemas__AircraftAssociationSchema = {
    enum: [
        'AIRFRAME',
        'ENGINE',
        'APU',
        'EQUIPMENT',
        'APPLIANCES',
        'OTHER'
    ],
    title: 'AircraftAssociation',
    type: 'string'
} as const;

export const app__data_import__schemas_external__CustomerSchema = {
    properties: {
        id: {
            maxLength: 100,
            title: 'Id',
            type: 'string'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        }
    },
    required: [
        'id'
    ],
    title: 'Customer',
    type: 'object'
} as const;

export const app__data_import__schemas_external__ImportSchema = {
    properties: {
        package: {
            $ref: '#/components/schemas/app__data_import__schemas_external__WorkPackage'
        },
        source: {
            $ref: '#/components/schemas/ERPVendor'
        },
        task: {
            $ref: '#/components/schemas/app__data_import__schemas_external__WorkTask'
        }
    },
    required: [
        'source',
        'package',
        'task'
    ],
    title: 'Import',
    type: 'object'
} as const;

export const app__data_import__schemas_external__WorkPackageSchema = {
    properties: {
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Aircraft'
                },
                {
                    type: 'null'
                }
            ]
        },
        created_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created At'
        },
        customer: {
            anyOf: [
                {
                    $ref: '#/components/schemas/app__data_import__schemas_external__Customer'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            maxLength: 100,
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        }
    },
    required: [
        'id'
    ],
    title: 'WorkPackage',
    type: 'object'
} as const;

export const app__data_import__schemas_external__WorkTaskSchema = {
    properties: {
        billing: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkTaskBilling'
                },
                {
                    type: 'null'
                }
            ]
        },
        children: {
            items: {
                $ref: '#/components/schemas/app__data_import__schemas_external__WorkTask'
            },
            title: 'Children',
            type: 'array'
        },
        corrective_action: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corrective Action'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        id: {
            maxLength: 100,
            title: 'Id',
            type: 'string'
        },
        number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        parent: {
            anyOf: [
                {
                    $ref: '#/components/schemas/app__data_import__schemas_external__WorkTask'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'id'
    ],
    title: 'WorkTask',
    type: 'object'
} as const;

export const app__data_import__schemas_internal__CustomerSchema = {
    properties: {
        address: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Address'
        },
        city: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'City'
        },
        country: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Country'
        },
        email: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email'
        },
        external_id: {
            maxLength: 100,
            title: 'External Id',
            type: 'string'
        },
        name: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        notes: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Notes'
        },
        phone: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phone'
        },
        state: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'State'
        },
        status: {
            anyOf: [
                {
                    maxLength: 100,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        },
        work_packages: {
            items: {
                $ref: '#/components/schemas/app__data_import__schemas_internal__WorkPackage'
            },
            title: 'Work Packages',
            type: 'array'
        },
        zip_code: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Zip Code'
        }
    },
    required: [
        'external_id',
        'work_packages'
    ],
    title: 'Customer',
    type: 'object'
} as const;

export const app__data_import__schemas_internal__ImportSchema = {
    properties: {
        customers: {
            items: {
                $ref: '#/components/schemas/app__data_import__schemas_internal__Customer'
            },
            title: 'Customers',
            type: 'array'
        },
        source_synced_at: {
            format: 'date-time',
            title: 'Source Synced At',
            type: 'string'
        },
        tenant_erp_config_id: {
            format: 'uuid',
            title: 'Tenant Erp Config Id',
            type: 'string'
        },
        tenant_id: {
            anyOf: [
                {
                    format: 'uuid',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenant Id'
        },
        workflows: {
            items: {
                $ref: '#/components/schemas/Workflow'
            },
            title: 'Workflows',
            type: 'array'
        }
    },
    required: [
        'tenant_erp_config_id',
        'source_synced_at',
        'customers'
    ],
    title: 'Import',
    type: 'object'
} as const;

export const app__data_import__schemas_internal__WorkPackageSchema = {
    properties: {
        aircraft: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Aircraft'
                },
                {
                    type: 'null'
                }
            ]
        },
        billing: {
            anyOf: [
                {
                    $ref: '#/components/schemas/WorkPackageBilling'
                },
                {
                    type: 'null'
                }
            ]
        },
        currency: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Currency'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        external_created_at: {
            format: 'date-time',
            title: 'External Created At',
            type: 'string'
        },
        external_ended_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ended At'
        },
        external_id: {
            maxLength: 100,
            title: 'External Id',
            type: 'string'
        },
        external_started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Started At'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        flat_rate_revenue: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flat Rate Revenue'
        },
        freight_revenue: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Freight Revenue'
        },
        is_freight_included_in_flat_rate: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Is Freight Included In Flat Rate'
        },
        labour_cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Labour Cost'
        },
        labour_revenue: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Labour Revenue'
        },
        materials_cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Materials Cost'
        },
        materials_revenue: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Materials Revenue'
        },
        misc_cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Misc Cost'
        },
        misc_revenue: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Misc Revenue'
        },
        number: {
            maxLength: 100,
            title: 'Number',
            type: 'string'
        },
        part: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Part'
                },
                {
                    type: 'null'
                }
            ]
        },
        services_cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Services Cost'
        },
        services_revenue: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Services Revenue'
        },
        work_tasks: {
            items: {
                $ref: '#/components/schemas/app__data_import__schemas_internal__WorkTask'
            },
            title: 'Work Tasks',
            type: 'array'
        },
        workflow_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workflow Name'
        }
    },
    required: [
        'number',
        'external_id',
        'external_created_at',
        'work_tasks'
    ],
    title: 'WorkPackage',
    type: 'object'
} as const;

export const app__data_import__schemas_internal__WorkTaskSchema = {
    properties: {
        actual_hrs: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Actual Hrs'
        },
        corrective_action: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corrective Action'
        },
        cost: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cost'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        estimated_hrs: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Estimated Hrs'
        },
        external_created_at: {
            format: 'date-time',
            title: 'External Created At',
            type: 'string'
        },
        external_ended_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Ended At'
        },
        external_id: {
            maxLength: 100,
            title: 'External Id',
            type: 'string'
        },
        external_is_warranty: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Is Warranty'
        },
        external_labor_hrs_taken: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Labor Hrs Taken'
        },
        external_started_at: {
            anyOf: [
                {
                    format: 'date-time',
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Started At'
        },
        external_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'External Url'
        },
        number: {
            anyOf: [
                {
                    maxLength: 255,
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number'
        },
        outside_services: {
            items: {
                $ref: '#/components/schemas/OutsideService'
            },
            title: 'Outside Services',
            type: 'array'
        },
        parts: {
            items: {
                $ref: '#/components/schemas/WorkTaskPart'
            },
            title: 'Parts',
            type: 'array'
        },
        workflow_step_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workflow Step Name'
        }
    },
    required: [
        'external_id',
        'external_created_at'
    ],
    title: 'WorkTask',
    type: 'object'
} as const;
